import "./sectores.css";

const Sectores = () => {
  return (
    <>
      <svg viewBox="0 0 1366 768">
        <defs>
          <linearGradient
            id="Degradado_sin_nombre_2"
            x1="683"
            y1="1.48"
            x2="683"
            y2="769.48"
            gradientTransform="matrix(1, 0, 0, -1, 0, 769.48)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#d8f0fe" />
            <stop offset="0.4" stop-color="#d6effe" />
            <stop offset="0.58" stop-color="#cfecfe" />
            <stop offset="0.71" stop-color="#c2e7fd" />
            <stop offset="0.83" stop-color="#b0e0fd" />
            <stop offset="0.92" stop-color="#99d6fd" />
            <stop offset="1" stop-color="#81cdfc" />
          </linearGradient>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
          <g id="Capa_1-2" data-name="Capa 1">
            <g id="fondo">
              <rect class="cls5-1" width="1366" height="768" />
            </g>
            <g id="Chimborazo">
              <path
                class="cls5-2"
                d="M1365.05,433.42V449l-13.15-5.17-42.21,16.37-34.45-2.59-50-13.78L1183,460.2s-15.51-4.31-18.09-6S1096,473.15,1096,473.15s-19.26-3.1-35-5.77c-10.49-1.77-19.42-3.36-20.11-3.7-1.72-.87-12.92,17.22-12.92,17.22l-37-4.3-131,31.81,44-37.9,24.12-16.37,39.2-19.81L955.66,455l56.85-14.64,14.65-.87,22.4-12.92,11.19,3.45-5.16,3.45,5.46-.8,23.82-3.51.42.56,2.17,2.89,7.26-1.27h0l11.21-2h0l16-2.8,26.71,4.31h18.08l37.9-1.72,17.23-5.17,23.26,2.58,21.53,2.59,17.23-5.17,45.05,6.63,13.53,2,17.28.61Z"
              />
              <polygon
                class="cls5-3"
                points="1108.12 417.97 1096.07 425.72 1085.29 429.73 1084.87 429.17 1055.58 433.47 1060.75 430.03 1049.55 426.58 1027.15 439.5 1012.51 440.36 955.66 455 967.29 434.34 967.3 434.34 968.15 433.91 1008.64 433.91 1010.71 432.68 1011.13 432.43 1007.35 437.78 1030.6 435.2 1048.69 424 1060.75 426.58 1075.39 418.83 1080.56 420.55 1093.15 413.47 1089.17 418.83 1095.2 416.25 1093.48 421.42 1108.12 417.97"
              />
              <polygon
                class="cls5-4"
                points="1130.52 396.43 1125.35 399.02 1130.15 400.85 1121.04 405.05 1114.16 405.05 1098.65 414.52 1094.34 412.8 1093.15 413.47 1080.56 420.55 1075.39 418.83 1060.75 426.58 1048.69 424 1030.6 435.2 1007.35 437.78 1011.13 432.43 1042.23 414.09 1044.81 418.4 1049.89 414.95 1061.61 412.8 1055.58 422.28 1066.78 417.97 1067.64 407.63 1077.11 411.94 1083.15 399.02 1100.94 399.16 1100.95 399.16 1103.38 399.45 1106.85 396.42 1107.26 401.6 1125.15 391.77 1125.78 391.7 1128.37 387.39 1132.55 387.39 1130.52 396.43"
              />
              <polygon
                class="cls5-2"
                points="1100.94 399.16 1083.15 399.02 1077.11 411.94 1067.64 407.63 1066.78 417.97 1055.58 422.28 1061.61 412.8 1049.89 414.95 1068.93 402.03 1068.93 405.48 1081.85 396.86 1100.94 399.16"
              />
              <polygon
                class="cls5-2"
                points="1125.15 391.77 1107.26 401.6 1106.85 396.42 1110.28 393.42 1125.15 391.77"
              />
              <polygon
                class="cls5-2"
                points="1163.26 376.62 1159.81 390.41 1147.75 390.41 1132.25 399.88 1130.15 400.85 1125.35 399.02 1130.52 396.43 1132.55 387.39 1133.54 387.39 1140.74 380.19 1152.05 380.07 1163.26 376.62"
              />
              <polygon
                class="cls5-5"
                points="1210.63 373.18 1214.93 368.87 1212.36 368.01 1199.43 378.34 1204.6 373.18 1212.36 367.15 1214.07 366.29 1216.66 368.87 1210.63 373.18"
              />
              <path
                class="cls5-6"
                d="M1214.93,348.19l-4.3,5.17-5.17,3.45-.86-.86h-1.72l-.87,1.72-7.74,6.89,5.16-8.61v-1.73l-9.47,6,9.54-9.26,11.13-6.25,9.46-4.73c-.26.25-8.61,8.18-9.46,9S1214.93,348.19,1214.93,348.19Z"
              />
              <path
                class="cls5-2"
                d="M1209.77,394.71c.86,0,6.89,3.44,6.89,3.44l-8.61-1.72v4.31l-9.48,6.89,8.62-3.44-2,8.64-.15.1L1189.1,424l2.58-6.88-7.76,8.61,5.18-10.34-7.75-9.47-26.71,11.2,9.48-16.37-12.93,9.47,5.17-4.3-15.5,4.3,2.58-2.58-16.36,7.75,13.78-2.58L1106,429.37h0l-11.22,2L1122,410.24v3.45l14.64-12.92,13.79-4.31-6.9,8.62,13.78-10.34-1.72,3.44L1172.73,387l-5.17,6,12.92-10.33,4.31-6.89L1177.9,381l.86-3.45-3.45,3.45,1.73-5.17,11.19-7.75,4.31.86v3.44l4.31-.86-5.17,4.31,6,2.58h-6.89l.86,5.17-15.5,10.34,13.77-5.16c-.36.27-12,9.46-11.19,9.46s11.71-4.17,12-4.3l-7.75,6,9.48-2.59-9.48,6.9,9.48-1.73.86,3.45,11.2-6h-6l6-4.31-6.89-.86,18.09-12.92-4.31,6.89L1233,374.9l-20.66,16.37h6S1208.91,394.71,1209.77,394.71Z"
              />
              <polygon
                class="cls5-5"
                points="1324.33 393.85 1324.33 394.71 1323.47 394.71 1324.33 393.85"
              />
              <polygon
                class="cls5-5"
                points="1329.5 394.71 1327.78 395.57 1327.78 394.71 1328.64 393.85 1329.5 394.71"
              />
              <polygon
                class="cls5-6"
                points="1365.05 354.55 1365.05 358.02 1364.82 357.68 1362.23 357.68 1362.23 355.95 1358.79 355.95 1364.82 352.51 1363.95 355.09 1365.05 354.55"
              />
              <polygon
                class="cls5-6"
                points="1364.82 362.84 1365.05 362.5 1365.05 362.95 1364.82 362.84"
              />
              <polygon
                class="cls5-6"
                points="1364.82 367.15 1365.05 367.04 1365.05 374.45 1363.95 376.62 1365.05 377.17 1365.05 386.17 1363.95 386.1 1359.64 384.38 1363.1 383.52 1361.38 381.79 1359.64 381.79 1355.34 378.35 1360.52 379.21 1363.1 373.18 1362.23 373.18 1359.64 369.73 1358.79 372.32 1356.2 370.6 1352.77 367.15 1348.45 369.73 1350.17 374.04 1346.72 373.18 1350.17 378.35 1347.6 379.21 1350.17 383.52 1335.54 399.02 1338.12 394.71 1336.39 394.71 1341.56 389.55 1335.54 389.55 1335.54 387.82 1328.64 386.96 1325.19 388.69 1320.03 385.24 1326.06 386.96 1331.22 382.65 1328.64 374.91 1327.78 381.79 1326.06 381.79 1317.44 373.18 1320.89 371.46 1332.94 367.15 1325.19 361.12 1327.78 366.29 1324.34 363.7 1322.62 363.7 1322.62 360.26 1324.34 359.4 1324.34 358.54 1321.76 357.68 1321.76 359.4 1318.31 357.68 1313.14 358.54 1315.71 355.95 1315.71 353.37 1313.99 353.37 1310.55 352.51 1312.28 351.64 1312.28 349.92 1313.99 352.51 1316.59 351.64 1319.16 354.23 1319.16 352.51 1321.76 354.23 1320.89 352.51 1325.19 356.82 1325.19 355.09 1327.78 358.54 1326.91 355.95 1330.37 358.54 1329.51 356.82 1332.94 356.82 1328.64 354.23 1329.51 353.37 1326.91 350.78 1330.37 351.64 1328.64 349.92 1331.22 349.92 1328.64 347.34 1337.26 351.64 1339.84 350.78 1341.56 352.51 1338.97 352.51 1338.12 353.37 1333.81 351.64 1336.39 355.09 1332.09 353.37 1338.97 361.98 1339.84 358.54 1342.42 355.95 1342.42 360.26 1345.01 355.09 1349.32 355.95 1349.32 354.23 1345.87 353.37 1349.32 352.51 1348.45 351.64 1345.87 350.78 1346.06 349.06 1348.45 349.06 1352.6 348.23 1351.04 350.78 1351.89 353.37 1351.04 355.95 1351.04 360.26 1352.77 356.82 1353.63 359.4 1351.89 364.56 1357.07 359.4 1354.47 365.43 1355.34 366.29 1357.07 364.56 1356.2 368.01 1357.92 369.73 1361.38 366.29 1362.23 369.73 1363.95 371.46 1364.82 369.73 1364.82 367.15"
              />
              <path
                class="cls5-7"
                d="M1365.05,500.62v45.79H939.23c1.78,0-2.07-30.82-3-38-.13-.94-.2-1.48-.2-1.48l94.53-21.77h0l6,3.44,22.39-6.88s.87,1,2,2.15c1.64,1.63,3.86,3.52,4.87,3,1.73-.86,4.31-8.61,10.34-5.16s86.14,15.5,86.14,15.5,23.25-.86,24.11-.86,40.49-6,40.49-6h36.18l74.08,8.61Z"
              />
              <path
                class="cls5-8"
                d="M1365.05,449v51.65L1337.26,499l-74.08-8.61H1227s-39.62,6-40.49,6-24.11.86-24.11.86-80.11-12.06-86.14-15.5-8.61,4.3-10.34,5.16c-1,.51-3.23-1.38-4.87-3-1.15-1.14-2-2.15-2-2.15l-22.39,6.88-6-3.44h0c-1.33.35-87,23.25-91.35,23.25H860.05l131-31.87,37,4.3s11.2-18.09,12.92-17.22c.69.34,9.62,1.93,20.11,3.7,15.76,2.67,35,5.77,35,5.77s66.33-20.67,68.91-18.95,18.09,6,18.09,6l42.21-16.37,50,13.78,34.45,2.59,42.21-16.37Z"
              />
              <line
                class="cls5-9"
                x1="967.76"
                y1="433.51"
                x2="967.3"
                y2="434.34"
              />
              <line
                class="cls5-9"
                x1="1011.99"
                y1="431.22"
                x2="1011.13"
                y2="432.43"
              />
              <line
                class="cls5-9"
                x1="1085.29"
                y1="429.73"
                x2="1084.38"
                y2="430.07"
              />
              <line
                class="cls5-9"
                x1="1199.51"
                y1="350.99"
                x2="1199.5"
                y2="351"
              />
              <path
                class="cls5-3"
                d="M1344.14,417.11,1333,426.58l-4,4L1283.85,424l-17.23,5.17-21.54-2.58L1221.83,424l-17.23,5.17-37.9,1.73h-18.09l-26.7-4.31-16,2.79,34.91-16.57L1127,415.39l16.36-7.75-2.58,2.58,15.5-4.3-5.17,4.3,12.93-9.47-9.48,16.37,26.71-11.2,7.75,9.47-5.18,10.34,7.76-8.61L1189.1,424l15.9-11.06.15-.1,3.76-2.62-4.31,8.62,4.31-.86,1.72,4.31.86-8.62,7.75-8.61,6,4.3-7.76.86-2.59,10.34,7.76-6.89-4.31,6.89,8.62-3.44,13.78,4.3L1227,412.8l24.11,11.2,22.4-18.94-8.61,12.06,9.47-8.62-2.58,14.65,19.81-12.07-8.6,11.2,19.81-19.82,11.2,5.17L1302,409.35l-8.62,7.76,7.76,7.75s16.36-4.31,16.36-3.45,5.17,7.75,5.17,7.75l15.51-12.92-3.45-.86-7.75,6,3.44-8.61-6,4.31.86-8.62-7.75-6.89Z"
              />
              <path
                class="cls5-3"
                d="M1365.05,411.94v21.48l-5.34-.2-13.83-12.67c.34.2,12,6.87,11.19,6s-12.55-17.55-12.91-18.07l5.16,4.29-3.45-6,15.51,14.64,1.72-8.62Z"
              />
              <line
                class="cls5-9"
                x1="1344.16"
                y1="408.5"
                x2="1344.14"
                y2="408.49"
              />
              <line
                class="cls5-9"
                x1="1345.87"
                y1="420.56"
                x2="1345.87"
                y2="420.55"
              />
              <line
                class="cls5-9"
                x1="1205.15"
                y1="412.83"
                x2="1205.01"
                y2="413.41"
              />
              <path class="cls5-9" d="M1190.82,393.85h0" />
              <path class="cls5-9" d="M1190,388.68h0" />
              <line
                class="cls5-9"
                x1="1094.72"
                y1="431.34"
                x2="1094.14"
                y2="431.79"
              />
              <polygon
                class="cls5-4"
                points="1231.3 363.7 1233.03 365.42 1229.58 366.29 1222.69 368.87 1224.41 364.56 1221.83 364.56 1229.58 355.95 1226.14 362.84 1227 362.84 1225.28 366.29 1227.86 365.42 1229.58 361.98 1233.03 361.98 1233.89 363.7 1231.3 363.7"
              />
              <polygon
                class="cls5-4"
                points="1246.81 363.7 1240.78 365.42 1243.37 365.42 1231.3 372.32 1217.52 382.65 1219.24 378.34 1211.49 381.79 1215.8 374.04 1220.11 376.62 1222.69 374.9 1218.38 373.18 1221.83 372.32 1226.14 372.32 1231.3 368.01 1233.89 368.01 1239.06 363.7 1236.47 363.7 1257.15 349.06 1241.64 363.7 1246.81 363.7"
              />
              <polygon
                class="cls5-4"
                points="1200.29 374.9 1201.15 371.45 1199.43 371.45 1201.15 369.73 1202.88 372.32 1200.29 374.9"
              />
              <polygon
                class="cls5-4"
                points="1210.63 373.18 1214.93 368.87 1212.36 368.01 1199.43 378.34 1204.6 373.18 1212.36 367.15 1214.07 366.29 1216.66 368.87 1210.63 373.18"
              />
              <polygon
                class="cls5-10"
                points="1264.9 390.41 1259.73 397.29 1259.73 398.16 1247.67 398.16 1245.08 399.88 1239.92 399.88 1240.78 400.74 1228.72 408.49 1233.03 401.6 1228.72 402.47 1231.3 400.74 1225.28 395.57 1227 400.74 1220.11 392.99 1220.97 389.55 1225.28 390.41 1232.16 380.07 1227 392.12 1233.89 386.96 1231.3 396.43 1239.92 391.27 1233.03 399.02 1244.23 394.71 1237.33 399.88 1243.37 398.16 1254.56 396.43 1249.39 394.71 1255.42 392.12 1249.39 391.27 1259.73 390.41 1253.7 387.82 1260.59 385.24 1264.9 390.41"
              />
              <polygon
                class="cls5-10"
                points="1306.25 389.55 1295.91 398.16 1286.43 404.19 1278.68 406.77 1281.26 403.33 1278.68 403.33 1276.09 404.19 1276.95 401.6 1274.38 401.6 1250.25 420.55 1251.98 416.25 1242.5 417.11 1253.7 411.94 1250.25 406.77 1257.15 408.49 1257.15 403.33 1261.45 405.91 1260.59 401.6 1264.9 404.19 1263.17 399.02 1269.2 403.33 1270.07 397.29 1273.51 399.88 1276.09 397.29 1273.51 396.43 1285.57 390.41 1279.54 399.02 1285.57 396.43 1283.85 401.6 1288.16 399.88 1299.35 391.27 1301.08 386.96 1301.08 370.59 1306.25 389.55"
              />
              <polygon
                class="cls5-4"
                points="1251.98 366.29 1254.56 366.29 1252.84 368.01 1248.53 371.45 1251.12 361.98 1254.56 361.11 1251.98 362.84 1251.98 366.29"
              />
              <polygon
                class="cls5-4"
                points="1252.84 381.79 1254.56 381.79 1252.84 383.51 1250.25 382.65 1248.53 382.65 1242.5 383.51 1247.67 381.79 1243.37 380.93 1244.23 380.07 1242.5 380.07 1237.33 374.04 1240.78 369.73 1241.64 368.87 1244.23 371.45 1243.37 368.01 1245.94 371.45 1244.23 372.32 1244.23 373.18 1241.64 370.59 1239.06 374.04 1242.5 378.34 1245.94 375.76 1245.94 379.2 1247.67 377.48 1247.67 374.9 1250.25 377.48 1251.12 375.76 1251.12 377.48 1252.84 376.62 1251.98 378.34 1247.67 379.2 1247.67 380.07 1251.98 380.07 1255.42 377.48 1252.84 381.79"
              />
              <polygon
                class="cls5-4"
                points="1314 375.76 1308.83 376.62 1312.27 372.32 1311.41 375.76 1312.27 374.9 1314 375.76"
              />
              <polygon
                class="cls5-4"
                points="1324.33 392.12 1321.75 390.41 1320.03 391.27 1316.58 392.12 1319.17 392.99 1315.72 396.43 1316.58 393.85 1313.13 393.85 1314.86 392.12 1314 392.12 1317.44 390.41 1321.75 388.68 1324.33 392.12"
              />
              <polygon
                class="cls5-4"
                points="1328.64 401.6 1328.64 399.88 1324.33 399.88 1324.33 397.29 1326.05 399.02 1327.78 398.16 1330.36 399.02 1332.09 400.74 1328.64 401.6"
              />
              <polygon
                class="cls5-4"
                points="1331.22 389.55 1331.22 391.27 1328.64 390.41 1331.22 389.55"
              />
              <polygon
                class="cls5-4"
                points="1311.41 395.57 1309.69 395.57 1310.55 394.71 1311.41 395.57"
              />
              <polygon
                class="cls5-4"
                points="1314 396.43 1312.27 398.16 1312.27 397.29 1314 396.43"
              />
              <polygon
                class="cls5-4"
                points="1324.33 393.85 1324.33 394.71 1323.47 394.71 1324.33 393.85"
              />
              <polygon
                class="cls5-4"
                points="1329.5 394.71 1327.78 395.57 1327.78 394.71 1328.64 393.85 1329.5 394.71"
              />
              <polygon
                class="cls5-4"
                points="1365.05 392.49 1365.05 393.71 1363.95 392.99 1363.95 392.13 1365.05 392.49"
              />
              <path
                class="cls5-11"
                d="M1365.05,354.54V351l-8-3.62-4.47.89-1.56,2.55.86,2.59L1351,356v4.31l1.73-3.44.86,2.58-1.73,5.16,5.17-5.16-2.59,6,.86.86,1.73-1.73-.86,3.45,1.72,1.72,3.45-3.44.86,3.44,1.72,1.73.86-1.73v-2.58l.23-.11V363l-.23-.11.23-.34V358l-.23-.34h-2.58v-1.73h-3.45l6-3.44-.86,2.58Zm-8.84-.32-2.58-.86.85-.86h-.85l.85-.87v-1.72l2.59,2.59.86-.87-.86-.86,1.72.86v1.73l.86.86Zm7.75,22.39,1.09.55v-2.72Zm1.09,15.87v-6.32l-1.09-.07-4.31-1.72,3.45-.86-1.72-1.73h-1.73l-4.31-3.44,5.18.86,2.58-6h-.86l-2.59-3.45-.86,2.59-2.58-1.72-3.44-3.45-4.31,2.58,1.72,4.31-3.45-.86,3.45,5.17-2.58.86,2.58,4.31L1335.54,399l2.58-4.31h-1.72l5.16-5.16h-6V387.8l-6.9-.86-3.44,1.73-5.17-3.45,6,1.72,5.17-4.31-2.59-7.74-.86,6.88h-1.72l-8.61-8.61,3.44-1.72,12.06-4.31-7.75-6,2.58,5.17-3.44-2.59h-1.72v-3.44l1.72-.86v-.86l-2.58-.86v1.72l-3.45-1.72-5.17.86,2.58-2.59v-2.58H1314l-3.45-.86,1.73-.87v-1.72l1.72,2.59,2.59-.87,2.58,2.59V352.5l2.59,1.72-.87-1.72,4.31,4.31v-1.73l2.58,3.45-.86-2.59,3.45,2.59-.86-1.72H1333l-4.31-2.59.87-.86-2.59-2.59,3.45.86-1.73-1.72h2.59l-2.59-2.58,8.62,4.3,2.58-.86,1.72,1.73H1339l-.86.86-4.31-1.73,2.59,3.45-4.31-1.72L1339,362l.86-3.44,2.59-2.59v4.31l2.58-5.17,4.31.86v-1.72l-3.45-.86,3.45-.86-.86-.87-2.59-.86.19-1.72h-3.63l-5.17-5.16-9.48-4.31h-11.19l-6,1.72-10.33-7.76-21.54-7.74-6.89-4.31H1246l-16.6,6.76,1.09,5.29,5.17-2.58.87,3.45,4.3-5.17h1.73l1.72-4.31h3.44l1.73-1.72,3.44,3.45.86-.86,6-3.45,1.71,6-2.58,2.58,3.45,2.58,1.72.87.86-2.59-3.45-7.75,3.45-1.72,9.48,6-1.72,2.58,2.58,3.45-5.17,2.58,4.31,4.31-3.45.86,1.73,3.44-2.59-.85,1.72,4.3-6-5.16-5.17,3.44,5.17-6,6-.86-3.44-2.59.86-2.58,4.31-1.73-2.59-1.72,1.73-2.58-6-4.31.87,3.45-3.45-3.45,1.72,5.17,1.73,2.58-2.59,3.45h-2.58L1257.2,331l1.72-1.72-.86-1.72,1.73-.86-.87-2.59-4.3,2.59,1.72,1.72-.86,2.58.86,1.72,2.58,2.59-2.58.86,2.58,4.31h-2.58l4.3,3.45-4.3-.87-2.59,4.31v-6.89l-5.17,1.72,3.45-6-3.45-1.72,3.45-1.73v-4.3l-2.58-3.45-.87,1.73-3.44-.86-2.58,6.88,1.72,6-1.72,1.72v4.31l-6,11.19,3.44-12.05-2.58-3.45,2.58-2.59.86-6.89-5.17,6-.86-4.31-5.17,2.59-.85-3.45-.87,1.72-2.07-3.84-3.1,1.26-1.72,8.62-.87.43h0c-.26.25-8.6,8.18-9.45,9s4.3-.86,4.3-.86l-4.3,5.17-5.17,3.45-.87-.87H1203l-.86,1.73-7.75,6.88,5.16-8.61v-1.72l-9.47,6,9.54-9.25-38,21.31-19,6-1.84,1.85,11.32-.13,11.2-3.45-3.45,13.79h-12l-15.51,9.47-2.09,1-9.11,4.2h-6.89l-15.5,9.48-4.31-1.73-1.19.67-4,5.36,6-2.58-1.72,5.17,14.64-3.45-12.06,7.75-10.78,4,2.17,2.89,7.26-1.27h0l27.18-21.13v3.44l14.64-12.92,13.79-4.3-6.89,8.61,13.78-10.34L1155.5,398l17.23-11.2-5.17,6,12.93-10.34,4.3-6.88-6.89,5.16.86-3.45-3.44,3.45,1.72-5.16,11.2-7.76,4.31.86v3.45l4.3-.86-5.17,4.31,6,2.58h-6.89l.86,5.17-15.5,10.33,13.78-5.16c-.36.28-12,9.47-11.2,9.47s11.72-4.18,12.06-4.3l-7.75,6,9.48-2.58L1183,404l9.48-1.72.86,3.44,11.19-6h-6l6-4.31-6.89-.86,18.09-12.92-4.3,6.9L1233,374.9l-20.67,16.36h6s-9.48,3.44-8.62,3.44,6.89,3.45,6.89,3.45l-8.61-1.72v4.3l-9.48,6.9,8.62-3.45-2,8.64,3.75-2.61-4.31,8.61,4.31-.86,1.73,4.31.86-8.62,7.75-8.61,6,4.31-7.76.86-2.58,10.34,7.75-6.9-4.3,6.9,8.61-3.45,13.78,4.31L1227,412.79l24.12,11.2,22.4-18.95-8.62,12.06,9.48-8.62-2.59,14.65,19.82-12.06-8.62,11.2,19.81-19.81,11.2,5.17-12.06,1.72-8.61,7.75,7.75,7.75s16.37-4.3,16.37-3.44,5.17,7.75,5.17,7.75l15.5-12.92-3.44-.86-7.76,6,3.45-8.62-6,4.31.86-8.62-7.75-6.88,26.7,15.5-11.2,9.47-4,4,13.53,2,17.28.61L1346,420.53c.34.2,12,6.87,11.19,6s-12.55-17.55-12.91-18.07l5.16,4.29-3.45-6,15.51,14.64,1.72-8.62,2-.85v-5.66l-2,.49,2-2.6V393.7L1364,393v-.86Zm-41.58-40.85.87.87h-.87l-4.3-3.45Zm-10.33-9.47.86,3.44,3.45,3.45v1.72l-5.17-3.44V345.6l-.86-.85Zm-137,31v-1.72l-2.59,3.45.87,1.71-1.73-.85-6,3.44h3.45l-1.73,2.58,4.31-2.58-3.44,3.44,3.44-.86L1165,387l.87-2.58-2.59.86,3.44-3.45-2.58-.86.86-2.58,6.89-4.31,1.72-1.72-5.17.86,2.59-1.72h1.72v-2.59l1.73,1.73,1.72-1.73,2.58,1.73Zm11.2-6h-2.59l1.72-2.59,1.73.87Zm143.85,22.4v1.72l-2.59-.86Zm-3.45,5.16.86-.86.87.86-1.73.86Zm-8.61-34.45,1.72,1.72v2.58l-1.72,1.73,2.59-.86v3.44L1320,368l-1.72,2.59-.86-1.73h-1.73l3.45-5.17V362l-4.31-1.72Zm-1.72,17.22-1.73,3.45-2.58.86Zm-6-17.22.86.86h-2.59Zm-48.24-9.48v-1.72l.86.86.86-.86,1.72,1.72h-1.72l1.72,1.73-1.72.86-3.45-2.59Zm-3.44,7.76,1.71,6H1264l1.72,3.45a35.26,35.26,0,0,0,1.73-5.17v6l7.75,1.73-.86-1.73,1.72-.86-5.17-4.31,7.75,1.73-.86-1.73h2.59l-2.59-3.44,4.31-1.72-6.89-.86-1.72-6.9,2.58-1.72-2.58-5.16,7.75,1.71,6.89,6-.86-1.72,4.31.86-4.31-5.17,6,4.31-1.72-2.58,3.44.86,1.72-4.3h12.06l-2.58,6.88h-2.58l3.44,6-1.72-1.73-.86,2.59-2.59,11.19-1.72-9.47-2.59-3.45L1295,366.18l-8.61,11.19-3.45-.86-14.64,13.79,4.31-6.89-6.9-6.9,5.17,2.59,6-6-4.3-1.72v3.45L1270,373.1l-3.45-.86V374l-4.3-.86-2.58,1.73h-6.9l4.31-3.45,1.72.86,2.58-.86,2.59-1.73-4.3-2.58,1.71,2.58-6-.86,2.58-3.44-1.72-.87.86-4.3a19.46,19.46,0,0,1,.86,3.44c.07.89,1.81-5.13,1.81-5.13Zm50,6h-4.3l.86-.86H1308l.86-.86Zm-55.12,17.23-1.73,1.73-2.58-.87h-1.73l-6,.87,5.16-1.73-4.3-.86.86-.86h-1.72l-5.17-6,3.44-4.31.87-.86,2.58,2.59-.86-3.45,2.58,3.45-1.72.86v.86l-2.58-2.58-2.59,3.44,3.45,4.31,3.44-2.58v3.44l1.72-1.73v-2.6l2.59,2.57.86-1.71v1.71l1.72-.86-.86,1.73-4.31.86v.86H1252l3.45-2.59-2.59,4.31Zm0-15.5-1.73,1.72-4.31,3.45,2.59-9.48,3.45-.86-2.59,1.72v3.45Zm-20.68-2.59h-2.58l1.72,1.73-3.45.86-6.89,2.58,1.73-4.31h-2.59l7.75-8.61-3.44,6.89h.86l-1.72,3.45,2.58-.86,1.72-3.45H1233Zm-15.5,0,4.3-6.88-.86-4.31,2.59,1.72,3.44-3.45-1.72-2.58,2.59.86V345.6l3.44,3.45Zm-6.89-3.44h-1.73l4.31-6.89-.86-.86h2.58l9.48-6.9-4.31-1.71,2.59-5.17v-4.31l2.58,3.44,3.44-.86,1.73,6-2.58,1.73-12.07,9.47-3.44,5.17-11.2,9.47Zm-10.34,9.47,1.72,2.59-2.58,2.59.86-3.45h-1.73Zm11.2-1.72-12.93,10.34,5.17-5.17,7.76-6,1.72-.86,2.58,2.58-6,4.31,4.3-4.31Zm19,4.31-13.79,10.33,1.73-4.3-7.75,3.44,4.3-7.75,4.31,2.58,2.58-1.71-4.3-1.73,3.44-.86h4.31l5.17-4.31H1234l5.17-4.31h-2.58l20.67-14.64-15.5,14.64h5.16l-6,1.73h2.59Zm-2.58,36.17,4.3-6.88-4.3.86,2.58-1.73-6-5.17,1.72,5.17-6.89-7.75.86-3.44,4.31.86,6.89-10.34L1227,392.12l6.89-5.17-2.58,9.48,8.61-5.17L1233,399l11.2-4.31-6.89,5.17,6-1.72,11.2-1.72-5.17-1.73,6-2.58-6-.86,10.34-.86-6-2.59,6.89-2.58,4.31,5.17-5.16,6.89v.86h-12.07l-2.58,1.72h-5.17l.86.86ZM1296,398.15l-9.47,6-7.76,2.59,2.59-3.45h-2.59l-2.58.86.86-2.58h-2.58l-24.12,18.95,1.72-4.31-9.47.86,11.19-5.17-3.44-5.16,6.89,1.71v-5.16l4.3,2.58-.86-4.3,4.31,2.58-1.72-5.17,6,4.31.86-6,3.45,2.58,2.58-2.58-2.58-.86,12.06-6-6,8.61,6-2.58-1.73,5.17,4.31-1.73,11.2-8.61,1.72-4.31V370.59l5.17,19Zm16.37-25.84-.86,3.45.86-.86,1.72.86-5.17.85Zm-2.59,23.25.86-.86.87.86Zm2.59,2.59v-.86l1.72-.86Zm7.75-6.89-3.44.86,2.58.86-3.45,3.45.87-2.59h-3.45l1.72-1.72h-1l3.45-1.72,4.31-1.72,2.58,3.44-2.58-1.72Zm4.31,2.58v.86h-.87Zm4.3,7.76v-1.73h-4.3v-2.58l1.72,1.72,1.72-.86,2.59.86,1.72,1.72Zm24.13-11.2-1.73-1.72.86-.87.87.87Zm5.16-5.17-3.45-.86-1.71.86v-.86l1.71-.86v-2.59l.86,1.72,1.73,1.73.86-.86Z"
              />
              <polygon
                class="cls5-4"
                points="1365.05 404.18 1365.05 406.29 1363.1 406.78 1365.05 404.18"
              />
              <polygon
                class="cls5-4"
                points="1357.92 383.51 1357.92 385.24 1354.48 384.37 1352.76 385.24 1352.76 384.37 1354.48 383.51 1354.48 380.93 1355.34 382.65 1357.06 384.37 1357.92 383.51"
              />
              <polygon
                class="cls5-4"
                points="1352.76 388.68 1352.76 390.41 1351.04 388.68 1351.9 387.82 1352.76 388.68"
              />
              <polygon
                class="cls5-4"
                points="1359.65 354.23 1356.2 354.23 1353.62 353.37 1354.48 352.5 1353.62 352.5 1354.48 351.64 1354.48 349.92 1357.06 352.5 1357.92 351.64 1357.06 350.78 1358.79 351.64 1358.79 353.37 1359.65 354.23"
              />
              <polygon
                class="cls5-4"
                points="1324.33 352.5 1323.47 352.5 1319.17 349.06 1323.47 351.64 1324.33 352.5"
              />
              <polygon
                class="cls5-4"
                points="1317.44 377.48 1315.72 380.93 1313.13 381.79 1317.44 377.48"
              />
              <polygon
                class="cls5-4"
                points="1312.27 361.11 1309.69 361.11 1311.41 360.26 1312.27 361.11"
              />
              <polygon
                class="cls5-4"
                points="1309.69 364.56 1305.38 364.56 1306.25 363.7 1307.96 363.7 1308.83 362.84 1309.69 364.56"
              />
              <polygon
                class="cls5-4"
                points="1321.75 365.42 1321.75 368.87 1320.03 368.01 1318.3 370.59 1317.44 368.87 1315.72 368.87 1319.17 363.7 1319.17 361.98 1314.86 360.26 1319.17 360.26 1320.89 361.98 1320.89 364.56 1319.17 366.29 1321.75 365.42"
              />
              <polygon
                class="cls5-4"
                points="1176.17 373.18 1176.17 371.45 1173.59 374.9 1174.45 376.62 1172.73 375.76 1166.7 379.2 1170.14 379.2 1168.42 381.79 1172.73 379.2 1169.28 382.65 1172.73 381.79 1164.98 386.96 1165.84 384.37 1163.26 385.24 1166.7 381.79 1164.12 380.93 1164.98 378.34 1171.87 374.04 1173.59 372.32 1168.42 373.18 1171.01 371.45 1172.73 371.45 1172.73 368.87 1174.45 370.59 1176.17 368.87 1178.76 370.59 1176.17 373.18"
              />
              <polygon
                class="cls5-4"
                points="1188.23 365.42 1187.37 367.15 1184.79 367.15 1186.51 364.56 1188.23 365.42"
              />
              <polygon
                class="cls5-4"
                points="1274.38 341.31 1270.93 342.17 1272.65 345.61 1270.07 344.75 1271.79 349.06 1265.76 343.89 1260.59 347.33 1265.76 341.31 1271.79 340.44 1268.34 337.86 1269.2 335.28 1273.51 333.55 1270.93 331.83 1272.65 329.25 1266.62 324.94 1267.48 328.39 1264.03 324.94 1265.76 330.11 1267.48 332.69 1264.9 336.14 1262.31 336.14 1257.15 330.97 1258.87 329.25 1258.01 327.53 1259.73 326.66 1258.87 324.08 1254.56 326.66 1256.29 328.39 1255.42 330.97 1256.29 332.69 1258.87 335.28 1256.29 336.14 1258.87 340.44 1256.29 340.44 1260.59 343.89 1256.29 343.03 1253.7 347.33 1253.7 340.44 1248.53 342.17 1251.98 336.14 1248.53 334.41 1251.98 332.69 1251.98 328.39 1249.39 324.94 1248.53 326.66 1245.08 325.8 1242.5 332.69 1244.23 338.72 1242.5 340.44 1242.5 344.75 1236.47 355.95 1239.92 343.89 1237.33 340.44 1239.92 337.86 1240.78 330.97 1235.61 337 1234.75 332.69 1229.58 335.28 1228.72 331.83 1227.86 333.55 1225.79 329.7 1229.35 328.25 1230.44 333.55 1235.61 330.97 1236.47 334.41 1240.78 329.25 1242.5 329.25 1244.23 324.94 1247.67 324.94 1249.39 323.22 1252.84 326.66 1253.7 325.8 1259.73 322.36 1261.45 328.39 1258.87 330.97 1262.31 333.55 1264.03 334.41 1264.9 331.83 1261.45 324.08 1264.9 322.36 1274.38 328.39 1272.65 330.97 1275.24 334.41 1270.07 337 1274.38 341.31"
              />
              <polygon
                class="cls5-4"
                points="1264.9 350.78 1266.62 352.5 1264.9 353.37 1261.45 350.78 1263.17 350.78 1263.17 349.06 1264.03 349.92 1264.9 349.06 1266.62 350.78 1264.9 350.78"
              />
              <polygon
                class="cls5-4"
                points="1218.38 363.7 1222.69 356.81 1221.83 352.5 1224.41 354.23 1227.86 350.78 1226.14 348.19 1228.72 349.06 1228.72 345.61 1232.16 349.06 1218.38 363.7"
              />
              <polygon
                class="cls5-6"
                points="1231.3 343.03 1228.72 344.75 1216.66 354.23 1213.21 359.4 1202.02 368.87 1211.49 360.26 1209.77 360.26 1214.07 353.37 1213.21 352.5 1215.8 352.5 1225.28 345.61 1220.97 343.89 1223.55 338.72 1223.55 334.41 1226.14 337.86 1229.58 337 1231.3 343.03"
              />
              <path
                class="cls5-6"
                d="M1303.66,350.78l3.45,6-1.73-1.72-.86,2.58-2.58,11.2-1.73-9.48-2.58-3.44L1295,366.28l-8.61,11.2-3.44-.86L1268.3,390.4l4.31-6.89-6.89-6.89,5.17,2.58,6-6-4.3-1.73v3.45L1270,373.2l-3.45-.87V374l-4.31-.86-2.58,1.72h-6.89l4.31-3.45,1.72.86,2.58-.86,2.58-1.72-4.3-2.59,1.72,2.59-6-.86,2.59-3.45-1.73-.86.87-4.3a19.46,19.46,0,0,1,.86,3.44c0,.86,1.72-5.17,1.72-5.17l1.72,6H1264l1.73,3.45a36.44,36.44,0,0,0,1.72-5.17v6l7.76,1.72-.87-1.72,1.72-.86-5.16-4.31,7.75,1.72-.86-1.72h2.58l-2.58-3.44,4.3-1.73-6.88-.86-1.73-6.89,2.58-1.73-2.58-5.16,7.75,1.72,6.9,6-.87-1.72,4.31.86-4.31-5.17,6,4.31-1.72-2.59,3.44.86,1.73-4.3h12.06l-2.58,6.89Z"
              />
              <polygon
                class="cls5-4"
                points="1317.44 349.06 1317.44 350.78 1312.27 347.33 1312.27 345.61 1311.41 344.75 1313.13 342.17 1314 345.61 1317.44 349.06"
              />
            </g>
            <g id="FIE">
              <path
                class="cls5-12"
                d="M1223,433.08h-46.93l-.53-22.25-.15-6.25c14.08,4.65,30.33,10.43,47.42,17.29l.13,7.74Z"
              />
              <path
                class="cls5-12"
                d="M1170.91,433.08h-39.42L1131,393.2v-1.13l.62-.62c6.43,1.7,20.49,5.57,38.83,11.51l.08,5.89Z"
              />
              <polygon
                class="cls5-12"
                points="1223.63 469.23 1176.94 469.23 1176.21 438.35 1223.11 438.22 1223.63 469.23"
              />
              <polygon
                class="cls5-12"
                points="1171.41 469.23 1131.89 469.23 1131.55 438.47 1170.98 438.36 1171.41 469.23"
              />
              <polygon
                class="cls5-13"
                points="1248.11 424.45 1249.19 514.01 1227.07 514.01 1225.99 424.45 1248.11 424.45"
              />
              <rect
                class="cls5-14"
                x="1224.91"
                y="422.29"
                width="23.2"
                height="2.16"
              />
              <path d="M1240.56,414.74l-9.71,9.71-2.95,2.94-1.85,1.85-1.14,1.14-2-.77-.13-7.74c-17.09-6.86-33.34-12.64-47.42-17.29l.15,6.25-5-2-.08-5.89c-18.34-5.94-32.4-9.81-38.83-11.51l-.62.62v1.13l-5.83-2.31-6-2.4-1.52-.6h0l-4.4-1.74.58-4.67h0l.34-2.74.06-.4.28-2.3.35-2.81h2.41C1167.42,375.55,1240.56,414.74,1240.56,414.74Z" />
              <path
                class="cls5-15"
                d="M1226.53,419.05v4.32l-1.62-.66-2.08-.84c-17.09-6.86-33.34-12.64-47.42-17.29-1.67-.56-3.32-1.1-4.93-1.62-18.34-5.94-32.4-9.81-38.83-11.51l-1-.27c-1.84-.48-2.83-.72-2.83-.72l1.62-1.92,1.1-1.32c5.82.43,22.25,5.58,39.91,11.6l4.9,1.69c19.46,6.74,39.36,14.11,47.44,17.13h0Z"
              />
              <polygon
                class="cls5-16"
                points="1226.16 438.21 1226.16 438.21 1223.11 438.22 1176.21 438.35 1170.98 438.36 1131.55 438.47 1129.95 438.48 1129.95 433.08 1226.1 433.08 1226.16 438.21"
              />
              <polygon
                class="cls5-17"
                points="1177.97 512.93 1172.04 512.93 1172 510.41 1171.56 479.48 1171.51 475.7 1171.45 471.85 1171.41 469.23 1170.98 438.36 1170.91 433.08 1170.56 408.86 1170.48 402.96 1170.42 398.83 1170.42 398.55 1175.27 398.55 1175.32 400.51 1175.41 404.58 1175.56 410.84 1176.09 433.08 1176.21 438.35 1176.94 469.23 1177 471.84 1177.09 475.7 1177.18 479.48 1177.91 510.47 1177.97 512.93"
              />
              <polygon
                class="cls5-18"
                points="1230.31 513.95 1230.31 514.01 1224.37 514.01 1224.32 510.9 1223.79 479.48 1223.73 475.7 1223.66 471.74 1223.63 469.23 1223.11 438.22 1223.02 433.08 1222.96 429.61 1222.83 421.88 1222.76 417.65 1222.76 417.64 1222.75 416.9 1227.61 416.9 1227.76 422.29 1227.82 424.45 1227.9 427.39 1229.06 469.23 1229.12 471.43 1229.13 471.73 1229.24 475.7 1229.35 479.44 1229.35 479.48 1230.22 510.96 1230.31 513.95"
              />
              <polygon
                class="cls5-19"
                points="1229.35 471.73 1229.35 479.48 1129.95 479.48 1129.95 471.93 1131.93 471.92 1171.45 471.85 1177 471.84 1223.66 471.74 1226.56 471.74 1228.53 471.73 1229.35 471.73"
              />
              <polygon
                class="cls5-20"
                points="1126.39 512.84 1123.36 512.92 1122.94 512.93 1119.18 511.1 1119.18 511.1 1093.65 498.64 1093.53 498.59 1093.47 498.55 1091.32 497.51 1083.83 493.86 1083.83 493.85 1079.7 491.84 937.88 422.64 936.48 421.96 934.96 421.21 933.87 420.68 933.39 420.45 931.48 419.52 921.69 414.74 921.69 379.13 876.91 381.29 876.91 416.9 863.96 416.9 863.96 381.83 828.89 382.91 828.89 416.9 820.8 416.9 821.07 400.42 821.26 388.57 821.34 383.98 783.57 385.6 783.57 417.98 777.63 417.98 777.63 385.6 743.64 387.22 743.64 419.59 736.63 419.59 736.88 404.91 737.1 392.08 737.17 388.3 707.49 389.92 707.18 407.04 706.95 419.59 695.62 419.59 696.08 408 697.24 378.05 697.52 378.03 697.54 378.03 932.09 364.67 934.1 364.56 934.27 364.57 934.41 364.58 937.5 364.82 1078.15 375.55 1082.43 375.87 1089.15 376.39 1091.83 376.59 1092.03 376.61 1111.81 378.11 1111.85 378.12 1113.91 378.28 1114.21 378.3 1119.16 378.68 1125.1 379.13 1125.21 390.89 1126.36 509.98 1126.39 512.84"
              />
              <polygon
                class="cls5-13"
                points="1132.38 512.66 1126.39 512.84 1126.36 509.98 1125.21 390.89 1125.1 379.13 1129.41 388.54 1130.62 391.18 1131.03 392.08 1131.04 393.2 1131.49 433.08 1131.55 438.47 1131.89 469.23 1131.93 471.92 1131.96 475.7 1132.01 479.48 1132.35 510.04 1132.38 512.66"
              />
              <polygon
                class="cls5-14"
                points="1132.11 391 1131.03 392.08 1130.62 391.18 1129.41 388.54 1125.1 379.13 1119.16 378.68 1114.21 378.3 1113.91 378.28 1111.85 378.12 1111.81 378.11 1092.03 376.61 1091.83 376.59 1089.15 376.39 1082.43 375.87 1078.15 375.55 937.5 364.82 934.41 364.58 934.27 364.57 934.1 364.56 932.09 364.67 697.54 378.03 697.52 378.03 695.62 378.05 695.62 375.35 932.12 361.41 933.56 361.32 934.32 361.38 934.44 361.39 937.56 361.65 1078.12 373.04 1082.41 373.39 1089.11 373.94 1091.8 374.15 1092 374.17 1110.35 375.66 1110.39 375.66 1112.46 375.83 1113.23 375.89 1114.49 376 1117.88 376.28 1117.92 376.29 1118.85 376.36 1126.17 376.97 1130.51 387.22 1132.11 391"
              />
              <polygon
                class="cls5-21"
                points="737.17 388.3 737.1 392.08 712.89 393.16 707.49 389.92 737.17 388.3"
              />
              <polygon
                class="cls5-22"
                points="712.89 393.16 712.89 419.59 706.95 419.59 707.18 407.04 707.49 389.92 712.89 393.16"
              />
              <polygon
                class="cls5-21"
                points="777.63 385.6 777.63 389.92 750.66 391 743.64 387.22 777.63 385.6"
              />
              <polygon
                class="cls5-22"
                points="750.66 391 750.66 419.59 743.64 419.59 743.64 387.22 750.66 391"
              />
              <polygon
                class="cls5-21"
                points="821.34 383.98 821.26 388.57 791.12 389.38 783.57 385.6 821.34 383.98"
              />
              <polygon
                class="cls5-22"
                points="791.12 389.38 791.12 417.98 783.57 417.98 783.57 385.6 791.12 389.38"
              />
              <polygon
                class="cls5-21"
                points="863.96 381.83 863.96 386.68 834.28 387.22 828.89 382.91 863.96 381.83"
              />
              <polygon
                class="cls5-22"
                points="834.28 387.22 834.28 416.9 828.89 416.9 828.89 382.91 834.28 387.22"
              />
              <polygon
                class="cls5-21"
                points="921.69 379.13 921.69 384.52 882.3 385.6 876.91 381.29 921.69 379.13"
              />
              <polygon
                class="cls5-22"
                points="882.3 385.6 882.3 416.9 876.91 416.9 876.91 381.29 882.3 385.6"
              />
              <polygon
                class="cls5-23"
                points="1172 510.41 1132.35 510.04 1132.01 479.48 1171.56 479.48 1172 510.41"
              />
              <polygon
                class="cls5-23"
                points="1224.32 510.9 1177.91 510.47 1177.18 479.48 1223.79 479.48 1224.32 510.9"
              />
              <polygon
                class="cls5-24"
                points="1366 548.81 1365.46 608.7 630.61 609.24 1052.72 524.45 1052.73 524.45 1100.26 514.9 1100.27 514.9 1100.3 514.89 1119.18 511.1 1119.18 511.1 1123.39 510.26 1124.83 509.97 1126.36 509.98 1132.35 510.04 1172 510.41 1177.91 510.47 1224.32 510.9 1227.03 510.93 1230.22 510.96 1232.89 510.99 1232.95 510.99 1234.95 511 1239.32 511.04 1245.34 512.7 1247.91 513.41 1247.92 513.41 1249.18 513.76 1250.56 514.13 1269.37 519.31 1272.34 520.12 1272.35 520.12 1279.25 522.02 1366 548.81"
              />
              <path
                class="cls5-25"
                d="M1272.38,523l-1.07-73.21-44.74,22.93.5,41.27s5.55-.13,5.74-.06.19-37.71.19-37.71,12.41-5.93,12.41-5.39-.07,44.74-.07,44.74l2.59.71-.36-46,21.58-9.71.23,61.6Z"
              />
              <polygon
                class="cls5-13"
                points="1279.27 524.77 1278.86 449.81 1271.31 449.81 1272.39 523.19 1279.27 524.77"
              />
              <rect
                class="cls5-26"
                x="1127.25"
                y="469.23"
                width="104.13"
                height="6.47"
              />
              <path
                class="cls5-27"
                d="M937,395.88l-2.85.1h-.32l-2,.06-10,.35c-9.78.34-23.42.83-39.39,1.45l-5.39.21-12.95.52c-9.46.38-19.44.8-29.68,1.25l-5.39.24-7.82.35c-9.92.45-20,.94-30,1.44l-7.55.38-5.94.31c-9.19.48-18.24,1-27,1.51l-7,.42-6.76.43c-8.49.55-16.54,1.11-24,1.68l-5.71.45c-3.91.32-7.62.64-11.1,1-15.9,1.48-27.07,3-30.67,4.58V495.7h33.65l.88-69.06,10.79,3.23,17.14-.42.13-3.89-.53,21.61H703.21v19.42h7.08l16.75-.08-.48,19.77L710,485.67l-7.91-.25v10.39l18.14.94h.2l5.83.3h.11l6.3.33h.05L762.65,499l4,.2h0l1.64.09h.19l17.39.91h.1l2.45.13,1.17.06,16.4.85,6.15.32h0l12.41.64,7,.37,6.56.34H839l16.81.88,7,.36H863l10.12.53h.64l6,.31h.44l29.31,1.53,7.18.37h.18V421.21h14.64L931.35,432l-.84,75.7-7.37-.37,7.5.39h0l1.34.07,1,0,4.86.26V395.85ZM691.9,457.36H671.34V427.15a52.07,52.07,0,0,1,6.1-.87H678c6.06-.47,13.84-.7,13.84-.7ZM765,429.3l-.62,17.84H747.13l.25-17.81Zm-18.16,38.28,16.85-.12L763,488l-16.42-.73Zm59.46,21.85-18.9-.56.53-21.26h19Zm1.29-42.32H788.48l.48-19.43,19.28-.45Zm48.46,43.7H831.71l.25-21.59h24.56Zm.88-43.7h-24.7l.24-20.14.74.18,24.16-.19Zm52.74,45.66-29.55-.28V470.3H910Zm.76-45.66H880.16V426.77l1.06.38H910.8Z"
              />
              <path
                class="cls5-28"
                d="M737.1,392.07l-.22,12.84c-8.49.55-16.54,1.11-24,1.68V393.15Z"
              />
              <path
                class="cls5-28"
                d="M777.63,389.92v12.63c-9.19.48-18.24,1-27,1.51V391Z"
              />
              <path
                class="cls5-28"
                d="M821.26,388.57l-.19,11.85c-9.92.45-20,.94-30,1.44V389.38Z"
              />
              <path
                class="cls5-28"
                d="M864,386.68v11.9c-9.46.38-19.44.8-29.68,1.25V387.22Z"
              />
              <path
                class="cls5-28"
                d="M921.69,384.52V396.4c-9.78.34-23.42.83-39.39,1.45V385.6Z"
              />
              <path
                class="cls5-29"
                d="M678,495.67l259.87,21V508L795.45,500.7S691.15,494.59,678,495.67Z"
              />
              <path
                class="cls5-30"
                d="M691.85,425.53v31.83H678V426.23C684.07,425.76,691.85,425.53,691.85,425.53Z"
              />
              <path
                class="cls5-31"
                d="M678,426.23v31.13h-6.67V427.15a52.07,52.07,0,0,1,6.1-.87H678Z"
              />
              <path
                class="cls5-32"
                d="M691.63,447.22l-13.83.39s-3.43.58-4.51-1"
              />
              <path
                class="cls5-32"
                d="M691.63,449.38l-13.83.39s-3.43.58-4.51-1"
              />
              <path
                class="cls5-32"
                d="M691.63,451.54l-13.83.39s-3.43.57-4.51-1.05"
              />
              <path
                class="cls5-32"
                d="M691.63,453.16l-13.83.38s-3.43.58-4.51-1"
              />
              <path
                class="cls5-32"
                d="M691.63,454.78l-13.83.38s-3.43.58-4.51-1"
              />
              <polygon
                class="cls5-33"
                points="728 425.53 727.87 429.42 710.73 429.85 699.94 426.61 728 425.53"
              />
              <polygon
                class="cls5-33"
                points="765.22 423.91 765.04 429.3 747.42 429.3 733.93 425.53 765.22 423.91"
              />
              <polygon
                class="cls5-34"
                points="747.42 429.3 747.16 447.12 746.88 467.58 746.6 487.28 746.45 498.02 745.9 497.99 741.47 497.77 741.08 497.75 740.94 497.75 732.73 497.34 732.35 497.32 732.35 497.32 733.93 425.53 747.42 429.3"
              />
              <polygon
                class="cls5-33"
                points="808.39 422.29 808.24 427.23 788.96 427.69 771.16 423.91 808.39 422.29"
              />
              <path
                class="cls5-34"
                d="M789,427.68l-.48,19.43-.51,20.5-.53,21.26-.29,11.29v.06H785.9l-17.4-.73v-.26l1.8-50.61c.05-1.43.11-2.82.15-4.18,0-.82.06-1.61.09-2.4V438.9l.07-1.95a16.17,16.17,0,0,1,.07-1.86c0-1.29.09-2.5.13-3.61v-1.61c0-.85.06-1.61.08-2.3v-.73c.06-1.83.1-2.86.1-2.86Z"
              />
              <polygon
                class="cls5-33"
                points="857.49 421.21 857.37 426.96 833.21 427.15 832.47 426.97 814.86 422.83 857.49 421.21"
              />
              <polygon
                class="cls5-34"
                points="832.47 426.97 832.23 447.11 831.97 469.23 831.71 490.81 831.57 502.55 831.57 502.57 829.98 502.49 829.26 502.46 828.18 502.4 824.57 502.22 812.16 501.6 812.16 501.54 814.86 422.83 832.47 426.97"
              />
              <polygon
                class="cls5-33"
                points="910.9 421.21 910.8 427.15 881.22 427.15 880.16 426.77 864.5 421.21 910.9 421.21"
              />
              <polygon
                class="cls5-34"
                points="880.16 426.77 880.16 505.07 879.72 505.05 877.94 504.98 877.85 504.97 862.88 504.3 862.88 504.18 864.5 421.21 880.16 426.77"
              />
              <polygon
                class="cls5-34"
                points="703.18 447.11 703.18 466.53 710.25 466.5 710.01 485.67 702.1 485.42 702.1 495.81 699.4 495.67 699.06 495.67 699.94 426.61 710.73 429.85 710.51 447.12 703.18 447.11"
              />
              <line
                class="cls5-35"
                x1="710.01"
                y1="485.67"
                x2="709.87"
                y2="496.19"
              />
              <line
                class="cls5-35"
                x1="699.06"
                y1="495.88"
                x2="699.06"
                y2="495.67"
              />
              <polygon
                class="cls5-36"
                points="931.47 421.21 931.35 431.98 916.83 421.21 931.47 421.21"
              />
              <polygon
                class="cls5-37"
                points="728 425.53 727.47 447.14 710.51 447.12 710.73 429.85 727.87 429.42 728 425.53"
              />
              <polygon
                class="cls5-37"
                points="727.01 466.42 726.53 486.19 710.01 485.67 710.25 466.5 727.01 466.42"
              />
              <polygon
                class="cls5-37"
                points="765.04 429.3 764.42 447.14 747.16 447.12 747.42 429.3 765.04 429.3"
              />
              <polygon
                class="cls5-37"
                points="763.73 467.46 763.02 488.01 746.6 487.28 746.88 467.58 763.73 467.46"
              />
              <polygon
                class="cls5-37"
                points="808.24 427.23 807.63 447.11 788.48 447.11 788.96 427.69 808.24 427.23"
              />
              <polygon
                class="cls5-37"
                points="807 467.61 806.34 489.43 787.44 488.88 787.97 467.61 807 467.61"
              />
              <polygon
                class="cls5-37"
                points="857.37 426.96 856.97 447.11 832.23 447.11 832.47 426.97 833.21 427.15 857.37 426.96"
              />
              <polygon
                class="cls5-37"
                points="856.52 469.19 856.09 490.81 831.71 490.81 831.97 469.23 856.52 469.19"
              />
              <polygon
                class="cls5-37"
                points="910.8 427.15 910.47 447.11 880.16 447.11 880.16 426.77 881.22 427.15 910.8 427.15"
              />
              <polygon
                class="cls5-37"
                points="910.08 470.27 909.71 492.78 880.16 492.5 880.16 470.3 910.08 470.27"
              />
              <polyline
                class="cls5-35"
                points="931.47 421.21 933.38 421.21 933.86 421.21 934.96 421.21 936.5 421.21 937.88 421.21 937.88 422.64 937.88 433.62 936.27 433.62 933.74 433.62 933.56 433.62"
              />
              <polyline
                class="cls5-35"
                points="930.51 507.68 932.02 507.75 933.02 507.8 933.18 507.81 933.36 473.72 933.36 473.28 933.56 433.62 933.19 433.35 931.35 431.98"
              />
              <polyline
                class="cls5-35"
                points="916.83 506.98 916.83 506.99 916.83 507 921.5 507.23 921.68 507.24 922.65 507.29"
              />
              <polygon
                class="cls5-38"
                points="726.53 486.19 726.53 486.22 726.38 497.03 726.38 497.07 726.38 497.29 726.27 497.28 702.1 496.01 702.1 485.42 710.01 485.67 726.53 486.19"
              />
              <polygon
                class="cls5-38"
                points="763.03 488.01 762.65 498.87 762.65 498.96 741.47 497.77 741.08 497.75 740.94 497.75 740.94 487.04 746.6 487.28 763.02 488.01 763.03 488.01"
              />
              <polygon
                class="cls5-38"
                points="806.34 489.43 806.23 501.06 805.98 501.05 787.15 500.16 780.04 499.82 779.79 499.81 779.79 488.65 787.44 488.88 806.34 489.43"
              />
              <polygon
                class="cls5-38"
                points="856.09 490.81 855.87 503.76 855.83 503.76 839.02 502.94 838.13 502.89 831.57 502.57 829.98 502.49 829.26 502.46 828.18 502.4 824.57 502.22 824.57 490.81 856.09 490.81"
              />
              <polygon
                class="cls5-38"
                points="909.71 492.78 909.68 493.73 909.28 506.46 880.16 505.05 873.77 504.74 873.13 504.71 873.13 492.43 880.16 492.5 909.71 492.78"
              />
              <polygon
                class="cls5-20"
                points="1119.16 378.68 1119.16 387.22 1114.15 378.7 1113.91 378.28 1112.47 375.83 1112.46 375.83 1088.41 334.89 1089.11 373.94 1089.15 376.39 1091.32 497.51 1091.64 515.63 1084.09 515.63 1083.83 493.86 1083.83 493.85 1082.43 375.87 1082.41 373.39 1081.93 333.27 934.64 340.82 934.44 361.39 934.41 364.58 934.1 395.98 933.87 420.68 933.86 421.21 933.74 433.62 933.36 473.28 933.36 473.72 933.02 507.8 933.02 508.08 932.02 507.92 930.68 507.71 930.66 507.71 930.64 507.7 930.51 507.68 931.35 431.98 931.47 421.21 931.48 419.52 931.74 396.05 932.09 364.67 932.12 361.41 932.48 328.95 1086.79 318.16 1116.25 373.24 1117.88 376.28 1117.88 376.28 1119.16 378.68"
              />
              <polygon
                class="cls5-14"
                points="931.94 326.79 931.94 328.95 932.48 328.95 1086.79 318.16 1119.16 378.59 1119.16 376.97 1087.87 316 931.94 326.79"
              />
              <polygon
                class="cls5-27"
                points="1084.09 515.63 931.94 512.93 934.64 340.82 1081.93 333.27 1084.09 515.63"
              />
              <polygon
                class="cls5-39"
                points="1079.78 497.29 935.18 494.59 937.88 344.06 1077.62 335.43 1079.78 497.29"
              />
              <polygon
                class="cls5-27"
                points="1091.64 515.63 1123.36 512.92 1123.48 499.44 1093.47 498.56 1091.64 344.06 1119.16 390.46 1119.16 387.22 1088.41 334.89 1091.64 515.63"
              />
              <polygon
                class="cls5-40"
                points="886.62 508.08 886.62 516.71 1064.93 525.02 1123.48 512.93 1091.64 515.63 1084.09 515.63 886.62 508.08"
              />
              <polygon
                class="cls5-39"
                points="1119.97 499.72 1118.85 389.94 1091.38 343.79 1093.53 498.64 1119.97 499.72"
              />
              <polygon
                class="cls5-13"
                points="1250.79 468.86 1250.54 517.52 1247.93 516.44 1247.84 470.04 1250.79 468.86"
              />
              <polygon
                class="cls5-13"
                points="1232.73 513.74 1234.89 513.74 1235.75 474.94 1232.73 513.74"
              />
              <polygon
                class="cls5-38"
                points="727.47 447.14 727.01 466.42 710.25 466.5 703.18 466.53 703.18 447.11 710.51 447.12 727.47 447.14"
              />
              <polygon
                class="cls5-38"
                points="764.42 447.14 763.73 467.46 746.88 467.58 742.56 467.61 742.56 447.11 747.16 447.12 764.42 447.14"
              />
              <polygon
                class="cls5-38"
                points="807.63 447.11 807.47 452.36 807 467.61 781.41 467.61 781.41 447.11 807.63 447.11"
              />
              <polygon
                class="cls5-38"
                points="856.97 447.11 856.52 469.19 831.97 469.23 825.65 469.23 825.65 447.11 856.97 447.11"
              />
              <polygon
                class="cls5-38"
                points="910.47 447.11 910.08 470.27 880.16 470.3 874.21 470.31 874.21 447.11 910.47 447.11"
              />
              <polygon
                class="cls5-41"
                points="931.35 431.98 930.51 507.68 923.14 507.31 922.92 507.3 922.65 507.29 916.83 506.98 916.83 421.21 931.35 431.98"
              />
              <line
                class="cls5-42"
                x1="709.98"
                y1="473.01"
                x2="726.65"
                y2="473.01"
              />
              <line
                class="cls5-42"
                x1="714.12"
                y1="466.54"
                x2="714.31"
                y2="485.42"
              />
              <line
                class="cls5-42"
                x1="726.18"
                y1="480.03"
                x2="714.31"
                y2="480.03"
              />
              <line
                class="cls5-42"
                x1="751.79"
                y1="467.62"
                x2="751.79"
                y2="487.53"
              />
              <line
                class="cls5-42"
                x1="746.58"
                y1="474.86"
                x2="763.28"
                y2="474.86"
              />
              <line
                class="cls5-42"
                x1="762.87"
                y1="481.65"
                x2="751.79"
                y2="481.65"
              />
              <line
                class="cls5-42"
                x1="717.82"
                y1="392.93"
                x2="717.82"
                y2="406.21"
              />
              <line
                class="cls5-42"
                x1="729.96"
                y1="393.16"
                x2="729.96"
                y2="405.36"
              />
              <line
                class="cls5-42"
                x1="736.82"
                y1="397.4"
                x2="712.69"
                y2="398.33"
              />
              <line
                class="cls5-42"
                x1="755.39"
                y1="390.81"
                x2="755.39"
                y2="403.78"
              />
              <line
                class="cls5-42"
                x1="767.31"
                y1="390.33"
                x2="767.31"
                y2="403.1"
              />
              <line
                class="cls5-42"
                x1="777.44"
                y1="395.32"
                x2="750.46"
                y2="396.72"
              />
              <line
                class="cls5-42"
                x1="795.17"
                y1="389.27"
                x2="795.17"
                y2="401.65"
              />
              <line
                class="cls5-42"
                x1="809.15"
                y1="388.9"
                x2="809.15"
                y2="400.98"
              />
              <path class="cls5-42" d="M821,394.17c-.37.07-30,1.29-30,1.29" />
              <line
                class="cls5-42"
                x1="840.02"
                y1="387.23"
                x2="840.02"
                y2="399.58"
              />
              <line
                class="cls5-42"
                x1="854.36"
                y1="387.23"
                x2="854.36"
                y2="398.97"
              />
              <line
                class="cls5-42"
                x1="863.76"
                y1="393.16"
                x2="834.09"
                y2="394.17"
              />
              <line
                class="cls5-42"
                x1="887.5"
                y1="385.46"
                x2="887.5"
                y2="397.65"
              />
              <line
                class="cls5-42"
                x1="882.11"
                y1="391.56"
                x2="921.49"
                y2="390.46"
              />
              <line
                class="cls5-42"
                x1="912.86"
                y1="384.77"
                x2="912.86"
                y2="396.71"
              />
              <line
                class="cls5-42"
                x1="716.05"
                y1="429.71"
                x2="716.05"
                y2="447.15"
              />
              <path class="cls5-42" d="M727.56,435.59c-.84.19-17.1,0-17.1,0" />
              <line
                class="cls5-42"
                x1="716.05"
                y1="441.8"
                x2="727.41"
                y2="441.8"
              />
              <line
                class="cls5-42"
                x1="752.43"
                y1="429.31"
                x2="752.43"
                y2="447.12"
              />
              <line
                class="cls5-42"
                x1="764.65"
                y1="434.82"
                x2="747.22"
                y2="434.82"
              />
              <line
                class="cls5-42"
                x1="764.43"
                y1="441.45"
                x2="752.43"
                y2="441.45"
              />
              <line
                class="cls5-42"
                x1="794.32"
                y1="427.56"
                x2="794.32"
                y2="447.12"
              />
              <line
                class="cls5-42"
                x1="807.83"
                y1="434.2"
                x2="788.61"
                y2="434.2"
              />
              <line
                class="cls5-42"
                x1="807.75"
                y1="441.45"
                x2="794.32"
                y2="441.45"
              />
              <line
                class="cls5-42"
                x1="792.87"
                y1="467.62"
                x2="792.87"
                y2="489.05"
              />
              <line
                class="cls5-42"
                x1="806.55"
                y1="476.14"
                x2="787.56"
                y2="476.14"
              />
              <line
                class="cls5-42"
                x1="806.33"
                y1="483.23"
                x2="792.87"
                y2="483.23"
              />
              <line
                class="cls5-42"
                x1="886.54"
                y1="427.15"
                x2="886.54"
                y2="447.12"
              />
              <line
                class="cls5-42"
                x1="879.97"
                y1="433.13"
                x2="910.51"
                y2="433.13"
              />
              <line
                class="cls5-42"
                x1="838.44"
                y1="427.11"
                x2="838.44"
                y2="447.12"
              />
              <line
                class="cls5-42"
                x1="832.27"
                y1="434.2"
                x2="857.03"
                y2="434.2"
              />
              <line
                class="cls5-42"
                x1="838.44"
                y1="440.68"
                x2="856.9"
                y2="440.68"
              />
              <line
                class="cls5-42"
                x1="852.32"
                y1="427"
                x2="852.32"
                y2="447.12"
              />
              <path class="cls5-42" d="M837.37,469.24v21.58" />
              <line
                class="cls5-42"
                x1="850.16"
                y1="469.24"
                x2="850.16"
                y2="490.82"
              />
              <line
                class="cls5-42"
                x1="856.16"
                y1="477.37"
                x2="831.67"
                y2="477.37"
              />
              <line
                class="cls5-42"
                x1="856.02"
                y1="484.46"
                x2="837.37"
                y2="484.46"
              />
              <line
                class="cls5-42"
                x1="886.54"
                y1="440.68"
                x2="910.51"
                y2="440.68"
              />
              <line
                class="cls5-42"
                x1="885.46"
                y1="470.3"
                x2="885.35"
                y2="492.44"
              />
              <line
                class="cls5-42"
                x1="879.97"
                y1="478.76"
                x2="909.62"
                y2="478.95"
              />
              <line
                class="cls5-42"
                x1="904.11"
                y1="427.11"
                x2="904.11"
                y2="447.12"
              />
              <line
                class="cls5-42"
                x1="901.96"
                y1="470.32"
                x2="901.96"
                y2="492.71"
              />
              <line
                class="cls5-42"
                x1="885.46"
                y1="486"
                x2="909.89"
                y2="485.96"
              />
              <line
                class="cls5-43"
                x1="936.94"
                y1="385.46"
                x2="1078.03"
                y2="381.29"
              />
              <line
                class="cls5-43"
                x1="993.55"
                y1="340.61"
                x2="992.17"
                y2="495.67"
              />
              <line
                class="cls5-43"
                x1="1001.84"
                y1="340.1"
                x2="1001.84"
                y2="495.84"
              />
              <line
                class="cls5-43"
                x1="1009.89"
                y1="339.6"
                x2="1009.98"
                y2="495.67"
              />
              <line
                class="cls5-43"
                x1="1018.5"
                y1="339.07"
                x2="1021.31"
                y2="495.67"
              />
              <line
                class="cls5-43"
                x1="1009.89"
                y1="361.82"
                x2="1077.74"
                y2="359.27"
              />
              <line
                class="cls5-43"
                x1="936.94"
                y1="364.57"
                x2="1001.84"
                y2="362.13"
              />
              <line
                class="cls5-43"
                x1="1001.84"
                y1="366.13"
                x2="937.68"
                y2="368.54"
              />
              <line
                class="cls5-43"
                x1="1077.74"
                y1="363.29"
                x2="1009.89"
                y2="365.83"
              />
              <line
                class="cls5-43"
                x1="1001.84"
                y1="371.05"
                x2="937.16"
                y2="373.2"
              />
              <line
                class="cls5-43"
                x1="1077.74"
                y1="368.54"
                x2="1009.93"
                y2="370.79"
              />
              <line
                class="cls5-43"
                x1="1001.84"
                y1="375.1"
                x2="937.1"
                y2="376.71"
              />
              <line
                class="cls5-43"
                x1="1078.03"
                y1="373.2"
                x2="1009.89"
                y2="374.89"
              />
              <line
                class="cls5-43"
                x1="1009.98"
                y1="378.92"
                x2="1077.97"
                y2="376.71"
              />
              <line
                class="cls5-43"
                x1="937.1"
                y1="381.29"
                x2="1001.84"
                y2="379.18"
              />
              <line
                class="cls5-43"
                x1="936.58"
                y1="405.3"
                x2="1078.31"
                y2="401.79"
              />
              <line
                class="cls5-43"
                x1="1067.53"
                y1="336.04"
                x2="1070.29"
                y2="497.12"
              />
              <line
                class="cls5-43"
                x1="1009.89"
                y1="343.83"
                x2="1077.49"
                y2="340.61"
              />
              <line
                class="cls5-43"
                x1="937.14"
                y1="347.3"
                x2="1001.84"
                y2="344.22"
              />
              <path
                class="cls5-43"
                d="M1010,422.29c17.68.15,35.34-.74,53-1,5-.08,10-.11,14.94,0"
              />
              <path class="cls5-43" d="M935,423.37c22.39-.81,45-.81,67.15-1" />
              <path
                class="cls5-43"
                d="M1002.35,426.15c-22.32.19-43.9.19-66.16,1"
              />
              <path
                class="cls5-43"
                d="M1078.5,425c-17.78-.21-35.56.38-53.33.77q-7.65.18-15.3.28"
              />
              <path
                class="cls5-43"
                d="M1001.78,430.39c-21.75-.81-43.87.81-65.59,0"
              />
              <path
                class="cls5-43"
                d="M1078.5,430.39c-22.39.27-45.59.27-68.45,0"
              />
              <path
                class="cls5-43"
                d="M1001.87,433.69c-21.84.74-44-.87-65.8.51"
              />
              <path
                class="cls5-43"
                d="M1078.5,433.09c-22.39.27-45.59.27-68.39.53"
              />
              <path
                class="cls5-43"
                d="M1002.06,438.48c-22,.27-44.15.27-66.07,0"
              />
              <path
                class="cls5-43"
                d="M1078.5,438.48c-22.93.27-45.59.27-68.52,0"
              />
              <line
                class="cls5-43"
                x1="1079.58"
                y1="443.76"
                x2="935.89"
                y2="443.76"
              />
              <line
                class="cls5-43"
                x1="934.98"
                y1="463.3"
                x2="1079.14"
                y2="464.52"
              />
              <line
                class="cls5-43"
                x1="934.98"
                y1="485.96"
                x2="1001.84"
                y2="487.23"
              />
              <line
                class="cls5-43"
                x1="1001.84"
                y1="490.82"
                x2="934.98"
                y2="490.82"
              />
              <polyline
                class="cls5-43"
                points="1079.14 492.44 1021.22 490.82 1009.87 490.82"
              />
              <line
                class="cls5-43"
                x1="969.51"
                y1="463.3"
                x2="968.97"
                y2="494.06"
              />
              <polyline
                class="cls5-43"
                points="1009.87 487.24 1021.31 487.24 1079.04 488.12"
              />
              <line
                class="cls5-43"
                x1="1091.74"
                y1="368.54"
                x2="1118.97"
                y2="405.57"
              />
              <line
                class="cls5-43"
                x1="1091.74"
                y1="372.08"
                x2="1118.97"
                y2="408.27"
              />
              <line
                class="cls5-43"
                x1="1091.74"
                y1="374.89"
                x2="1118.97"
                y2="410.97"
              />
              <line
                class="cls5-43"
                x1="1091.74"
                y1="379.13"
                x2="1118.97"
                y2="413.66"
              />
              <line
                class="cls5-43"
                x1="1091.74"
                y1="383.38"
                x2="1118.97"
                y2="416.36"
              />
              <line
                class="cls5-43"
                x1="1091.96"
                y1="387.23"
                x2="1118.97"
                y2="419.6"
              />
              <line
                class="cls5-43"
                x1="1092.2"
                y1="407.23"
                x2="1118.97"
                y2="435.79"
              />
              <line
                class="cls5-43"
                x1="1092.42"
                y1="426.04"
                x2="1118.97"
                y2="449.81"
              />
              <line
                class="cls5-43"
                x1="1092.47"
                y1="430.39"
                x2="1118.97"
                y2="453.05"
              />
              <line
                class="cls5-43"
                x1="1092.42"
                y1="433.62"
                x2="1118.97"
                y2="455.75"
              />
              <line
                class="cls5-43"
                x1="1092.57"
                y1="438.69"
                x2="1118.97"
                y2="457.91"
              />
              <line
                class="cls5-43"
                x1="1092.62"
                y1="442.62"
                x2="1118.97"
                y2="460.6"
              />
              <line
                class="cls5-43"
                x1="1092.67"
                y1="447.24"
                x2="1118.97"
                y2="463.3"
              />
              <line
                class="cls5-43"
                x1="1092.91"
                y1="467.12"
                x2="1118.97"
                y2="479.49"
              />
              <line
                class="cls5-43"
                x1="1093.19"
                y1="490.82"
                x2="1118.97"
                y2="494.6"
              />
              <line
                class="cls5-43"
                x1="1093.23"
                y1="494.6"
                x2="1118.97"
                y2="497.29"
              />
              <line
                class="cls5-43"
                x1="1105.35"
                y1="367.51"
                x2="1106.1"
                y2="498.94"
              />
              <line
                class="cls5-43"
                x1="1108.37"
                y1="498.94"
                x2="1108.06"
                y2="372.08"
              />
              <line
                class="cls5-43"
                x1="1110.19"
                y1="375.67"
                x2="1110.19"
                y2="499.06"
              />
              <line
                class="cls5-42"
                x1="1151.22"
                y1="438.42"
                x2="1151.22"
                y2="469.24"
              />
              <line
                class="cls5-42"
                x1="1171.08"
                y1="459.48"
                x2="1131.38"
                y2="459.53"
              />
              <line
                class="cls5-42"
                x1="1131.62"
                y1="462.11"
                x2="1171.08"
                y2="462.11"
              />
              <line
                class="cls5-42"
                x1="1131.65"
                y1="464.52"
                x2="1171.16"
                y2="464.52"
              />
              <line
                class="cls5-42"
                x1="1131.68"
                y1="467.12"
                x2="1171.19"
                y2="467.12"
              />
              <line
                class="cls5-42"
                x1="1176.7"
                y1="459.48"
                x2="1223.27"
                y2="459.48"
              />
              <line
                class="cls5-42"
                x1="1176.58"
                y1="462.11"
                x2="1223.31"
                y2="462.11"
              />
              <line
                class="cls5-42"
                x1="1176.58"
                y1="464.52"
                x2="1223.35"
                y2="464.52"
              />
              <line
                class="cls5-42"
                x1="1176.58"
                y1="467.12"
                x2="1223.27"
                y2="467.12"
              />
              <line
                class="cls5-42"
                x1="1199.36"
                y1="437.94"
                x2="1199.94"
                y2="469.24"
              />
              <line
                class="cls5-42"
                x1="1131.38"
                y1="421.51"
                x2="1170.22"
                y2="421.76"
              />
              <line
                class="cls5-42"
                x1="1131.38"
                y1="423.38"
                x2="1170.57"
                y2="423.38"
              />
              <line
                class="cls5-42"
                x1="1131.38"
                y1="426.04"
                x2="1170.57"
                y2="426.04"
              />
              <line
                class="cls5-42"
                x1="1131.38"
                y1="428.96"
                x2="1170.65"
                y2="428.96"
              />
              <line
                class="cls5-42"
                x1="1131.38"
                y1="431.43"
                x2="1170.22"
                y2="431.47"
              />
              <line
                class="cls5-42"
                x1="1175.66"
                y1="423.38"
                x2="1222.56"
                y2="423.38"
              />
              <line
                class="cls5-42"
                x1="1175.66"
                y1="426.04"
                x2="1222.56"
                y2="425.53"
              />
              <line
                class="cls5-42"
                x1="1175.77"
                y1="428.59"
                x2="1222.74"
                y2="428.59"
              />
              <line
                class="cls5-42"
                x1="1175.85"
                y1="431.43"
                x2="1222.56"
                y2="431.47"
              />
              <line
                class="cls5-42"
                x1="1198.61"
                y1="412.5"
                x2="1199.15"
                y2="433.09"
              />
              <line
                class="cls5-42"
                x1="1150.36"
                y1="397.17"
                x2="1150.8"
                y2="433.09"
              />
            </g>
            <g id="capa_superior" data-name="capa superior">
              <rect class="cls5-44" width="1366" height="768" />
            </g>
            <g id="mapa">
              <path
                class="cls5-45"
                d="M1320.79,406.37c1.07.16,2.28.08,2.21,1.76-.06,1.36-.91,1.47-2,1.54-1.29.09-2.24-.16-2.15-1.71C1319,406.81,1319.56,406.18,1320.79,406.37Z"
              />
              <path
                class="cls5-46"
                d="M1316.14,408h-36.42c3.34,5.68,8.63,9.42,11.69,14.83l-.62.32c-2.55-.46-4-2.45-5.4-4.24-2.09-2.57-4.43-4.92-6.65-7.37a6.38,6.38,0,0,0-3.8-2.28c-7-1.19-8.2-.13-8.28,6.94-.13,9.92.4,19.85-.3,29.77a3,3,0,0,1-.74,1.24,1.72,1.72,0,0,1-2.33-.65,1.59,1.59,0,0,1-.12-.27,7.55,7.55,0,0,1-.51-2.9c-.2-9.13,0-18.27-.14-27.4,0-2.19,1.12-5.25-1.7-6.26s-6-1.22-8.65,1a2.79,2.79,0,0,1-1.47.69c-1.71-1.79-1.29-3.52.16-5.21,2.21-1.53,4.75-1,7.18-1.07,4.32-.15,4.58-.36,4.64-4.79,0-3.7-.06-7.41.07-10.94-2.85,3.62-5.36,7.94-11,8a1.59,1.59,0,0,1-.8-1.54c1.73-1.86,1.76-5.12,5.91-5,1.87.05,3.61-3.53,3.18-6.46-.16-1.07-1-2-.82-3.17a1.93,1.93,0,0,1,1.07-1.29c3.19-2.86,1.44-6,.45-9.05-.61-1.45-2-2.31-2.79-3.63-4.35-6.13-12-8.16-19.1-5.1-1.63.7-3,2-4.89,2.14a1.48,1.48,0,0,1-1.07-.61c2.14-5,6.81-6,11.34-6.63,5.16-.69,9.63,1.53,13.58,4.76a16.78,16.78,0,0,1,1.26,1.27,19.39,19.39,0,0,0,2.06,1.89,4.48,4.48,0,0,1,1,1.32,29.17,29.17,0,0,1,1.57,3.23c.11-2-.67-4,.89-5.69h.75l.21,8.27a13.74,13.74,0,0,1,.84,1.93c.49,3,.18,6,.26,9v1.34a30.8,30.8,0,0,0,.41,5.25,5.83,5.83,0,0,1-.1,1.32c-.6,3.24,0,6.52-.28,9.77s1,4.62,4.2,4.33c1.35-.13,2.72,0,4.08-.06a13.24,13.24,0,0,1,2.08-.23c7.89.4,15.79,0,23.67.25,3.65.13,6.26-3.1,9.91-2.52,1.88,0,3.73.31,5.61.41A3.72,3.72,0,0,1,1316.14,408Z"
              />
              <path
                class="cls5-47"
                d="M1213.25,398c.81,2.67.65,5.43.77,8.17,1,2.06.36,3-1.91,3a6.81,6.81,0,0,1-2-.33c-1.3-.6-2.22-1.71-.89-2.73,2.22-1.72,1.84-4.38,3-6.46.11-.54.22-1.08.34-1.63A3.19,3.19,0,0,0,1213.25,398Z"
              />
              <path
                class="cls5-48"
                d="M1164.94,353.83h1.76l.69.24.81,1.44-.91.31h-2.14a4,4,0,0,1-2.65,1,5,5,0,0,1-3.63-3.19c0-.82.63-1.24,1.13-1.74a1.83,1.83,0,0,1,1.42-.54C1162.19,352.72,1163,354.08,1164.94,353.83Z"
              />
              <path
                class="cls5-49"
                d="M1193.17,604.28l-2.37.05-1.73-.87c-1.43-1.43-3.65-.15-5.1-1.5-1-2.61,1.63-4.59,1.19-7.1.7-1.27,1.4-2.55,3.1-2.66,2.18.3,3.36,1.37,2.84,3.73-.22,1.73,0,3.31,1.51,4.47,1.52,1,3.21,1.81,4.21,3.53A3.33,3.33,0,0,1,1193.17,604.28Z"
              />
              <path
                class="cls5-50"
                d="M1209.79,610.88c-.71-1.07,2.2-3-.83-3.51,0-1,.84-1.87,1.38-1.76,3.11.63,5.32-1.42,7.9-2.35.73,1.66,2.72,3.11.87,5.2-1.6.8-3.61-1.19-5,.76.34.61.42,1.19-.27,1.64l-3.35.2A3.78,3.78,0,0,1,1209.79,610.88Z"
              />
              <path
                class="cls5-51"
                d="M1234.31,365.58c-4.94,1.17-4.6,5.77-6,9.25.41,3.19-.27,6.55,1.75,9.5a3.25,3.25,0,0,1-.07,3.54c-4.07,0-3.08-3.41-3.86-5.64.23-2.77-.53-5.58.28-8.34,2-3.48,2.66-7.83,6.58-10l1.26.11C1234.28,364.5,1234.3,365,1234.31,365.58Z"
              />
              <path
                class="cls5-52"
                d="M1226.42,373.89a19.91,19.91,0,0,1,.63,8.44c-2.4-.87-1.13-2.88-1.24-3.92-2.45,4.78-4.43,10.27-8.6,14.52l-2.44,2.55c1.92-6.38,6-11.62,9-17.49A39.27,39.27,0,0,1,1226.42,373.89Z"
              />
              <path
                class="cls5-47"
                d="M1248.74,406.33l-.12,7.53c-1.73.72-2-.75-1.94-1.66.12-3.48-2.07-3.41-4.47-3.16h-2.37a32.46,32.46,0,0,1-5.49.06c-1,0-2.11-.06-3.17,0h-6.62a58,58,0,0,1-6.85-.2c-1.23-.48-2.86-.54-2.74-2.5,2.79.34,3.52-2.18,5.13-3.89,1,1.43-.94,2.19-.43,3.56h14.88c2.37-1.5,5-.95,7.55-1C1244.35,405.17,1246.76,404.58,1248.74,406.33Z"
              />
              <path
                class="cls5-53"
                d="M1222.31,393.93c3.53-4.9,3.53-4.9,9.83-.67a22,22,0,0,1-1.71,2.77c-1,1.19-1.65,3.86-3.23,3.08C1225.19,398.11,1222,397.45,1222.31,393.93Z"
              />
              <path
                class="cls5-54"
                d="M1214.94,406.42l2.52,1.68c-1.3,2.58.16,5.48-.91,8.09-2.35,1.45-1.13,4-1.89,6a2.17,2.17,0,0,1-.78.94,1.39,1.39,0,0,1-1.13-.54c-1-1.64-.7-3.59-1.37-5.3-.2-3.15-1.1-6.38.93-9.31,2.11.86,1.6-.77,1.71-1.81Z"
              />
              <path
                class="cls5-55"
                d="M1242.26,406.17l-7.74-.08c-.27-.4-.55-.79-.83-1.18a1.45,1.45,0,0,1,.69-.86c2.44-.66,4.54-1.72,5.19-4.46a2.78,2.78,0,0,1,1-.61c1-.15,2.67.33,2.44.71C1241.75,401.81,1244.23,404.27,1242.26,406.17Z"
              />
              <path
                class="cls5-55"
                d="M1233.69,404.91c-3.76-1.31-2.62-3.7-1.34-6.19,1.57-.54,1.92,2.87,3.56,1.26,1.16-1.14.46-2.83.36-4.3,4,.79,4.14,1,2,4.39-.69,2.16-3.75,2.05-4.22,4.43Z"
              />
              <path
                class="cls5-56"
                d="M1237.43,399.77c1-1.75,2-3.51-1.16-4.09a1.34,1.34,0,0,1-.73-1.42l6.67,2a1.2,1.2,0,0,1,.94.93v.89c-.78,1-2.24.57-3.05,1.48l-.61.13a1.4,1.4,0,0,1-2,.16Z"
              />
              <path
                class="cls5-57"
                d="M1238.91,582.65l-.05,1c-1.43,3.59,3,2.13,3.53,4.49-2.89-1.51-3.82-.74-3.59,2.49.44,6.44-.54,7.1-7.14,6.09-2-.3-4-1.16-6.07-.83-2.21.78-4.1-.39-6.08-1-.32-3.2,2.49-1.27,3.56-2.19,4.88.83,9.73,2,14.59,1.38-.94-8.47-2-17-2.8-25.54-.18-1.88-1.1-3.36-1.81-5l1.82-.71a4.73,4.73,0,0,1,2,3.77c-.17-1.27.62-2.64,1.94-3.78l1.59.52.25.18a7.57,7.57,0,0,1-3.34,5.8c-1.25.93-.76,2.25-.76,3.46C1238.72,575.73,1238.68,579.23,1238.91,582.65Z"
              />
              <path
                class="cls5-58"
                d="M1231.24,561.66a3.75,3.75,0,0,0,0-.82c-.56-2.57-4.41-4.67-2.48-7.23a17.78,17.78,0,0,1,10-6.57l6.78,10a8.74,8.74,0,0,0,4.17,3.12q.43.18.3.39t-.27.21a1.61,1.61,0,0,1-2,.89c-3.51-1.71-5.28-5-7.39-8a11.56,11.56,0,0,0-1.94-2.62c-1.23-1-2.29-.43-3.28.43s-.51,1.62.29,2.35,1.51,1.27.93,2.42c-1.48.76-2.49-.36-3.83-.94,2,1.29,4.21,2,6.06,3.31.83.57,2.53.74,1.71,2.51l-1.65.58c-1.3-.75-3-.79-4.09-1.79-2.63-2.33-1,1-1.63,1.19Z"
              />
              <path
                class="cls5-59"
                d="M1228.88,562.6a2.2,2.2,0,0,1-.76.16c-1.35,1.11-3,1-4.57,1.06-1.92,0-4,.94-5.66-.76-1.9-2.4-2.84-4.78.19-7a4.23,4.23,0,0,1,2.4-1.85,7.5,7.5,0,0,1,2.45-.22,2.12,2.12,0,0,1,2.21,2c.08,1.29-.77,2-2.08,2-.54,0-1.16-.18-1.62.11-.88.54-.35,1.14.09,1.65.23.26.49.6,1,.33,3.21-1.84,3.21-1.84,4.85,1.56l1.53.23A4.46,4.46,0,0,1,1228.88,562.6Z"
              />
              <path
                class="cls5-60"
                d="M1257.17,559.36c.4-2.79,3.15-4.2,3.95-6.74.93-1,1.22-2.66,2.78-3.15,0,3,1.95,6,0,9.1-1.22-.91-1-2.32-1-4.24a3.56,3.56,0,0,0,1,4.3c-.22,1.06.53,2.45-1,3.06-1.71-1.26-4-1.24-5.72-2.36Z"
              />
              <path
                class="cls5-61"
                d="M1245.62,530.89a1.38,1.38,0,0,1,.8-1.52l17.35,14v1.79c-1.82-.85-2.78-2.91-4.82-3.47a18.51,18.51,0,0,1-4.33-3C1252.27,535.36,1248.73,533.38,1245.62,530.89Z"
              />
              <path
                class="cls5-62"
                d="M1301.23,505.38a3.18,3.18,0,0,1-2.45-1.06,3.31,3.31,0,0,1,0-.77c1.71-.72.37-4.11,2.36-3.67s.55,3,.94,4.62Z"
              />
              <path
                class="cls5-63"
                d="M1271.48,502.17a1.8,1.8,0,0,1,1.53-1.86c1.73.88,2.14,2.3,1.67,4.09-1.47,1.64-4.29,2.69-2.49,5.75l-5.93-.11c-.21-2.48,1.38-3.69,3.29-4.68C1270.52,504.49,1272.24,504.09,1271.48,502.17Z"
              />
              <path
                class="cls5-64"
                d="M1263.73,515.19a4.44,4.44,0,0,0,.92-3.18c1.77-1.63,3.9-.64,5.87-.81-2.26,2.08-3.15,5.09-5,7.44A4.7,4.7,0,0,0,1263.73,515.19Z"
              />
              <path
                class="cls5-65"
                d="M1269.63,496.91c-4.29.12-3.65,3-3.16,5.73-.32.9-1,1-1.87,1a6.06,6.06,0,0,1-.79-5V498C1265.41,495.64,1267.08,493.82,1269.63,496.91Z"
              />
              <path
                class="cls5-66"
                d="M1057,462.8a2.14,2.14,0,0,0-1.68-1.68l-.91-.91c.21-3.76,2.54-2,4-1.28,2.35,1.27,4.24,3.32,6.88,4.15,1.4.86,2.91,1.62,3.8,3.07.47.78,1.11,1.85-.72,1.84-3.65-1.2-6.35-4.42-10.34-4.89Z"
              />
              <path
                class="cls5-67"
                d="M1179.85,604.69c-.27,1.58-1.17,2.65-2.72,2.68a2.19,2.19,0,0,1-2.52-1.8,2.16,2.16,0,0,1,0-.76c.12-1.6,1-2.7,2.54-2.73S1179.56,603.2,1179.85,604.69Z"
              />
              <path
                class="cls5-68"
                d="M1205.79,604.22l1.58,2.42a47.59,47.59,0,0,1-14.2-2.36l3.07-.18-4.72-3.19a4.47,4.47,0,0,1,2.5-2c1.34,1.26,1.53-1.06,2.54-.82s1.74.69,1.85,1.8c-.73,1.12-.94,2.15.53,2.88C1201.05,604.14,1203.48,603.88,1205.79,604.22Z"
              />
              <path
                class="cls5-69"
                d="M1189.79,596.53c3.07-1.72,2.94,1.74,4.35,2.7a2.46,2.46,0,0,1-2.62,1.68A5.64,5.64,0,0,1,1189.79,596.53Z"
              />
              <path
                class="cls5-70"
                d="M1187.49,591.33c.22.48.43.95.64,1.43-1.3.33-1.48,1.79-2.45,2.46-1.84.86-2.32-.26-2.53-1.76a.84.84,0,0,1,.07-1.16A6.25,6.25,0,0,1,1187.49,591.33Z"
              />
              <path
                class="cls5-71"
                d="M960.62,303.2c1.73.1,3.13,1.19,3.09,2.68-.08,3.46,2.08,3.18,4.29,3.11,1.58-.54,2,.69,2.52,1.68h0c2.47.84,3.77,2.85,5,5,.47,2,.75,3.78,3.72,3.8,1.45,0,3.51,1.41,1.31,4-2.06,2.4-4.92,4.47-5.07,8.12-3.45,4.49-6.84,9-9.9,13.79-2.11,1.85-2.79,5-5.73,6.11-1.74-.37-.73,1.75-1.77,2a3.17,3.17,0,0,1-1.5,0,1.13,1.13,0,0,1-.41-1c3.5-5-2-4.84-3.88-6.77.74-1.23,2.36-.25,3.36-1.43-1.48-2.06-1.35-4.4-.75-6.79.81-2.66,1.71-5.25,4.67-6.36a2,2,0,0,0,1.36-2.27,4.18,4.18,0,0,1,1.64-3.59c1.77-1.37,3.19-1.16,4.34,1.74-.71-2.9-2.77-3.07-4.23-4a1.73,1.73,0,0,1-.65-1c.69-1.59,2-1.74,3.43-1.33.83-.06,1.68-.1,2-1.07-2.07-.49-1.56-2.81-2.87-4.15-3-3-8.4-3.72-9.06-9-1.89-1.56-1.87-2.58.81-2.88C957.77,303.46,959.26,304,960.62,303.2Z"
              />
              <path
                class="cls5-72"
                d="M834.36,271.44l-1.81-.09a2.4,2.4,0,0,1-1.69-1.94c-.61-7.78,2-11.6,10-14.16a26.26,26.26,0,0,1,8.45-1.65c2.5,2.42-.41,3.74-.86,5.24-.67.65.2.9-.26.6,1.6-2.17,4.42-3.4,5-6.39a3.24,3.24,0,0,1,3.06-1.31,9.85,9.85,0,0,0,2.31-.79c2.9-.8,5-.25,5.53,3.18l-1.57,4c4.51-3.23,10-1.15,13.11-6,.93-1.43,2.73-.32,3.6,1.19.68,1,.23,2.25-.57,2.4-2.53.48-4.38,2.62-7,2.64-2.68.58-5.69-.23-8,2.09-.58.58-1.53.09-1.9-.9-.16-.42-.53-1.77-1-.3-.86,2.42-1.59,1.64-2.53.12-.54-.87-1-2.48-2.31-1.59s-.09,1.68.64,2.54c2.73,3.2-3.29,1.27-2.18,3.62-.62,1.53-2.37,1.55-3.39,2.54-1.12,1.81-3.53,2.53-4.74,2-2.91-1.29-4.29-.39-5.61,2-.93,1.71-2.24,2.33-3.94.68a1.44,1.44,0,0,0-2-.13A1.57,1.57,0,0,0,834.36,271.44Z"
              />
              <path
                class="cls5-73"
                d="M924.66,269.18c1.14,3.64,5.23,4.26,7.28,7.19s6.31,4.62,6.38,9.34c0,1.78,1.82,2.55,3.7,2.54,2.84,0,5.23.95,6.05,3.9.64,2.29,3.57,1.48,4.23,3.53-.42.69-1.16,1.14-1.43,1.95-.49,1.52-1.3,2.94-3.11,2.56a3.44,3.44,0,0,1-2.59-3.33c-.1-3.79-2.13-4.87-5.49-4.48a5,5,0,0,0-3.82-3.35c-1.88-.51-4-1.17-4.44-3.58-.25-1.27-1.21-1.29-2.2-1.38-.79-.08-2-.16-1.49-1.3,1.47-3.18-1.32-2.27-2-1.81-4,2.62-4.76,1.2-4.27-2.89.12-1,1.45-2.8-.8-3.44-.3-1.83.63-3.3,1.39-4.82A2.24,2.24,0,0,1,924.66,269.18Z"
              />
              <path
                class="cls5-74"
                d="M955.55,337.32c.21,2.13-.75,4.31,1.27,6.33,1,1,.73,3-1.8,2.51-.92-.18-1.84-.33-2.76-.49-2.47-1.48-4.34-.57-5.9,1.51a.8.8,0,0,1-1,.18c-2.42-1.79-2.19-4.75-3-7.72-1.51,2.48.55,4.71-.7,6.67-1.41.77-1.71-.42-2.21-1.25a1.23,1.23,0,0,1,.3-1.13c-.41-3.38-1.18-6.76,0-10.15.27-.79.34-1.74,1.39-1.71.83,0,1,.83,1.09,1.53a3,3,0,0,0,.23,1.21c2.8,4.09,2.81,4.09,2.46,8.58a12.62,12.62,0,0,0,7.14-4.3,3.1,3.1,0,0,1,2.43-2.09A1.33,1.33,0,0,1,955.55,337.32Z"
              />
              <path
                class="cls5-75"
                d="M900.85,246.72l1.38-.05c1.78,2.18,4.2,2.41,6.76,2.2a6.07,6.07,0,0,1,3.08.65,1.16,1.16,0,0,1,.52,1.11,3.32,3.32,0,0,1-1.88,1.59c-1.53.55-3.15.33-4.73.52-2,.23-3.1,1-1.64,3.12a2.43,2.43,0,0,1,.15,1.68,10.19,10.19,0,0,0-1.07,5,5.62,5.62,0,0,1-.68,3,.8.8,0,0,1-1.11.19c.26-1.35-1.16-1.63-1.62-2.52.61-3.07-2.68-4.7-2.74-7.52.58-.78,2.59.07,2.18-1.68-.45-1.92-1.78.11-2.64-.38-1.07-.62-1.63.21-2.26.85-3.44-.65-6.67-2.24-10.25-2.27l-3.47-2.4c3.64-2,7.64-.88,11.46-1.35C895.23,248.34,898.57,250.15,900.85,246.72Z"
              />
              <path
                class="cls5-76"
                d="M954.62,392.16c-1.4,4.73.86,9.43.11,14.15a6.06,6.06,0,0,1,.82,1.3c.82,7.36.52,14.74.19,22.12a3,3,0,0,1-1.82,2.34h-.78a2.07,2.07,0,0,1-.18-.69,5.05,5.05,0,0,1-1-2.82c-.31-6.76-.09-13.53-.13-20.3a22.66,22.66,0,0,0-.85-6.95c.43-3.7,1.47-7.36.8-11.14a2.83,2.83,0,0,1,1.16-2.25l.15-11.57,2.42,1.54c-1.9,3.86-.58,7.92-.64,11.88a4.89,4.89,0,0,1-.14,2.31Z"
              />
              <path
                class="cls5-77"
                d="M899,282.44c.06-1,.1-2-.92-2.63a5,5,0,0,1-1.53-3.43c.9-1.67,2.09-3.05.21-5.13-2.53-2.78,1.75-2.91,2.23-4.61,1.53,1.2,2.91.29,4.32-.3a1.12,1.12,0,0,1,1.07,1,.68.68,0,0,1-.11.63c.44-.18.11-.61.29-.9,1.09-.95,1.64-.48,1.9.71a4.33,4.33,0,0,0,.86,2.77c.11,1.18.59,2.36,0,3.54l-.94.06c-2.51.72-3.49-3.23-6.15-2-.29,3-.54,5.51,3.88,5.81,2.47.16,3.9,2.65,3.56,5.5-1.8,3.17-4.91,1.73-7.5,2.16C898.47,285,898.14,284,899,282.44Z"
              />
              <path
                class="cls5-78"
                d="M955.55,337.32l-.76-.08c-1.26-2.3-3.06-3.62-5.81-3.18.22-1.13,1.94-1.95.72-3.4l.38-.43c2.52-.73,5.13-1.35,5.58-4.6,2.06.26,3.43-.37,3.43-2.71.95-.71,1.92-1.24,3.12-.6l.08.25c.49,1,0,2.18.75,3.07-.49,1.24-2.32,2.1-.81,3.89,1,1.15-.26,1.85-1.1,2C957.78,332.09,956.84,334.85,955.55,337.32Z"
              />
              <path
                class="cls5-79"
                d="M939.68,292.38c1.24-.31,2.25-3.32,2.83-1.81.84,2.17,4.76,1.47,3.7,4.42-.8,2.23.31,4,1.78,4.36,1.88.43,1.91-1.1,1.49-2.93-.24-1,1.82-.49,2.82-.74a4.76,4.76,0,0,1,.75.07,4.89,4.89,0,0,1,.81,2.25c.24,1.85.08,3.43-1.84,4.47-2.35,1.26-3.38-.65-4.78-1.75-4-.85-5.66-4.86-8.8-6.91C938.19,293.64,939.05,292.7,939.68,292.38Z"
              />
              <path
                class="cls5-80"
                d="M873.31,246.47c1,.45,2.36-.16,3.23.88-2.24.38-2.25,3.28-4.85,3.87-1.86.43-3.53,1.76-5.73,1.3-1.1-.23-1.73.54-2,1.61-1.85-3.23-4.6-2.71-7.44-1.77-2.4-1.13-5.24,1.78-7.48-.82a2.87,2.87,0,0,1,1.8-1.59,9.13,9.13,0,0,1,5.4-.77c4.2,1.34,7.76-1,11.51-2.06C869.61,246.59,871.32,245.41,873.31,246.47Z"
              />
              <path
                class="cls5-81"
                d="M902.53,340c-.07,3.7-.17,7.39-.17,11.08,0,1.14-.37,2.8,1.53,2.75,5.82-.17,11.68.87,17.47-.51l2.68,2.13c-5.67.05-11.33.06-17,.16-1.31,0-2.81-.52-3.84.86a1.37,1.37,0,0,1-1,1c-.91-.07-1.54-.76-2.35-1.07a3.5,3.5,0,0,1-1.36-.95c-.88-1.84,0-2.09,1.58-1.77,1.46-4.88.15-9.89.75-14.81Z"
              />
              <path
                class="cls5-82"
                d="M899,282.44c0,1.19,0,2.36,1.64,2.52.58,5.18.07,5.69-5.54,5.45a2.9,2.9,0,0,1-2.67-1.43c4.07-2.62.53-4.14-1.1-5.17-1.44-.91-3.14-1.42-4.37-2.77-.54-.59-2.35-.29-1.55-1.75a5.69,5.69,0,0,1,2.7-2.43c1.55-.59,1.58.91,1.89,2a4.93,4.93,0,0,0,3.32,3.45c1.67.48,1.87,2.42,3.48,2.89C897.71,284.4,897.62,282.79,899,282.44Z"
              />
              <path
                class="cls5-83"
                d="M907.33,283.27c-1.22-2.42-1.24-6.53-5.9-3.94-.94.53-1.25-.67-1.58-1.4-1-2.36-.79-4.83-.75-7.3,3.63.11,5.48,3,7.81,5.08l3,6.72c.64,1.69.82,3-1.75,2.39C907.56,284.46,907.13,284,907.33,283.27Z"
              />
              <path
                class="cls5-84"
                d="M939.82,344.69l1.45,1.82a1.35,1.35,0,0,1,.52,1.55c-.75,1.7-2.83,1.5-3.9,2.7s-2.32,2.7-1.57,4.69c-.45,1.21-1.48.91-2.4.93a1.1,1.1,0,0,1-.2-1.49c0-.14.09-.33,0-.4-3.38-3.91-2-8.12-.87-12.35.12-.42-.38-1-.59-1.51.36-1.25.59-2.57,1.75-3.41l2.26,3.54a6.44,6.44,0,0,0-1.33,3.27c.07,1.12-.18,2.46,1.66,2.29C937.93,346.22,938.74,345.19,939.82,344.69Z"
              />
              <path
                class="cls5-85"
                d="M877.48,302.28c1.19-.51,1.87-1.11,3.72-.43,3.3,1.21,6.55-.19,7.17-4.53,3.07,0,4.86,1.93,6.42,4.22.46,1-.08,1.47-.84,1.89-1.64.4-2.68-3.13-4.18-1.11-1.7,2.29.84,2.1,2.15,2.41a8.1,8.1,0,0,1,1.6.38l.37.19a.89.89,0,0,1,.29,1c-1.9,2.37-4-.32-6,.23-.2.2-.47.45-.69.38-3.08-1-6.28-1.62-9.25-3Z"
              />
              <path
                class="cls5-86"
                d="M908.21,284.19c1.95.74,1.57-.73,1.66-1.76,1.36,1.06.73,2.55.77,3.86.05,1.53.25,2.77,2.21,2.74,1.24,0,2.61-.09,2.78,1.7.15,1.49-1.15,1.69-2,2.26-.45.3-.86.67-1.29,1-1.59,1.5-3.29,1.31-5,.34C905.33,290.74,906.34,287.42,908.21,284.19Z"
              />
              <path
                class="cls5-87"
                d="M865.8,269.27c.78-.26,1.8.23,2-1.34.27-1.78,1.67-3.51,3.5-3.17,2.13.4,2.13,2.43,1.63,4.33-.12.45.26,1,.41,1.53a4.35,4.35,0,0,1-1.77,2.53c-1.73-3.57-3.21-.1-4.81.17a1.43,1.43,0,0,1-2.29-.75C864,271.14,864.22,269.92,865.8,269.27Z"
              />
              <path
                class="cls5-88"
                d="M925.85,303.21h1.47a2.16,2.16,0,0,1,2.23-.36,1.3,1.3,0,0,1,.56,1,14.8,14.8,0,0,1-2.68,4.26v1.27c1,1.71,2.21,3.39.73,5.44-1.58,0-2.08,1.59-3.68,2.5-.45-3.74-.88-7.26-1.31-10.78A5.13,5.13,0,0,0,925.85,303.21Z"
              />
              <path
                class="cls5-89"
                d="M865.8,269.27c-.69,1.6-2,3.34,1,4.05l1.48,1.41c1.22,2.52,5.13,1.92,5.82,5-1.43,1.53-2.81,1.62-4.53.27a19.88,19.88,0,0,0-7.16-3.59,27.33,27.33,0,0,1,1.92-9.82Z"
              />
              <path
                class="cls5-90"
                d="M947.24,300.72c4.94,2.42,5.8,1.68,5.81-5a3.21,3.21,0,0,1,2,3.27c.08,3.94,2.38,4.57,5.56,4.18-1,1.18-2.44.81-3.71.82-2,0-2.21.93-1.36,2.47C951.84,305.91,948.66,304.58,947.24,300.72Z"
              />
              <path
                class="cls5-91"
                d="M907.46,294.12l4.85-.13h.13c.55,3.7-3.17,2.16-4.43,3.63-2.18-.52-.61,1.68-1.51,2.08-.51,1.44.3,3.39-1.63,4.29a1.8,1.8,0,0,1-1.92.5c-2.51-1.23.54-3.93-1.4-5.31.19-1.92.9-3.46,2.94-4C905.46,294.79,906.33,294.08,907.46,294.12Z"
              />
              <path
                class="cls5-92"
                d="M925.58,345c.84,1.06,2.94.47,3.14,2.24.18,1.57,1,3.52-.49,4.64s-3.2-.08-4.38-1.14a16.08,16.08,0,0,1-2.26-3.34C922.73,346.25,923.46,344.45,925.58,345Z"
              />
              <path
                class="cls5-93"
                d="M885.75,257.46c3.4-1.25,6.16,1.45,6.94,3.24,1,2.4-1.67,4.1-4.5,4.16a1.37,1.37,0,0,1-.3-.91c0-1.57-2.35-1.41-2.3-3,1-1.11-.38-2.34.17-3.47Z"
              />
              <path
                class="cls5-94"
                d="M943.11,315c-.74-.23-1.91-.31-1-1.48.63-.83,1.8-1.27,1.69-2.52l-.36-.37c-1,1.26-2,2.42-3.69,1-.67-.57-1-2-.23-2,1.78-.07,2.7-3.2,4.9-1.29.92.8,1.92,1.51,2.89,2.26a4.48,4.48,0,0,1-.47,2.3C945.92,314.15,945.27,315.88,943.11,315Z"
              />
              <path
                class="cls5-95"
                d="M864.32,266.63c-.06,3.39-.1,6.78-1.92,9.82l-1.65.06c-1-.33-2.23.35-3.08-.69.36-.83-1.41-1.91.48-2.64,5-1.93,5.15-2.43,3.7-7.81a6.13,6.13,0,0,1-.12-1.21C863.43,264.11,864,265.19,864.32,266.63Z"
              />
              <path
                class="cls5-96"
                d="M904.83,295.8c-2.11.16-1.33,3.11-3.28,3.42a26.49,26.49,0,0,0-6.77-3.93c-1.7-.8-2.88-1.77-1.52-3.78,3-.57,4.86,2.6,7.74,2.55C902.3,294.57,903.88,294.49,904.83,295.8Z"
              />
              <path
                class="cls5-97"
                d="M929.88,313.28c.47.05,1.33.6,1.3-.17,0-1.27-.33-2.58,1.16-3.05s2.45,1,3.49,1.78c1.37,1,1.58,2.13-.4,3-1.6.69-3.09,1.67-4.62,2.52C929.55,316.2,928.71,315,929.88,313.28Z"
              />
              <path
                class="cls5-98"
                d="M943.11,315c1.73-.08,2.17-1.76,3.27-2.62,2.75,1.55,3.26,3.77,1.91,6.52l-5.89,1a8.18,8.18,0,0,1-2.57-2.6C940.55,316,943,317.17,943.11,315Z"
              />
              <path
                class="cls5-99"
                d="M936.32,355.45c-1.71-1.75-.64-5.3,2-6.4,1-.42,2-.72,3-1.07-1,2.72,1.27,1.76,2.37,2.08a10.17,10.17,0,0,1,2.28.82c1.61,1.8,1.46,3.08-1.07,3.65-1.89-.45-3.23-2-5.09-2.56C937.67,352.15,937.27,354.07,936.32,355.45Z"
              />
              <path
                class="cls5-100"
                d="M882.51,286.32c.09-1.37,0-3.18,1.92-3s4,1.41,4.13,3.24c.09,2.19-2.61,2.05-4.13,2.42C882.49,289.48,882.4,287.77,882.51,286.32Z"
              />
              <path
                class="cls5-101"
                d="M897.35,310.7c.64,2.14,5.43,1.87,3.28,5.63l-1.22.1c-1.35.13-3.37,2-3.82-.08C895.23,314.68,893.93,311.63,897.35,310.7Z"
              />
              <path
                class="cls5-102"
                d="M877.47,270.76c1.53,1.87,4.65,1.25,5.81,3.74.36.76,1.77,1.22.79,2.33a1.9,1.9,0,0,1-2.61.29c-1.44-1.44-3.14-1.4-4.89-1.43C875.29,273.76,875.68,272.13,877.47,270.76Z"
              />
              <path
                class="cls5-103"
                d="M949.85,330.53c-.05-2.19-.48-4.43.72-6.48,2-.6,3.56.52,5.09,1.58C956.45,329.4,954.94,330.67,949.85,330.53Z"
              />
              <path
                class="cls5-104"
                d="M949,334.06a6.81,6.81,0,0,0,1.15-.4c2.8-1.56,5.31-2.69,4.2,2.47-.07.32.29.74.46,1.11l-2.7,1.85C951.57,337.1,948.44,336.72,949,334.06Z"
              />
              <path
                class="cls5-105"
                d="M877.47,270.76l-.9,4.93c-2.41.63-3.42-1.48-5-2.54-.08-1.31.22-2.36,1.77-2.53C874.76,270,876.16,269.24,877.47,270.76Z"
              />
              <path
                class="cls5-106"
                d="M947.94,310.79c4-3.05,4-3,5.79,2.51-1.23.7-1.22,2-1.49,3.14a2.34,2.34,0,0,0-1.82,1A6.91,6.91,0,0,1,947.94,310.79Z"
              />
              <path
                class="cls5-107"
                d="M848.22,275.73h-1.51c-1.55-.32-3.89,1-4.14-2-.17-2,1.13-2.24,2.68-2.19.82,0,1.65,0,2.48.06,1.57,0,1.68,1.21,1.81,2.37A2.2,2.2,0,0,1,848.22,275.73Z"
              />
              <path
                class="cls5-108"
                d="M943.75,353.81c1.8.05,3.53.05,1.91-2.51a2.76,2.76,0,0,1-.19-3.9l.1-.1.79-.08c.11,1-.06,2.09,1,2.71a6.94,6.94,0,0,0,3.12,2.36v1.53a5.64,5.64,0,0,1-2.5,2.63c-.84-.27-1.71-1.29-2.51.07a3.39,3.39,0,0,1-3.32-.13l-.78-1.36a1.77,1.77,0,0,1,2.14-1.3Z"
              />
              <path
                class="cls5-109"
                d="M934.06,344.05c-.33-1.83.06-3.17,2.24-3.29,1.16,1.05.71,3.89,3.48,3.17a3.22,3.22,0,0,0,0,.76c-.19,2.12-1.42,2.83-3.41,2.52A11,11,0,0,1,934.06,344.05Z"
              />
              <path
                class="cls5-110"
                d="M912.54,314.2c-.09,2.56-1.57,5.9,3.19,5.79l-1.71.79c-2.27,0-4.58,0-5.81-2.48a8,8,0,0,1,1.51-3.31Z"
              />
              <path
                class="cls5-111"
                d="M888.14,264.28a5.67,5.67,0,0,0,.05.58c-1,1.47-1.32,3.51-3.31,4.23h0c-2.36-2.45-1.75-4.5.86-6.28C887.15,262.18,887.32,262.28,888.14,264.28Z"
              />
              <path
                class="cls5-112"
                d="M883.28,262.23c-1.83,1.14.18,3.93-2.48,5,0-3-1.11-5.1-4.68-4.82,1.33-2,3.08-1.46,4.58-1.73C881.71,261,883.15,260.47,883.28,262.23Z"
              />
              <path
                class="cls5-113"
                d="M925.85,303.21c2.21,3.69-.68,3.11-2.72,3.25-.24-1,.16-2.37-1.58-2.3a1.23,1.23,0,0,1-.16-1.71c.21-1.27.8-2.4,2-.94A7,7,0,0,0,925.85,303.21Z"
              />
              <path
                class="cls5-114"
                d="M947.33,363.11a11.56,11.56,0,0,1,2.81.28c1.09.39,2.54.66,2.57,2.23,0,1-.78,1.39-1.63,1.53-1.43.24-2.76.23-3.14-1.63-.17-.8-.43-1.57-.65-2.36Z"
              />
              <path
                class="cls5-115"
                d="M930.7,340.42c-1.41.06-2.65-.45-2.32-2s.1-3.46,1.82-4.24c1-.46,1.65.55,2.11,1.41C932.42,337.44,932.35,339.19,930.7,340.42Z"
              />
              <path
                class="cls5-116"
                d="M964.63,355.55c.53,1.78,2.44,2.06,3.49,3.26-4.36,1.28-6.22.07-6-3.95C963.12,354.42,964.29,353.46,964.63,355.55Z"
              />
              <path
                class="cls5-117"
                d="M920.54,309.63c-.77,3.28-3,2.75-5,2.45-.68-.09-1.4-.62-1.12-1.42.43-1.22,1.62-.7,2.51-.8C918,309.73,919.09,309.71,920.54,309.63Z"
              />
              <path
                class="cls5-106"
                d="M949,319.84c1.71,0,1.59-1.22,1.5-2.39,1.49-.18,3.08-.59,4,1.15a1.42,1.42,0,0,1-.67,1.77C952.06,321.46,950.47,320.94,949,319.84Z"
              />
              <path
                class="cls5-118"
                d="M894.18,306.33a2.18,2.18,0,0,0-.18-.65,2,2,0,0,1-.07-2.6l.86-1.54c.85-.87,1.71-1.69,3.43-1C896.68,302.45,896.36,305,894.18,306.33Z"
              />
              <path
                class="cls5-119"
                d="M860.17,285.72c1.1-1.79,2.2-3.58,3.59-5.82C865.84,284.05,862.71,284.81,860.17,285.72Z"
              />
              <path
                class="cls5-120"
                d="M930.7,340.42c.36-1.66.25-3.48,1.61-4.81l1.73,1.61c-.22,1.32.43,3.09-1.75,3.41Z"
              />
              <path
                class="cls5-121"
                d="M932.26,298.28a5.38,5.38,0,0,1-2.45,5l-2.49-.07c.29-1.51,2.54-1.54,2.5-3.31C930.33,298.87,931,298.07,932.26,298.28Z"
              />
              <path
                class="cls5-122"
                d="M936.8,333.16c1,.17,1.91.62,1.81,1.76s-1.08,1.46-2.08,1.48-1.6-.33-1.53-1.4A1.88,1.88,0,0,1,936.8,333.16Z"
              />
              <path
                class="cls5-123"
                d="M924.07,296.49c-.56.94-1.2,1.83-2.48,1.48s-.91-1.44-1-2.31C922.36,293.25,923.41,294.05,924.07,296.49Z"
              />
              <path
                class="cls5-124"
                d="M906.5,299.74c.19-.87-1.06-2.37,1-2.4,1.35-.85,2.41-.71,3,.9C909.64,299.88,908.65,301.38,906.5,299.74Z"
              />
              <path
                class="cls5-125"
                d="M902.57,265.74l.59.69c-.61,1.19-1.22,2.58-2.79,2.44-1.06-.1-1.27-1.25-1.35-2.23.63-1,1.66-.81,2.61-.89Z"
              />
              <path
                class="cls5-126"
                d="M849.13,274l-1.41-2.39c.67-1.74,1.62-2.44,3.19-.88,0,1.11-.11,2.22-.16,3.33a1.14,1.14,0,0,1-1.61-.05Z"
              />
              <path
                class="cls5-127"
                d="M929.68,304.27a2.21,2.21,0,0,1-1.75,4.06,2.29,2.29,0,0,1-.5-.3C927.21,306.19,927.82,304.86,929.68,304.27Z"
              />
              <path
                class="cls5-128"
                d="M964.63,355.55c-.64-1-1.61-.76-2.54-.69l-.61-1.05c1.59,0,3.26.61,4.71-.57l.43-.37c1.51.3,3,.64,3,2.64Z"
              />
              <path
                class="cls5-93"
                d="M885.76,257.45c-.91.58-1.43,2.48-2.92,1.16a1.58,1.58,0,0,1-.13-2.22,1.52,1.52,0,0,1,.37-.3c1.26-.69,2.43-.36,2.67,1.37Z"
              />
              <path
                class="cls5-129"
                d="M947.19,329.13l.94,1.49a1.65,1.65,0,0,1-2.19,1.61,1.15,1.15,0,0,1-1-1.26.57.57,0,0,1,0-.18,1.83,1.83,0,0,1,2-1.7A1.35,1.35,0,0,1,947.19,329.13Z"
              />
              <path
                class="cls5-130"
                d="M924.68,320c1.25-.07,1.7.49,1.75,1.42S926.1,323,925.1,323a1.51,1.51,0,0,1-1.63-1.38v-.05C923.34,320.61,924.18,320.3,924.68,320Z"
              />
              <path
                class="cls5-131"
                d="M938.87,298.93c-1.19.08-2.45.5-3.33-.75.24-1.1.55-2.36,1.93-2.12S939.18,297.59,938.87,298.93Z"
              />
              <path
                class="cls5-132"
                d="M909.72,315c0,1.35.5,2.89-1.51,3.31-1.88-1.19-2-2.39,0-3.58Z"
              />
              <path
                class="cls5-133"
                d="M879,265a1.24,1.24,0,0,1-.91,1.51,1.19,1.19,0,0,1-.46,0,1.48,1.48,0,0,1-1.63-1.33.22.22,0,0,1,0-.08,1.45,1.45,0,0,1,1.24-1.64h.16C878.38,263.42,878.77,264.17,879,265Z"
              />
              <path
                class="cls5-134"
                d="M952.24,316.44c-.37-.94-2-1.51-1.17-2.75.58-.91,1.74-.48,2.67-.39a2.3,2.3,0,0,1-1.19,3Z"
              />
              <path
                class="cls5-135"
                d="M857.48,283.21c-1.11.08-2.26.11-2.72-1.15-.1-.27.43-1,.8-1.15,1.26-.44,2.47-.5,2.59,1.35Z"
              />
              <path
                class="cls5-136"
                d="M907.36,274c-.67-1.17-1.48-2.35,0-3.53.9.2,2,.37,2,1.44S908.41,273.69,907.36,274Z"
              />
              <path
                class="cls5-137"
                d="M934.05,307.27c0-2.23,1.51-2.46,3.21-2.45C937.73,307.65,936,307.63,934.05,307.27Z"
              />
              <path
                class="cls5-138"
                d="M947.29,363.16c-1.18-.07-2.61.13-2.39-1.74,0-.32.77-.82,1.16-.8,1.78.07,1.8,1.17,1.27,2.49Z"
              />
              <path
                class="cls5-123"
                d="M918.46,294a1.3,1.3,0,0,1-1.43-1.13c-.06-.76.56-1.16,1.32-1.2a1.16,1.16,0,0,1,1.36.92,1.36,1.36,0,0,1,0,.2C919.77,293.57,919.27,294,918.46,294Z"
              />
              <path
                class="cls5-139"
                d="M1004.6,327.47c.06-6.73,0-13.46.22-20.18.11-3.35-1.21-4.2-4.18-3.2a2.05,2.05,0,0,1-1.89-.95c-1-4.19,2.45-3.94,4.81-4.76,2-1.36,1-2.86.2-4.34,1.79-1.51,3.25-.46,3.13,1.2-.3,3.81,2,4.59,4.82,5.3a19.56,19.56,0,0,1,3.7,1.75c1-.27,2.1-1.07,2.38.77-3.72-.24-7.36,0-10.74,1.8-1.68-.14-1.24,1.19-1.21,2,.31,6.58-.79,13.21.62,19.76.31,1.43-.27,2.11-1.79,1.62A6.68,6.68,0,0,1,1004.6,327.47Z"
              />
              <path
                class="cls5-140"
                d="M953.86,271.59c-1.84,3.27,1.81,5.49,1.62,8.44-1.9,1-2.74,3.35-4.93,4-2.24-1.29-4.52.66-6.77-.09a3,3,0,0,1,.93-3.21c.92-.05,1.92.12,2.54-.84,1-1.27,1.3-3,2.49-4.2v.05c.47-1,2.3-2.52-.77-2.44-.17-2-1.33-1.47-2.47-.95-1.35-2.43,1.21-3.24,2-4.8,2-2.61,4.33-3.54,7.09-1-.27.85-.55,1.69-.82,2.53C953.46,269.62,952.66,270.27,953.86,271.59Z"
              />
              <path
                class="cls5-141"
                d="M978.07,297.42c2.56-1.18,3.29-4.79,6.59-5,1.13,2.2,0,4.38,0,6.57-.69,1.44-.88,2.6,1.32,2.54a2.58,2.58,0,0,1,2.93,2.55h0L981.4,304c-.89-1,.54-2.46-.69-3.45-1.42.73-.62,2.68-1.91,3.44h-6c-1.82.06-2.32-.94-2.24-2.52C971.87,298,974.46,296.75,978.07,297.42Z"
              />
              <path
                class="cls5-142"
                d="M1006.28,335.72c0,1.62-.94,3.25.09,4.85a6.75,6.75,0,0,1,0,7.51c-2,.92-2.33-.52-2.67-1.88s0-2.95-.2-4.46c-1-.29-1.77.6-2.7.41a12.79,12.79,0,0,1-7.26-6.27,2,2,0,0,1,2.58-1.16h0c.82,1.33,2.53,2.47,2.86.52.37-2.19,1-2.74,2.88-2.72,2.27,0,1.6,2.21,2.41,3.31a5.32,5.32,0,0,1,.49,1.57Z"
              />
              <path
                class="cls5-143"
                d="M956.4,282.23l1.65-.7c2.18-1.67,4.86-3.08,3.32-6.62,2-.24,3.36.24,3.58,2.64a3.81,3.81,0,0,0,2.2,3.22,2,2,0,0,1,.93,2.3,10.88,10.88,0,0,0,.52,4.87A1.54,1.54,0,0,1,968,290l-.07,0c-1.24.49-1.7-.69-2.08-1.46-2.6-5.22-3-5.4-8.61-3.76C956.32,284.2,955.81,283.4,956.4,282.23Z"
              />
              <path
                class="cls5-144"
                d="M984.61,299c-1.91-2.2-.45-4.38,0-6.57,1.23-.87.66-2.18.8-3.32a4.56,4.56,0,0,1,2.53-1.75c1.24.43,2.4.55,3.24-.75a9.09,9.09,0,0,1,2.39,2.4c-.93,1.64-1.22,3.72-4.27,2.72-2.14-.7-2.89,1.52-3.08,3.41C986.12,296.61,986.38,298.22,984.61,299Z"
              />
              <path
                class="cls5-145"
                d="M1004.55,299.15c-2.12,1.05-5.48.31-5.8,4-1.89-.14-2.62-1-1.91-2.89.5-1.39.41-2.67-1.47-3a2.92,2.92,0,0,1,.81-3.14,7.57,7.57,0,0,0,6.67.77C1004.17,296,1004.28,297.62,1004.55,299.15Z"
              />
              <path
                class="cls5-146"
                d="M955.52,266.58c-2.59-.67-5-.74-6.71,1.86-1.08-1-.59-2.42-.8-3.65a1.71,1.71,0,0,0-.74-1.61c-.2-1.4,1-1.67,1.83-2.26,2.17-.88,4.28-1.17,6.22.56a3.79,3.79,0,0,1,.21,5.09Z"
              />
              <path
                class="cls5-147"
                d="M988,287.35c-.08,1.69-1.3,1.74-2.53,1.75l-2.55-2.43c-.17-2.48-3.8-3.08-3.24-6,.74-1.17,1.41-2.13,2.69-.4C984.16,282.71,986.11,285,988,287.35Z"
              />
              <path
                class="cls5-148"
                d="M1017.79,303.06c-.58-.9-1.55-.64-2.38-.77l4.05-3.43c-.4-.58-.44-1.1.22-1.52a3.42,3.42,0,0,0,.78-.06c1.71,1.05-.1,3.29,1.49,4.38a3.21,3.21,0,0,1,1.33.84,3.52,3.52,0,0,1,.36,1,9.14,9.14,0,0,1,0,3.13c-.21,1.9-1.34.95-1.91.45C1020.36,305.83,1019.11,304.41,1017.79,303.06Z"
              />
              <path
                class="cls5-149"
                d="M961.37,274.91c3.44,4.32,2.81,5.57-3.32,6.62,0-1-.37-2.07.43-2.78,1.62-1.44,1.31-2.49-.38-3.53-.8-.51-2-1.21-1.37-2.22.8-1.32,2-.31,2.87.23A11.25,11.25,0,0,1,961.37,274.91Z"
              />
              <path
                class="cls5-150"
                d="M978.27,258.31c.91,1.35,2.72.43,3.89,1.8,2.8,3.33-.09,4.64-1.85,6.44-1.65-.23-2.43-1.67-3.61-2.57a3.87,3.87,0,0,1-.42-1.18C976.21,261,976.28,259.21,978.27,258.31Z"
              />
              <path
                class="cls5-151"
                d="M954.74,261.8c-1.91-1.27-3.85-.33-5.79-.07a1.43,1.43,0,0,1-1-1.71l-.74-1.56a5.38,5.38,0,0,1,1.69-2.62l.87-.91c2.42,0,1,2.71,2.43,3.45a5.31,5.31,0,0,0,.2.68,8.52,8.52,0,0,0,6.52.14c.75.27.82.88.78,1.55C958.46,263.15,956.62,262.55,954.74,261.8Z"
              />
              <path
                class="cls5-152"
                d="M978.07,297.42c-3.13.23-5.14,2.52-7.55,4.09l-2.59-2.6a1,1,0,0,1,.11-1.48l.14-.1c.38.14,1,.48,1.08.4C972.08,293.75,975.1,296.24,978.07,297.42Z"
              />
              <path
                class="cls5-149"
                d="M956.4,282.23l.87,2.63c-2.58,2.55-4.69,1.21-6.72-.81,1.57-1.44,1.61-4.74,4.93-4Z"
              />
              <path
                class="cls5-153"
                d="M977.29,264c2.05-.41,2.15,1.51,3,2.51s1.81,2.23-.26,3.15c-1.71.76-3.44,2.12-4.64-.63a2.74,2.74,0,0,1-.66-2.19,3.86,3.86,0,0,1,1-2.09A2.23,2.23,0,0,1,977.29,264Z"
              />
              <path
                class="cls5-154"
                d="M987,310.63c-.81,2.32-2.86,2.17-4.43,2.58-1.19.31-2.37-.51-1.85-1.86s-.28-4,2-3.85C984.4,307.58,986,309,987,310.63Z"
              />
              <path
                class="cls5-155"
                d="M935.68,266.65c.08-1.4-.78-2.49-1.65-3.76,3.44.33,6.67,3.62,6.6,6.25a2.11,2.11,0,0,1-1.88,2.32h0c-1.61.2-3.49.62-4.48-1.12-.86-1.53-.35-2.93,1.4-3.66.93.55.23,2.28,2,2.45C938,267.43,936.54,267.26,935.68,266.65Z"
              />
              <path
                class="cls5-156"
                d="M973.14,261.63c1.33.58,2.15,2.34,4,1.68a4.52,4.52,0,0,0,.16.73l-.91.76a16.23,16.23,0,0,0-2.76.63c.4.81,1.52.43,1.91,1.2l-.12,2.44c-1.43-.16-3,.41-4.25-.77C968.75,266.06,969.52,263.41,973.14,261.63Z"
              />
              <path
                class="cls5-157"
                d="M970.54,251.62h-8.37l1.84-4,6.53,3.11Z"
              />
              <path
                class="cls5-158"
                d="M978.78,304a12.7,12.7,0,0,1,.07-1.63c.12-1.28-.5-2.92,1.14-3.56a2.73,2.73,0,0,1,2.15.8c1.36,1.31,0,2.46-.44,3.66-.09.25-.21.49-.32.74Z"
              />
              <path
                class="cls5-140"
                d="M954.74,261.8c1.68-.16,3.44,0,4.92-1.05l.92,1.52a4.76,4.76,0,0,1-1.69,2.69l-3.36,1.62C955.61,264.93,955.79,263.26,954.74,261.8Z"
              />
              <path
                class="cls5-159"
                d="M936.28,251.74a2.8,2.8,0,0,0-3.28,1.42,1.57,1.57,0,0,1-1.61.65A1.82,1.82,0,0,1,930,252a4.21,4.21,0,0,1,1.33-2.51A5.1,5.1,0,0,1,933,248a2.26,2.26,0,0,1,2.41,1l1,1.72A5.72,5.72,0,0,1,936.28,251.74Z"
              />
              <path
                class="cls5-160"
                d="M989.64,271.09c-1.21,0-1.64-.78-1.5-1.85a2,2,0,0,1,2.16-1.83l.16,0c1.22,0,1.71.74,1.63,1.87C992,270.79,990.72,270.78,989.64,271.09Z"
              />
              <path
                class="cls5-161"
                d="M947.91,260l1,1.7-1.68,1.47c-2.07.05-4.3.57-5.76-2.07C943.77,260.59,946.36,262.85,947.91,260Z"
              />
              <path
                class="cls5-162"
                d="M1004.55,299.15c-1.81-.91-1.66-2.61-1.7-4.24l.91-.87C1007.72,295.17,1006.1,297.16,1004.55,299.15Z"
              />
              <path
                class="cls5-163"
                d="M993.71,279.55l-5.26,4.07C988.24,279.27,991.1,279.41,993.71,279.55Z"
              />
              <path
                class="cls5-164"
                d="M954.78,250.79c-.63,2.33-2.29,1.79-3.84,1.29a.81.81,0,0,1-.63-1,.86.86,0,0,1,.15-.32c1.16-1.36,2.68-.87,4.12-.66C954.64,250.36,954.71,250.57,954.78,250.79Z"
              />
              <path
                class="cls5-165"
                d="M950.62,248.37a2.58,2.58,0,0,1-1.64-2.43c1.26,0,2.73-1.88,3.67-.26S952.19,248.12,950.62,248.37Z"
              />
              <path
                class="cls5-166"
                d="M996.87,282.6c1.28.27,2.14.85,2.13,1.9s-.94,1.24-1.82,1.22-1.66-.3-1.61-1.41C995.61,283.35,996.33,283,996.87,282.6Z"
              />
              <path
                class="cls5-167"
                d="M944.71,280.75a3.64,3.64,0,0,1-.93,3.21c-1.47-.08-2.54-.81-2.11-2.32S943.43,280.18,944.71,280.75Z"
              />
              <path
                class="cls5-168"
                d="M943.79,254.2a1.63,1.63,0,0,1-1.72,1.47c-1,0-1.43-.69-1.4-1.63a1.31,1.31,0,0,1,1.58-1.42A1.58,1.58,0,0,1,943.79,254.2Z"
              />
              <path
                class="cls5-169"
                d="M993.45,270.94c.45-.87,1-1.72,2.15-1.53a1.29,1.29,0,0,1,1.18,1.39s0,.05,0,.07a1.59,1.59,0,0,1-1.64,1.53,1.55,1.55,0,0,1-.43-.07,1.31,1.31,0,0,1-1.25-1.37Z"
              />
              <path
                class="cls5-170"
                d="M958.89,265c-.18-1.36,0-2.49,1.69-2.69,1.3.4,1.88,1.23,1.16,2.48S959.88,265.43,958.89,265Z"
              />
              <path
                class="cls5-171"
                d="M962.27,290.68c-1.41-.59-1.72-1.81-1.84-3.15,1.11,0,2.45-.78,3.17.61S962.71,289.82,962.27,290.68Z"
              />
              <path
                class="cls5-172"
                d="M953.86,271.59c-1.36-.06-2.53-.61-2.06-2.11.54-1.74,1.84-.86,2.9-.37Z"
              />
              <path
                class="cls5-71"
                d="M979.5,333.08c-.61.25.09,2.53-1.59,1.09a32.68,32.68,0,0,1-2.46-2.67C977,331.49,978.7,331.16,979.5,333.08Z"
              />
              <path
                class="cls5-173"
                d="M962.18,270.39c-.15.76-.54,1.25-1.36,1.14a1.6,1.6,0,0,1-1.38-1.74c0-.76.73-1.12,1.43-1.1C961.89,268.74,962.14,269.52,962.18,270.39Z"
              />
              <path
                class="cls5-174"
                d="M958.88,259.2c-2.22,2.07-4.38,1.3-6.52-.14Z"
              />
              <path
                class="cls5-175"
                d="M826,255.81l-3.44-.79c-2.64-.68-5.73,1.09-8.1-1.19,5.65.47,11.25,1.3,16.37-2.1l4.41.11c-2.07,2.33-5.22,2.54-7.76,3.95Z"
              />
              <path
                class="cls5-176"
                d="M819.28,260.78c1.11-1.3,2.75-1.71,4.17-2.49.11.51.46,1.38.3,1.48-2.78,1.8-4.94,4.67-8.53,5.11C815.88,262.83,818.46,262.68,819.28,260.78Z"
              />
              <path
                class="cls5-177"
                d="M820.93,265.05a3.59,3.59,0,0,1,3.38-2.63c.08.18.15.35.23.52.49,3.79,4.12,4.36,6.43,6.27.29.25.56.51.83.78l.75,1.36c0,.7.84,1.47-.2,2.07Z"
              />
              <path
                class="cls5-178"
                d="M943.17,408.1l-12.72,11.59c8.57,3,14.69,8,22.51,9v2.69a2,2,0,0,0-.69-.16c-2.52-1.06-5.13-1.93-7.58-3.17l-7.43-3.44a8.07,8.07,0,0,0-5.09-2.38l-2.35-1v-2.39c2.27-3.46,5.77-5.81,8.56-9.15-3.49-1.66-7.2.46-10.21-1.65l-3.36-.23C930.94,406.86,937.07,406.38,943.17,408.1Z"
              />
              <path
                class="cls5-179"
                d="M1287.16,488.86c2.3-2.74,2.58-6,2.23-9.34l1.09-.08c1.24,3.89-1.16,7.21-1.7,10.83-.85,1.19-2.78,1-3.36,2.52a1.22,1.22,0,0,1-1.67,0c-.15-1.72,2.3-1.67,2.26-3.31Z"
              />
              <path
                class="cls5-180"
                d="M1283,471.14c-3.61-2-7.4-3-11.52-1.89-.79-2,.36-1.92,1.72-1.58a16,16,0,0,1,10.47,2.83Z"
              />
              <path
                class="cls5-181"
                d="M1041.16,303.16l-10,.15a7.68,7.68,0,0,1-8.15,0c-.09-.29-.17-.58-.26-.87,5-.74,10.13.59,15.11-.75.49-1.1.86-2.38,2.54-1.79,1,.57-.31,2,.89,2.52C1041.25,302.69,1041.21,302.93,1041.16,303.16Z"
              />
              <path
                class="cls5-182"
                d="M1026.26,354.05c1.74-2.49,4.27.84,6.12-.84.54,1.34,2.09,1.41,2.94,2.35l-6.67-.13C1028,354.77,1026.15,356.08,1026.26,354.05Z"
              />
              <path
                class="cls5-183"
                d="M1055.28,355.57l-6-.09c.4-3.35,1.79-4,4.27-1.56Z"
              />
              <path
                class="cls5-184"
                d="M1195,406.18h8c1.15.4.52,1,.18,1.57l-9.06.11a1.1,1.1,0,0,1-.55-.76,1,1,0,0,1,.46-.81Z"
              />
              <path
                class="cls5-185"
                d="M1233.08,452.05c-3.25-.13-4.45-3.42-7-4.55,1.54-1.69,1-4.87,3.29-5.67,1.24-.44,1.48.23,1-1.5-.58-2.32,2.59-3.63,2.7-6.05l2.35.27,3.46,3.38c2.63,2.81,6,4.66,9.18,6.65h0c4.5,3.4,4.72,4,1.35,8.32-1.21,1.55-1.51,4-3.83,4.59-1.27-.38-2.06-1.8-3.58-1.64-.94-.16-1-2.14-2.48-1.19a21.75,21.75,0,0,1-3.22-3.07c-2-2.47-.82,1.12-1.62.77A1.32,1.32,0,0,1,1233.08,452.05Z"
              />
              <path
                class="cls5-46"
                d="M1251.45,397.28c0,3,0,6-.07,9A10.58,10.58,0,0,1,1251.45,397.28Z"
              />
              <path
                class="cls5-54"
                d="M1218.17,416.26c2.33-2.65,5-5,6.57-8.27h1.73a4.45,4.45,0,0,0-.12.73c-.37,2.58-2.3,4.27-3.6,6.32a6.21,6.21,0,0,1-2.36,1.79A2,2,0,0,1,1218.17,416.26Z"
              />
              <path
                class="cls5-186"
                d="M1237.43,399.77l2-.08c.48,3.6-.66,4.6-5.45,4.81-1.33-1.84-1.62-3.24,1.39-3.13C1236.59,401.41,1237,400.61,1237.43,399.77Z"
              />
              <path
                class="cls5-187"
                d="M1259.52,551.62c-2.22,1.73-3.22,4.61-5.67,6.13-1.44-1-3.69-1.9-2.83-3.85,1.19-2.69,3-5.75,5.77-6.57C1258.86,546.71,1260.66,548.83,1259.52,551.62Z"
              />
              <path
                class="cls5-188"
                d="M1220.58,551l-6.45,5.22a6.38,6.38,0,0,0-1.89.3c-1.42.56-2.59,2-4.38,1.3-2.44-4.33,2.59-4.16,3.81-6.3.26-.45.11.25.28-.22.1-.27-.33.15-.55.07.15.54-.83-.21-.41.14-1.27-.07-2.6.5-3.78-.36,0-2.27,2.55-3.48,2.35-5.82a14.31,14.31,0,0,0,5.83-2.64,4.14,4.14,0,0,1,2.86-.49c1.27.47,1.64,1.63,2.08,2.72.88,1.85,1.44.37,1.94-.24,2.5-3.1,4.91-6.27,7.69-9.14-1.37,1.62-2.74,3.2-5.08,3.33a2.37,2.37,0,0,1-1.3-1.11c-.49-2.76.17-5.51.15-8.28,1.15-1,2.46-.42,3.71-.38,2.38.29,3-1.22,3.34-3.14.27-1.54-1-4.11,1.65-4.23,2.29-.1,3.33,1.94,3.45,4.22-.37,1.69-3.18,3.2-.35,5.12-.22,2.93-3,4.31-4.09,6.69-.89,4-4.41,6-6.64,9C1223.68,548.25,1222.81,550.4,1220.58,551Z"
              />
              <path
                class="cls5-189"
                d="M1212.27,555.21a1.79,1.79,0,0,1,1.86,1c.25.61-1.11,2.74,1.22,1.38.9-.52,1.52-1.54,2.73-1.53-1.59,2.2-.8,4.34.15,6.48-.93,1.36-2.49,1.14-3.8,1.54a4.25,4.25,0,0,1-1.81,0,3.66,3.66,0,0,1-1.52-1,2.73,2.73,0,0,1-.77-1.56C1211.29,559.51,1211.47,557.26,1212.27,555.21Z"
              />
              <path
                class="cls5-190"
                d="M1219,587.47a3.21,3.21,0,0,0,2.34.86c-.55,1.92-.63,3.65,1.78,4.35-.73,1.25-3.37.05-3.16,2.49-.52,2.16.32,4.52-1,6.57-.38-1,.51-2.66-1.16-3.12-1.35-.37-2.29,0-3.38,1.31-1.75,2.09-4.6.57-6.93,1a3.44,3.44,0,0,0-.58-2.2,4,4,0,0,1-1.67-2.74,1.29,1.29,0,0,1,1-1.19c1.79.12,2.5,2.82,4.7,2,2.28,1.72,3.67-1.89,5.8-1,1.75-.59,1-2,1-3.15a9.25,9.25,0,0,1,.74-4.84Z"
              />
              <path
                class="cls5-191"
                d="M1223,562.88l5.12-.12c-1.1,2.06,1.9,3.57.77,5.64-.58.33-1-.22-1.51-.27s-.85.71-1.47.49c.17.7,1,.09,1.29.67a.94.94,0,0,1-.24,1.31l-.1.06a4.25,4.25,0,0,1-4.6-.41c-1.64-2.64,2.57-3.1,2-5.34C1223.81,564.24,1223,563.82,1223,562.88Z"
              />
              <path
                class="cls5-192"
                d="M1255.47,511.19h-13.29c-5.63,2.16-11.33,1.24-17,.4a1.16,1.16,0,0,1-.62-1.1c.13-.24.27-.57.5-.61,4-.78,8.39-.83,11.29-4.51,2.24.91,4.6-1.39,6.81.26.95,1,1.6,2-.15,2.85-1.85,1.2-1.39,1.75.53,1.78,4.2.06,8.39.08,12.58.12Z"
              />
              <path
                class="cls5-193"
                d="M1291.75,505.17c1.47,1.85,3.44.66,5.18.83-.91,2.14-2.71,2-4.44,1.55C1291.37,507.24,1290.56,506.41,1291.75,505.17Z"
              />
              <path
                class="cls5-63"
                d="M1286.11,504.21a2.62,2.62,0,0,1-1.55,2c-2.11-.75-3.69-2.75-6.18-2.55a.62.62,0,0,1-.79-.41.58.58,0,0,1,0-.23,5.83,5.83,0,0,1,1-3.51c2.22-.11,2.75-3.35,5.29-2.88,2,.63,1.21,2.46,1.55,3.78S1284.76,503.15,1286.11,504.21Z"
              />
              <path
                class="cls5-194"
                d="M1257.84,498.8l.45,1.49c0,.84,0,1.67-.07,2.51-1,2-3.06,2-4.78,2.64-.62-2.41-2.7-4.85.4-7,.7-.18,1.05.18,1.22.8.24.36-.18.89.3,1.19a7,7,0,0,0-.11-1.21C1255.87,497.56,1256.63,496.81,1257.84,498.8Z"
              />
              <path
                class="cls5-179"
                d="M1277.91,502.79c-3.06-.1-1.17-3.12-2.5-4.24-1.11-1.19-2.21-.91-3.31,0l-1.57-.85c-.48-1.05.11-1.72.82-2.35,4.37.19,8.42-1.09,12.43-2.61,0,.82-.09,1.63-.14,2.45-1.76,1.26-4.62,1.27-4.88,4.27C1278.79,500.66,1279.63,502.06,1277.91,502.79Z"
              />
              <path
                class="cls5-195"
                d="M1271.35,495.37c-.27.78-.54,1.57-.82,2.35l-.9-.81c-2.54-1.48-4.18,0-5.73,1.76-.05-1.86-.09-3.73-.14-5.59.75-1.18,2-.5,2.94-.73,1.1.17,2.22.29,2.83,1.44C1269.59,494.94,1270.32,495.33,1271.35,495.37Z"
              />
              <path
                class="cls5-63"
                d="M1272.1,498.57c.14-1-.2-2.48,1.51-2.26,1.11.14,2.68.32,1.8,2.24l-2.41,1.77Z"
              />
              <path
                class="cls5-196"
                d="M1155.16,395.52c.64,2.21,3.49,3,3.9,6.76-3.94-4.1-8.94-5-11.61-9.27-1.39-1.82-.89-3.55.23-5.31-.78.38-1.45,1.09-2.42.88a1.9,1.9,0,0,1-1-.61c-.72-4.57,2.58-4.91,5.71-5.41,2.35.1,1.76,4.18,4.71,3.47,1.76.26,3.3,0,4.35-1.65a1.58,1.58,0,0,1,2.09-.82,1.57,1.57,0,0,1,.44.28,7.15,7.15,0,0,1,.7,4.22,2.94,2.94,0,0,1-.5,1,4.18,4.18,0,0,1-1,.59c-1.6.65-2.13,2.71-4.25,2.91a2.27,2.27,0,0,0-1.37,2.9Z"
              />
              <path
                class="cls5-197"
                d="M1160.94,399.6l.7.11a15.28,15.28,0,0,0,9.08,5.93,3.64,3.64,0,0,1,2.44,1.59c-.53,0-1.24-.09-1.55.2-.82.76,0,.95.57,1.35,1.27.91,3.6,1.09,2.74,3.63-3.4.37-5.23-3.11-8.39-3.41.78,1.07,2.71,1.61,1.55,3.5a7.69,7.69,0,0,1-8.78-5.26C1162,405.15,1160,402.05,1160.94,399.6Z"
              />
              <path
                class="cls5-183"
                d="M1049.78,366.26c.22-.16.64-.32.64-.48,0-4,3.12-6.23,5.17-9.06.15-.2-.2-.76-.32-1.15l2.4.09c2.22,2,1.25,3.85-.27,5.72-1,1.16-1.67,2.54-3.07,3.27a3.27,3.27,0,0,0-1.58,3.32c-.53,4-3.3,3-5.81,2.61C1046.43,368.18,1048.62,367.56,1049.78,366.26Z"
              />
              <path
                class="cls5-198"
                d="M1054.33,364.65c.86-1.48,1.45-3.28,2.66-4.38,1.7-1.52,1.33-2.95.68-4.61l3.4,2.42c-.2.92-.48,1.84-.59,2.77C1059.94,365.31,1058.56,366.17,1054.33,364.65Z"
              />
              <path
                class="cls5-199"
                d="M1141.05,377.1c.78.74,1.62,1.43,2.35,2.23,1.76,1.94.14,3.65-1,4.59-1.48,1.22-1.35-1.46-2.45-1.74C1138.48,380.09,1140.41,378.73,1141.05,377.1Z"
              />
              <path
                class="cls5-200"
                d="M1088.45,558.61c2.36.83,4.86,2.12,5.82-1.73,1.36.89.85,3.5,2.92,3.57a67.78,67.78,0,0,0,8.9-.16c.91-.08,1.05-1.14,1.16-1.95.19-1.33,0-2.75,1.07-3.84l1.17.07c.68,4.43,2.78,7,7.73,6.27a2.3,2.3,0,0,1,2.1,1,2.89,2.89,0,0,1,0,.72c-1.13,1.3-2.73,1.38-4.2,1.27-3.83-.31-4.76,1.72-4.57,5,.14,2.48.08,5,0,7.45,0,1.64.11,3.36-1.28,4.63l-1-.22c0-4.53.11-9.07.15-13.61,0-5-.78-5.52-5.8-3.72h0c-2.95-.61-5.9-1.18-8.93-.54-1.11-2.09-3.79-.19-5-2C1088.65,560.16,1088.06,559.43,1088.45,558.61Z"
              />
              <path
                class="cls5-201"
                d="M1133.52,561.61l12.15.13c0,1.67.67,3.43-.67,4.91.5-3-.66-4.07-3.79-3.95-6.19.23-12.38,0-18.57,0,.13-1.36-.63-2.86.59-4.06-.19,4.19,2.82,2.9,5,3A4.23,4.23,0,0,1,1133.52,561.61Z"
              />
              <path
                class="cls5-202"
                d="M1092.64,545.28c3.9-.49,2.34-4,3.25-6.1.84-1.93-1.38-2.22-2.45-3.07,5.78-.46,3.65-5,4.18-8.15,1,0,1,1.24,1.69,1.57a1.47,1.47,0,0,1,.49.88c0,.86-.07,1.72,0,2.58a4.91,4.91,0,0,1-.13,1.08,7,7,0,0,0-.3,3.77c-1.51,1.56-3,2.88-2.88,5.58C1096.61,545.73,1094.8,546.43,1092.64,545.28Z"
              />
              <path
                class="cls5-203"
                d="M1099.4,530.36l-.09-.83c2.32-.54,4.41,1,6.7.71,3.09,2.08,3.12,6.19.06,9.12l-4.21-2.42c.38-.61,1.52-.72,1.56-1,.1-.89-.89-.47-1.38-.66-1.1-.43-2.35-.59-2.82-1.93V533c1.62-2.08,3.56-.11,5.25-.49C1102.87,531.72,1100.62,532.23,1099.4,530.36Z"
              />
              <path
                class="cls5-204"
                d="M1130.79,511.88a33.42,33.42,0,0,0,3.12,1.79c2.89,1.4,3,3,.69,5.17-.7.62-1.07,1.68-2.26,1.25s-1.07-1.41-.66-2.35c1-2.4-1.22-2.92-2.31-4.12C1128.84,512.23,1129.56,511.85,1130.79,511.88Z"
              />
              <path
                class="cls5-205"
                d="M1127.57,515.18c.43,1.29,3.6,1.47,1.61,3.67-1.08,1.2-2.4.43-3.1-.59-1.17-1.7-.35-2.71,1.53-3Z"
              />
              <path
                class="cls5-206"
                d="M970.61,437c-.94-1.13-2.27-.55-3.42-.78-2.8-.29-5.5-1.18-8.3-1.46-2.1-.48-3.14.26-3.11,2.51a62.1,62.1,0,0,1-.13,6.82c.92-.92,1.38-2.16,2.62-2.56,1.08-.07,2.27-.33,2.28,1.37-1.81,2.38-2.73,5.36-5.06,7.37-2.16-2.29-1.57-5.14-1.6-7.85V432.06l.88-1.72c1.49-1,3-.33,4.38.15,13.19,4.53,27.12,4.73,40.69,7.07,1.71.29,4.19-.4,4.15,2.68a1.31,1.31,0,0,1-1.85.21l-.09-.07c-3.51-1.51-7.2-.5-10.8-.8-6.77-2-13.77-2-20.71-2.59Z"
              />
              <path
                class="cls5-207"
                d="M1013.78,441.13c-2.73-.77-5.52-2.09-7.88.82-.71-.66-.29-2-1.41-2.39l-.06-7.57c-.61-4.23-.15-8.51-.88-12.76-.83-4.86-5.28-9.77-10.21-10.27-1.23-.13-2.51.1-3.62-.64a1.7,1.7,0,0,1-.43-1.8,2.69,2.69,0,0,1,2.14-1.15c2.29,0,4.65-1,6.85.43,1.3.66,2.33,2.49,4.13.93.79-.74,1.26-1.81,2.3-2.29a1.71,1.71,0,0,1,1.39.85c2.08,3.37.41,7.43,2,10.9-1.41,6.57-.45,13.21-.63,19.82-.05,1.82,1,2.51,2.62,2.36,4.48-.41,8.76,0,12.75,2.3,2.12,1.2,4.15-1.8,6.33-.25,1.56,2.7,3,2.69,5.11-.05a1.94,1.94,0,0,1,1.9-1.09c1.29.56,2.61,1.1,2.69,2.82-2,2.35-3.28,5.39-6.17,7a17.91,17.91,0,0,1-8.84-3.86C1021,442.56,1016.9,443.05,1013.78,441.13Z"
              />
              <path
                class="cls5-208"
                d="M1173.14,577c-1-3.5-2.32-6.94-2.75-10.5-.4-3.26-2-4-4.75-3.85a1.43,1.43,0,0,0,.1-.79c4.81.31,2-3.17,2.46-5a3.54,3.54,0,0,1,4.19.57c1.45,1.25,2.47,2.55,1.09,4.54a3.88,3.88,0,0,0-.12,4c1.26,2.72,1.14,5.6,1.18,8.48A3.38,3.38,0,0,1,1173.14,577Z"
              />
              <path
                class="cls5-209"
                d="M1168.45,591.66c.71,0,1.28-.16,1.49-.93,2.08-1.15,4.53-.66,6.67-1.51,1.14-.46,2-1.44,3.06-1.94,1.41-.65,2.9-.9,4.18.17s.09,2.22-.11,3.33a4.2,4.2,0,0,1-.54,1.92,3.22,3.22,0,0,1,0,.76c-1.41-1.18-3.08-.94-4.72-.89-3.29-1.63-6.32-.65-9.28,1C1169.32,592.76,1167.3,592.81,1168.45,591.66Z"
              />
              <path
                class="cls5-210"
                d="M1149,584.36c-1.24-3.68.52-13.3,2.71-14.87C1151.87,574.64,1152.59,579.89,1149,584.36Z"
              />
              <path
                class="cls5-211"
                d="M1161.73,584c-.91.59-1.17,2-2.57,2a7.76,7.76,0,0,0,1.43-5.86,121.14,121.14,0,0,1,.09-16.5h1Q1161.72,573.82,1161.73,584Z"
              />
              <path
                class="cls5-212"
                d="M1161.55,545.15c0,.92-.1,1.84-.14,2.76-2.51-.64-3.08-2.18-2.07-4.45.21-.53.41-1.06.61-1.6.39-4.76-.62-9.58.64-14.29l.52.46C1161.55,533.73,1160.66,539.46,1161.55,545.15Z"
              />
              <path
                class="cls5-213"
                d="M1198.18,600.07c.82,1.09,1.1,2.16-.1,3.18-.94-.5-2.16-1-1.93-2.22C1196.3,600.18,1197.3,600,1198.18,600.07Z"
              />
              <path
                class="cls5-214"
                d="M1200.51,575.23c-2,1-1.7,3.13-2.23,4.84-.13,1.07.56,2.21-.25,3.23l-1.57,1.05-1.62-.1a2.13,2.13,0,0,1-1.45-1.09l-.18-.36c-3.18-6.3-2.71-7.56,4-10.62.67,0,1.34,0,2-.09,1.15-.26,2.4-2.32,3.41-.45C1203.52,573.33,1202.43,574.73,1200.51,575.23Z"
              />
              <path
                class="cls5-215"
                d="M1183.2,592.7c-.37-.54-1-1.05-1-1.63-.14-1.19,2.75-2,.89-3.24-1.66-1.1-3.3.35-4.59,1.65a5,5,0,0,1-1,.65c-1.77-2.66.64-3.52,2.08-4.76s2.8-2.26,4.68-.9a12.4,12.4,0,0,0,2.73,1.74c1.09.74,2.74,1.16,2,3.09a1.34,1.34,0,0,0-.4,0c-1.09.22-2.65-1.31-3.21.32s2.49-.22,2.22,1.73Z"
              />
              <path
                class="cls5-216"
                d="M1194,583.4c.28.29.57.57.86.85l-.65.89c-.33.31-.53.79-1.08.81-1.24-.07-1.88.79-2.51,1.65a4.27,4.27,0,0,1-3.65-4.55,3.24,3.24,0,0,1,3-3.43h.19C1192.21,580.12,1193.05,581.8,1194,583.4Z"
              />
              <path
                class="cls5-217"
                d="M1190.73,580.06c-4.09,2.1-4.09,2.42-.12,7.54.07,1.23.66,3-1.73,1.7-.28-1.25-1.49-1.73-2.2-2.62-1.56-.88-3.63-1.87-2.84-3.88a6.41,6.41,0,0,1,5.72-4,1.06,1.06,0,0,1,1.18.92A1,1,0,0,1,1190.73,580.06Z"
              />
              <path
                class="cls5-218"
                d="M1199.06,589.26l.79,1c.85,2.87-1.48,3.19-3.2,4a1.93,1.93,0,0,1-1.78-2.07,2.32,2.32,0,0,1,.07-.38C1196.18,590.75,1197.16,589.27,1199.06,589.26Z"
              />
              <path
                class="cls5-219"
                d="M918,366.59c-4.89-3.48-10.58-5.79-14.87-10.15,6.93,2.25,12.5,6.91,18.47,10.79s11.71,8.22,17.85,11.93c4.57,2.76,8.34,6.76,13.42,8.75l-.63,1.65c-3.71.68-5.23-2.8-7.89-4.12-1.34-1.08-3-1.69-4.32-2.76-6.6-4.91-13.69-9.08-20.35-13.9C918.9,368.25,918.94,367.06,918,366.59Z"
              />
              <path
                class="cls5-220"
                d="M849.92,254.33l3.48-1c1.05,2.75-1.15,3.56-2.78,4.76a18,18,0,0,1-4,2.55Z"
              />
              <path
                class="cls5-221"
                d="M964.53,389l-.72,2.27c-3.15,2.29-4.79.35-6.21-2.22-.36-.65-1.23-1.23-.1-2s1.7-.68,2.33.44C960.92,389.46,962.36,390.39,964.53,389Z"
              />
              <path
                class="cls5-222"
                d="M894.19,340.63c-1.08,1.64-2.13,2.68-4.2,1-1.84-1.47-3.64-2.64-1.68-5.2C891.17,336.58,893.24,337.82,894.19,340.63Z"
              />
              <path
                class="cls5-128"
                d="M982.9,341.5c1.1-.8,2.21-.13,3.31,0,1.2,1.13.67,2.21-.09,3.28-1.14,1.05-2.45,1.88-3.65,2.86a5.18,5.18,0,0,1-2.13.84,2.17,2.17,0,0,1-1.08-.33c-.91-.7-1.87-1.45-2.71,0A2.08,2.08,0,0,0,977,351a2.55,2.55,0,0,0,.43.23,5.9,5.9,0,0,1,.79.79c2.12,1.63,4.93.06,7.08,1.54.66.75.25,1.4-.21,2-1,1-2.79.52-3.54,2-1,1.24-1.91,2.66-3.67,3-3.21.27-4.25-3-6.59-4.09.79-1.55,3.13-2.91.59-4.87a3.69,3.69,0,0,1-.43-1c-.19-1.06-.2-2.21-1.65-2.88-1.54,1.42-1.71,3.86-3.35,5.26l-.29.26-1.55-1.18c-.82-1.61,1.73-2.43,1-4-.22-1.31,1.34-1.44,1.61-2.43,1.37-3.87,4.12.3,5.92-1a19.33,19.33,0,0,0,3.06-2.43,2.47,2.47,0,0,1,2.6.62C981.24,345.87,981.48,341.76,982.9,341.5Z"
              />
              <path
                class="cls5-223"
                d="M990.52,355.65l-1.72-1.53c3.22-2.46,7.11-1.41,10.62-1.62a9.4,9.4,0,0,0,5.74-2.13c2.18,2,5.08,2.35,7.7,3.35.53,1,0,1.64-.71,2.25-2,1.07-4.26.5-6.35,1a6.63,6.63,0,0,1-1.26,0c-2.42-.7-4.83.41-7.26.08a4.69,4.69,0,0,1-2.67-1.46Z"
              />
              <path
                class="cls5-224"
                d="M972.36,351.53c1.4,0,2.56.63,2.33,2.12a3.25,3.25,0,0,1-3.37,2.86l-1.67-1L966.48,353c-.79-2.84,3.24-4.15,2-7.22,2,1.3,5.11,1.4,3.68,4.84-.33.69-1.67.3-1.52,1.23C970.67,352.13,971.75,351.63,972.36,351.53Z"
              />
              <path
                class="cls5-225"
                d="M979.65,362.21c.89-1.14,1.74-.82,2.66,0,1.31,1.19,2.09.68,2.49-.87,2,.77,1.9,1.87.66,3.35-1.11,1.32-2.16,1.68-3.41.31C981.22,364.1,980.45,363.15,979.65,362.21Z"
              />
              <path
                class="cls5-226"
                d="M974.64,368a7,7,0,0,1-2.12-1c-1-1-3.83-1.47-2.83-3.16,1.22-2,2.49,1.31,4.07,1l1.67,1.71C975.16,367,974.9,367.48,974.64,368Z"
              />
              <path
                class="cls5-227"
                d="M968.71,374.11c-.83,1.54-2.05,3.09-3.47,3.22a5.11,5.11,0,0,1-4.12-2,1.25,1.25,0,0,1,.27-1.07c2.2-.42,4.42-.78,6.65-1.06C968.22,373.15,968.47,373.76,968.71,374.11Z"
              />
              <path
                class="cls5-228"
                d="M849.13,274l1.62.06a1.09,1.09,0,0,1,.13,1.92c-1,.91-1.87.69-2.66-.28C848.34,275.06,848.42,274.37,849.13,274Z"
              />
              <path
                class="cls5-229"
                d="M914,338.15a14,14,0,0,0-1.55-1.88c-2.8-2.38-4.21-5.15-2.23-8.65a7.49,7.49,0,0,1,9.27-3.33c2.93,1.18,4.64,3.48,4.37,6.76a7.68,7.68,0,0,1-7.4,7c-.82.06-1.65.05-2.48.08Z"
              />
              <path
                class="cls5-230"
                d="M918.07,266.76,904,257.33v-1.42l15.16,9.81Z"
              />
              <path
                class="cls5-231"
                d="M900.66,294.71c-1.16-2.5-4-3-5.72-4.9.09-.1.21-.3.26-.28,3.94,1,5-1.39,5.47-4.57,1.93-1.7,4.91.72,6.66-1.69l.88.92c.14,3.34-1.45,6.55-.76,9.93a3.1,3.1,0,0,1-2.62,1.68C903.37,295.69,901.88,295.71,900.66,294.71Z"
              />
              <path
                class="cls5-232"
                d="M904.43,267.37h.08c.74.91,1.92,1.77.71,3.06a1.41,1.41,0,0,1-1.43,0C902.5,269.17,903.78,268.31,904.43,267.37Z"
              />
              <path
                class="cls5-233"
                d="M886.34,298.23a2.56,2.56,0,0,1-2.2,2.17,2.2,2.2,0,0,1-.21-4.4h.29C885.35,296.05,886.08,297.05,886.34,298.23Z"
              />
              <path
                class="cls5-234"
                d="M934.06,344.05c1.55.49,2.78,1.21,2.35,3.16C932.85,348.22,934.16,345.61,934.06,344.05Z"
              />
              <path
                class="cls5-235"
                d="M1009.17,308.24c2.93,2.2,5.88,4.39,8.79,6.63.17.13.09.76-.06,1.08a1,1,0,0,1-1.32.5l-.06,0q-4.2-2.9-8.29-5.95c-.29-.21-.29-1-.18-1.45C1008.11,308.74,1008.65,308.58,1009.17,308.24Z"
              />
              <path
                class="cls5-236"
                d="M1014.68,333.33c1.42-1.19,3.08-1.92,4.18-3.7,1-1.55,1.71-.48,1.5,1-2.14,1.31-2.14,4.92-5.41,5Z"
              />
              <path
                class="cls5-237"
                d="M1032,286.67a12.18,12.18,0,0,1-.14,1.34c-1.36,1.73-2.82,3.38-4,5.2-1.07,1.62-2,1.79-3.64.68s-1.89-2.12-.59-3.61a13.68,13.68,0,0,0,1.91-2.69C1027.23,284.16,1029.35,283.76,1032,286.67Z"
              />
              <path
                class="cls5-238"
                d="M998.69,342.41c1.69.83,1.95,1.92.86,3.52-1.23,1.82-2.57,1.67-4.11.53l-2.53-4.27c.37-1.47-2.07-2.35-.84-4C994.66,339,996,341.79,998.69,342.41Z"
              />
              <path
                class="cls5-239"
                d="M976.23,342.5c.34,2.74-1.44,2.34-3.11,2.08-3.38-2.15-.69-3.39.72-4.83h.87a1.76,1.76,0,0,1,1.22.79A2.73,2.73,0,0,1,976.23,342.5Z"
              />
              <path
                class="cls5-240"
                d="M982.9,341.5c-.23,1.79-.6,3.66-2.75,3.84a1.51,1.51,0,0,1-1.69-1.3,1.54,1.54,0,0,1,.17-.92,2.53,2.53,0,0,1,.88-2.73,1.7,1.7,0,0,1,1.71.17Z"
              />
              <path
                class="cls5-241"
                d="M981.22,340.56l-1.85.15c-1.25,1-2.49.52-3.73,0l-1-.89C977.46,334.9,979.12,339.59,981.22,340.56Z"
              />
              <path
                class="cls5-152"
                d="M975.59,302.07a1.59,1.59,0,0,1-1.59-1.51c-.14-1,.46-1.49,1.42-1.52s1.63.28,1.64,1.34A1.6,1.6,0,0,1,975.59,302.07Z"
              />
              <path
                class="cls5-242"
                d="M926.38,262.43c-.79-2.12-1.08-3.67,1.93-4.59,1.3-.39,2-2.85,2.93-4.37l1.76-.31A21,21,0,0,1,926.38,262.43Z"
              />
              <path
                class="cls5-243"
                d="M921.91,268.28c-.06-1.75-.92-3.91,2.09-4.09C925.42,266.64,923.76,267.51,921.91,268.28Z"
              />
              <path
                class="cls5-242"
                d="M926.33,248.37c1.57,2.07,3.75,1.79,5.93,1.54l-1.76,1.86-4.8-.05A5.28,5.28,0,0,0,926.33,248.37Z"
              />
              <path
                class="cls5-244"
                d="M830.08,263.26c-1.29.26-1.28,2.7-3.08,2-1.17-.48-1.16-1.69-1.07-2.8C827.27,262.92,829.35,259.76,830.08,263.26Z"
              />
              <path
                class="cls5-195"
                d="M1271.28,491.3c.1-3.89,4.36-5.48,5-9.06l1.66.61c2.3,2.29,3.76,1.76,5.17-1.12,1-2,1.75-4.37,4-5.59-.44,3.49-3.72,5.71-4.13,9.21-2.18,2-4-.48-6-.78-.1,2.33,3,1.93,2.93,4.21-1.86.51-2.78-1.54-4.47-1.59-.29,1.11.78,1.17,1.26,1.64.83.81,2.69,1.56,1.6,2.8-1.38,1.57-1.67-.9-2.37-1.42C1273.69,488.6,1272.64,490.3,1271.28,491.3Z"
              />
              <path
                class="cls5-245"
                d="M1023.72,352.4l-1.49-1.14c-.34-1.08-1.76-2.08-.22-3.29C1023.72,349,1025.68,349.94,1023.72,352.4Z"
              />
              <path
                class="cls5-246"
                d="M1036.43,365.38c-1.45-3.47-6.23-2.93-7.66-6.42,3-3.06,5.16.73,7.75,1,4.92.43,4.19,3.19,2.8,6.33C1037.9,367.49,1037.13,366.57,1036.43,365.38Z"
              />
              <path
                class="cls5-247"
                d="M1036.16,369.65a24.3,24.3,0,0,1,2.71,1.89c2.33,2.12,4.13,1.77,5.54-1H1047c0,.54-.09,1.08-.13,1.61-3.79.73-3.49,2.25-.89,4.33,2,1.61,4.67,2.43,6,4.87l-.48.36c-3.52.2-5.65-2.53-8.07-4.26-2.86-2-6.69-3.12-8.14-6.87Z"
              />
              <path
                class="cls5-248"
                d="M1027.78,355.67c-4.13.34-8.38-1.17-12.42.77a2.66,2.66,0,0,1-3.38-1l.81-1.46h13.47l2.4,1.39Z"
              />
              <path
                class="cls5-249"
                d="M1044.46,366.62c-1.71-.21-2-1.78-2.77-2.8-.55-.73.37-1.46.9-1.23,1.11.48,2.86.54,2.58,2.53C1045.09,365.72,1045.41,366.51,1044.46,366.62Z"
              />
              <path
                class="cls5-250"
                d="M1028.6,315.63c.44-.42.92-1.51,1.41-.95s.27,1.72.36,2.62c-2.15,2.3-4.8,4.15-6.2,7.12-.26.55-.65,1.72-1.65.66-.14-.15.17-.73.28-1.11-.11-2.66,1.63-4.23,3.42-5.77C1027.17,317.49,1028.3,316.94,1028.6,315.63Z"
              />
              <path
                class="cls5-212"
                d="M1172.55,511.12a9,9,0,0,0-5,5.8c-.31,1.18-1.41,3.42-3.84,2.12-1.41-.75-2.67.44-1.93,1.31,2.36,2.74-.6,4.95-.25,7.39-.25.37-.51.37-.77,0l-.22-.17a56,56,0,0,0-9.8-12.31c1.37-1.32,2.46.54,3.86.33-.4-2.89-2.35-3.63-5-3.68-.16,1.32,2,1.88,1.13,3.37a6.21,6.21,0,0,1-4.47-2.67c-1-1.6-2.47-1.49-4-1.62-.5-.29-1-.53-1.19-1.17.11-2.53,2.7-1.48,4-2.62,1.66-1.5,2.43-2.2.89-4.15-.92-1.17-1.35-2.7-2.35-3.86-1.17-1.73-2.47-3.37-3.72-5-1.68-2.39-4-4.31-4.88-7.27a3.31,3.31,0,0,1,1.21-3.32,1.63,1.63,0,0,1,1.17-.11,2.27,2.27,0,0,1,.68,1.59c.09,2.52,2,4,3.36,5.77,1.62,2.08,1-1,1.85-.85a2.27,2.27,0,0,1,2.16-.06c1.21,1.22-.74,2.71.35,4a20.87,20.87,0,0,0,6.17,8.22c.8.68,1.61,1.87,2.82,1.15,1-.6.45-1.76.31-2.68a59.36,59.36,0,0,0-1.85-8.94c-1.11-5-1.57-10.06-3.45-14.83.32-2.62-1.25-4-3.36-4.92-3.23.55-3.91,3.82-6,5.61-1,.84-1.38,2.4-3.08,2.23a3.87,3.87,0,0,1-1.83-3.51,16.47,16.47,0,0,0,5.58-6.11c.43-.55.9-1.05,1.34-1.59,1.93-2.41,2.33-4.42-1-6A3.88,3.88,0,0,1,1139,459c1-1.46,2.48-2.82,1-4.81a2.62,2.62,0,0,1,.66-2.24c2-.73,2.44.92,3.19,2.1.68,1.59,2.63,2.49,2.56,4.51,0,.77-.48,1.48-.31,2.34,1.2-.13.53-1.07.7-1.62a2.51,2.51,0,0,1,1.37-2.39c3,.15,4.94,2.23,7.06,3.82s3.65,1.77,5.71.66c.48,1.31-.3,2.79.54,4.06,2.81,3.93,7.36,5.67,10.94,8.64,1.29,1.06,2.92,1.71,2.38,3.83-.46.39-1.08.62-1.51.24-3.73-3.25-8.47-5.2-11.63-9.16-2.53-1.1-4.78-3-7.78-2.79-.74-1.43-.09-3.52-2.41-4.3,5.17,2.82-2,4.34-.38,6.79,1.14-.56,1-2.95,3.07-2.34,1.32,1.34-.14,2.9.33,4.49,2.66.53,4.57-1.47,6.85-2.14,1,1.94,2.74,3.42,3.85,5.31.21,1.89,2.34,2.7,2.6,4.57,0,1.43.7,2.94-.41,4.27-2.26.19-2.6-2.09-4-3.08a.44.44,0,0,0-.39,0c-.11.05-.15.22-.2.37-.23,1.53,1.16,2.83.54,4.38-1.2,3-.41,6.16-1.09,9.19-1,2.16.3,4.92-1.76,6.8a.94.94,0,0,1-1.12-.39c-1.31-4.34-.6-8.78-.5-13.17.06-2.76.23-5.53.29-8.29.06-2.38-1.36-3.83-3.63-3.42-2.46.43-.94,2.39-.8,3.69.81,7.3,3.22,14.3,4.12,21.58.51,3.94.52,4,3.79,2a6.46,6.46,0,0,1,2.91-1.24,2.85,2.85,0,0,1,2.68,1,1.12,1.12,0,0,1-.24,1.08c-2.6,1.7-5.1,3.55-8.44,5.37,3.13.3,2.41,3,3.77,4.33.69.35,1.29,1.62,2.2.18-.77-.89-2.08.59-2.73-.64-.54-2.95,1.41-3.66,3.62-3.62a26,26,0,0,0,5.29-.4c.2.06.39.14.58.21A10.94,10.94,0,0,1,1172.55,511.12Z"
              />
              <path
                class="cls5-251"
                d="M1179.88,484.52c.85-.65,1.82-.26,3.37-.28l-7.65-6.41c.49-.6,1.12-.9,1.78-.41,3.1,2.24,6.43,4.25,9.13,6.9,1.36,1.34,2.63,3.46.09,5.94-3.08,3-4.39,7.53-7.76,10.53-1.15,1-2,2.23-3.75,2.07l-.45-.37c-.45-1.39.47-2.17,1.3-3,2-1.55,1.84-4.2,3.11-6.12a10.89,10.89,0,0,0,3.69-4.51c.81-2.11-1.4-1.59-2.09-2.39C1180,486,1179.51,485.41,1179.88,484.52Z"
              />
              <path
                class="cls5-252"
                d="M1194.8,465.48l4.94,3.4c.43.74,1.63,1.46.06,2.26-1.6-.35-3-2.49-4.85-.51-1.51.58-2.66,1.47-2.65,3.38.57-2.91,3.11-1.81,4.84-2.48a3.13,3.13,0,0,1,2.66-.38c-1.41,2.89-4.82,4.89-5.71,7.21-1.42,3.7-2.84,2.67-5,1.92.18-3.62-.9-7.26.47-10.86.41-1.06-.88-1.56-1.46-2.27-.39-1.7.69-2.9,1.44-4.21l.32-.19C1192.48,461.85,1193.67,463.62,1194.8,465.48Z"
              />
              <path
                class="cls5-253"
                d="M1161.58,465.34c-1.4-1.16-.59-2.78-.88-4.17a4.55,4.55,0,0,1-1.3-3.14,3.59,3.59,0,0,1,1.11-2.56,1.81,1.81,0,0,1,1-.35c1.54.73,3.08.16,4.62-.05a1.53,1.53,0,0,1,.95.5c1.13,1.39,2,3.15,4.22,2.95,1.37-.64,2.27-2.34,4.14-1.87,1.09.35,2.27.61,2.1,2.18-1.52,1.37-4.08,2.23-2.51,5.11-.11,1.48-.53,2.43-2.29,1.57-3.38-1.65-7.66-1-10.15-4.57C1161.28,462.62,1161.94,464.07,1161.58,465.34Z"
              />
              <path
                class="cls5-254"
                d="M1204.82,498.58l3.51,2.5c-1.08,3.52-2.34,6.86-6.69,7.44a5.81,5.81,0,0,1-4.08-3.81,3.78,3.78,0,0,1,.08-1.86,19,19,0,0,1,2.45-4.15C1201.62,496.73,1203.22,497.41,1204.82,498.58Z"
              />
              <path
                class="cls5-255"
                d="M1188.36,466.94c2.4.19,3.74.72,2.05,3.56a7,7,0,0,0,.14,7.22c1.26,2.1-1.55,1.4-1.48,2.56-3.09-.36-3.38-3.74-5.51-5.19-.66-.46.44-1.4.63-2.12.31-1.17,2.69-1.46,1.37-3.26a4.34,4.34,0,0,1,.11-.59A3.5,3.5,0,0,1,1188.36,466.94Z"
              />
              <path
                class="cls5-256"
                d="M1198.14,502.89l-.11,1.6a2,2,0,0,1-2.53.91c-.94-.67-1.83-2-3.09-.6-1.61,1.8.62,2.54,1.15,3.74a2,2,0,0,1-.14,1.71,1.58,1.58,0,0,1-1.11.32c-3.24-1.71-6.76-3-9.08-6.12.62-1.92.42-4.76,3.89-3.48l.46.3c.4.28-.1,1.76,1,1a5,5,0,0,0,1.72-3.92,1.57,1.57,0,0,1,.62-.91c.82-.35,2-.43,2.22.32C1194,500.32,1196.76,500.9,1198.14,502.89Z"
              />
              <path
                class="cls5-257"
                d="M1190.64,497.82a4.79,4.79,0,0,0,.1.76c-.83,1.11-1.49,2.43-3.16,2.46a3.62,3.62,0,0,1-.46-.06c-.38-2.22,3.65-9.6,5.62-10.3a2.45,2.45,0,0,1,2.28.6c3.3,2.38,6.89,4.39,9.8,7.3-1.52-.4-3.07-1-4.25.69a10.53,10.53,0,0,1-1.49-1.42C1195.25,494.23,1194.51,494.23,1190.64,497.82Z"
              />
              <path
                class="cls5-258"
                d="M1212.22,455.38V437.17a1.22,1.22,0,0,1,0-1.72l0,0,5,.16c-2.64.44-3.85,1.8-3.42,4.63a47.62,47.62,0,0,1,.22,6.09,5.44,5.44,0,0,1,0,5.71v11C1211.24,460.37,1212.91,457.62,1212.22,455.38Z"
              />
              <path
                class="cls5-259"
                d="M1224.18,460.82a4.2,4.2,0,0,0-1.61-.23c-1.92.57-4.24,1.18-4.7-1.3-.27-1.48,1.42-3.32,3.37-3.65,2.34-.4,4.42.14,5.16,2.81a5.37,5.37,0,0,1-.07,1.65C1225.89,461.15,1225,460.82,1224.18,460.82Z"
              />
              <path
                class="cls5-260"
                d="M1212.21,486.07V467.81c1-.86-1.81-3.95,1.88-3.3v20.56l-.09.54a1.78,1.78,0,0,1-1.38.75Z"
              />
              <path
                class="cls5-261"
                d="M1228.88,428.74c1.71-2.32,1.66-4.84.81-7.44-.19-.77.07-1,.82-.7.72.88,1.66.63,2.57.52.91.59,3-.44,2.81,1.37-.14,1.46-1.52.44-2.33.23-1.26-.33-1.28.4-1.34,1.32-.28,3.87-.3,3.87-3,7.47C1227.51,430.76,1229.3,429.61,1228.88,428.74Z"
              />
              <path
                class="cls5-262"
                d="M1204,479.3c3.47,2.34-.71,3.42-.86,5.16-.64.81-.82,2.31-2.45,1.67C1198.28,482.17,1201.75,481,1204,479.3Z"
              />
              <path
                class="cls5-263"
                d="M1175.09,502.86c.76,2.68.16,4.73-2.67,5.74h0c-1.63-1.75-5.18-2.09-4.21-5.75l.12-.12a1.48,1.48,0,0,1,1.59-.28c1.53,1.57,3.15.24,4.73.14Z"
              />
              <path
                class="cls5-264"
                d="M1200.65,486.13l2.45-1.67c-.48,2.88,4.26,2.73,3.39,5.84C1202.49,491.78,1202.59,487.53,1200.65,486.13Z"
              />
              <path
                class="cls5-265"
                d="M1206.4,474.67a9.2,9.2,0,0,0,1,1.24c.91.78,3.1,1.07,1.56,2.88s-2.11-.85-3.28-1.06c-.7-.75-2-1.2-1.4-2.61C1204.77,474.05,1205.62,474.41,1206.4,474.67Z"
              />
              <path
                class="cls5-266"
                d="M1175.05,463.94c-.77,0-1.5.93-2.25.22s-.15-1.3.24-1.8c1.15-1.5,1.49-4,4.26-3.57.22.11.31.25.26.4s-.1.25-.17.25l-1.65,4.39A1.48,1.48,0,0,0,1175.05,463.94Z"
              />
              <path
                class="cls5-255"
                d="M1180.81,467.13l4-.08a1.88,1.88,0,0,1,1.09,2.25l-.3.41C1183.68,469.39,1181.65,469.36,1180.81,467.13Z"
              />
              <path
                class="cls5-267"
                d="M1244.59,457c-.86,0-.11,1.67-1,1.27a2.77,2.77,0,0,1-1.33-2.82,1.89,1.89,0,0,1,2.6.15C1245.42,456.1,1244.86,456.55,1244.59,457Z"
              />
              <path
                class="cls5-268"
                d="M1221.09,409.53c-.62,1.46-.06,3.5-2,4-.37.1-1.29-.41-1.31-.68C1217.58,410.64,1220,410.72,1221.09,409.53Z"
              />
              <path
                class="cls5-269"
                d="M1203.93,420.34c2.22.25,4.47-1.22,6.68.09-.48,2.18,1.08,2.3,2.54,2.51-1.08,3.28-2.44,3.45-4.07.35-.91-1.75-2.72-1.41-4.14-2.05-1,1.41,1,1.49.82,2.43-2.53,0-3.31,2.16-4.47,3.81-.72,1-1.51,1.58-2.76,1-1.74-.83-1.11-1.89-.28-3C1200.55,424.22,1200.91,420.81,1203.93,420.34Z"
              />
              <path
                class="cls5-270"
                d="M1227.33,521.77c4.1,3.56,4.11,4.88,0,7.68-1.15.85-2.29-.05-3.43,0-3.71,1.44-4.31-2.4-6.39-3.76-1.32-1.64-3.52-2.76-3.22-5.38a4.86,4.86,0,0,1,.66-1.51c2.84-4.27,3.93-4.48,8.21-1.64A16.25,16.25,0,0,1,1227.33,521.77Z"
              />
              <path
                class="cls5-271"
                d="M1210.73,551.05l3.85-2.22c-.29,3.31-3.1,4.08-4.95,5.29-1.57,1-2.24,1.75-1.55,3.48a4,4,0,0,1-.53,3.42,1.38,1.38,0,0,1-1.12.15c-3.15-4.39-3.15-4.39.3-8.06C1207.89,552.1,1209.07,551.11,1210.73,551.05Z"
              />
              <path
                class="cls5-272"
                d="M1209.75,545c2.34-4.8,2.75-4.91,5.9-1.65C1213.81,544.4,1212.62,547.7,1209.75,545Z"
              />
              <path
                class="cls5-273"
                d="M1225,538.71l-5.37,6.36c-.56-.9-1.11-1.81-1.66-2.71.36-.48.72-1,1.09-1.42a29.68,29.68,0,0,1,2.57-1.88,8,8,0,0,1,2.26-1.35l.06-.06Z"
              />
              <path
                class="cls5-274"
                d="M1228.19,520.15c0-.88-.66-2.18.39-2.52s1.16,1.32,2,1.81C1230.48,522.08,1229.2,520.67,1228.19,520.15Z"
              />
              <path
                class="cls5-275"
                d="M1207.29,561.68l3.26.05.89.73a2.49,2.49,0,0,1-.17.8,3.7,3.7,0,0,1-1.3,1.39c.61-.27,1.09-.77,1.72-1a3.17,3.17,0,0,1,.8-.17l1.45-.05.21,1.6c-.36,1.9-3.5,2.62-2.21,5.22-.34,2.18,1.59,4.27.26,6.49-1.47-1.85-2.89-3.76-4.45-5.54-1-1.17-1.18-.17-1.24.69-1.34,2-3.38,3.3-5.07,5l-.93-1.61c.42-1.19,2.13-1.81,1.46-3.78-1.47.8-2.48,3.26-4.6,1.57-1.08-1.58.33-2.38,1.23-2.8C1202.54,568.38,1204.64,564.77,1207.29,561.68Z"
              />
              <path
                class="cls5-276"
                d="M1212.34,593.34c.68-1.55-1.11-2.51-.93-3.94,1.6-1.47,3.12-3,4.82-4.36,1-.77,2.17-2.14,3.54-1,1.66,1.41-.36,2.29-.82,3.39l-.07.3c-2,1.65-4.31,3.09-4.94,5.92A1.33,1.33,0,0,1,1212.34,593.34Z"
              />
              <path
                class="cls5-277"
                d="M1206.66,579.86l2.51,2.27c.28.94,1.4,2.25-.17,2.65-1.27.33-2.47-.76-3.23-2S1204.63,580.32,1206.66,579.86Z"
              />
              <path
                class="cls5-278"
                d="M1214,593.35c2.41-.23,4,.39,3.21,3.26-1.26.22-2.74-.28-3.6,1.21-.41.71,0,2.18-1.49,2-1.65-.25-1.15-1.87-1.57-2.91.25-1.36-.68-3.34,1.84-3.53Z"
              />
              <path
                class="cls5-279"
                d="M1222.25,569.29l-1.71.09c-1.4-1.26-.15-1.85.67-2.51,1.16-.94,2.36-1.85,3.55-2.77,1.33.33,2.11.93.85,2.2C1224.55,567.36,1223.38,568.3,1222.25,569.29Z"
              />
              <path
                class="cls5-280"
                d="M1214,570.11c-.91,3.94-1.69-1.58-2.57,0-3.83-4.21,2-3.26,2.69-5C1217.44,566.8,1212.9,568.39,1214,570.11Z"
              />
              <path
                class="cls5-281"
                d="M1219.07,571c.49.57,1,1.13,1.49,1.7.08.78.47,1.83-.55,2.1-1.33.35-1.78-1-2.44-1.79-.87-1-1.42-2.16.49-2.76Z"
              />
              <path
                class="cls5-282"
                d="M1251.41,496.2c-1.87,1.11.45,3.7-1.67,4.72-.68,1.29-1.81-1.47-2.44.29-1.26.42-1.36-1.23-2.35-1.3-1.19-.21-2.57-.05-3-1.64,1.25-5.5,5.35-7.06,9.81-3.75A1.74,1.74,0,0,1,1251.41,496.2Z"
              />
              <path
                class="cls5-283"
                d="M1251.41,496.2c0-.55-.05-1.1-.07-1.64-.68-2-2.34-2-4-2.11-1-.08-1.93-.64-1.74-1.83.15-1,1.14-1,2-1.12,3.56-.38,6.16,1.84,9,3.34-.35,1.19-1,2.45,1.12,2.73a2.87,2.87,0,0,1,1.94,1.38c-.6.62-1.2,1.23-1.79,1.85-.92-.64-1.75-.87-2.27.46-.21.38-.47.4-.79.12l-.94-.92a7.8,7.8,0,0,0,.8-1.17A3.42,3.42,0,0,0,1251.41,496.2Z"
              />
              <path
                class="cls5-284"
                d="M1242.3,498.57l3,.93c1,1.62-.24,3.24,0,4.86l-1.37.84c-1.06-.69-2.53-.56-3.37-1.7v-4C1240.88,498.67,1241.35,498.16,1242.3,498.57Z"
              />
              <path
                class="cls5-285"
                d="M1255.4,482.89a5.79,5.79,0,0,1,4.11.68c1.25.23,1.43-.77,1.8-1.56,1.39-1.41,2.86,5.27,4.21,0,3.68,1.41,4,3.51,1.41,6.38-1.16,1.29-2.44,2.73-.8,4.59-.72,1.33-1.59-.08-2.37.13l-3.21,3.15c-1.6-.78-1.13-1.9-.44-3a22.34,22.34,0,0,1,2.71-3.49c.69-.95,1.08-1.77-.73-1.58-1.21-1.05-1.53,1-2.5.75a4.84,4.84,0,0,0-1.61-.09c-3.15.67-4.11-.56-3-3.53C1255.31,484.51,1255.15,483.67,1255.4,482.89Z"
              />
              <path
                class="cls5-286"
                d="M1254.78,499.38a2.66,2.66,0,0,0,.79-.12,1.37,1.37,0,0,1,.63,1.72c-.21.79.46,2.24-1,2.19s-1.59-1.27-1.27-2.44A5.59,5.59,0,0,1,1254.78,499.38Z"
              />
              <path
                class="cls5-287"
                d="M1161.76,435.47v4a1.53,1.53,0,0,1,.18,1.7,2.9,2.9,0,0,1-.89.78,4.75,4.75,0,0,1-3.26.52c-1.27-1.25-1.79,1.21-2.93.62S1153,441.62,1152,441s-1.4-.11-1.76.7c-.72,1.3-1.1,2.93-2.66,3.49s-3.38,1.09-4.78.22c-1.72-1.06.2-2.35.37-3.57a3.48,3.48,0,0,0-.31-1.59c0-2.69,1.81-4.25,3.63-5.8a1.27,1.27,0,0,1,1.42.76c-.2,3.3,2.4.54,3.28,1.52l.42.38c3.19,4,6.62,3.11,10-2.47Z"
              />
              <path
                class="cls5-288"
                d="M1195.67,424.59l6.53-9.69c-.65,4.12-3.21,7-5.63,10Z"
              />
              <path
                class="cls5-289"
                d="M1108.65,408.78a2.35,2.35,0,0,0,.53,0,11.75,11.75,0,0,0,2.7,1.82c1.4.8,1.65,2.06.4,2.94-2.82,2-1.24,3.3.42,4.73a13.37,13.37,0,0,1,2.49,3.21c1.08,1.71,3.12,2.18,4.49,3.51,1.52,1.49,2.65,3.14,2.34,5.41a2,2,0,0,1-2,1.15,14.07,14.07,0,0,1-4.85-4.22c-1-1.36-3.4-1.14-5.15-1.74-.72-.24-1.75.14-2.18-.73-1.9-3.84-6.2-4.85-8.93-7.7a2.89,2.89,0,0,1-.91-1.5,2,2,0,0,1,1.13-2l2.6-2.4c2.46-.56,3.28,2.18,5.32,2.65C1107.68,412.25,1106.53,410,1108.65,408.78Z"
              />
              <path
                class="cls5-290"
                d="M1099.17,413.69l-.66,1.75c-2.5,0-4.36-1.63-5.9-3.08-3.51-3.34-7.42-4.11-11.92-3.16-.84.41-1.52-1.27-2.43-.17a1.81,1.81,0,0,1-1.29-.89c-.34-.71-.62-1.42,0-2.14,1.57-1,3.37-.95,5.17-.88-6.1-5.07-12.82-8.93-18.87-13.73a15.1,15.1,0,0,0-5.85-3c-1.63-2.49-5-3.61-5.49-7h0c6.85,1.59,10.68,7.65,16.34,11.05,7.07,4.25,13.48,9.52,20.59,13.77C1092.5,408.35,1095.36,411.69,1099.17,413.69Z"
              />
              <path
                class="cls5-291"
                d="M1092.5,400.32v2c-1.75.61-4,2-3.22-1.8,1-1.63,1-1.63-1.41-3.22C1091.14,395.39,1091.91,395.9,1092.5,400.32Z"
              />
              <path
                class="cls5-292"
                d="M1083.53,391.09a25.87,25.87,0,0,1,1.72,2.19c1.39,2.25,0,2.25-1.64,1.89C1084.08,393.8,1081,392.51,1083.53,391.09Z"
              />
              <path
                class="cls5-293"
                d="M1065.09,378.06c-.47,1,1.28,2.54-.76,3.16-.58-1.32-2.28-2-2.25-3.69C1063.33,376.57,1064,378.24,1065.09,378.06Z"
              />
              <path
                class="cls5-294"
                d="M1106.06,409.44c-1.62.89-1.73-1.1-2.71-1.41-1.43-4.51,1.59-1.24,2.6-1.49C1106,407.51,1106,408.47,1106.06,409.44Z"
              />
              <path
                class="cls5-295"
                d="M1067.76,383.23l.06-1.21c1.38-.06,2.8-.18,3.75,1.11.17.23.11,1-.06,1.06C1070,384.9,1069,383.54,1067.76,383.23Z"
              />
              <path
                class="cls5-296"
                d="M1141.51,391.05a13,13,0,0,1-5.27-3.56C1140.22,385.27,1140.3,385.31,1141.51,391.05Z"
              />
              <path
                class="cls5-297"
                d="M1145.15,388.12l1.41,4.89c0,1.54-.63,2.3-1.61.63s-1.75-3.63-.64-5.67Z"
              />
              <path
                class="cls5-298"
                d="M1099.22,533.32c1.56.36,3.12.7,4.67,1.08,1,.25,2.52.41,2.52,1.55,0,1.6-1.6.88-2.55,1a13.35,13.35,0,0,1-2,0c-1.12-.49-1.69.53-2.49.9C1096.09,536.44,1099.05,534.84,1099.22,533.32Z"
              />
              <path
                class="cls5-299"
                d="M1110.89,483.69c-5.37.52-5.36.53-3.33-4.65a3.51,3.51,0,0,0,0-1.21c-1.86-3.44-5.81-4.42-8.29-7.11-.84-.9-3.14-1-2.32-2.78.68-1.52,2.44-.1,3.69-.38-.75-.82-2.75-.51-2.05-2.47a4.32,4.32,0,0,1,3-1.75,3,3,0,0,1,2,1c-.67,2.34,2.65,1.51,2.65,3.32a2.46,2.46,0,0,1,0,1.08c-.1.48-.66.92-.36,1.39s.7,0,1.07-.07a3.73,3.73,0,0,1,2.49,1.87c.17.51-.23,1.32.26,1.51.73.28,1.09-.59,1.57-1,.63-1.58-.92-2.13-1.52-3.1-1-1.54-1.61-2.94.21-4.3,4-1.21,6.87.93,9.66,3.3.91,1.56,2.54,2.09,4,2.72,4,1.68,4.07,1.68,2.28,5.76a3.61,3.61,0,0,1-.68,1c-1.14.62-2.13,0-3.15-.4-.65-.24-1.7-.72-1.94-.24-1.79,3.51-6.46,2.62-8.45,5.72A2.48,2.48,0,0,1,1110.89,483.69Z"
              />
              <path
                class="cls5-300"
                d="M1077.75,455.19c-1.46,0-2.17,1.35-3.32,1.9-.47-.47-.58-1.14-1-1.66a6.92,6.92,0,0,0,1,1.67c-1,1.79-.92,3,1,4.38,1.31.89,3.16,1.77,3.18,3.9-3.34-1.86-6.64-3.77-9.27-6.63,1.55-2.34-1.78-3.79-1.09-6,.93-1.94,2.77-3.23,3.63-5.07-.71.66-1,2-2.35,2.11a1.94,1.94,0,0,1-1.27-1.12c.73-2.52-.46-4.16-2.42-5.51-3.39-2.33-6.7-4.79-9.94-7.33a17,17,0,0,1-2.64-2.85c-.44-2.33,1.79-1.92,2.82-2.74,1.09.85,1.33,2.48,2.76,3,.86.21,1.78-.07,2.62.31a50.72,50.72,0,0,1,5,3.48c2.27,1.82,3.79,1.27,5.14-1,2.67-1,4.87,2.81,7.65.74a2.27,2.27,0,0,1,1.23,1.15c.57,1.84-.49,3.18-1.5,4.48a6.73,6.73,0,0,0-1.72,4.11,2.77,2.77,0,0,1-.64,1.45c-2,2-2.32,3.77.38,5.43A1.66,1.66,0,0,1,1077.75,455.19Z"
              />
              <path
                class="cls5-300"
                d="M1079.83,466.18c0-1.51-.15-3.24,1.51-3.87,3.87-1.46,5.18-5.09,7-8.17,1.91-3.3,3.25-2.67,5.09-.19a4,4,0,0,1,.94,2.63,6.24,6.24,0,0,1-.81,4.05c.64,3-.24,6,.32,8.93.32,1.68-.85,2.42-1.89,3.28-1,1.17-2,.49-2.9-.09A63.32,63.32,0,0,1,1079.83,466.18Z"
              />
              <path
                class="cls5-301"
                d="M1132.5,495.29c-2.35.06-5.13-.51-5,3.33-.26.34-.51.34-.77,0-1.26-1.75-1.82-3.26.23-5.1.78-.69,2.26-3.33-1.22-3.28a24.84,24.84,0,0,1-2.61-1c-.5,1,1,1.81.15,2.75a43.37,43.37,0,0,1-12.59-6.53c-.78-.58,0-1.21.15-1.81l.12-1c2.33-1.35,4.47-1.94,6.65.5,1.5,1.67,3.36,1.76,5-.16.62-.74,1.32-1.47,2.45-1.24.78.57,1.19,1.47,1.9,2.1,2,1.77,4,3,6-.07a2.54,2.54,0,0,1,2.7-1.42,1.63,1.63,0,0,1,1.07,1.31,4.93,4.93,0,0,0-.87,3.31,26.77,26.77,0,0,1-2.13,3.71C1132.14,491.94,1133.36,493.9,1132.5,495.29Z"
              />
              <path
                class="cls5-302"
                d="M1094.38,484.36l-2.43.91c.16-2.06-.34-3.6-2.52-4.5-3.86-1.61-6.62-5.23-10.92-6.09l-.12-.86c.95-.52.36-1.16.15-1.77C1084,475.88,1091.16,477.61,1094.38,484.36Z"
              />
              <path
                class="cls5-303"
                d="M1068.69,458.62c-.49-1.66-.86-3.36-1.49-4.95a3.67,3.67,0,0,1,1.45-4.85l.72.71c.76,1.3-.31,2.19-.71,3.22a7.75,7.75,0,0,0,1.95,3.53c2,1.92,0,2.08-1.26,2.47A5.13,5.13,0,0,1,1068.69,458.62Z"
              />
              <path
                class="cls5-304"
                d="M1059.22,452.94c1.14-1.17,3.81-1,3.1-3.87-.22-.89,1.21-.76,2-.39s1.88.94,1.12,1.72c-1.43,1.48-1.66,5.1-5.19,3.37Z"
              />
              <path
                class="cls5-305"
                d="M1123.33,492c-.32-1.68-3.9-2.69-1.73-4.48,1.26-1,3.09,1.22,4.19,2.7C1124.69,490.46,1125.4,493.18,1123.33,492Z"
              />
              <path
                class="cls5-212"
                d="M1134.17,503.62c1.29.33,3-2.51,3.57-.05a28.44,28.44,0,0,1,.6,3.44C1136.4,506.55,1135.22,505.16,1134.17,503.62Z"
              />
              <path
                class="cls5-212"
                d="M1126.78,498.63h.77c2.43,1.4,5.1,2.47,6.66,5C1131.1,502.91,1128.9,500.83,1126.78,498.63Z"
              />
              <path
                class="cls5-306"
                d="M1136.69,510.05l5,.07.75.87c-2.67-.23-5.47,1.08-8-.66Z"
              />
              <path
                class="cls5-307"
                d="M1119.25,522.92c.76,1.2,3.66,0,3.11,2.41s-2.68.25-3.9,1c-3.32-.27-5.28-1.49-3.83-5.28.44-1.17.53-2.46,2.3-2.31s1.47,1.32,1.51,2.41A1.93,1.93,0,0,0,1119.25,522.92Z"
              />
              <path
                class="cls5-308"
                d="M1099.4,530.36c2.11.45,4.24.86,6.35,1.36.69.16,1.87,0,1.5,1.33-.31,1.06-1.17.82-2,.68-2-.3-4-.51-6-.75C1097.9,532,1098.83,531.2,1099.4,530.36Z"
              />
              <path
                class="cls5-309"
                d="M981.71,428.64c-.58-2.73-1.09-5.47-1.77-8.18-.16-.62-.24-1.06.31-1.31s1.67-.1,1.78.5c.51,2.93,1.7,5.87.85,8.87Z"
              />
              <path
                class="cls5-310"
                d="M973.6,423.45c1.53,1.5,3.73,2.72,2.22,5.3-.39.66-1.33,1.75-1.85,1.24C972.05,428.13,973.35,425.75,973.6,423.45Z"
              />
              <path
                class="cls5-311"
                d="M1005.48,405.51l-.9-.95a2.23,2.23,0,0,1-2-1.92c.88-2.82,1.77-5.64,4.95-6.78a2.23,2.23,0,0,1,1.08.19c.73,1.64,2.59,1.6,3.8,2.53.63.5,1.13,1.24,2.13.92,5.43-1.76,8.72,1.52,11.89,5.08a1.9,1.9,0,0,1-1,1.95c-2,.17-3.26-1.35-4.67-2.31-2.74-1.86-4.74-1.56-6.46,1.31a9.09,9.09,0,0,1-2.83,3.47C1008.56,409.37,1007.51,406.6,1005.48,405.51Z"
              />
              <path
                class="cls5-312"
                d="M1005.48,405.51c.69.16,1.54-2,2.23.41.36,1.24,2.29,2,3.51,3,2.2.38,3.89,1.38,4.42,3.73-.24.73-1,1.26-.75,2.18a1.51,1.51,0,0,1-.37.9,22.11,22.11,0,0,1-2.78,1.22c-.16.05-.33.08-.5.12-1.69.55-2.41-.85-3.4-1.7-1.62-1.6-2.93-3.39-1.6-5.7C1007.24,408,1005.2,407,1005.48,405.51Z"
              />
              <path
                class="cls5-313"
                d="M1029.22,441.14l1.08-1.67c2-2,3.06-.41,4.2,1l1,.78c.73.62.32,1.71-.1,1.62-2.39-.51-4.57,1.84-6.77.61C1027.24,442.72,1029.37,442.05,1029.22,441.14Z"
              />
              <path
                class="cls5-314"
                d="M1170.75,526.75a5.53,5.53,0,0,0-1-4.09c1.61-3.52,3.5-3.85,5.88-.63.55.74,1.16,1.86,2.6.6,1.81-1.59,2.69.72,4.07,1.45.67-.94,0-2.82,1.83-3,1.2,2.13,3.18,3.86,3.29,6.54a3,3,0,0,1-1.72,2.57c-1.08.52-1.74,1.85-3.2,1.63-1.8-.69-3.44,1.1-5.24.34-2.71-1.24-4.49-2.92-2.74-6.51C1173.15,526.36,1172.4,528.68,1170.75,526.75Z"
              />
              <path
                class="cls5-315"
                d="M1160.81,527.74a1.67,1.67,0,0,1,.77,0v17.41c-.56-.09-1.07-.23-1-.95Q1160.66,536,1160.81,527.74Z"
              />
              <path
                class="cls5-316"
                d="M1173.14,577c.18-.93-.06-2,.88-2.68a3.35,3.35,0,0,1,1.57,1.82c1.32,3.58,3,3.07,5,.56,3.22.66,4.68-1.19,5.51-3.91a21.4,21.4,0,0,0-3.28-4.62,9,9,0,0,1-1.36-2.36,7.07,7.07,0,0,0-2.34-2.8c-.82-.75-1.74-1.57-1-2.76,1.92-2.92.9-5.65-.34-8.4a1.46,1.46,0,0,1,1.14-1.19c3.36.8,3.81,3.38,3.68,5.64,1.85-2.17,3.82-4.63,7.39-5a3.41,3.41,0,0,1,2.71,3.1c-.89,2.71-1.34,5.78-5,6.24-1-.19-1.14-1.48-2.14-1.77-.44,1.16.54,2.08.45,3.16a1.28,1.28,0,0,1-1.15,1.1c-1,0-1.16-1-1.64-1.62.41,1.54,1.73,2.28,2.9,3.16,2,1.25,2.73,3.32,3.66,5.29a7.91,7.91,0,0,1,.36,1.17c1.21,3.25.21,5.39-2.94,7s-4.68,5-7.74,6.64c-1.43.77-2.81,2.62-4.62.57Z"
              />
              <path
                class="cls5-317"
                d="M1198,583.3c-.42-1.12-1.3-2.27.25-3.23a34.48,34.48,0,0,1,2.81,2.86c.58.76,1.82,1.75.55,2.74s-1.85-.42-2.54-1.18Z"
              />
              <path
                class="cls5-318"
                d="M1201.44,576.84c.6-2.76,2.75-4,5.07-5C1206.8,574.51,1204.94,576.33,1201.44,576.84Z"
              />
              <path
                class="cls5-319"
                d="M982,387.06c.6,2.91,4,2.79,5.3,5-1.46.13-3.06-1.47-4.12,1.51-.66,1.83-3.47-.21-3.6-1.35-.3-2.73-2.13-3-4.27-3.68,2.71.1,1-2.26,2.18-3.25s1.78-2.8,3.52-2.09-.58,2.07.07,3.11A4.14,4.14,0,0,0,982,387.06Z"
              />
              <path
                class="cls5-320"
                d="M1001.16,406.24a4.42,4.42,0,0,0-3.23-.75l-.91-.83c.92-2,2.32-1.75,4-1S1001.51,405.36,1001.16,406.24Z"
              />
              <path
                class="cls5-321"
                d="M972.36,351.53c-.47,1.53-1.18,2.63-2.94,1.44-.68-.46-1.32-1-.81-2,1-2.11,2.35-.31,3.53-.33C972.21,350.91,972.29,351.22,972.36,351.53Z"
              />
              <path
                class="cls5-322"
                d="M975.64,340.67c1.25-1,2.48.26,3.73,0a2.62,2.62,0,0,1-.74,2.41l-2.4-.62A1.34,1.34,0,0,1,975.64,340.67Z"
              />
              <path
                class="cls5-323"
                d="M984.59,355.55c-.21,2.35-1.18,3.13-3.26,1.56C981.18,354,983.58,356.24,984.59,355.55Z"
              />
              <path
                class="cls5-324"
                d="M989.78,348.06c1.46.57,3.37-1.4,4.48.65.76,1.4-1.1,1.93-1.48,3.09-.77,2.38-2.51.28-3.8.46C989.46,350.9,991.06,349.75,989.78,348.06Z"
              />
              <path
                class="cls5-325"
                d="M904.8,286.21c.77.28,1.68.45,1.63,1.54a1.15,1.15,0,0,1-1.09,1.22,1,1,0,0,1-.25,0,1.52,1.52,0,0,1-1.59-1.43v-.11a1.11,1.11,0,0,1,1-1.22A.94.94,0,0,1,904.8,286.21Z"
              />
              <path
                class="cls5-285"
                d="M1265.51,482l-2.51-1.43c2.84-.77.64-4,2.52-5.21C1265.52,477.53,1265.52,479.75,1265.51,482Z"
              />
              <path
                class="cls5-326"
                d="M1099.18,465.34c2.32-5.21,7-9,8.84-14.51-4.36,3.8-6.72,9.16-10.49,13.43-1.84-1.81,4-2.83.22-4.65-1.78-.85-1.06-1.95-.19-2.91a19.16,19.16,0,0,0,3-3.88c1.75-1.69,2.83-4,5-5.31a3.87,3.87,0,0,0,2.3-1.59c.81-1,1.76-1.38,2.63,0a10.68,10.68,0,0,1,0,2.65c3.32-.27,3.46-2.57,3.25-5.09.94-2,2.58-3.56,3.39-5.74a2.65,2.65,0,0,1,3.39-1.6,2.73,2.73,0,0,1,.81.47c6.34,4.44,12.86,8.66,18.91,13.51a1.75,1.75,0,0,1,.67,1.84l-.09,2.54a1.17,1.17,0,0,1-1.52.33,4.87,4.87,0,0,0-3.44-2.4,5.1,5.1,0,0,1-2.24-2.37c-.74-1-1.53-.76-2.33-.07-1.09,1-2.11,2.06-3.77,1.88-2.35-.59-3.93-2.37-5.83-3.68-.9-.62-1.75-2.54-3.28-.72-.93,1.91-4.94,3-1.64,6-.4,1.52.54,1.67,1.67,1.63a15.53,15.53,0,0,1,2.38,2.2c2.59.64,5.64-.63,7.77,1.9a2.61,2.61,0,0,1,.34,1.68,6.93,6.93,0,0,1-.51,1.66c-1.72,2.84-2.63-.1-3.9-.52-3.53.24-3.56,2.92-3.81,5.44-.28.73-.42,1.64-1.58,1.16-3-1.24-5.57-3.53-9.08-3.25l-.31-.48c-.24-1.38,1-2.11,1.4-3.18.52-1.28,1.58-2.63-.06-3.87-1.44.07-1.84,2.63-3.73,1.58-.59.13.38-2.26-1.08-.69s-2.26,4.06-4.63,4.91Z"
              />
              <path
                class="cls5-327"
                d="M1146.54,471.15c-3.88,3.54-5.8,8.53-9.21,12.42l-.6.16-1-1c-.81-1.19,0-1.82.84-2.45l.85-.89c2.42-2.86,4.94-5.66,7.24-8.63C1145.83,469.34,1146.24,469.35,1146.54,471.15Z"
              />
              <path
                class="cls5-328"
                d="M1140.66,469.72c.28.26.55.53.82.8-.9,2.83-1.67,5.78-5.59,5.58a3.1,3.1,0,0,1,.73-3.34C1138.35,469.47,1138.45,469.39,1140.66,469.72Z"
              />
              <path
                class="cls5-329"
                d="M1163.4,512.77l.7-.4c.91-.57,1.24-2.4,2.87-1.42a1.19,1.19,0,0,1,.4,1.63.91.91,0,0,1-.11.16c-.84,1.13-1.31,3-3,2.85-1.4-.14-1-1.66-.92-2.71Z"
              />
              <path
                class="cls5-330"
                d="M1139.23,454.51h1.61c1.79,2.25,1.13,3.59-1.56,4.16h-.07C1137,457.27,1136.21,455.88,1139.23,454.51Z"
              />
              <path
                class="cls5-331"
                d="M1147.55,459.31c1.36,1.33.81,2.46-.46,3.36a1.63,1.63,0,0,1-2.18-.5c-1.41-1.59.5-2.32,1-3.43C1146.7,458.17,1147,459.06,1147.55,459.31Z"
              />
              <path
                class="cls5-326"
                d="M1147.55,459.31l-1.66-.57c.29-2.09-2.56-2.27-2.54-4.2,2.25-.36,3.34,1.61,5,2.48Z"
              />
              <path
                class="cls5-332"
                d="M1164.93,474.53a19.84,19.84,0,0,1,3.65,3c1,1.24-.44,1-1.11,1.08C1167.38,476.79,1163.71,477.18,1164.93,474.53Z"
              />
              <path
                class="cls5-333"
                d="M1161.78,500.16c-.43.63-.86,1.27-1.58.27,1.51-2-.36-4.68,1.29-6.67C1161.59,495.89,1161.68,498,1161.78,500.16Z"
              />
              <path
                class="cls5-334"
                d="M1223.06,490.3c0,1.44-1,2.86-.11,4.33-1.77.88-1.62-1.09-2.43-1.64-2.42-1.86-4.4.08-6.53.76a2.1,2.1,0,0,1-.78-1.59,2.35,2.35,0,0,1,1-2.07c1.59-.39,3.08-1.53,4.85-.69C1220.48,489.24,1221.32,491.78,1223.06,490.3Z"
              />
              <path
                class="cls5-335"
                d="M1238.92,498.66a2.58,2.58,0,0,0,.09.82c.33,2.6-3.08-1.58-2.61,1.45.22,1.36.19,2.73,1.84,3.21a2.31,2.31,0,0,1-2.69.3c-1-.44-2.32-.39-2.83-1.68a1.48,1.48,0,0,1,.39-1.59C1234.74,499.62,1235.94,497.07,1238.92,498.66Z"
              />
              <path
                class="cls5-336"
                d="M1229.73,487.85c-2.26-.51-4.15.53-6,1.48C1226.5,484.63,1227,484.52,1229.73,487.85Z"
              />
              <path
                class="cls5-260"
                d="M1214.15,485.07c1.18-.26,2.06-2.11,3.61-.5,1.06,1.09,1,1.84-.18,2.64a5.59,5.59,0,0,1-1-.13c-.94-.47-3.13,1.18-2.73-1.6Z"
              />
              <path
                class="cls5-336"
                d="M1233.09,494.49v-4.24C1235.84,491.55,1235.84,491.74,1233.09,494.49Z"
              />
              <path
                class="cls5-260"
                d="M1219,489.4c-1.56-.32-2.59,1.76-4.27,1a2.77,2.77,0,0,1,2-3.38,2.67,2.67,0,0,1,.48-.08c.12.11.25.21.38.31C1217,488.67,1218.64,488.61,1219,489.4Z"
              />
              <path
                class="cls5-260"
                d="M1214,491.93v10.82l-1.7-.88c0-3.83.65-7.78-1.38-11.31-1.23-2.15,0-3.24,1.33-4.48l.37.28C1214.76,487.79,1212.59,490.3,1214,491.93Z"
              />
              <path
                class="cls5-337"
                d="M1174.15,487.92a4.17,4.17,0,0,1,.62-3c1.46-3.09,3.38-.61,5.11-.41.32.56.63,1.13.95,1.7.31,1.64-.72,2.74-1.68,3.76-.74.8-.05,1,.32,1.42a1.77,1.77,0,0,1-.33,2,7.26,7.26,0,0,1-2.76,6.79,19.9,19.9,0,0,1-3.12-1.59l1-8.61c.77-.7,1.35-1.57,2.17-2.31C1175.53,487.29,1174.92,488.36,1174.15,487.92Z"
              />
              <path
                class="cls5-212"
                d="M1168.43,491.09c-.33-2.76-.67-5.52-1-8.29,1,.31,1.1,1.75,2.33,1.68C1169.12,486.64,1172,489.5,1168.43,491.09Z"
              />
              <path
                class="cls5-338"
                d="M1185.86,469.3a2.39,2.39,0,0,1-1.09-2.25c1.75-1.18,1.9-4.2,4.75-4.11,1.08,1.76-.84,2.65-1.17,4C1187.69,467.9,1187.15,469,1185.86,469.3Z"
              />
              <path
                class="cls5-339"
                d="M1173.26,498.61c1.85-1.06,2.61,0,3.12,1.59-.57.8-1.14,1.59-1.7,2.39-1.53,1.21-3,4.83-4.7.18C1171.57,501.78,1172.26,500.07,1173.26,498.61Z"
              />
              <path
                class="cls5-340"
                d="M1179.06,491.2c1.23-.94,1.57-3.35,4-2.4-.22,2.44-.45,4.88-3.88,4.61C1179.11,492.67,1179.08,491.94,1179.06,491.2Z"
              />
              <path
                class="cls5-341"
                d="M1197.36,472.07l-2.55-1.71c1.33-2.92,1.78-2.85,5,.78h0Z"
              />
              <path
                class="cls5-342"
                d="M1163.22,448.63a8,8,0,0,1,7.2,4c1.21,2,4.17,1.87,4.5,4.47-1.62.06-1.61,2.57-3.45,2.29-1.62-1.18-3.4-2.17-4.52-3.92l-.34-.1c-.29-1-.55-2-1.91-1.1-.91.59-1.7,1.46-2.94,1.31l-1-.16c-.09-.15-.18-.31-.28-.46-1.82-2.72,0-4.5,1.63-6.33A1.15,1.15,0,0,1,1163.22,448.63Z"
              />
              <path
                class="cls5-343"
                d="M1167,455.44c1.91.84,4.09,1.37,4.52,3.92C1168.54,459.54,1167.19,458.37,1167,455.44Z"
              />
              <path
                class="cls5-344"
                d="M1193.4,510.12l7.35.1,4-.05.4.47c.17,1.55-.5,2.31-2.07,2.26a15.3,15.3,0,0,0-2-.59c-1.5-.19-3.3-.58-4.33.52-1.31,1.4,1,2.16,1.25,3.41.11.53.39,1,0,1.53-5,.94-.59,3.37-.81,5.07-1.73,2.41-5.3,3.58-5,7.38h-6.59c.35-.94.69-1.88,1-2.83,3.17-.67,4.49-3.46,6.39-5.58,1-1.11-.41-1.56-.68-2.32,2.63-1.15.25-2-.27-2.79s-2.14-1.32-1.09-2.55c3-3.56-.26-2.76-2-3.06.78-1.15,2.07-.67,3.11-1C1192.59,510.09,1193,510.1,1193.4,510.12Z"
              />
              <path
                class="cls5-345"
                d="M1195.78,505.34l-2.64,3.18c-1.18-.68-3.32-.61-2.57-2.85.48-1.44,1.46-3,2.93-3.17S1195.78,503.76,1195.78,505.34Z"
              />
              <path
                class="cls5-346"
                d="M1187.58,501c.9-1,1.39-2.57,3.16-2.46,1.28,3-1.75,4-2.8,6a1.32,1.32,0,0,1-1-.23C1185.91,503,1187,502.07,1187.58,501Z"
              />
              <path
                class="cls5-344"
                d="M1207.39,507.13c1.53,4.15,4.69,6,8.91,6.39.76,2.09-.82,3.11-2,4.34a1.64,1.64,0,0,1-1.09.13,1.75,1.75,0,0,1-.65-.91,4.07,4.07,0,0,0-1.56-2.89,31.85,31.85,0,0,0-3.31-2.22,14.81,14.81,0,0,1-2.7-1.49l-.29-.31C1205.52,509.06,1205.86,507.58,1207.39,507.13Z"
              />
              <path
                class="cls5-347"
                d="M1214,491.93c-3.07-1.21-.21-3.89-1.38-5.58l1.25-.87c.17,1.19.62,1.29,1.51.5,1.28-1.13,1.93-.77,1.86.92l-2.44,3.46A1.53,1.53,0,0,0,1214,491.93Z"
              />
              <path
                class="cls5-348"
                d="M1196.48,545.19a16.65,16.65,0,0,0,3.53-11.43c-.06-1.26,1.16-1.79,2.37-1.82s2.51-.32,3.33,1c1.65,2.72,1.77,6.13.2,8.21-2.89,3.83-1.87,7.44-1.12,11.3,1.11,2.17-.51,2.41-2,2.79a4.43,4.43,0,0,1-2.1-.33C1198.07,552.23,1194.72,549.83,1196.48,545.19Z"
              />
              <path
                class="cls5-349"
                d="M1178.18,551.8c-2.68.79-3.43,3.8-5.76,5-3.67-2.32-5.92-8.35-5-12.71.35-1.63,1.69-2,2.6-3a.89.89,0,0,1,1.22-.32,1.07,1.07,0,0,1,.27.25c2.33,3,4,6.62,7.7,8.42.33.58.38,1.1-.3,1.48Z"
              />
              <path
                class="cls5-350"
                d="M1196.48,545.19c-.13,3.74,2.43,6.2,4.29,9,1,3-.58,5.17-3.14,5.55-3.6.55-4.66-2.49-5.32-5.42a4.5,4.5,0,0,0-2.21-2.49c-.78-.4-.63-1-.28-1.57,3.22-2,3.78-4.22.81-7-.82-.78-2.45-2.11-.6-3.34s2.71.08,3.22,1.76S1195.55,543.87,1196.48,545.19Z"
              />
              <path
                class="cls5-188"
                d="M1202.29,554.39c1.23-.13,2.54-.15,2.5-1.92l1.61-.69c.07.75.07,1.54,1,1.87-3.39,2-1.87,4.6-.77,7.12A78.47,78.47,0,0,1,1196.08,571c-2.65,2-4.78,2.86-7.07-.19a3.14,3.14,0,0,1,.08-.86,9.55,9.55,0,0,0,0-2c.07-.79.15-1.75,1.06-1.9,1.21-.22,1.34,1,1.77,1.74,3.38,1.06,6.28-1.23,6.76-5.38a2.74,2.74,0,0,1,1.07-2.08c1.82-1.19,2.84-2.52,1.69-4.78C1201.17,555.14,1201.84,554.69,1202.29,554.39Z"
              />
              <path
                class="cls5-351"
                d="M1189.82,550.25c.09.52.19,1,.28,1.57-3.32.79-5,4-8.31,5.43.33-2.71-.42-5-2.88-6.3l.3-1.49,3.07-1.9c1.19-.4,2.43-1.78,3.54,0,1,1.59-.55,2.43-1.6,3.83,1.81-2,3.39-2.85,5.38-1.12Z"
              />
              <path
                class="cls5-352"
                d="M1171.51,541.05l-1.5.07c-.15-1.15.21-2.65-1.75-2.57h0c1.53-2.12.11-3.19-1.52-4.09-.75-.41-2.24-.12-2-1.42s1.59-1.17,2.68-1.12a3,3,0,0,1,2.24,1.57c1.64,2.51,3.11,2,4.55-.16a1.2,1.2,0,0,1,1.08.42,2.25,2.25,0,0,1-.16,2.39C1174.55,538.24,1172.87,539.52,1171.51,541.05Z"
              />
              <path
                class="cls5-353"
                d="M1175.11,536.14l-.07-2.61a3.41,3.41,0,0,1,2.36-1.75c1.7.86,3.45-4.19,5.12.05C1180.71,534.39,1178.69,536.61,1175.11,536.14Z"
              />
              <path
                class="cls5-188"
                d="M1223.89,537.71l-1.62,1.64c-1.09-.19-2.18.42-3.27,0-1.3-2.1-.09-4.85-1.79-6.85.49-.68,1.4-1.58,1.84-.57C1220.11,534.4,1222.62,535.51,1223.89,537.71Z"
              />
              <path
                class="cls5-316"
                d="M1189.6,550.28c-3-1-4.63,1.45-7.09,3.12,3-6,3-6-.23-5.84C1185.46,544.4,1185.68,544.48,1189.6,550.28Z"
              />
              <path
                class="cls5-354"
                d="M1220.52,493l2.43,1.64c1.39,2,4.64,2,5.37,4.74a3.25,3.25,0,0,1-.79,3.29l-1.14,1c-3.31-.61-2.8-3.82-4-5.86-.29-1.6-3-1.15-2.77-3.18A1.51,1.51,0,0,0,1220.52,493Z"
              />
              <path
                class="cls5-355"
                d="M1219.63,494.66c.68,1.52,2.69,1,3.51,2.25-.37.6-.71,1.25-1.61,1a1.69,1.69,0,0,0-2.34-.48l-.16.12c-.87.64-1.48,2.28-3,.88-.56-.54-1.4-1.14-.72-2,.85-1.11,1.52-2.76,3.49-1.9A4.63,4.63,0,0,0,1219.63,494.66Z"
              />
              <path
                class="cls5-356"
                d="M1230.58,503.78c1,.12,1.6-.54,2.22-1.15.92.6,1.84,1.2,2.75,1.81-.57.35-1.17.66-1.71,1.06-.9.67-.54,2.71-2.36,2.33s-.86-2.34-1.75-3.29A1.12,1.12,0,0,1,1230.58,503.78Z"
              />
              <path
                class="cls5-357"
                d="M1221.36,498.58a4.24,4.24,0,0,1,.46.65,2,2,0,0,1,.15.69l-.18.14c.21-.09.52-.31.63-.24,1.15.73.54,1.92.72,2.91-.13,0-.29.09-.4,0-2.17-.92-2.32,4-4.13,1.85-1-1.24,1.93-3.11,2.05-5.16C1220.68,499.16,1221.12,498.88,1221.36,498.58Z"
              />
              <path
                class="cls5-358"
                d="M1264,490.22l-1.87-2.36c.52-.72,1-2.15,2-1.3S1264.71,489,1264,490.22Z"
              />
              <path
                class="cls5-359"
                d="M1126.57,418.66a2.67,2.67,0,0,0,.68.15c-.24,2.58-1.46,4.08-4.24,3.87-1.42-1.16-4.08-.38-4.61-2.94,1.77-.41,4.35-.17,2.69-3.35C1123.23,416.38,1124.14,419.37,1126.57,418.66Z"
              />
              <path
                class="cls5-342"
                d="M1167.39,445.36c-1.87,0-2.55,1.75-3.86,2.58a1.7,1.7,0,0,1-1.62-1.78,1.6,1.6,0,0,1,.18-.68c1.12-2.17.52-4.56,1.22-6.74C1166.13,440.05,1169.08,441.27,1167.39,445.36Z"
              />
              <path
                class="cls5-360"
                d="M1124.86,427.87a3.28,3.28,0,0,0,2,2.73c1.28,4,4.89,5.33,8.15,7,1.08.55,2.38.67,3.33,1.54,1,1.89,2.55.76,3.9.73a2,2,0,0,1,1,.43c3.85,1.84-.44,2.7-.48,4.07,4.55.13,4.55.13,7.23-3.38,2.19-.31,3.29,1.23,4.47,2.65,1.41,4.53,1.42,4.54-3,6.25-.9.35-1.55,1.07-2.43,1.41-6.11-2.61-10.68-7.47-16.12-11.06-2.52-1.66-4.78-3.71-7.59-4.91-1.13-.48-2.18-1-1.44-2.37,1.84-3.28-.9-2.34-2.31-2.66-.35-2.85-2.06-4.62-4.49-5.94-1-.56-2.35-.95-2.66-2.38,1.73.27,1.17-2,2.48-2.23,1.19,2.19,3.77,2.83,5.26,4.68C1122.79,425.79,1122.69,427.74,1124.86,427.87Z"
              />
              <path
                class="cls5-361"
                d="M1149,451.32c.19-.78,0-1.74.84-2.23,3.9-2.34,4.08-2.54,4.32-5.37a.93.93,0,0,1,.93-.79c.36-.53.69-1.09,1.09-1.59s.57-1.81,1.55-1.18c.81.52-.19,1.39-.23,2.13.31.62-.09,1.7.5,1.91,1.23.42,1.07-.9,1.4-1.55a3.37,3.37,0,0,1,1.09-1.22l1-.22c.11,2.54-.31,5.15.93,7.55-1,2.08-2.2,4.12-1.63,6.59-1.69-.75-2.46-2.26-3-4-1.73.58-1.46,2.65-2.87,3.24C1152.17,454.94,1150.92,452.52,1149,451.32Z"
              />
              <path
                class="cls5-362"
                d="M1155.09,442.93l-.93.79c-1.87-.17-2.57-2.13-4.17-2.71-.73-1.36-.84-2.83,1.16-1.9C1152.71,439.83,1154.67,440.75,1155.09,442.93Z"
              />
              <path
                class="cls5-363"
                d="M1143.24,440.32a1.79,1.79,0,0,1-.69.08c-2.29-2.93-1.82-4.19,2.46-6.61a1.68,1.68,0,0,1,1.68.78Z"
              />
              <path
                class="cls5-364"
                d="M1085.22,413c-3-.21-4.57-2.64-6.81-4,.24-2.68,1.19-.21,1.8-.25C1081.89,410.08,1084.11,410.87,1085.22,413Z"
              />
              <path
                class="cls5-365"
                d="M1073.65,404.24l3.24,2.11.81,1.73c-1.53-.62-3.14-1.09-4.24-2.46A1,1,0,0,1,1073.65,404.24Z"
              />
              <path
                class="cls5-366"
                d="M1121.67,424.5c-1.87-1.31-5.42-.9-4.8-4.73h1.53c.73,2,3.95-.25,4.28,2.48C1123.32,423.41,1122.85,424.11,1121.67,424.5Z"
              />
              <path
                class="cls5-367"
                d="M1079.41,443.79c2.57,1.81,4.68,4.48,8.27,4.33a65.54,65.54,0,0,0-4.12,6.08c-1.62,3-3.48,3-5.81,1-4.62-3.9-4.62-3.9-.81-8.94C1077.21,444.87,1077.34,443.35,1079.41,443.79Z"
              />
              <path
                class="cls5-368"
                d="M1101.05,453c.1,1.52-.78,2.4-1.87,3.34-.9.78-2.21,1.66-1.43,3.29-1.14,1.93-2.35,3.54-4.37.82a3.7,3.7,0,0,1,.94-3.85c1.59-.73,1.75-2.46,2.59-3.71a8.34,8.34,0,0,1,4.09-5.55c1.06-.21,1.85-.66,1.73-1.93a2.82,2.82,0,0,1,3.54.29C1105.25,448.63,1102.64,450.43,1101.05,453Z"
              />
              <path
                class="cls5-369"
                d="M1103.63,443.76c-.68.13-1.49.57-2,.34-1.3-.59-3.77-1.81-3.6-2,1.57-1.63.87-4.56,2.79-5.53,1.55-.79,2-2.13,3.42-3.82,1.13,2.92,2,5.41,1.62,8.24a2.51,2.51,0,0,1-.18,1.53C1105.21,443.31,1104.71,444,1103.63,443.76Z"
              />
              <path
                class="cls5-370"
                d="M1094.27,426l-1.73-.82c-2,1.08-2.82-.4-3.8-1.63-.67-.59-1.47-1.11-1.12-2.22,1-.63,2.27-1.23.78-2.59-1-.91-.08-1.66.13-2.47a1.22,1.22,0,0,1,1.73,0h0c1.91.15,2.21,2.78,4.23,2.77.58,1.24,2.27,1.64,2.4,3.21l-.27.81c-.64.34-2.4.21-.65,1.55Z"
              />
              <path
                class="cls5-371"
                d="M1115.11,438.75c-.83,3-2.95,5.25-4.86,7.59-.9-1.13-1.42-.87-1.87.41-.37,1.06-.69,2.58-2.38,1.22,0-3,2.23-5,3.27-7.56C1110.57,437.6,1112.45,436.8,1115.11,438.75Z"
              />
              <path
                class="cls5-372"
                d="M1105.94,426.33a1.66,1.66,0,0,0,2.28.48l.11-.08c1.8-1,1.07.59,1.18,1.28.73,2.86,3.62,3.31,5.53,4.82,3.32,2.62,3.44,3,0,5.93,2-4-1.27-5.24-3.68-6.76-1.5-.94-1.83.39-2,1.56-.22,1.47.34,3-1,5.7.26-5.66.34-10.21-4.09-12.95-.29-.15-.39-.31-.32-.49s.16-.29.25-.29Z"
              />
              <path
                class="cls5-373"
                d="M1109.27,440.41c.89,3.38-2.8,4.78-3.28,7.56-1.89,1.42-2.68,3.94-4.94,5,.79-3.05,3.9-4.62,4.8-7.59-.24-1.06.69-2.34-.61-3.2l.62-1.18C1106.93,440.45,1108.33,441.7,1109.27,440.41Z"
              />
              <path
                class="cls5-374"
                d="M1104.21,425.53a3,3,0,0,0,.07.78c-3.23.08-4.75-3-7.38-4-.78-1.09-3-1.12-2.4-3.21C1098.12,420.64,1100.94,423.42,1104.21,425.53Z"
              />
              <path
                class="cls5-375"
                d="M1081.53,459.8c-2.29.6-3.65.38-4.47-1.07-.26-.47.53-.83,1-1C1080.06,457.06,1080.12,458.8,1081.53,459.8Z"
              />
              <path
                class="cls5-374"
                d="M1096,424.64c-1.19-.29-3.31-.2-2.53-2,.89-2.09,2,.84,3.18.47C1096.41,423.6,1096.2,424.12,1096,424.64Z"
              />
              <path
                class="cls5-376"
                d="M1105.91,468.73v-.88a3.13,3.13,0,0,0,1.58-2.47,1.71,1.71,0,0,1,2.41-.17l.17.17h0c-1.93,3,1.7,3.67,2.36,5.59.15.43,1.59.14,1,1.15-.27.46-1.15.56-1.75.82-1.12.66-1.85.22-2.36-.85-1.28,0-1.69-1.11-2.41-1.83C1106.07,470.08,1105.62,469.65,1105.91,468.73Z"
              />
              <path
                class="cls5-326"
                d="M1103.46,464.55l1.65-1.69a2.94,2.94,0,0,1,1.31,1.59c.38.62-.42,2,1.22,1.78.92,2.1-.72,1.52-1.7,1.62C1105.17,466.71,1102.48,467,1103.46,464.55Z"
              />
              <path
                class="cls5-377"
                d="M1087.62,421.33l1.69,1.63c.44,4.27-2.85,6.83-4.8,9.92a58.37,58.37,0,0,1-3.77,4.82l-.56.2-.93-.87a7,7,0,0,1-3.28-2c-1.17-1.74-4.34-2.22-3.36-5.31,3.73,1.59,4.52-2.2,6.51-3.68,1.71-1.27.09-3.34.63-5a3.22,3.22,0,0,0-1.63-1c-1-.24-.7.77-1,1.28-2,3.39-4.78,3.76-7.88,1.17a11.6,11.6,0,0,0-1-.79c-5.19-3.9-5.1-6.1.41-10.26.85,1.34-.07,2.39-.63,3.43-1.27,2.35-.39,3.91,1.67,5.16s3.79,1.4,5.32-.86a9.44,9.44,0,0,1,3.43-3.5C1081.94,416.85,1084.45,419.61,1087.62,421.33Z"
              />
              <path
                class="cls5-378"
                d="M1071.74,436.38c-.69,3.28-2,4.33-5,1.83-1.81-1.54-4.41-2.1-5.61-4.45-.05-2.92,1.68-3.34,4-2.66a14.92,14.92,0,0,1,4.14,2.49c.62.44,1.24.87,1.84,1.34A1.66,1.66,0,0,1,1071.74,436.38Z"
              />
              <path
                class="cls5-379"
                d="M1058.46,434.56c-1.48-1-2.74-2.05-2.42-4.08,0-2.93,1.61-4.82,4-6.16a8.59,8.59,0,0,1,3.75,1.91C1064,430.29,1061.08,432.32,1058.46,434.56Z"
              />
              <path
                class="cls5-380"
                d="M1058.46,434.56c1.71-2.74,4.22-5,5.06-8.26.45-.41,1.16-.67,1.43-.19,1.22,2.18,3.25,3.53,4.93,5.25,1,1,1.81,2.55-.45,3.39a20.56,20.56,0,0,1-2.75-1.79c-2.23-2-4.07-2-5.55.8Z"
              />
              <path
                class="cls5-381"
                d="M1052.88,433a1.08,1.08,0,0,0,.66-.13c1.15.62,2.59.93,2.77,2.59q-1.45,1.92-2.92,3.83c-1,1.24-2,1.8-3.27.34C1049.39,436.78,1051.34,435,1052.88,433Z"
              />
              <path
                class="cls5-382"
                d="M1074.42,457.1c-1.37-.74-2.56-1.6-2.39-3.51,2.88-.2,2.31,1.88,2.4,3.5Z"
              />
              <path
                class="cls5-383"
                d="M1052.88,433c.14,2.66-2.46,4.16-2.76,6.63-2.61,1.56-.76,3,.37,3.95A61.06,61.06,0,0,0,1057,448c1.77,1.11,2.15,2.13,0,3.19l-17.45-12.45a1.28,1.28,0,0,1-.24-1.6c2-.89,3.31.69,4.72,1.61,1.12.75,1.86.83,2.69-.38s.85-2.18-.53-3c-1.6-1-3.46-1.65-4.52-3.38,2-4.4,4.36-5.74,7.39-4.22a3.27,3.27,0,0,1,1.25,1.93C1051.37,430.59,1053.46,430.79,1052.88,433Z"
              />
              <path
                class="cls5-384"
                d="M1088.76,469.32c-.68-1.9-1-4.06-3.73-3.66-1.11.15-2.31-1-1.9-2.05s2.56-2.36,3.2-1.13c1.08,2.07,6.2-1.65,4.38,3.21C1090.32,466.73,1090.21,468.3,1088.76,469.32Z"
              />
              <path
                class="cls5-312"
                d="M1048.77,428.65c-2.08-1.43-2.21-1.48-2.91.75-.65,2-3.77-.07-3.89,2.53.54,1.89-1,1.82-2,2.15a2.11,2.11,0,0,1-1.07-.49c-1.44-1.71-3.39-2.74-5.16-4s-4.08-3-2.12-5.93c2.66.12,2.65-1.18,1.45-2.9-.8-1.15-2.15-1.05-3.39-1-1.93-1-2.3,1.17-2.88,1.38.49-.28,1.11-1.68,2.62-1.55,1.74,1,5.92.26,3.1,4.44-1.67-1-2.45.33-3.39,1.27s-1.54,2.61-2.76,3.55c-3.49-1.1-6.1-3.52-8.86-5.76a22.86,22.86,0,0,0-5.61-3.37c-1.78-.72-1-1.57-.61-2.54h0c1.15-1.45,3,1.73,4-.66a15.73,15.73,0,0,1,3.26-.6,13.64,13.64,0,0,1,3.81,1.45c.42.82-.12,1.73.13,3,1.74-1.73,2.71-3.12.73-4.89-.9-.68-2.17-.67-3-1.55-.22-1.23.51-1.77,1.52-2.12a3.39,3.39,0,0,0,3.38-1.72c.86-1.4,1.79-2.47,3.35-.49.23.29.42-1.68,1.51-1.88,6.21-3.17,10.17,1.47,14.56,4.34,1.36.88,2.77,1.7,4.11,2.62,1.93.74,2.73,3.09,4.91,3.49.75.35,1.42.74.8,1.73-2.78.46-4.46,1.67-3.87,4.92A4,4,0,0,1,1048.77,428.65Z"
              />
              <path
                class="cls5-312"
                d="M1037.9,434.58l1.59-.81h0a2.4,2.4,0,0,1,.06,3.39l-.06.06v1.52C1037.71,437.82,1036.35,436.77,1037.9,434.58Z"
              />
              <path
                class="cls5-385"
                d="M1015.46,417.12l-.91-1.61a3.22,3.22,0,0,0,.09-.76c1.15,1.14,3.14,0,4.17,1.48C1018,417.79,1016.58,416.86,1015.46,417.12Z"
              />
              <path
                class="cls5-386"
                d="M1177.4,531.78a2.41,2.41,0,0,1-2.36,1.75l-1,.11c-2.75-.58-4.17-2.24-4.09-5.1.28-.59.56-1.19.85-1.79.63-.26,1.78.63,1.89-.65.06-.76-1.6-1.75-.14-2.32s2.36,1,3.33,1.9.33,1.64-.51,2.28a9.49,9.49,0,0,0-1.15,1.22C1175.22,530.26,1177.46,529.66,1177.4,531.78Z"
              />
              <path
                class="cls5-387"
                d="M1168.26,538.55c-.51,2.21-2,.86-2.71.47-1-.51-.17-1.67.29-2,1.78-1.28,1.27,1.5,2.41,1.52Z"
              />
              <path
                class="cls5-388"
                d="M1191.48,568.49c-3.26-3.57-.58,2.65-2.39,1.46l-3.57-4.92c-.79-.63-1.48-1.28-.68-2.36l.89-.8c.13-1,.23-1.92,1.59-1.78,3.5-.33,3.14-4,5-5.78a10.86,10.86,0,0,0,1.06,1.19c1.36,1.16,1.44,4,3.83,3.61s3-2.79,3.57-4.92l1.52.2c-1.6,2.18,2.94,4.07,1,5a19.64,19.64,0,0,0-4.35,3.17C1196.82,565,1195.06,567.87,1191.48,568.49Z"
              />
              <path
                class="cls5-389"
                d="M1054.28,419.71l-.72-1.62c2.06-.14,3.16,1.6,4.5,2.61a42.13,42.13,0,0,0,8.19,4.44c2.3,1.05,3.42,4.12,6.36,4.52.09,2.79,3.51,2.74,4.22,5-1.66,2.3-3.88.3-5.78.75-.64,0-1.26,0-1.62-.66.64-.62,1.1-1.59.39-2.12a22.21,22.21,0,0,1-6.3-6.33,2.68,2.68,0,0,1-3.27-1.65c-.57-1.58-2.1-1.86-3.38-2.49C1055.39,422,1054.25,421.46,1054.28,419.71Z"
              />
              <path
                class="cls5-390"
                d="M1030.29,407.94c.68-2.09,2.92-2.16,4.31-3.35,4.9,3,9.83,6,14.05,10a16.38,16.38,0,0,1-7.83-4.35c-2.92-2.68-5.6-3.71-9.17-1.76C1031.12,408.79,1030.6,408.48,1030.29,407.94Z"
              />
              <path
                class="cls5-390"
                d="M1034.58,404.58c-1-1.22-5.17-.43-2.63-4C1033.35,401.57,1036.35,401.51,1034.58,404.58Z"
              />
              <path
                class="cls5-391"
                d="M1045.31,384.74c-3-.16-4.54-2.75-6.92-3.94-1.3-.65-2.2-2.14-3.93-1.9,0-1.15-.17-2.53,1.58-1.26C1039.19,379.92,1042.74,381.7,1045.31,384.74Z"
              />
              <path
                class="cls5-392"
                d="M1054.44,392.15v-1.24c1.91,1.66,2.5-.18,3.36-1.28-.64,4,2.78,4.89,5,6.68-2.6.88-4-1.35-5.85-2.34A23.58,23.58,0,0,1,1054.44,392.15Z"
              />
              <path
                class="cls5-392"
                d="M1054,390.55c-3.15-.19-5.12-2.25-7-4.44C1049.89,386.63,1051.89,388.65,1054,390.55Z"
              />
              <path
                class="cls5-393"
                d="M1127.52,451.23c1.76,0,2.38-1.48,3.46-2.45,1.28-1.16,2.81-1.79,3,1-.33,1.29-1.34,2.11-2.12,3.09-1.57,1.66.23,4-1.21,5.73a3.28,3.28,0,0,1-1.25,1.2,1,1,0,0,1-1-.24c-2.19-.65-4.23-2.14-6.66-.26-.94.73-1.57-.47-1.67-1.53a47.62,47.62,0,0,1,4.51-6.43C1125.54,450.21,1126.56,452,1127.52,451.23Z"
              />
              <path
                class="cls5-394"
                d="M1128.41,459.53l1-.06c1.84.22,3.58,1.22,5.52.71.69,1.68,2.16,1.93,3.71,2,.12,1.82.83,3.05,2.89,2.93,1.3,1.82-.22,3.12-.83,4.59-2.21-.14-2.07,2.85-4,3-.4-.7-.86-1.71-1.74-1.35-3.18,1.28-1.08-1.24-1.47-1.94,1.47-2.51.34-4-2-5.06-1.06-1.05-2.52-1.71-3.1-3.22C1128.38,460.64,1128.39,460.08,1128.41,459.53Z"
              />
              <path
                class="cls5-395"
                d="M1124.73,451.33a9.19,9.19,0,0,1-4.65,6.41c-.42-.82-1.68-1.08-1.53-2.29-.11-1.23-.34-2.33-2-1.89-3.09.26-4-.81-1.77-3.27,1.1-1.2,1.34-3.46,3.67-3.3C1120.54,448.41,1123.14,449.13,1124.73,451.33Z"
              />
              <path
                class="cls5-396"
                d="M1107.64,466.23c-1.88.83-1.72-.42-1.64-1.6.23-3.53,3.1-5.25,5.16-7.53,1.31-.86,2.1-1.26,2.17,1.07.08,3-2.26,4.78-3.23,7.22C1109.18,465.37,1108.2,465.17,1107.64,466.23Z"
              />
              <path
                class="cls5-397"
                d="M1139.23,454.51c-1.39,1.38-1.47,2.76,0,4.15-1.81.58-3.15-2.68-5.13-.62a1,1,0,0,1-1.08-.92V457c1.39-.88.68-2.53,1.32-3.69a2.1,2.1,0,0,1,1.69-1.28C1138.1,451.54,1139.8,451.5,1139.23,454.51Z"
              />
              <path
                class="cls5-398"
                d="M1124.73,451.33c-1.24-.17-1.83-1.66-3.69-1-2.92,1-.32-3.26-2.61-3.34-.83-2,.34-1.92,1.45-1.19,2.61,1.71,5.1,3.61,7.64,5.43C1126.64,452.65,1125.66,451.19,1124.73,451.33Z"
              />
              <path
                class="cls5-399"
                d="M1109.42,448.56c2.51-.72,3-3.41,4.74-4.88,2.58,3.51-1.21,5.08-2.61,6.84C1110.36,452,1109.46,450.07,1109.42,448.56Z"
              />
              <path
                class="cls5-393"
                d="M1125.06,461.14c-2,1.69-2.55,4.57-4.94,5.91C1119.35,463.41,1122,460.27,1125.06,461.14Z"
              />
              <path
                class="cls5-400"
                d="M1111.16,457.1l-5.16,7.53c-.78-.34-.86-1-.89-1.77l2.38-3.41C1109.4,459.75,1108.64,455.85,1111.16,457.1Z"
              />
              <path
                class="cls5-401"
                d="M1116.53,453.56c.54-1.33,1.51-2.32,2.8-1.22s-.34,2.1-.78,3.11c-1.14.71-2.5,1.1-3.34-.09S1116.82,454.74,1116.53,453.56Z"
              />
              <path
                class="cls5-402"
                d="M1136,452.1l-1,1.69c-1.84.83-3.21.74-3.34-1.74.64-.9,1.12-2,2.31-2.3Z"
              />
              <path
                class="cls5-403"
                d="M1128.36,461.19l3.37,2.46c-.09,1.13.22,2.52-1.62,2.53.35-2.08-1.5-2.75-2.51-4Z"
              />
              <path
                class="cls5-404"
                d="M1130.11,466.18l1.62-2.53a16.18,16.18,0,0,1,4.73,3.3l-3,2.52A6.79,6.79,0,0,1,1130.11,466.18Z"
              />
              <path
                class="cls5-405"
                d="M1174.15,487.92c1.23-.55,1.35-2.49,3-2.49a1,1,0,0,1,.92,1.07v.05c-.24,1.6-1.5,2.51-2.65,3.44-.24.19-.77,0-1.17,0C1174.22,489.3,1174.18,488.61,1174.15,487.92Z"
              />
              <path
                class="cls5-406"
                d="M1133.21,457.2l.87.84c.35.68,1.06,1.23.81,2.14-2.3,3.32-3.79.34-5.52-.71l.69-.77C1131,457.87,1131.28,455.86,1133.21,457.2Z"
              />
              <path
                class="cls5-407"
                d="M1141.49,465.13c-1.36-.32-1.8,2.53-3.38,1.08s.15-2.68.49-4C1140.28,462.47,1141.91,462.79,1141.49,465.13Z"
              />
              <path
                class="cls5-408"
                d="M1211.45,513.49c-1.41,1.8-3.12,3.42-3.29,5.91l-.49.23a4.44,4.44,0,0,1-2.19-2.9c.92-1.85,3-3.15,2.66-5.58Z"
              />
              <path
                class="cls5-408"
                d="M1208.16,519.4c3.14,2.1,3.4-1.52,5-2.5a4.8,4.8,0,0,0,.14.83c-1.23,1.9-1.63,5.49-5.23,2.58-.23-.16-.32-.33-.26-.51s.13-.27.2-.27Z"
              />
              <path
                class="cls5-344"
                d="M1208,519.53a2,2,0,0,1,.06.78,51,51,0,0,0-4.82-3c-3.13-1.5-2.61-3-.16-4.55-.64,2.19-.7,4,2.4,3.94C1206.85,517.19,1207.11,518.64,1208,519.53Z"
              />
              <path
                class="cls5-409"
                d="M1221.15,513c.7.36,1.68.52,1.63,1.53,0,.66-.45,1.36-1.32,1a2,2,0,0,1-1.45-1.75C1220,513.07,1220.57,513,1221.15,513Z"
              />
              <path
                class="cls5-287"
                d="M1145,433.79c-.86,2.19-4.82,3.22-2.46,6.61-1,.36-2,.75-3.08,1.07-2.92.9-1.2-1.05-1.18-2a13.42,13.42,0,0,0-2.68-1.81c-1.11-.73-1.39-1.64-.22-2.62a2.76,2.76,0,0,1,1.14-.15c3.7.4,4-1.68,3.22-4.47.07-.64.32-1.07,1.07-.9A10,10,0,0,1,1145,433.79Z"
              />
              <path
                class="cls5-364"
                d="M1090.27,416.3h-1.74c-1.12-1.12-3.06-1.41-3.36-3.35C1087.5,413.09,1088.74,414.92,1090.27,416.3Z"
              />
              <path
                class="cls5-392"
                d="M1073.65,404.24c-.06.46-.13.92-.19,1.38-2.86-2.53-6.75-3.61-9.34-6.58-.75-.87-.86-1.29.23-1.74Z"
              />
              <path
                class="cls5-410"
                d="M1081.86,437.9l-1.68-.07c2.64-4.11,5.27-8.23,7.93-12.33.52-.8,1.32-1.45,1.2-2.54,1.65-.09,1.19,2.89,3.23,2.22-1,1-1.9,1.94-2.84,2.93-2.2,2.34-3.62,4.73-.44,7.4C1085.34,431.81,1083.57,434.77,1081.86,437.9Z"
              />
              <path
                class="cls5-411"
                d="M1039.41,412.26c-.75,1.71-1.56,3.62-3.39,4.28-1,.35-2.82-1.1-2.56-1.9.59-1.85,1.68-3.84,3.76-4.43C1038.25,409.92,1039.13,411,1039.41,412.26Z"
              />
              <path
                class="cls5-412"
                d="M1021.93,417.14l1.74-2.54a4.1,4.1,0,0,1,.59,5.77,4,4,0,0,1-1.54,1.17c-1.42.63-2.15-.16-2.05-1.48C1020.75,419,1022.22,418.44,1021.93,417.14Z"
              />
              <path
                class="cls5-413"
                d="M1038.5,421c1.73,1.81,4.31,1.28,6.83,3.14-3-.63-3.06,3.45-5.93,2.08C1036.71,425,1039.79,422.66,1038.5,421Z"
              />
              <path
                class="cls5-414"
                d="M1029.48,419.63c2-2.28,3.18.09,4.69.77,1,.46,1.17,1.08.55,1.91s-.82,3-2.78,1.43h0c1.67-1.71.63-2.71-1.06-2.92-1-.12-1.4-.26-1.37-1.24Z"
              />
              <path
                class="cls5-415"
                d="M1029.52,419.58a8.53,8.53,0,0,0-3,3.36c-.47.78-1.1,1.85-2.24.82-.88-.79-.1-1.42.33-2.12.85-1.41,2.29-2.27,3.36-3.44,1.39-1.52,1.21.63,1.49,1.43Z"
              />
              <path
                class="cls5-416"
                d="M1040.9,385c0,.65-.26,1.26-.9,1.08a2.61,2.61,0,0,1-2.06-2.25c-.07-.57.3-1.2.92-1.09C1040.07,383,1040.47,384.07,1040.9,385Z"
              />
              <path
                class="cls5-403"
                d="M1133.21,457.2c-1.4-.24-2,1.28-3.15,1.5-.2-1.11,1.13-2,0-3.4-1.52-1.85.68-2.36,1.64-3.25.6,1.58,1.88,1.82,3.34,1.74A6.52,6.52,0,0,1,1133.21,457.2Z"
              />
              <path
                class="cls5-417"
                d="M1136.55,435.4l3.39-5.08c3.3,1.85.93,3.33-.2,5.08S1137.61,437.16,1136.55,435.4Z"
              />
              <path
                class="cls5-418"
                d="M1213.71,396.59l-.24-1.68a2.21,2.21,0,0,0-1.34.21h0a4.1,4.1,0,0,0-1.52,2.22,5.69,5.69,0,0,1-1.08,1.84c-1,1-2.07,0-3.32-1.62l-.4-.53h0q-1.41-1.87-2.9-3.69c-4.64-5.62-4.58-5.6-1-11.72a49.3,49.3,0,0,0,4.21-8.09,15.79,15.79,0,0,0,.57-1.89c.31-1.33.78-2,2.24-1,1.27.92,2.37,2.29,4.6,2.32,0-5.18-.14-10.25,0-15.32.1-2.7-.73-3.63-3.48-3.55-7.91.21-15.84.18-23.76.25,1.83,2.83,1.41,5.44-.73,7.92a11.3,11.3,0,0,0-1,1.8c-2.34,4.18-2.71,4.31-6,.62s-6.49-7.51-10.12-10.92a2.06,2.06,0,0,0-2.27.18c-.68,1.48.42,2.33,1.2,3.23,12.24,13.85,23.68,28.38,35.66,42.44,5.9,6.91,6.31,6.83,10.93-1.27A2.24,2.24,0,0,0,1213.71,396.59Zm-23.77-21.21c-1.08-1.41-2.9-2.65-2.16-4.62a28,28,0,0,1,4.46-8.34,1,1,0,0,1,1.16-.13c2.9,1.84,6.19,3.42,8,6.39,1.33,2.22-1.13,4-2.06,5.93-.61,1.24-1.37,2.41-1.89,3.68a4.92,4.92,0,0,1-4.7,3.32C1194,378.54,1191.37,377.22,1189.94,375.38Z"
              />
              <path
                class="cls5-419"
                d="M1213.27,392.28l-1.14,2.84h0c-1,2.39-1.74,3.71-2.6,4.06s-2-.36-3.72-2.15h0c-.71-.74-1.52-1.63-2.47-2.71-.38-.4-.79-.77-1.16-1.18-4.26-4.72-4.43-4.93-1.23-10.29,1.82-3,2.89-6.56,5.18-9.32a11.59,11.59,0,0,1,1.71-1.72c-2.55,4.54-5.07,9.09-7.69,13.59-.85,1.47-1.09,2.76.06,4.14,2.37,2.84,4.69,5.71,7.07,8.55,1.23,1.47,2.06.69,2.81-.57C1211.11,395.75,1211.71,393.73,1213.27,392.28Z"
              />
              <path
                class="cls5-420"
                d="M1214.43,396.59c1.21-.42,1.34-1.48,1.51-2.53h0c1-.82.75-2.67,2.48-2.84,1.76.27,3.29,1.6,5.22,1.12a6.48,6.48,0,0,1,.54.62c3.75,4.75,5.24,4.51,7.65-1.27,0-1.24-1.24-2.5,0-3.72,3.33-.23,4.14,2.59,5.63,4.6a9.56,9.56,0,0,1,.71,1.64c.11,2.58,1.57,6.12-3.53,5-.76-.16-1,.34-1.08.9-.36,1.61,1.18,2,1.9,2.93.47.68,1,1.36.26,2.18-4.45,1.52-9,.53-13.53.64-1.28,0-2.06-1.79-2.66-1.39-1.24.83-2.31,1.43-3.8,1.06a2.36,2.36,0,0,1-1.07-.78A13.31,13.31,0,0,1,1214.43,396.59Z"
              />
              <path
                class="cls5-421"
                d="M1292.41,469.81c5.08-.07,7.54,4.19,11.66,6.08.48-1.06,3.44-2.13,1.1-4.85,1.52-.79,0-4.59,3.59-3.49.76.23,1.06-1.09,1.46-1.76,1.82-3.07,3.6-6.16,5.39-9.24.73,0,1.42,0,1.6.93a21.91,21.91,0,0,1-4,8c-1.81,2.58-1.78,4.45,1.27,5.87a5.2,5.2,0,0,1,2.71,2.41v6c-3.1,7.19-7.89,13.48-10.91,20.71a1.32,1.32,0,0,1-1.59.94,5.49,5.49,0,0,1-1.15-4c2.52-5.72,6.2-10.79,9.13-16.28,1.14-2.13,1.57-3.71-1-5.16-2.35-1.34-4-1.26-5.47,1.25-3.1,5.24-6,10.59-9.31,15.71-5,1.7-5.08,1.68-4.2-3,.91-3.74,3.56-6.52,5.42-9.73,1.62-2.78,1.8-4.71-1.48-6.23-1.23-.57-2.36-1.42-3.56-2.11A1.83,1.83,0,0,1,1292.41,469.81Z"
              />
              <path
                class="cls5-422"
                d="M1305.09,501.43c3.27-7.65,7-15.06,12.2-21.6v3.24c-.85,4.85-4.35,8.39-6.28,12.7-.18.37-.4.71-.61,1.06-.69,1.16-1.83,2.34-.89,3.72s2.61,1.12,4.07.64c1.88-2.31-.42-4.48-.23-6.73.6-2.33.69-5,3.93-5.46q-.06,8.6-.1,17.18c-2.79,2.63-6.3.3-9.31,1.36-1.07.25-2.15-.47-3.19-.05-1.2.48-2.47,1.87-3.63.62s.12-2.74.67-4.06a7.23,7.23,0,0,1,1-1.33A3.31,3.31,0,0,1,1305.09,501.43Z"
              />
              <path
                class="cls5-423"
                d="M1163,335.91v-4.12c1.34-1.32,2.58-.45,3.75.23,2.06,1.21,4,2,5.8-.45a1.33,1.33,0,0,1,1.8-.58c1,.64.38,1.47,0,2.17-1.16,2.2-2.44,4.34-3.6,6.53-.44.83-1.79,1.72-.32,2.82l16.54,9.83h-5c-3.68-.83-6.73-2.93-9.89-4.83-1.32-.79-2.59-2.61-4.32-1.39a4.38,4.38,0,0,0-1.51,5.15,1.49,1.49,0,0,1-.31,1.52c-2.09.55-3-.75-3.74-2.34-.28-3.68,3.41-6,3.24-9.68.26-1.07.56-2.12,1.75-2.6A5.73,5.73,0,0,1,1163,335.91Z"
              />
              <path
                class="cls5-424"
                d="M1213.47,394.91a25.71,25.71,0,0,0-1.71,2.29c-2.87,4.92-2.92,5-6.39.77-2.62-3.17-6.34-6.18-7.24-9.83s3.18-7,4.93-10.58c1-2.06,1.57-4.48,3.63-5.92l1.14.17c-2.55,4.54-5.07,9.09-7.69,13.59-.85,1.47-1.09,2.76.06,4.14,2.37,2.84,4.69,5.71,7.07,8.55,1.23,1.47,2.06.69,2.81-.57,1-1.77,1.63-3.79,3.19-5.24C1213.34,393.16,1213.4,394,1213.47,394.91Z"
              />
              <path
                class="cls5-425"
                d="M1317.39,401.6c-1.48,1.54-3.31.76-5,.74-.36-1.83-1.82-2.61-3.26-3.45-5.94-3.42-11.78-7-17.7-10.49-1.61-.95-3.52-1.67-4.15-3.75.06-.18.13-.37.2-.55,1.32-.14,2.31.55,3.41,1.2,8.75,5.18,17.56,10.27,26.36,15.38A8.84,8.84,0,0,0,1317.39,401.6Z"
              />
              <path
                class="cls5-426"
                d="M1169.63,354.45c3.43,3.79,6.92,7.53,10.29,11.37,1.49,1.7,2.55,1.86,3.6-.34a26.18,26.18,0,0,1,2.08-3.59c2.08-3,2.5-5.63-1.37-7.51h2.1c3.3,1.49,3.49,3.66,1.41,6.37a14.55,14.55,0,0,0-1.52,2.43c-4.4,8.91-4.46,6.52-9.27,1.17-2.9-3.22-6.39-6-8.48-9.93a.55.55,0,0,1,.66-.43.53.53,0,0,1,.25.12A3,3,0,0,1,1169.63,354.45Z"
              />
              <path
                class="cls5-427"
                d="M1215.33,370.76c.59.35,1.21.66,1.76,1.06,5.24,3.7,5.35,3.75,8-1.95,1.39-3,5-5.79,4.08-8.62-.76-2.4-4.7-3.78-7.21-5.65a8.5,8.5,0,0,1-1.08-1.24l1.83-.05a42,42,0,0,0,5.29,3.91c3.1,1.62,3.28,3.51,1.53,6.29a93.12,93.12,0,0,0-4.76,8.72c-1.63,3.29-3.43,4.65-6.46,1.36a14.6,14.6,0,0,0-3.09-2C1215.28,372,1215.3,371.36,1215.33,370.76Z"
              />
              <path
                class="cls5-428"
                d="M1218.46,346.68c1.14,3.08,4.37,3.62,6.68,5.53-2.84,1-5.7.27-8.41.1-2.91-.19-1.4-3-1.44-4.59-.1-3.16,2.21-.3,3.2-1Z"
              />
              <path
                class="cls5-429"
                d="M1213.27,349.31c-2.9-1.83-6-3.46-8.67-5.53-2.13-1.63-3.2-.78-4.23,1-1.44,2.52-2.82,5.07-4.22,7.6h-1.82c1.9-3.17,3.85-6.31,5.67-9.53,1.12-2,2.17-2.29,4.25-1,3.17,1.93,6.08,4.19,9.06,6.35C1213.3,348.58,1213.29,348.94,1213.27,349.31Z"
              />
              <path
                class="cls5-430"
                d="M1179.36,352.48c-2.1-2.26-5-3.34-7.54-4.85-1.29-.75-2.73-2.85-4.57-.6-1.67,2.05-1,3.77.63,5.39a1.18,1.18,0,0,1-1.67.1l-.1-.1c-2.77-2.71-.9-5.06.8-7.16,1.89-2.35,3.4,0,4.86.87,3.47,2,6.83,4.12,10.24,6.2Z"
              />
              <path
                class="cls5-431"
                d="M1310.51,495.36c1.29-4.62,4.65-8.1,6.73-12.29V489c-2,1.41-2.63,3.57-3.21,5.76a3.78,3.78,0,0,1-2.74,1.15A.87.87,0,0,1,1310.51,495.36Z"
              />
              <path
                class="cls5-432"
                d="M1215.2,387.36c1.18-2.63,4.91-4.28,3.11-8.06l1-1c2,1,1.86,2.38.86,4.06-1.67,2.84-3.24,5.73-4.86,8.6Z"
              />
              <path
                class="cls5-433"
                d="M1262.55,365l-.94-1c.14-2.14,1-3.25,3.34-2.48l.84.91c0,2.46-.08,4.93-.13,7.39,0,.06-.21.17-.31.16a1.32,1.32,0,0,1-.36-.2c-.48-1.94-1.29-3.84-.59-5.9C1264,364.72,1263.54,365.31,1262.55,365Z"
              />
              <path
                class="cls5-433"
                d="M1259.15,361.77l5.7-4.4c.48,1.14,1.54,2.23.29,3.51-2.26-1.28-2.89,2.46-5,1.63Z"
              />
              <path
                class="cls5-434"
                d="M1260.14,362.51c1.17-.89,2.31-1.82,3.53-2.64s1.23.3,1.47,1a4.38,4.38,0,0,0-.19.71c-1.55.25-2.43,1.38-3.34,2.48A1.91,1.91,0,0,1,1260.14,362.51Z"
              />
              <path
                class="cls5-435"
                d="M955.91,559.59c9.94,0,19.88-.17,29.81.09,3.73.1,4.94-1.5,5-4.74.25-7,0-14-2.25-20.82-2.46-7.62-7.4-15.26-.16-23.25-7.18-1.07-13.69.59-20-1,.82-1.16,2.09-1.27,3.33-1.26,6.74,0,13.48-.3,20.21.16,1.86.48,1.8,1.64,1.16,3.12s-1.72,2.48-1.66,4.23c3.42.53,6.48-2.24,9.9-1,1,1.41-.42,3,.44,4.48-2.15,2-5.08,1.9-7.67,2.7-2,.62-3.9,1.07-2.87,3.83.9,2.42.65,5.91,4.82,5.41,1.37-.16,2.68-.65,4-.85s3-.63,4.21.79c-.25,1.18,1.16,1.52,1.28,2.51-1.61,2.55-4.48,2.56-6.91,3.09-3,.64-3.8,2.1-3.4,4.92.57,4.07,1.35,8.15.43,12.3-.32,1.46-1.35,3.67,1.18,4,2.27.31,5,1.19,6.56-1.81.64-1.24.18-3.2,2.25-3.52.13,8.69,1.29,7.39-7.3,7.45-12.73.08-25.45,0-38.17,0C958.74,560.36,957.1,561.06,955.91,559.59Z"
              />
              <path
                class="cls5-436"
                d="M1029,531.32c-.87-1.73-2-2.45-4.08-1.71-1.62.57-3.35,1.3-5.2.79-1.21-.56-2.17-1.26-1.56-2.83a16.83,16.83,0,0,0,7-11.09,1.16,1.16,0,0,1,.88-.92c1.44.27.74,2,1.72,2.77a10.27,10.27,0,0,1-1-6.14c-5.27.75-9.91,3.61-15.13,2.5a1.68,1.68,0,0,1,0-.74c.2-2.51,2.35-2.44,4-2.75a50.45,50.45,0,0,0,8.35-2.41c6.75-.31,13.49-.64,20.22.16a2,2,0,0,1,1,.9c-.34,1.93-2,1.58-3.25,1.76a47.16,47.16,0,0,0-7.23,1.7c-4.29,1.34-4.49,1.87-3.43,6.2.6,2.41,1.5,3.75,4.26,2.73a19.46,19.46,0,0,1,4.47-.76c3-.36,4.84-1.75,5.31-4.79,1.46-1.23,1.87.14,2.07,1,.4,1.74,1.39,1.55,2.6,1.08,2.87,0,5.74-1.55,8.6,0a4.78,4.78,0,0,1,.19,4.78,3.62,3.62,0,0,1-3.34,1.3c-4-.27-4.31,2-4.37,5.25-.11,5.81,2.44,9.64,7.65,11.89a3.42,3.42,0,0,1,0,3.2c-4.7,1.82-11.85-2.42-12.24-7.45-.22-2.89-.67-5.74-1-8.62-.11-1.11-.31-2.71-1.63-2.4-3.72.89-8.17,0-10.76,4C1031.89,532.43,1030.31,531,1029,531.32Z"
              />
              <path
                class="cls5-437"
                d="M1055.66,558.8c-1.68,2.62-4.44,1.19-6.67,1.76-12.42,0-24.84-.21-37.26-.1-3.28,0-4.69-.61-4.46-4.28.35-5.77.13-11.58.15-17.38,4.06-.15,3.54,2.81,3.22,5.17-.45,3.39-1.32,6.72-2,10.07-1.06,4.88-.56,5.53,4.37,5.55,2.2,0,4.47-.33,6.6.07,6,1.1,9.73-2.78,13.18-6.24,2.51-2.5-.55-5.83-1.22-8.71-.61-2.62-2.69-.38-4.09-.5a10.92,10.92,0,0,0-2.4.51c-1.29.21-3,1.81-3.46-.94-.34-2.1,1-2.39,2.71-2.6a53,53,0,0,0,6.35-1.56c1.55.42,2.74-1,4.23-.82,1.45,1.51,1.56,3.5,1.88,5.39a45.89,45.89,0,0,0,1.25,5.67c2,6.75,4.71,8.66,11.63,8.63C1051.62,558.49,1053.72,557.45,1055.66,558.8Z"
              />
              <path
                class="cls5-438"
                d="M1049,561.11c1.23.35,3.75-.48,1.77,2.87,2.64-1.18,4.33-4.2,7.15-1.83-.19.21-.36.42-.55.62-1.83,2-6.13,2.61-5.68,5.42.57,3.49,3.26,6.54,6.44,8.69a1.44,1.44,0,0,1,.47.67c.07,1.05.25,2.17-1.4,2-2.75-.73-2.84-4.12-5.61-5.55.61,1.58,1.07,2.76,1.53,3.93-2.66.18-3.8-2-5.15-3.58-1.75-2.12-3.24-4.45-5-6.6a12.53,12.53,0,0,0-13.89-4.36c-2.06.6-3,2.25-4,3.93-.73,1.19-.68,3.12-2.74,3.19-.5-2.87.91-5.29,2.53-8.78-3.4,2.8-3.39,5.9-4.08,8.6-.8,3.18-2,4.93-5.71,3.71-2.42-.8-5.11-.8-7.68-1.15v-1.64c2.14-1.63,4.24-.15,6.34.12,3.28.43,6.92-3.79,5.82-6.9-.56-1.57-2-1.1-3.19-1.23-3-.34-6.09.78-8.84-1.13,1.16-1.53,2.82-.78,4.22-.8C1024.15,561.2,1036.57,561.17,1049,561.11Z"
              />
              <path
                class="cls5-439"
                d="M1190.25,602.06c-.07.82-.07,1.76-.91,2.14a10.51,10.51,0,0,1-2.35.52l1.88.95a11,11,0,0,1-.87,1.27c-2,2.41-4.89,3.33-7.79,4.13-2.71.79-4.86-.44-6.88-2a11.86,11.86,0,0,0-8.13-2.5,1.87,1.87,0,0,1-1.11-.53,4.17,4.17,0,0,1-.72-4.11c2.1-1.85,4.17.26,6,0a27.8,27.8,0,0,0-5.78-.95,2.53,2.53,0,0,1-1-.64,2.69,2.69,0,0,1-.32-1.84,2.14,2.14,0,0,1,1.93-1.46,9.75,9.75,0,0,1,5.49,1.26,3.59,3.59,0,0,0,3.49.24c3.13-1.39,6.11-.72,9.06.55a21.15,21.15,0,0,1,3.08.44C1187,600.35,1189.33,599.77,1190.25,602.06Z"
              />
              <path
                class="cls5-440"
                d="M1211.63,609.66c0,2.25-1.14,3.06-3.4,3-8.21-.1-16.43,0-25.28,0l8.25-6.51a3.25,3.25,0,0,1,3.06-.72c5.46,1.09,11.16,1,16.38,3.28A2.27,2.27,0,0,1,1211.63,609.66Z"
              />
              <path
                class="cls5-441"
                d="M1162.75,598.55v1.54c0,.54-.38.5-.74.26-1.69.11-3.22,1.45-4.89.11-.53,2.11,1,2.27,1.58,3.14-1.24,0-2.57.45-3.44-.91-3.48-2.47-7.66-2.36-11.6-3.11-1.27-.24-2.83.27-3.55-1.38,1-1.46-3.16-1.67-.87-3.47,1.44-.63,3-.44,4.46-.55,5.18.23,10.28,1.07,15.41,1.72C1160.88,596.11,1162.4,596.5,1162.75,598.55Z"
              />
              <path
                class="cls5-442"
                d="M1211,609.48l-19.77-3.34c0-1.12-.1-2.29.78-3.21a2.56,2.56,0,0,1,2.48-.78c4.58.58,9,1.93,13.67,2.23a11,11,0,0,1,2.56.8C1213,606.47,1212.54,607.94,1211,609.48Z"
              />
              <path
                class="cls5-443"
                d="M1263.35,594.46l.33.25c-1.5.59-3.08,1.79-4.47,1.6-1.18-.16-2-.54-2.68.59-2.55,4.36-5,8.75-7.55,13.13-.4.7,0,1.32.24,2a20.67,20.67,0,0,1-11.74.1c6.53,1.06,10.74-1.21,13.34-7.68,2-5,5.42-9.54,8.69-15.11C1259.28,592.84,1261.33,593.63,1263.35,594.46Z"
              />
              <path
                class="cls5-444"
                d="M1165.3,606.14c2.49-1.76,5-.37,6.73.86a29.8,29.8,0,0,0,8.18,4.07c-1.54,2.87-3.89,2-5.76.81a5.6,5.6,0,0,0-3.46-.79C1167.61,611.15,1165.7,609.51,1165.3,606.14Z"
              />
              <path
                class="cls5-445"
                d="M1265.06,580.43l-.15-2.42a2,2,0,0,1,0-2.76v-6.6a3.61,3.61,0,0,1-4.89.16c-3.45-2.42-7.14-4.51-10.72-6.74,1.37-.64,2.73-1.4,4.12,0,3.56,2.15,6.78,5.48,11.57,3.35,1.17,3,.75,6.23.88,9.38.06,1.58-.66,3.33.76,4.71v1Z"
              />
              <path
                class="cls5-446"
                d="M1165.3,606.14a12.56,12.56,0,0,0,5.69,5c-1.81,2.26-5.17,2.26-8.34,0a5.61,5.61,0,0,1-.66-4.34c.5-1.46,1.28-2.16,2.55-.62Z"
              />
              <path
                class="cls5-447"
                d="M1266.72,584.52c4.31,2.46,8.63,4.9,12.93,7.4.7.41,2.2.59,1.22,2-.64.9-1.42.25-2.16-.17-4-2.22-8-4.4-11.94-6.59C1266.75,586.25,1266.74,585.39,1266.72,584.52Z"
              />
              <path
                class="cls5-448"
                d="M1001.62,515.55l4-1v3.53l-4,.8c-1-.12-2-.33-2.2-1.42C999.21,515.94,1001.22,516.58,1001.62,515.55Z"
              />
              <path
                class="cls5-436"
                d="M1009.89,531.31a16.88,16.88,0,0,1,6.68.15c-2.85,1.45-6.1,1.36-9.06,2.38C1007.27,532,1009.21,532.26,1009.89,531.31Z"
              />
              <path
                class="cls5-449"
                d="M1215,609.46l.27-1.64c1.5,1.31,3.73.27,5.84,1.78-2.18,1.15-4.11.48-5.86.77Z"
              />
              <path
                class="cls5-450"
                d="M875.39,301.67l-1.76-1.4c-3.31-.93-5.55-3.49-8.14-5.48-9.25-7.12-18.43-14.36-27.66-21.52a6.56,6.56,0,0,1-2.66-3c3.84-.8,6.76-4.1,10.64-4.38a15.62,15.62,0,0,0,5.91-1.26c1.32-.48,2.93-.6,3-2.53.59-1.42,2-2.52,1-4.47-.53-1.06.79-2.57,1.79-1.95,4.54,2.79,9.15.78,13.73.61a3.25,3.25,0,0,1,1.59.35c1.83,2.16,3.58,1.13,5.34-.13,1.47-1,2.52-2.19,1-4a1.81,1.81,0,0,0-2.56.22l0,0c-3,2.82-7.15,2.44-10.66,3.81a1.93,1.93,0,0,1-2.28-.46c-1-1.42.28-2.55.64-3.79.34-.77.82-1.73,1.61-1.71,4.72.09,7.94-3,11.57-5.25,2-.12,3.4,1.12,4.84,2.24,1.18,1,2.51,1.74,3.71,2.68,5.34,3.5,10.59,7.11,15.68,11,.8.87,1.74,1.68,1.3,3.07-.55.85-1.51,1.15-2.24,1.75-1.45,1.23-2.58,2.43-1.31,4.57,1.1,1.85-.1,3.43-1.12,4.94-1.58,2.11.19,2.28,1.55,2.68a2.26,2.26,0,0,1,.87,2.64c-2.29,4.31-2.18,4.13-6.11,1.55-2.19-1.44-3.56-3.67-5.87-5.57-.67,2.47,1,3,2.13,3.65a20.71,20.71,0,0,1,3.83,2.44c1.68,1.65,2,3.25.08,4.92-.55.86,0,1.67.13,2.5-.14,1.88,1.26,2.55,2.6,3.24,1.92,1,4,1.86,5.49,3.47,1.88,1.42,1.26,3.58,1.64,5.45a10.88,10.88,0,0,0,.32,3.06,2.4,2.4,0,0,1-.55,1.54,42,42,0,0,1-5.41,3.2c-2.43,3.28-2.3,3.48,2.9,4.68.48,2.47,0,5.23,2.12,7.18a5.85,5.85,0,0,0,5-1,17.69,17.69,0,0,1,5.64-2.48c.7-.27,1.39-.57,2.1-.83a5.75,5.75,0,0,1,1.09-.25c1-.2,2.09.38,3.31-.36-.56-1.35-1.89-1.64-3-2.2-1.42-.7-2.79-1.61-4.51-1.26a12,12,0,0,1-2.8.46,3,3,0,0,1-1.63-.55c-1.13-2.86,1.25-5.18,1.22-7.87a1.65,1.65,0,0,0-.26-1.74c-1.38-.94-3.41.86-4.52-1.09.27-1.73.41-3.52,1.69-4.91a8.28,8.28,0,0,0,4.17-1.56,2.79,2.79,0,0,1,1.07-.17c1,.16,2,.34,3.08.53a4,4,0,0,1,2,1.42c.25.22.49.44.76.64.77.6,2,.8,1.82,2.21a3,3,0,0,1-1,1.27c-1.16.86-2.38.08-4,0,1.28,2.69,2.81,2.42,4.57,1.15a10,10,0,0,1,3.31-1.42c1.6.14,1.89,1.36,2.15,2.6.24,2.14,1,4.24.8,6.4-.25,2.66,1.33,2,2.74,1.66,1.65-.22,1.54,2.17,3.1,2.05,1.08-.63,2.08-1.34,3.14-2s1.59-1.26.47-2.19c-.88-.72-1.81-.74-2.26.52-.55,1.52-1.31,2-2.65.8a28.75,28.75,0,0,0-2.45-4.32,1.61,1.61,0,0,1,.1-1.08c.78-.78,1.92-1,2.74-1.74,1.41-2,2.94-2.38,4.65-.35,1,.27,1.47-.07,1.27-1.15-1.39-2.52-1.54-4.76,1.36-6.31.15-.29.12-.64-.14-.67-.43,0-.68.38-1,.67-1.11,1.33-2.39,2-4.07,1.08a7.57,7.57,0,0,0-2.36.75c-1.2.25-2-.51-2.78-1.18-.54-.42-1.08-.83-1.64-1.23a14.55,14.55,0,0,1-1.68-1.24,1.62,1.62,0,0,0-2.25-.41,1.6,1.6,0,0,0-.41.41c-1.75,1.92-3.8,1.87-6,.91a5.89,5.89,0,0,1-1.92-1.43,4.44,4.44,0,0,1-1-2.17,2.4,2.4,0,0,1,.37-1.1c.39-.77,1.93-2,1-2.2-4.53-1.11-3.32-5.07-4.37-7.88-.85-2.13-2.22-4-2.69-6.32a5.57,5.57,0,0,1-.13-2.26,3.06,3.06,0,0,1,.64-.91c1.29-1,.61-1.81-.24-2.61a2.63,2.63,0,0,1-.3-3.31c2.09-.62,3.17,1.15,4.61,2,3.1,1.86,5.79,4.57,9.75,4.61,3.57,1.14,1.14,4.35,2.39,6.65,2.69-.78,5.2-1.68,7.22,2.25a11.85,11.85,0,0,0,7.56,5.93,3.32,3.32,0,0,1,2.3,3.16c.51,4.48,4.88,5.55,7.33,8.31,2,2.94,4.92,4.5,8.2,5.54,2.06,4.44,6.84,5.92,10,9.17,2.55,2.63,2.78,4.72.14,6.12a3,3,0,0,1-.78-.23c-4.75-2.39-4.75-2.39-5.3,3.12-.47,2.16-2,2.66-3.92,2.46-1.84-.42-3.45-1.72-5.48-1.39a19.49,19.49,0,0,1-5-.38,3.87,3.87,0,0,0-4.16-.07.9.9,0,0,0-.32,1.23l.11.15c1,1.37,2.49,1.39,4,1.27,1,0,1.93.14,2.4,1.19.24.81-1.14,1.28-.48,2.1.16.2.75-.2,1.14-.36a2.29,2.29,0,0,1,1.59.08c1.83,1.1.8,2.56.51,3.93.08,2,2.58,3,2.35,5.23-.5,1.6-1.87,2.36-3.17,3.1s-2.91,2.2-4.51,1.21-.87-2.74-.48-4.18c.8-3-2.23-3.29-3.18-5-2.42,3,.51,6.62-1.36,9.6-2.51,1.12-3.24-.74-4.07-2.44a21.21,21.21,0,0,0-2.29-3.83,6.86,6.86,0,0,0-1.88-1.8c-1.63-.64-1.73.71-2,1.62-.38,1.2.46,1.63,1.43,1.87a5.61,5.61,0,0,1,1.56.7c1.44,1.23.77,2.61.54,4.14-.53,3.42-.52,6.87,1.14,10.09-.57,1-1.69-.08-2.37.57.48.68,1.16.5,1.78.52a2.69,2.69,0,0,0,2.16-1.16c1-1.27,1.62-3.08,3.81-2.55,1,.62,1.4,1.71,2.21,2.46a5.54,5.54,0,0,1,1.14,1.87c.28.5.24,1.41,1.06,1.26.64-.11.68-1,1-1.49.83-1.19,1.89-1,3-.48,1.51.57,2.74.79,2-1.55-.19-.49-.33-1-.47-1.48-.39-1.62-2-1.74-3.09-2.5a2.88,2.88,0,0,1-.75-2.84c1.36-2.82,3.47-3.74,6.41-2.52,2.29,1.77,6.54,1.75,5.82,6.4,0,.31,1.23-1.18,2-.21a31.79,31.79,0,0,1,2,2.62,5.35,5.35,0,0,1,.69,1.52c.55,3.62,3.16,3.47,5.83,3.2a2.21,2.21,0,0,1,1.82,2.54l0,.15c-1.3,2.16-2.08,4.12,1,5.62a4,4,0,0,1,2.23,3.28c-.13,1.31-1.07,3.2-1.91,2.68-4.3-2.66-8.69,2.17-13.25-1.15a16.86,16.86,0,0,0,5.65,7.15c2.19,1.7,4,3.84,3.44,7a2,2,0,0,1-1,.58c-4.51-1.18-7.63-4.53-11.19-7.19a29.18,29.18,0,0,0-2.81-2c-9.72-6.6-19.21-13.54-28.67-20.52a29.45,29.45,0,0,0-3.13-2.32,36.24,36.24,0,0,1-7.34-5.51,4.35,4.35,0,0,1-.8-2.86c.74-2.58,2.46-4.5,4.32-6.33,3-1.63,5.41-4,8-6.07.72-2.42,1.38-4.83-.63-7a12.29,12.29,0,0,1-3.3-1.65,8.29,8.29,0,0,0-11.42,2.65,8.53,8.53,0,0,0-.68,1.35c-.75,1.93.92,4,.17,6a9,9,0,0,1-2.45,3.88c-1,.74-1.72,2-3,2.38a3.57,3.57,0,0,1-1.63-.43,19,19,0,0,1-2-1.17c-.58-.36-1.13-.75-1.67-1.16-6.12-4.5-6.2-5.05-1.63-11.21,2.51-3.16.25-5.2-1.89-6.94-3.43-2.79-7-5.44-10.44-8.17-1.27-1-2.94-1.7-3.08-3.66,1-2.3,2.59-1.48,3.95-.67,1.68,1,2.4.24,3-1.18,1.65-1.3,3.63.5,5.3-.58a6,6,0,0,0,2.38-3.22c.46-1.33-.8-.4-1.2-.67-2.14-1.41-4-3.32-6.52-4.07-1.5-1.21-1.27-2.54-.31-3.93.06-.35.31-.9-.14-1-.73-.14-1,.67-1.49,1.07-2,1.57-3.61-.45-5.89-.6,2.72,3.63-1.33,5.7-1.63,8.69a3.48,3.48,0,0,1-.34,2.24,2.47,2.47,0,0,1-1.69.44A2.91,2.91,0,0,1,875.39,301.67Z"
              />
              <path
                class="cls5-450"
                d="M954.33,240.33l.79-.05c3.63,1.64,7.59,2.66,10.47,5.7.37,1.79-.59,3.15-1.46,4.53-.77,1.1-1.14,2.29,0,3.25,2.79,2.26,5.23,5.2,9.32,5.1a1.6,1.6,0,0,1,1,1.27,1.12,1.12,0,0,1-.2.77c-3.37,3.83-3,4.86,2.13,6.18,2.38,1.15,4.38,1.51,4.47-2.14,2.7-4.85,2.7-4.85-1.92-7.29-2.09-1.54-3.74.21-5.54.76-2.85.76-2.89-1.07-1.94-2.61,1.29-2.09.92-3.78-.18-5.62a1.58,1.58,0,0,1,.41-1.1,3.55,3.55,0,0,1,2.35-.54,2.15,2.15,0,0,1,1.9,1.22.71.71,0,0,1-.32.68.45.45,0,0,0-.11.19c9.38,4,17.33,10.55,26.66,14.62a5.29,5.29,0,0,0,3.58.5c1.31.12,1.71,1.46,2.7,2,3.86,2.44,8.19,3.87,12.27,5.82,1.63.77,3.41,1.41,3,3.78-1.22,3.14-4.34,5.48-5.08,8.34s2.81,5.64,3.29,8.94a2.2,2.2,0,0,1-.21,1.21,1.5,1.5,0,0,1-1,.53,2.73,2.73,0,0,1-1.73-.83c.09,1.32,1.46,1.26,1.76,2.16-.55,2.32-2.47,3-4.38,3.62-2.21-.25-4.11-1.48-6.25-2a4,4,0,0,1-3-3.55c-.19-1-.11-2.34-1.75-2.25a7.37,7.37,0,0,0-1.4.71c-2.36,1.09-4.66.55-6.93-.25-.36,0-.89-.11-.94.3-.08.62.61.64,1,.88,3,1,.72,4.55,2.92,5.93a7,7,0,0,1,1.69,1.48c.69,2.73-1.58,3.87-3,5.36-4.9,5.11-4.94,5.07-.17,10,2,2.41,3.84,5,6.39,6.91a8.31,8.31,0,0,1,.86.71,6.32,6.32,0,0,1,.7.85c.89,1.68,2.77,2.42,3.75,4,.61,2.11-.78,3.3-2,4.55-1.44,1.84-2.77,2.89-4-.26-.85-2.27-1.8-2.95-3.53-.39-1.42,2.09-3,1.57-3.92-.75-.08-1.76,1.47-2.85,1.91-4.69-2.85,1-3.61,3.4-4.67,5.59a2.45,2.45,0,0,1-1.08.41c-2.75-.42-2.06-2-1.19-3.6a37.29,37.29,0,0,1,4.24-5.62c-1-1.12-2.44-1.27-3.57-2-4.63-3-6.15-2.64-9.18,1.9a2.34,2.34,0,0,0,.4,3.29l0,0a30.62,30.62,0,0,0,5.39,4.44c1.9,1.18,4,2.82,1.66,5.52-4.28-.7-6.89-4.13-10.29-6.27-1-1.19-2.51-1.44-3.83-2a2,2,0,0,1-.62-.93c-.32-3,1.87-4.65,3.47-6.64,1.28-1.58,2.62-3.17-.69-4.09-2.12-.59-2.87-2.34-3.09-4.38.86-4.42.86-4.42-3.63-4.62a1.54,1.54,0,0,1-.79-.78c-.23-1.11,1-2.34-.25-3.41-1.43.28-1.14,2.15-2.39,2.57-2.33.75-4,.18-4.79-2.31a3.81,3.81,0,0,0-2.69-2.83c-3.51.13-5.77-1.21-6.13-5a3.64,3.64,0,0,0-1.32-2.49c-.34-.21-.67-.45-1-.69-1.89-1.33-4-2.36-5.12-4.63-.85-1.65-2.69-2.24-4.58-2.39-2.26-.18-4.13-1.25-4.69-3.46-1.5-6-6.7-8.81-10.69-12.63-1.19-1.14-2.83-1.79-2.57-3.83,2.16-5.43,6.33-9.59,9.23-14.56.69-1.18,1.56-2.26,2.19-3.48a8.15,8.15,0,0,1,.65-1c2.81-2.85,4.36-6.59,6.8-9.7,1.52-1.93,3.2-3.13,5.32-.71-.18,1.7-1.64,3.07-.93,5.08.5,1.42-.82,2.17-2.08,2.58-1.87.53-1.45,1.19-.1,1.91a2.83,2.83,0,0,1,1,1.17,2.66,2.66,0,0,0,3,2.29,1.6,1.6,0,0,1,1,1.83,2.54,2.54,0,0,1-.91,1.38c-.65.58-2,.76-1.24,2.16a3,3,0,0,1,.31,2.09c-.65,1.69-1.94,2.21-3.72,2,1,.32,1.92,0,2.79.37a1.92,1.92,0,0,1,1.21,1.84c-.26,2.44-1.57,4.44-2.76,6.5-.28.47,0-.16-.07.38,0,.17.42.23.71,0,1.38-.51,2.52-.42,3.13,1.13a7.31,7.31,0,0,1,.44,2.82,1.83,1.83,0,0,1-.6.92c-1.82.79-1.62,2.52-1.86,4.05a2.5,2.5,0,0,1-2.41,1.21c-.67.15-1.71-.42-1.86.72-.06.48.72.58,1.22.67,2,.27,4.16-1,6.13.36s4.1,2.47,6.49.73c5.76-2.06,7.87-1.31,10.07,4.32,0-2.21-.45-3.73.41-5,.82-.88,1.75-.43,2.68-.21a1.23,1.23,0,0,0,1.58-.7,1.33,1.33,0,0,0,.07-.56c0-1.17-.85-1.25-1.72-1.12A12.24,12.24,0,0,1,968,280a4.12,4.12,0,0,1-2.89-3.06,3.26,3.26,0,0,0-2.75-2.52,20.32,20.32,0,0,1-3-1.82c3.4,3.27.88,5.41.14,7.75a2.25,2.25,0,0,1-2.1,1.05,3.79,3.79,0,0,1-1.9-2.37c-.39-2.88-3-5.32-1.72-8.55a18.47,18.47,0,0,0,1-2.59,6.68,6.68,0,0,1,1.06-2.5,5.09,5.09,0,0,1,.75-.79,7.15,7.15,0,0,1,3.4-1.52c.85-.17,2.12,0,1.17-1.54a12.45,12.45,0,0,1-1.11-1.58,1.88,1.88,0,0,0-1.58-1c-1.74-.17-3.55.22-5.16-.75a2.4,2.4,0,0,1-.69-1,2.44,2.44,0,0,1,.84-2.78c.93-.3,2.77,1,2.48-1.44a10.71,10.71,0,0,0-.75-2.89,6.4,6.4,0,0,0-.65-.72c-1-.87-2.88-.36-3.14-2.21,2-2.36-.65-1.86-1.51-2.46-.49-1.65.63-2.82,1.26-4.14C952.27,239.29,953.3,239.94,954.33,240.33Z"
              />
              <path
                class="cls5-451"
                d="M1005.56,219.3v1.19c-1.62,2.8-4.77,2.64-7.25,3.76a5.56,5.56,0,0,1-4.75-.76c-5.3-3.67-10.55-7.42-14.78-10.25,3.08,2.59,7.83,5.2,12,8.56,2.77,2.22,2.77,3.76-.37,4.95-3.44,1.31-6.83,3-10.63,3.11-.58-.28-1-.62-.68-1.37,2.81-1.06,5.59-2.26,8.47-3.14,2.32-.71,2.41-1.54.55-2.87-4.71-3.37-9.45-6.68-14.12-10.1-1.57-1.14-3-.89-4.65-.32-4.42,1.55-8.78,3.29-13.4,4.15-.11-.86-1.43-1.67-.11-2.58,2.2,1.78,4.18,0,6.06-.63,10.46-3.29,20.84-6.82,31.26-10.25,2.8-.92,5.55-1.52,8.1.84,1.24,1.15,2,.47,2-1.05s-.06-3-.09-4.53c.65,0,1.92.1,1.7.39-1.83,2.37.35,5.52-1.65,7.77-4-3.43-8.2-3-12.76-1-3.84,1.65-7.94,2.68-12.86,4.29,6.25,4.38,11.61,8.11,17,11.86,2.11,1.49,4,0,5.88-.48C1002.17,220.41,1003.86,219.82,1005.56,219.3Z"
              />
              <path
                class="cls5-452"
                d="M850.64,292.44c.77-6-2.29-9.3-7.32-12.1-3.67-2-6.56-5.5-9.79-8.32.2-.74-.42-1.69.56-2.24a1.36,1.36,0,0,1,1.44.26q18.35,14.4,36.68,28.81a13.6,13.6,0,0,1,1.42,1.42c-2.47-.2-4.92.94-7.41.21.06-.75.57-.8,1.14-.76,0-.22-.23-.14-.34-.22a184.33,184.33,0,0,1-14.86-11.72l-.31-1.81h-.49Z"
              />
              <path
                class="cls5-453"
                d="M995.84,248.49l-2.55.07c-2.59.07-4.23-1.81-6.18-3.05a19.37,19.37,0,0,1-2.82-1.73c-7.62-6.81-15.93-8.5-25.19-3.55-1,0-2.06,0-2.6-1.14.3-1.45,1.7-1.31,2.6-1.83-1.05.05-2,1.08-3.2.44v-1.61l10.83-3.24c2.35.92,4.63-.63,7-.18,5.83,5,12.71,8.27,19.08,12.38C994.09,245.89,996,246.29,995.84,248.49Z"
              />
              <path
                class="cls5-454"
                d="M874.46,305.93c-1-1.41-1.46-3.2-3.24-3.94l4.17-.32,2.27,1.1c2,.91,4,1.91,5,4.07,5,4,10.06,8,15,12,2.35,1.94,3.49,4.28.83,7-1.56-5.69-6.59-7.91-10.89-10.85-2.92-1.81-5.43-4.17-8.24-6.13-.08-1.13-.59-1.58-1.71-1A18.94,18.94,0,0,0,874.46,305.93Z"
              />
              <path
                class="cls5-455"
                d="M951.86,206c.78,1.64,3.26,3.33.29,5-4.07,2.32-6.36,2-7.6-1-.75-1.77-1.34-3.61-2-5.41a5.58,5.58,0,0,0-1.19-2.19l-2.66.61c-.18.77.64,1.73.82,2.47a20.83,20.83,0,0,0,2,5c2,3.64.25,4.67-3,4.85-.07,0-.13.12-.19.37a.73.73,0,0,0,.23.71,3.56,3.56,0,0,0,3.84,0c2.44-1.37,5.15-1.43,7.77-1.94,1.57-.47,3.28-.71,4-2.51,0-1.49,0-3,.12-4.48C954.42,205.4,953,205.93,951.86,206Z"
              />
              <path
                class="cls5-456"
                d="M956.8,238.68c.64.9,1.61.68,2.5.74a58.15,58.15,0,0,1,14,6.11,3.28,3.28,0,0,1,2.06,2.87l-1,.86h-2.57a7.18,7.18,0,0,1-6.53-3.1c-3.06-2.49-7.63-2.36-10.07-5.89.68-.4.68-1.1.77-1.77a.55.55,0,0,1,.84.18Z"
              />
              <path
                class="cls5-457"
                d="M946.69,234.59c2.72-.21,4.39,3,7.28,2.22l.36,3.52c-.92.89-1.65-.36-2.5-.23a2.44,2.44,0,0,1-2.66-1.27c-1.91-1.64-3-.75-4.3,1-2.41,3.17-3.75,7.15-7.22,9.5-1.3.44-1.28-.58-1.48-1.35C938.72,242.77,941.21,237.51,946.69,234.59Z"
              />
              <path
                class="cls5-439"
                d="M954.13,214.54a1.54,1.54,0,0,1,0,.74,3.46,3.46,0,0,1-2.54,1.92c-6.78,1.81-13.25,4.61-20,6.37-2.43.62-4.37,2.39-6.87,2.77s-4.4,2.09-6.83,2.4c-1.53.2-3.15,1.11-4.56-.36-.51-1.64.87-2.11,1.78-2.87a4.36,4.36,0,0,1,1-.64,5.15,5.15,0,0,1,1.23-.24c10.06-2.23,19.56-6.26,29.41-9.14C949.12,214.81,951.44,212.88,954.13,214.54Z"
              />
              <path
                class="cls5-458"
                d="M954.13,214.54c-8.45,1.86-16.41,5.25-24.66,7.76-3.53,1.07-7.07,2.14-10.59,3.27-.82.27-1.54.61-2.14-.32,1.63-2.67,4.66-2.51,7.1-3.5a61.44,61.44,0,0,1,7.36-2.41,11.57,11.57,0,0,0,2.36-.75c5.44-1.94,11.16-2.93,16.58-5l4-1.67C954.13,212.83,954.13,213.69,954.13,214.54Z"
              />
              <path
                class="cls5-459"
                d="M955.72,212.21l32.42-10.4.39,1.19-32.66,10.61Z"
              />
              <path
                class="cls5-460"
                d="M924.47,225.32c9.83-3.55,20-6,29.69-10l-.12,1.87L932.1,224.3c-1.3.43-2.68.68-3.62,1.83a3.08,3.08,0,0,1-3.92.4.71.71,0,0,1-.31-1A.75.75,0,0,1,924.47,225.32Z"
              />
              <path
                class="cls5-461"
                d="M1007.62,219.62l-1-1.82c.46-3.32-.79-6.79.89-10,3,2,5.93,4,8.85,6,1.81,1.28,2.24,2.46-.44,3.24S1010.37,218.77,1007.62,219.62Z"
              />
              <path
                class="cls5-462"
                d="M870.3,302c-2.26,6.07-4.59,7.1-8.06,3.61-1.13-1.13-1-1.72.55-2.22,1.91-.63,4.07-.16,5.82-1.41Z"
              />
              <path
                class="cls5-463"
                d="M826.34,302c-1.5,4.35-.94,5.47-8.39,0A33.65,33.65,0,0,1,826.34,302Z"
              />
              <path
                class="cls5-459"
                d="M955.87,198.54c-1.45,3.92-1,7.87,0,11.83q.11-5.94.22-11.89Z"
              />
              <path
                class="cls5-464"
                d="M956.8,238.68l-.91-.17a1.59,1.59,0,0,1,0-.81c1.7-.62,3.35-1.52,5.67-1.42C960.18,238.2,958.28,238,956.8,238.68Z"
              />
              <path
                class="cls5-465"
                d="M1266.67,579.55c0-1.14.07-2.27.11-3.41,1-4.21,4.2-7.12,6-10.32-2.16,1.19-1.65,5.82-5.93,5.47v-3.47c.45-2,1.77-3.67,1.48-5.8,3-1.45,6.2-.59,9.29-.63,12.11-.15,24.23-.1,36.34-.07,1.14,0,2.52-.58,3.36.82h-37c-1.44,0-3.32-.56-3.86,1.46s1.53,2.11,2.51,2.76c4.32,2.84,9.21,4.8,12.64,9.06-4.65-2.74-9.48-5.23-13.9-8.31-3.81-2.65-3.94,1-5.18,2.57-1.5,1.87-2.09,3.74.81,5.25,4.69,2.45,9.25,5.15,14,7.82-1.37,1.43-2.16-.4-3.23.61.09,1.06,2.15.74,2.1,2.28-.31.07-.75.35-1,.22-4.35-2.4-9-4.4-12.9-7.41C1269.33,576.11,1268.16,577.22,1266.67,579.55Z"
              />
              <path
                class="cls5-466"
                d="M1266.82,372.58a13.26,13.26,0,0,0-.08-1.78l18.48,11a5.11,5.11,0,0,1,2.24,2.31h0a1.39,1.39,0,0,1-1.51.42C1279.05,381.37,1272.35,377.92,1266.82,372.58Z"
              />
              <path
                class="cls5-467"
                d="M1307.32,559.56v.84h-30.9a7.69,7.69,0,0,1-4-.79c-1-1.22-.36-2.39.26-3.43q13.42-22.56,26.75-45.19a6.43,6.43,0,0,1,1.18-1.15H1314c-6.32-.37-8.88,4-11.18,8.8-.22.45-.8.73-1.21,1.09-2.1-.16-3.17,1.12-4.18,2.74-1.67,2.68-2.84,5.66-5,8.07.91-1.08,1.76-2.14,3.25-.92-.61,4.44-4.13,7.33-6,11.12a175.72,175.72,0,0,1-9.24,15.52c-1.79,2.86-.78,3.43,2.12,3.39C1290.8,559.52,1299.06,559.57,1307.32,559.56Z"
              />
              <path
                class="cls5-467"
                d="M1295.7,529.61a7.33,7.33,0,0,1,3.32-5.81C1298.59,526.13,1297.82,528.25,1295.7,529.61Z"
              />
              <path
                class="cls5-468"
                d="M1170.36,342.51c-1.8-.25-1.86-.29-1-1.88,1.64-3,3.35-5.88,4.9-9.32-3,5.13-6.15,2.84-9.37.79a5.24,5.24,0,0,0-2-.31V330c1.8-1,3.18.28,4.57,1,3.56,1.8,4.14-1.39,5.53-3.18s1-3.34-1-4.79c-3.1-2.26-6.57-4.06-9.18-7l.09-1.89c5.88,3,10.87,7.41,16.41,11a.93.93,0,0,1,.17,1.3,1.1,1.1,0,0,1-.22.21A78.66,78.66,0,0,0,1170.36,342.51Z"
              />
              <path
                class="cls5-469"
                d="M1201,329.26c-7.16-3.42-13.43-8.25-19.8-12.89-2.52-1.83-5.59-2.9-7.61-5.42a1.38,1.38,0,0,1,1.23-1.13c8.83,4.92,16.89,11,25.12,16.82a2.93,2.93,0,0,1,1.27,2.06Z"
              />
              <path
                class="cls5-470"
                d="M1179.36,326.61c0-.5,0-1,.05-1.51a225,225,0,0,1,19.23,13c1.13.84,1.75,1.87,0,2.83-.33.44-.65.42-.94-.05,1.1-1.93-.62-2.28-1.68-3Z"
              />
              <path
                class="cls5-471"
                d="M1174.42,310.19l-.83.76L1163,304.36c.06-.87-.71-2,.74-2.43C1167.28,304.66,1172,306,1174.42,310.19Z"
              />
              <path
                class="cls5-472"
                d="M1210.22,334.27l-.78,1.73c-2.45-2.7-6.4-3.53-8.44-6.74h0C1205.43,328.47,1207.62,331.74,1210.22,334.27Z"
              />
              <path
                class="cls5-473"
                d="M1197.72,340.88l.94.05a21.44,21.44,0,0,1-4.85,8.42C1194.2,345.54,1196.64,343.52,1197.72,340.88Z"
              />
              <path
                class="cls5-470"
                d="M1157.33,298.45c-14.07-9.64-28.12-19.3-42.29-28.79-2.1-1.41-3.58-2.71-3.83-5.07l-.76-.46c-.17,4.87-.42,9.76.65,14.59,1-.53,1-1.54,1.17-2.49.66-4.77,1.19-5.07,4.93-2.31,8.22,6.06,16.79,11.62,25.25,17.31,4.22,2.83,8.08,6.26,12.18,8-3.74.19-8.21-1.24-12.52.82,5.11,1.67,10.36.35,15.52.74l1-.83A8.5,8.5,0,0,0,1157.33,298.45Z"
              />
              <path
                class="cls5-474"
                d="M1074.77,300.89l.23,1c3.91.9,7.71,2.05,11,4.53,2.64,5.08,6.93,8.9,10.34,13.39,5.43,7.15,11.78,13.55,17.26,20.67.75,1,2.08,2.1,1.14,3.23-1.26,1.52-2.49-.12-3.5-.81-12-8.2-23.79-16.69-35.66-25.06-4.37-3.08-8.4-6.56-14.52-6s-11.26,4-13,9.8c-1.88,6.32.29,13.49,5.16,16.76a20,20,0,0,1,4.53,3.62,4.61,4.61,0,0,1,1.06,2.24c.1,1.48-.17,2.94,0,4.43.21,2.45-1.1,3.75-3.4,4.21-1.75-.3-3.61-.91-4.42,1.53-1.59,2.16-2.71,4.74-5.33,6-2.74.14-4.46-1.47-6-3.46,0-1.57,1.6-4.56-2.32-2.56a3.17,3.17,0,0,1-1.15.09,4.18,4.18,0,0,1-3.48-2.83,3.82,3.82,0,0,1-.06-1.17,15.55,15.55,0,0,1,3.31-5.16c1.31-1.6,1.9-3.33-.15-5-1.85-1.5-3.59-1.83-5.5-.07s-2.85,4-4.54,5.84a3.3,3.3,0,0,1-2.9-.26c-8.21-5.12-8.2-5.11-3.43-13,.64-1.06,1.28-2.11,2-3.13s1.39-1.83,2.08-2.75a95.18,95.18,0,0,0,8-11.6c1.17-2.42,3.13-4.26,4.68-6.4,1.65-2.56,3.77-4.78,5.21-7.48a7.59,7.59,0,0,1,.57-1c2.82-3.63,5.46-7.39,8.3-11,2.61-1,4.4.94,6.38,2C1062.66,294.57,1068.5,298.15,1074.77,300.89Z"
              />
              <path
                class="cls5-475"
                d="M1103.54,271.9c-6.17-3.71-11.86-8.11-17.9-12-2.8-1.81-4.78-1.17-6.73,1.33-2.65,3.39-4.69,7.17-7.14,10.68-.93,1.35-2.19,2.59-1.67,4.47.45,1.56,1.9,2.2,3.4,3.48a8.64,8.64,0,0,0-3.9-1.56c-.94-.07-2.31.94-2.5-1a5.49,5.49,0,0,0-1.76-3.22c-.75-.78-1.78-1.15-2.95-2.15a19.86,19.86,0,0,0,2.16,1.33c3.89,2.36,4.26,2.21,6.92-1.58,2.53-3.62,5-7.32,7.49-11,1.79-2.57,1.48-4.67-1.24-6.22-2.53-1.45-4.78-3.28-7.27-4.78a2.53,2.53,0,0,0-2.27.26c-.85,1.83.74,2.4,1.73,3.19a30.43,30.43,0,0,0,4.08,2.76c2.15,1.23,2.46,2.63,1,4.66-1.84,2.56-3.61,5.18-5.23,7.88-1.42,2.34-3,2.39-5.09,1-1.42-.92-2.59-2.62-4.69-2l-.37.44A5.33,5.33,0,0,0,1059,271c.06,6.62,0,13.24,0,19.86a2.12,2.12,0,0,0,2.21.8c3.35-1.39,4.39-4.79,6.29-7.42,1.48-2.06,2.84-2.6,5.1-1,3.83,2.69,7.79,5.21,11.76,7.68,3,1.84,5.67,3.57,3.11,7.61-.27.43.12,1.06.47,1.51l.88.22c.62-.8,2-.48,2.41-1.54,2.47-5.62,2.42-5.81-2.6-8.71,1.22.06,1.88,1.08,2.82,1.6,1.81,1,3.47,1,4.75-.8,3-4.16,6.09-8.22,8.82-12.54C1106.62,275.68,1106.15,273.46,1103.54,271.9Zm-1.52,6.49c-2.47,3.1-4.55,6.54-6.82,9.82-.92,1.31-1.72,2.27-3.62.92-5.29-3.71-10.72-7.24-16.17-10.71-2.64-1.68-3.73-3.21-1.3-6.1s4.42-6.3,6.65-9.44c.52-.73.78-1.88,2.43-1.68l1.77,1.16c5.38,3.59,10.75,7.21,16.15,10.76,2.24,1.48,2.79,2.88.89,5.27Z"
              />
              <path
                class="cls5-476"
                d="M1160.1,313.44a33.19,33.19,0,0,1-10-6.39c-4.3-4.23-8.47-3-12.78-.25-3,1.41-3.84,4.51-5.44,7-1.2,1.85.74,2.25,1.92,2.8,8,3.78,15.85,7.65,23.79,11.44a17.49,17.49,0,0,1,3.54,2.08h0c1.1,3.18-.58,3.43-2.84,2.46-3.8-1.64-7.62-3.29-11.27-5.23-4.15-2.2-8.61-3.78-12.6-6.23-3.34-2.05-6.22-2.59-8.8,1a1.6,1.6,0,0,1-2.08-.78c1.36-5.42,1.34-5.39-3.67-8.75-1.95-1.31-4.06-2.33-6.06-3.54-1-.63-2.21-1.23-2.67-2.48a2.89,2.89,0,0,1,.08-2.78c.73-1,1.82-.47,2.62,0,3.66,1.92,7,4.28,10.51,6.53,1.55,1,3.36,3.06,5.18.19a10.6,10.6,0,0,1,.65-.95c2.36-2.24,3.28-5.68,6.19-7.46,7.26-.08,14.53-.17,21.79-.21,1,0,2.24-.36,3,.79-2,2.62-5.08,1.46-7.71,2.15-.27,1.3.88,1.56,1.53,2.06,4.47,3.46,4.49,3.45,5.22-2a3.38,3.38,0,0,1,1-2.2C1161.59,306.32,1163.19,310.11,1160.1,313.44Z"
              />
              <path
                class="cls5-477"
                d="M1091.15,250q-.23-.21-.42-.42l-.28-.19c-1.49,0-3,0-4.47.07-2.7,1-1.19,2.4,0,3.16,6,3.89,11.48,8.52,17.55,12.3,4.72,2.93,5.53,6.52,2.68,11.34-2.23,3.75-5.7,6.73-6.87,11.12a1.93,1.93,0,0,0,1.17,1.33c1.82,0,2.53-1.48,3.4-2.64a88.54,88.54,0,0,0,4.87-7.57,10.28,10.28,0,0,0,.76-4.45V263.54A153.25,153.25,0,0,1,1091.15,250Z"
              />
              <path
                class="cls5-478"
                d="M1162.59,349.92l-.69.67c-1.44.83-2.24-.35-3.12-1.07-8.59-6.91-16.82-14.26-25.4-21.17a1.75,1.75,0,0,1,.29-1.76c6.39.65,11.78,3.67,17,7.18.61,1.28-2.13,2.58,0,3.82,1.54.91,2.43-.34,3.43-1.17a2.28,2.28,0,0,1,1.53-.35c1.64.34,3.34.56,4.09,2.41.81,1.07,2,.74,3,.72a3.78,3.78,0,0,1,3.41,1.7C1167.12,344.76,1163.47,346.8,1162.59,349.92Z"
              />
              <path
                class="cls5-479"
                d="M1126.83,322.53c1.69,2.42,5.21,1.87,6.92,4.25l.21,1.56a2.15,2.15,0,0,1-1.7.79c-3.69-.34-6.75-2.37-10-3.88-10.72-5-21.74-9.46-32.21-15-1.16-1.38-3.56-1.28-4.11-3.41,0-1,.77-1.39,1.6-1.64a4.84,4.84,0,0,1,1.2-.11c3,1.12,6.27.85,9.41,1.34,2.16,4.89,7.38,5.4,11.24,7.86.35,1.19.35,1.19,1,.77a1.31,1.31,0,0,1,1.1-.2,80,80,0,0,0,10.92,5.06,2.63,2.63,0,0,1,1.33,1.11c.35.69,1,.72,1.64.65A2.34,2.34,0,0,1,1126.83,322.53Z"
              />
              <path
                class="cls5-480"
                d="M1100.69,288.51a38.41,38.41,0,0,0,5-6.95c.69-1.22,1.24-2.86,3.07-3,1.42,4.14.38,8.3.07,12.46-.58,3.18-3.08,5.43-4,8.5-.62,2-2.71,1.08-4.25.61l-.12.09c-.9-.78-2.17-1.24-2.35-2.67a3.07,3.07,0,0,1,.44-2.3c.3-.49.8-.06,1.17-.24C1096.9,291.7,1097,291.07,1100.69,288.51Z"
              />
              <path
                class="cls5-481"
                d="M1109.43,314.25c-4,.26-6.77-2.73-10.3-3.74-2.12-.62.4-2.89-1.14-3.83-.69-3.18,1.23-4.14,3.82-4.22.89,0,1.82.57,2.81.37,3.91-1.94,4.39-1.56,4.64,2.44A76.91,76.91,0,0,1,1109.43,314.25Z"
              />
              <path
                class="cls5-482"
                d="M1061.56,291.08c2.52,3.13,6.27,4.3,9.7,5.93a21,21,0,0,1,5.26,3.13l-1.75.75c-5.87-.63-10.4-4.26-15.39-6.84-2.91-1.49-5.56-3.54-8.94-4-2.19-1-2.53-2.45-1.15-4.37,3.17,0,5.81,1.7,8.64,2.82.25.82-.48,2.09,1,2.33Z"
              />
              <path
                class="cls5-483"
                d="M1113,301.86c4,4.08,9.18,6.34,13.84,9.41,1.74,1.14,2.29-1,3.56-1.18-.45,3.7-2.25,3.88-5,2.06-4.45-2.91-9-5.71-13.53-8.59-1.29,2.46.32,3.13,1.55,3.93,3,1.93,6.08,3.78,9.08,5.73,4.54,3,4.53,3,1.33,7.77l-1.78-.22c1.28-3.09.47-5.16-2.62-6.73-2.27-1.15-4.33-2.75-6.6-4.06-1.23,1.56.35,4-1.76,5.11a1.68,1.68,0,0,1-.59-.07V304.46C1110.37,302.63,1111,301.56,1113,301.86Z"
              />
              <path
                class="cls5-484"
                d="M1104.62,302.83c-1,.24-1.32,1.82-3.19.44-1.37-1-2.92,1.51-3.44,3.41-2.06,2.08-4.27.44-6.39.17a10.79,10.79,0,0,1-2.61-1.07c-1.25-2-.09-3,1.54-3.8C1095.25,302,1100,301.11,1104.62,302.83Z"
              />
              <path
                class="cls5-485"
                d="M1126.83,322.53a1.32,1.32,0,0,1-1.4-.89c1.82-4,4.23-4.34,8.12-2.24,8,4.31,16.36,8,24.55,12.05,1.61.78,3.22,1.86,3-1.34,1.71,1.37.58,2.75,0,4.13-9.41-4.53-18.85-9-28.22-13.63C1130.08,319.22,1128,319.06,1126.83,322.53Z"
              />
              <path
                class="cls5-486"
                d="M1161.09,330.1,1132,316.59a2.29,2.29,0,0,1-1.49-1.83c-.16-1.48,5.07-7.59,6.78-8-6.19,8-6.13,7.85,2.81,12,7.09,3.3,14,6.93,21,10.41C1161.11,329.52,1161.1,329.81,1161.09,330.1Z"
              />
              <path
                class="cls5-487"
                d="M1100.55,300.09c1.7-.12,3.37.71,3.68-2.56.22-2.31,3-4.38,4.61-6.55.11.53.21,1.06.32,1.59C1110.7,299.85,1108.12,302.1,1100.55,300.09Z"
              />
              <path
                class="cls5-488"
                d="M1098.8,297.68l1.63,2.5-1.62-.06c-1.19-.7-2.55-.78-4.09-1.24,1.46.71,2.91.52,4.09,1.24-3.31,2.06-6.67.11-10,.13l1.68-1.41C1093.6,293.76,1094.77,293.6,1098.8,297.68Z"
              />
              <path
                class="cls5-489"
                d="M1088.08,305.93a1.84,1.84,0,0,0-1.72.87c-.23.32-.47.34-.71,0-3.56-1.62-7.37-2.71-10.65-4.92h5.71C1083.35,302.92,1086.93,302.2,1088.08,305.93Z"
              />
              <path
                class="cls5-490"
                d="M1088.08,305.93c-2.1-2-5.07-2.4-7.37-4l9.82.07c-.54,1.25-1.63,2.29-1.54,3.8Z"
              />
              <path
                class="cls5-491"
                d="M1166.11,340.9a5.71,5.71,0,0,1-3.41-1.7c.08-1.1.16-2.2.25-3.29C1165.27,336.77,1168.75,336.9,1166.11,340.9Z"
              />
              <path
                class="cls5-492"
                d="M1130.38,310.12c-.18-3.52,3.85-4.93,4.11-8.24l1.84.15C1134.55,304.87,1133.38,308.17,1130.38,310.12Z"
              />
              <path
                class="cls5-475"
                d="M1078,300.3l9.25-.05A14,14,0,0,1,1078,300.3Z"
              />
              <path
                class="cls5-493"
                d="M1163.44,355.09c.73-1.22,1.86-.76,2.89-.66q19.65,23.49,39.28,47c2.83,3.39,3.46,3.35,5.77-.62.55-1,.9-2,2-2.58-.33,2.58,2.11,6.1-2.63,7.24-.63.15.57.81,1.08,1.09.06,2.66-1.78,2.53-3.53,2.31a8.54,8.54,0,0,1-3.27-1.42c-.91-.47-1-1.49-1.57-2.22a3.48,3.48,0,0,1-1.32-2.84,16.31,16.31,0,0,0-9.67-10.64c-9-11.12-18.34-21.89-27.18-33.11C1164.45,357.57,1163.24,356.69,1163.44,355.09Z"
              />
              <path
                class="cls5-494"
                d="M1203.81,366.82c-3.34-2.43-6.59-5-9.94-7.4-1-.7-2.11-1.59-3,.19-2,3.77-4,7.53-6.07,11.29a1.9,1.9,0,0,0,.17,2.32c2.72,2.69,4.29,6.44,7.8,8.39.18,1.77,1,3.45,2.69,3.65,1.44.19,1.9-1.83,2.56-2.94,2.25-3.79,4.25-7.71,6.4-11.56C1205.22,369.26,1205.42,368,1203.81,366.82Zm-4.49,7.79c-.61,1.24-1.37,2.41-1.89,3.68a4.92,4.92,0,0,1-4.7,3.32c1.31-3.07-1.36-4.39-2.79-6.23-1.08-1.41-2.9-2.65-2.16-4.62a28,28,0,0,1,4.46-8.34,1,1,0,0,1,1.16-.13c2.9,1.84,6.19,3.42,8,6.39,1.31,2.22-1.15,4-2.08,5.93Z"
              />
              <path
                class="cls5-495"
                d="M1262.64,369c1.69,2.84,1.88,6,1.69,9.15-.14,2.48-1.33,1.89-2.6.76l-.92-.62c-1.17-1.46-2.53-2.57-4.56-2.46-5.89-.88-10-5.33-15.08-7.81-2.17-1.06-4.89-1.82-6.45-4.09-.1-.64-.11-1.24.72-1.4,8-6.11,17.58-5.53,24,1.41a2.15,2.15,0,0,1,.62,1.85C1259.23,368.25,1261.83,367.9,1262.64,369Z"
              />
              <path
                class="cls5-496"
                d="M1261.68,378.29v.65l-1.1,1.06a2.63,2.63,0,0,1-3.34.23c-1.69-1.11-2.6.3-3.81.75-1.4-.73-.58-2.66-1.87-3.43-1.27.92-1.36,2.81-2.91,3.45-1.75.17-3.22,3-5.26.57-1.26-1.72-1.39-3.82-1.93-5.79-.58-2.14-1.52-2.95-3.27-.92a33.49,33.49,0,0,1-4.65,4c-2.75,2.17-4.1,1.57-4.49-1.87-.15-1.35-.26-2.72-.33-4.09a25.1,25.1,0,0,1,2.7-6.72c.83-1.4,1.69-3.35,4-2a66.49,66.49,0,0,1,15.2,8.6c1.85,1.47,4.07,1.3,6,2.18S1260.05,377.13,1261.68,378.29Z"
              />
              <path
                class="cls5-497"
                d="M1265.09,444.83l1.44.89a1.2,1.2,0,0,1,.25,1.31c-1.25,4.13-.36,8.37-.62,12.55-.16,2.56.31,5.16-.4,7.7-.38.87-1.13,1.44-2,1-4.87-2.73-10.2-4.88-13.43-9.86.19-3.39,2.69-5.57,4.37-8.14,1.12-1.71,2.2-3.44,3.37-5.12C1260.35,443.12,1262.65,442.33,1265.09,444.83Z"
              />
              <path
                class="cls5-498"
                d="M1252.66,395.84c5.58-1.46,8.78-5.67,12.43-10.24,0,6,.05,12,0,17.94,0,1.6-1.47,1.36-2.53,1.37h-9.94a18.77,18.77,0,0,1,.07-9Z"
              />
              <path
                class="cls5-499"
                d="M1252.75,394c.39-4.39-.38-8.83.46-13.21,2.14-3.52,4.93-.67,7.42-.77,2.66,3.68,1.36,8.91-2.59,11.55-2.25,1.51-1-1.88-2.88-1.17C1254.2,391,1256,394.42,1252.75,394Z"
              />
              <path
                class="cls5-500"
                d="M1276.51,404.86c-9.85.19-9.91.19-9.79-9.62,0-1.95-.83-4.08.72-5.87,3.52,4.17,6,9,8.93,13.57A1.76,1.76,0,0,1,1276.51,404.86Z"
              />
              <path
                class="cls5-501"
                d="M1258.36,445.68l-5.19-4.06c3.95.31,7.87,1,11.86.7l.06,2.51C1262.65,443.53,1260.45,444.2,1258.36,445.68Z"
              />
              <path
                class="cls5-502"
                d="M1281.6,391.65c-5.42-1.84-9.74-5.64-14.74-8.23v-1c5.32,2.44,10.45,5.19,14.81,9.18Z"
              />
              <path
                class="cls5-503"
                d="M1266.48,446.52a2.15,2.15,0,0,0,0-.8c.1-.31.2-.63.29-.94,2.26,1.41,4.18,4.26,7.38,1.76a1.83,1.83,0,0,1,.34,1.73c-2.75,3.93-2.93,3.91-7.94-.59A1.32,1.32,0,0,1,1266.48,446.52Z"
              />
              <path
                class="cls5-504"
                d="M1262.55,365c1.09-.64,2.59-2.63,2.45.77v4.05Z"
              />
              <path
                class="cls5-505"
                d="M1262.64,369c-3.64-.36-4.16-1-2.63-3.21C1261.11,366.7,1262.75,367.15,1262.64,369Z"
              />
              <path
                class="cls5-506"
                d="M1231.53,386.94c-1.78-4.34-2.8-8.79-2-13.51,1.28,1.72.12,3.8,1,6.13,3-1.33,5.12-3.59,7.24-5.86.7-.75.85-2.26,2.33-1.85a3.32,3.32,0,0,1,2.45,3,23.89,23.89,0,0,0,1.66,6.77,116.72,116.72,0,0,1-1,13.6c-2.72.7-4.68-.66-6.52-2.37-1.5-1.73-2.28-4.25-5-4.59C1230.24,388,1230.86,387.46,1231.53,386.94Z"
              />
              <path
                class="cls5-507"
                d="M1231.53,386.94c.1.44-.51,1,.15,1.33l1.64,3.59c-.26.09-.61.27-.77.16-3.17-2.3-6.17-1.92-9.06.51-2.13,1.85-3.54.05-5.1-1l8.58-16.16c1.28,1.94-.14,4.08,1.26,5.56C1229.23,383,1228.59,386,1231.53,386.94Z"
              />
              <path
                class="cls5-508"
                d="M1265,543.81l.09,4.26c-1.14,1-.92,3.1-2.75,3.62a1.67,1.67,0,0,1-2-1c-.41-1.21.1-3.06-1.81-3.28-1.76-.2-2.59,1.38-3.52,2.51s-2.3,2.55-1.12,4.39c.44.69,1.17,1.17,1.51,2,.28,4-2.92,2.24-4.67,2.87a4.49,4.49,0,0,1-4.2-2.26c-2.13-4-5.59-7.14-7.25-11.42a3.94,3.94,0,0,1,.29-2.37c1.73-2.19,4.38-3.46,6.44-6.08-3.39-.32-4.42,3.48-7.26,2.88-1.91-2.47-.57-4.81.74-6.74a11.17,11.17,0,0,1,5.85-4.87,4,4,0,0,1,1.78.55c3,2.81,7.27,4.3,9.19,8.35-.22,3.22-2.28,1.88-3.86,1.51-2-.48-3.66.08-4.42,2s.8,3.1,2,4.12c1.67,1.44,4,.4,5.22-2.7,1-2.56,2.31-3.54,4.92-2.61C1262.37,540.27,1263.7,542,1265,543.81Z"
              />
              <path
                class="cls5-509"
                d="M1240.2,543c-.09.88-.17,1.75-.26,2.63-1.89,2-4.41,3.14-6.65,4.66-2.43,1.65-3.33,3.35-1.45,6,.75,1.08,2.12,2.37.58,3.92l-2.37.24a1.44,1.44,0,0,1-1.64.15c-1-2.16-1.05-4.64-2.56-6.67-1.18-1.57-2.25-1.66-3.68-.57a32.13,32.13,0,0,0-2.86,1.89c-4,2.58-4,2.58-4.65-.61a18.78,18.78,0,0,1,6.82-5.59c2.59-1.1,4.59-3.57,7.76-3.33,1.2.09,1.21-.7,1.14-1.62s.33-1.91,1.11-2c5.62-1,2.58-3.37.93-5.53-.14-3,2.77-4.43,3.46-7a5.47,5.47,0,0,1,1.3-1.82c.56-.46,1.19-.84,1.76-1.3,1.51-1,2.26-2.86,3.9-3.77a5.73,5.73,0,0,1,3.86.9c-.15,1.8-.67,3.54-.91,5.33-3.72,2.65-7.75,5.11-6.63,10.75C1240.28,540.54,1241,541.53,1240.2,543Z"
              />
              <path
                class="cls5-510"
                d="M1266.77,558.68c2.07,0,2.65-1.65,3.48-3.07,4.2-7.22,8.38-14.47,12.67-21.64.92-1.53,2-3,0-4.19-5.29-3.25-10.11-7.32-16.16-9.22v-1.8c1.84-1.06,3.14.3,4.48,1.11,2,1.18,3.17.72,4.42-1.14,2-3,2.9-6.6,5.87-8.88h5.11c-1.08,4-3.61,7.31-5.72,10.79-1.47,2.43-1.8,4,1.1,5.63s4.21.21,5.57-2.08c2.87-4.83,5.19-10,8.9-14.32h2.65c.93,1.9-.57,3.12-1.36,4.45-8.13,13.75-16.44,27.39-24.48,41.2a40.48,40.48,0,0,0-2.43,4.78C1269.49,559.81,1267.51,560.83,1266.77,558.68Z"
              />
              <path
                class="cls5-511"
                d="M1230.05,561.2c1.4.31,3-.11,4.18.94,2.16.83,2.66,2.72,2.76,4.69.39,8.09,2.19,16,2.52,24.13.09,2.19-.2,2.79-2.44,2.92a43.86,43.86,0,0,1-12.64-1.55c-2.78-.82-3.64-2.68-3-5.4a7.14,7.14,0,0,1,3.72-4.56,2.28,2.28,0,0,1,2.8.89c-.22,3.49-.22,3.49,5.23,4.64-.46-1.3-1.62-2.35-1-3.65,1.69-3.66.15-7.14-.6-10.67-1-2-1.52-4.1-2.32-6.14.06-2.08-2.21-4-.38-6.22A.86.86,0,0,1,1230.05,561.2Z"
              />
              <path
                class="cls5-445"
                d="M1249.2,562.06l-2.37.23c4.61,2.84,8.64,5.45,12.8,7.83,2,1.15,2.5,2.32,1.29,4.31-2.57,4.22-5.13,8.45-7.56,12.75-1.06,1.87-2.07,2.24-3.89.93-3-2.16-6.63-3.36-9.43-5.87a.83.83,0,0,1-.26-.68c0-.25.08-.37.14-.37,3.53-.48,5.57,2.66,8.54,3.55,1.1.33,2.22,2.21,3.25-.2.75-1.75,2.27-3.43-.46-4.81-4.2-2.11-7.89-5.1-12.17-7.08a4.3,4.3,0,0,1-1.94-1.51,2.77,2.77,0,0,1,.43-3.25c2.75-.51,3-3.07,4-5v-1A9,9,0,0,1,1249.2,562.06Z"
              />
              <path
                class="cls5-512"
                d="M1270.88,560.27c-1.18-1.52.11-2.5.78-3.63q13.29-22.26,26.55-44.53a16.69,16.69,0,0,0,.94-2.27h1.54c-2.11,6.51-6.55,11.71-9.77,17.59-6,10.83-13,21-18.42,32.18C1272.15,560.31,1271.52,560.3,1270.88,560.27Z"
              />
              <path
                class="cls5-513"
                d="M1237.89,554.73c-.37-.41-.76-.8-1.11-1.21-.88-1-3.63-.8-2.8-2.72.62-1.42,2.53-2.57,4.12-3.21,1.86-.76,2.53,1.34,3.25,2.47a71.85,71.85,0,0,0,7.61,10.17l-3.91-.66C1242.44,558.29,1239.22,557.9,1237.89,554.73Z"
              />
              <path
                class="cls5-514"
                d="M1265,565.38c-2,3-4.44,2.8-6.74.71-1.56-1.42-4.47-1.25-4.83-4.06,2.84.69,5.43-.93,8.31-.76C1264.8,561.45,1266.14,562.17,1265,565.38Z"
              />
              <path
                class="cls5-515"
                d="M1250.93,559.34v-.6c1.06-1.33,4.12.77,4.13-2.39,1.41-2.48,2.46-5.31,5.67-6.13a1.74,1.74,0,0,0,1.6,1c.59,3.36-2.07,4.83-4,6.74C1256.22,560.28,1253.88,561.45,1250.93,559.34Z"
              />
              <path
                class="cls5-516"
                d="M1237.89,554.73c2,2.15,5.48,2.19,7.16,4.84-1.14,1.23-2.33,1.09-3.54.1l-10.28-6.78.35-.62Z"
              />
              <path
                class="cls5-517"
                d="M1266.8,571.29c4-1.64,4.63-6.15,7.71-8.68-1.82,4.94-4.75,9.25-7.73,13.53C1266.79,574.52,1266.79,572.9,1266.8,571.29Z"
              />
              <path
                class="cls5-518"
                d="M1234.14,559.65l-2.49-4.61c3.29,2.2,6.22,2.87,8.21,5.22C1237.93,560.24,1235.93,560.92,1234.14,559.65Z"
              />
              <path
                class="cls5-519"
                d="M1258.32,557.93c2.41-.45,4.52-.15,5.72,2.36-1.49,0-3,0-4.47.07C1257.19,560.52,1258.42,558.9,1258.32,557.93Z"
              />
              <path
                class="cls5-520"
                d="M1240,561.42c0,1.64-1.06,2.77-1.91,4.33a6.74,6.74,0,0,1-2-4.32Z"
              />
              <path
                class="cls5-517"
                d="M1268.28,562c1,.22,1.93.55,1.16,1.83s-1.76,2.65-2.64,4C1266.87,565.78,1265.72,563.42,1268.28,562Z"
              />
              <path
                class="cls5-521"
                d="M1292.77,499.93c.15.43.3.86.44,1.29a19.31,19.31,0,0,0,.35,2.6c.91,2.39,2.59,1.21,4.07.88l.56-.05,1.76-1.73a2,2,0,0,1,2.46,1.06l-1.25,4.13c2.25-.69,3.92-3.85,6.15-.94l-.06,1.59-20.62-.09c-1.3-3.3,1.63-4.29,3.25-6,.41-.9.31-2.07,1.37-2.63A1.73,1.73,0,0,1,1292.77,499.93Z"
              />
              <path
                class="cls5-431"
                d="M1314,502.19c-2,.77-4.11,1.5-5.51-.88-1.54-2.62.24-4.32,2-5.95l.16.18C1313.23,496.23,1314.08,497.91,1314,502.19Z"
              />
              <path
                class="cls5-522"
                d="M1033.89,250.4h2.78c3.15,1.12,5.61,3.38,8.31,5.22,3.64,2.48,3.6,2.54,6.18-1.26,1-1.46,1.77-3.13,3.47-4l3.42-.08-.06,3.38c-.37.59-.43,1.41-.85,1.88-3.34,3.76-3,7.17.79,10.35l.07,1.86c-3.45-1.05-6.64-2.51-7.94-6.19-.27-.75-.35-.2-.59-.29A32,32,0,0,1,1033.89,250.4Z"
              />
              <path
                class="cls5-523"
                d="M1033.89,250.4c5.27,3.52,10.2,7.47,15.81,10.59a43.15,43.15,0,0,1,8.3,6.76v1.56c-1.49,1.18-2.57,0-3.54-.78-3.09-2.37-6.17-4.7-9.86-6.09a51.12,51.12,0,0,0-6-4.34,58.31,58.31,0,0,0-11.22-7.05C1029.44,249.69,1031.7,250.4,1033.89,250.4Z"
              />
              <path
                class="cls5-524"
                d="M1044.85,261.74c4.23-.28,5.81,3.75,8.83,5.46,1.41.79,2.52,2.18,4.35,2.11-.06.62-.12,1.25-.17,1.87a16.5,16.5,0,0,1-2.23-1c-6.25-4-6.23-4-10.19,2-1.58,2.42-3.21,4.81-4.82,7.21-.56.77-.46,2.06-1.74,2.28a3.8,3.8,0,0,1-3.47-1,2.46,2.46,0,0,1-.79-2.21c3.46-5.11,8.23-9.41,9.72-15.75A1.73,1.73,0,0,1,1044.85,261.74Z"
              />
              <path
                class="cls5-494"
                d="M1057.94,243.68c-4.33-2.88-8.72-5.67-13-8.68-2.06-1.47-3.14-1.14-4.54.93-2.67,3.95-4.53,8.48-8.12,11.81h-.76c-.13-3.8,2.39-6.07,4.84-8.38,2.29-2.27,2.86-7,6.15-7.06,2.62,0,5.2,3.12,7.88,4.7s4.66,3.78,7.53,4.8A8.46,8.46,0,0,1,1057.94,243.68Z"
              />
              <path
                class="cls5-525"
                d="M1057.9,232c-5-2.45-9.06-6.12-13.41-9.48,5.06,1.59,8.76,5.52,13.44,7.73Z"
              />
              <path
                class="cls5-526"
                d="M1283.28,508.6l-9.92.15c-3.24-3.45.4-4.58,2.13-6.36,1.14-.4,2.38-.43,3.51-.89,3.16-.9,5.12,1.13,7.18,2.94A3.75,3.75,0,0,1,1283.28,508.6Z"
              />
              <path
                class="cls5-527"
                d="M1265.78,502.24a2.47,2.47,0,0,0-.23.79c.25,6.45-.27,6.84-7,5.22l-.45-.34c-.17-2.69,2-4.22,3-6.27a1.63,1.63,0,0,1-2.29-.27,1,1,0,0,1-.08-.11,2.16,2.16,0,0,1,.06-2.21c2.39.56,4.21-1.28,6.4-1.56A4.88,4.88,0,0,1,1265.78,502.24Z"
              />
              <path
                class="cls5-528"
                d="M1264.9,513.79c-1.87,3.77-3.81,1.08-5.75.08-2.79-1.45-.93-2.74.11-4.07,2.21.06,4.52-.66,6.57.81C1266.88,512.07,1266.45,513.09,1264.9,513.79Z"
              />
              <path
                class="cls5-529"
                d="M1272.66,500.77c-1.51,1.92-3.2,1.92-5,.47-1.82-3.63-1.49-4.66,2-6.36a4.4,4.4,0,0,1,1.85.43,13.49,13.49,0,0,1,2.06,1.17,2.23,2.23,0,0,1,1.07,1.88,2.62,2.62,0,0,1-.36,1C1273.89,500,1273.19,500.3,1272.66,500.77Z"
              />
              <path
                class="cls5-63"
                d="M1272.66,500.77a1.8,1.8,0,0,1,1.52-1.86c1.74.88,2.15,2.3,1.68,4.09-1.47,1.64-4.29,2.69-2.5,5.75l-5.92-.11c-.21-2.48,1.38-3.69,3.29-4.68C1271.69,503.09,1273.42,502.69,1272.66,500.77Z"
              />
              <path
                class="cls5-530"
                d="M1283.28,508.6l2.45-3.8a6.44,6.44,0,0,0,.55-3c.47-2.23-1-5,1.85-6.57,2.42.6,2,2.63,2,4.3,0,1.4-.34,2.76,1.38,3.39-2.09,1.53-4.66,2.65-4.9,5.76Z"
              />
              <path
                class="cls5-64"
                d="M1264.9,513.79a4.49,4.49,0,0,0,.93-3.18c1.77-1.63,3.89-.64,5.87-.81-2.26,2.08-3.15,5.09-5,7.44A4.69,4.69,0,0,0,1264.9,513.79Z"
              />
              <path
                class="cls5-527"
                d="M1258.2,508.84l-.92.18c-4.18,1.78-8.55,1.07-12.81.72-2.25-.18-2.94-1.5-.5-2.93,4.77.35,9.68-1.14,14.29,1.1.1.12.21.23.32.34A1.1,1.1,0,0,1,1258.2,508.84Z"
              />
              <path
                class="cls5-531"
                d="M1270.73,504l-3.29,4.68C1265.61,504.1,1265.84,503.76,1270.73,504Z"
              />
              <path
                class="cls5-532"
                d="M1213.49,406.57v10l-.42.41c-3.77,1-5.78-1.65-7.84-4-3-3.4-3.27-3.41-5.89.36-1.87,2.68-3.39,5.63-5.94,7.8-3.52.53-5.07-1.65-6.18-4.45,1.73-4.62,4.4-8.5,8.79-11,2.83-.22,5.69-.94,8.37.65,2.48-.17,4.85,4.1,7.42.17Z"
              />
              <path
                class="cls5-533"
                d="M1163.44,355.09,1190,386.93c1.12,1.36,2.58,2.58,2.58,4.6-.25,2-1.8,3.23-2.75,4.83-2.69,3.46-4.88,7.28-7.45,10.83-3.32,3.47-4,3.43-8.34-.4a7.27,7.27,0,0,0-2.69-2c-1-.57-2.09-1.07-2.32-2.4.75-3.23,3-5.55,5-8,3.32-4.15,3.32-4.37-1-7.28-1.83-1.24-3.69-2.45-5.53-3.69a7.32,7.32,0,0,0-7.48.54c-1.26.47-2.51,1.08-3.88.39-1.08-1.35-.57-2.63.28-3.78a35.32,35.32,0,0,0,2.86-5.49c2.59-5.27,2.62-5.25-2.41-8.7-.68-.47-1.31-1-1.95-1.54-2.52-2.06-4.51-2-6.35,1.06-1.7,2.82-4,5.24-5.77,8.06a10.58,10.58,0,0,0-.18,2.1c-.61,1.68-.74,3.48-1.34,5.17a3.14,3.14,0,0,1-1.79.88c-1.2.24-3-2.35-3.57.46-.49,2.22-.87,4.45,1.82,6.1,5.72,3.52,11,7.65,16.6,11.44,1.68,1.15,3.63,2.16.93,4.26a5.79,5.79,0,0,1-2.75.81c-10.28.28-20.56.34-30.84,0a4.87,4.87,0,0,1-2-.59,2.34,2.34,0,0,1-1.33-2.74c.67-2.35-.48-3.62-2.37-4.65s-3.41-.22-4.8,1.09c-1.8,1.5-1.93,4.31-4.23,5.42a8.52,8.52,0,0,1-7.59-5.19c.17-.94,1.48-.44,1.73-1.32-1-.38-1.6.27-2.31.67a3.52,3.52,0,0,1-2.86-.44c-1.25-.75-2.36-1.61-2.47-3.23a13.92,13.92,0,0,1,3-5.76c1.55-2,2.18-3.53-.45-5.37s-4.08-.87-5.52,1.49a54.9,54.9,0,0,1-3.18,4.77,2.52,2.52,0,0,1-1.74.31c-1.88-.76-3.75-1.54-4.61-3.6,1-2.72.67-4.27-2.74-3.24a4.18,4.18,0,0,1-3.79-.78,3.37,3.37,0,0,1-1.19-2c0-2.92,2.25-4.58,3.74-6.62s1-3.3-.9-4.69-3.36-2.35-5.11.11c-.87,1.24-1.57,2.57-2.38,3.83a6,6,0,0,1-2.28,2c-1.84.56-3.17-.31-4.36-1.58-.08-.1-.23-.21-.23-.32.07-4.08-2-5-5.56-3.83a4.15,4.15,0,0,1-2.75-2.4,2.79,2.79,0,0,1,1.64-3.6l.07,0c3.4.35,5.79-.56,5.87-4.57a3.71,3.71,0,0,1,1-2.15c2.66-2.64,6.36-2.37,9.57-3.43-.09-2.23-2.26-2.37-3.48-3.42s-3-1.83-3.86-3.52c-.62-1.81.35-3.22,1.26-4.57,1.38-2,.46-3.26-1.23-4.41s-3.13-1.68-4.55.39c-1.1,1.6-2.34,3.15-4.71,2.43-5.9-3.41-8.28-8.61-7.7-15.29.47-5.51,3.64-9.29,8.38-11.45a14.22,14.22,0,0,1,13.49.54,58.22,58.22,0,0,1,6.16,4.15c.24.32.54.74.41,1.09-1.31,3.43.21,3.16,2.49,1.94,4.06.87,6.84,3.89,10,6.15,7.57,5.39,15.54,10.23,22.56,16.38.77,1.79,0,3.23-1.2,4.44-1.76,1.75-1.34,3,.63,4.18,1.74,1,3.41,2.72,5.19.05.81-1.22,1.33-2.75,3-3.14,5.93,1.74,8.37,6.4,9.28,11.88s-1.34,9.93-5.46,13.49a22.36,22.36,0,0,1-3.83,2.4c-5.4,2.1-10.42.84-14.92-2.28-8.63-6-17.22-12-25.66-18.25,8.45,6.32,17.07,12.4,25.76,18.36,4.74,3.26,10,4.55,15.65,1.78,11.19-5.48,11-20.29,2.07-26.33-3.5-2.37-5.63-6.41-8.31-9.73-5.43-6.74-11.32-13.09-16.68-19.88-2.3-2.92-4.78-5.7-7-8.72-.78-1.09-1.49-2.37,1-1.9l41.65,18.91c3.75,1,6.31,3.87,9.1,6.28,6,5.15,12.29,9.83,18.13,15.12.57.51,1.51.86,1.08,1.94Z"
              />
              <path
                class="cls5-534"
                d="M1160.36,351.75l-28.31-23.34,1.91-.07c7.88,4.82,14.24,11.55,21.53,17.12,2.18,1.66,4.28,3.42,6.41,5.13C1161.78,351.5,1161.13,351.71,1160.36,351.75Z"
              />
              <path
                class="cls5-535"
                d="M931,419.86l-8.35-3.3q1.53-3.78,3.07-7.55c-3.67,5.27-6.7,3.37-9.77-.6-.73-.94-2.78,0-3.28-1.73h5.05c2.48,3.79,4.93,1.56,7.39,0l.88-.22a6.77,6.77,0,0,1,3-.22c.11.08.29.14.32.24.68,2.63-2.82,4.24-2.13,6.17s4.05,2.25,4.54,5A2.56,2.56,0,0,1,931,419.86Z"
              />
              <path
                class="cls5-536"
                d="M876.91,406.69l1.71-.11a2.59,2.59,0,0,0,1.1.48c3.85,1.41,8.92,1.55,12.09.31.1,1.2.68,2,1.48.63a2.29,2.29,0,0,1,2.83-1.33c-.26,2.17-1.78,3.72-2.86,5.45-1.48,2.41-1.34,4,1.49,5.06a7.63,7.63,0,0,1,3.22,2.33C890.6,415.82,883.05,412.44,876.91,406.69Z"
              />
              <path
                class="cls5-537"
                d="M1024.92,574.58c7.49,1.29,15.15,1.73,22.44,4.14-7.6.7-14.79-1.62-22.1-3C1025.08,575.69,1025,575,1024.92,574.58Z"
              />
              <path
                class="cls5-538"
                d="M1063.55,581.8c-1.69-.87-4.43-.74-3.73-3.9.38-1.52,1.75-2.06,2.85-2.84,5.49-3.89,11.53-7,16.14-12.14a3.36,3.36,0,0,1,2.21-1c1-.07,1.18-.75,1.28-1.54.21-1.2,1-2.21,1.27-3.38a2.25,2.25,0,0,1,1.23-1,1.84,1.84,0,0,1,1.06.21,20.36,20.36,0,0,0,4.66,2.83c1.53.67,3.62,0,4.63,2a4.63,4.63,0,0,1,0,2.45c-.44,2.4.52,3.26,2.73,2.2,1.59-.76,2.92-.83,4.07.58a3.22,3.22,0,0,1,0,4.48c-1,1.33-.56,3.22-1,4.82s.19,2.37,1.82,2.5a5.51,5.51,0,0,1,3,1.2c1.41,1.45,1.73,3.09.56,4.78a3.08,3.08,0,0,1-4,1c-2.44-1.1-2.52,1.31-3.62,2.17-7.31.11-14.33-2-21.5-2.93C1072.67,583.62,1068.12,582.63,1063.55,581.8Z"
              />
              <path
                class="cls5-539"
                d="M1098.76,587.18a23.12,23.12,0,0,1,.12-2.88c.22-1.56.89-2.43,2.38-1,1.22,1.16,2.62,1.84,4,.74,1.71-1.29.87-3,.16-4.48,1.09-1.15,2.48-1,3.87-1a8.31,8.31,0,0,1,1.31.21c2.1.78,4.67-.09,6.48,1.55,1.09-6.05,1.51-12.42,2.57-18.7a8.08,8.08,0,0,1,.18-1.2c1.32-2.82.57-4.44-2.65-4.84-2.33-.29-4.57-1.09-6.88-1.52a9.9,9.9,0,0,1-1.2-.17A17,17,0,0,1,1106,553c-2-.81-1.94-1.9-.36-3.14a27.1,27.1,0,0,1,4-1.9,7.53,7.53,0,0,1,1.89-.24,40.17,40.17,0,0,1,6.9,1.11c3.36.6,6.71,1.66,9.79-1a2,2,0,0,1,2.83,0,1.54,1.54,0,0,1,.17.19c1,1.32,0,2.32-1,3.14-1.94,1.75-4,3.35-4.87,6-.63,1.37-.58,2.89-.91,4.34-.68,5.63-1.62,11.22-2.55,16.81-.74,4.47-.32,8.59,3.79,11.48.65.46,1.48,1.05,1.23,2s-1.28,1.08-2.07.93c-4.74-.86-9.69-.37-14.27-2.2a12.43,12.43,0,0,0-3.45-1.69C1104.3,588.63,1101.38,588.67,1098.76,587.18Z"
              />
              <path
                class="cls5-540"
                d="M1264.87,575.25V578c-4.57,5.83-7.78,12.52-11.75,18.73-1.63,2.55-2.94,5.32-4.62,7.84-.62.94-1.07,3.18-2.89,2-1.38-.91-.09-2.3.49-3.28,4.24-7.26,8.56-14.46,12.85-21.69,1-1.66,1.91-3.35,2.92-5C1262.57,575.52,1263.33,574.49,1264.87,575.25Z"
              />
              <path
                class="cls5-541"
                d="M1221.09,593.77c2.19-2.19,3.86-.16,5.67.72-.5,5-3.63,8.73-6.47,12.57.9-1.93-1.93-3.08-1-5-.65-.81-.34-1.61,0-2.42C1220.42,597.86,1219.16,595.31,1221.09,593.77Z"
              />
              <path
                class="cls5-542"
                d="M1228.42,606.27c.31-1.91.59-3.8.94-5.68a2.06,2.06,0,0,1,2.19-1.93,2,2,0,0,1,.92.29c1.59.7.3,1.34-.13,2.32-.69,1.6.68,3.58-.26,5.53-.58,1.2-.32,2.93-2.38,2.5C1227.9,608.92,1228.57,607.4,1228.42,606.27Z"
              />
              <path
                class="cls5-543"
                d="M1239.15,601.54c-.13.41.34,2.27-.94,1.61s-2.15-2.5-2.9-4c-.33-.66.3-1.94,1.22-1.6C1238,598.14,1239.59,599,1239.15,601.54Z"
              />
              <path
                class="cls5-544"
                d="M1240.9,605.33c-.28-2-.61-4-.82-6.05a18.38,18.38,0,0,1,.2-2.87c1.21,2.44-.1,5,1.84,6.66,1.46.09,1.13-2.12,2.85-2.16,0,2.77-2.17,3.49-4,4.43Z"
              />
              <path
                class="cls5-544"
                d="M1240.92,605.34a4.59,4.59,0,0,1-2.67,4.71c-1.5.6-1.43-.79-.59-1.63s1.91-1.11,2.42-2.19a3.7,3.7,0,0,1,.82-.9Z"
              />
              <path
                class="cls5-545"
                d="M1084.94,556.17l-.84.94a3.37,3.37,0,0,1-1.91-2.08c-4-9.47-2.86-19.15-1.23-28.86,1.33-2.35,1.39-5,1.94-7.57.66-3.07.75-6.38,3.34-8.72v-1.12a2,2,0,0,1-.45-1.1,24.3,24.3,0,0,1,1.73-5.85c2.75-2.65,3.38-2.58,7.3.78,1.44,2.23-1.57,4.8.55,7-2.49,2.23.46,2.82,1.23,4.06,1.46,3,5.16,3.06,7.11,5.48.63.78,2.08.21,2.55-.6,3.17-5.34,8-9.38,11.26-14.65,1.15-1.5,1.81-3.58,4.2-3.67,2.31.87,4.15,2.67,6.6,3.26a2.6,2.6,0,0,1,1,.59c4.17,5.3,10.29,8.05,15.61,11.82A38.29,38.29,0,0,1,1158.57,533c-.77,4.45-3.33,5.24-8.07,2.55-1.31,1.93.56,5.5-3.25,6.14-1.28-.73-1.23-2-1.36-3.24-.17-1.56-1-2.93-2.46-2.78-4.49.44-7.86-2.6-11.89-3.49-4.87-1.06-5.35-.86-7.77,3.46-1.49.12-1.56-1.05-1.84-2-.25-2.16.33-4.34-.18-6.5,1.12-2,3.6-4.25-.76-5.54a5.47,5.47,0,0,1-.86-3.1c-.13-1.43-1-1.75-2.24-1.77a2.1,2.1,0,0,0-2.41,1.67A10.84,10.84,0,0,0,1115,522a8,8,0,0,1-2,6,3.49,3.49,0,0,1-1.85,1.68,13.08,13.08,0,0,1-3.94.36c-2.21.06-4.29-.7-6.43-1.06-1-.25-1.78-1-2.76-1.27-2.53-.56-5-1.34-7.57-1.72-2-.3-3.72,0-4.51,2.4s-.08,3.57,2.23,4.22a3,3,0,0,1,2,1.91c.39,2.81-1.33,5.37-1,8.18-.42,1.24-1.21,2.36-1.25,3.74C1088.08,550,1088.26,553.61,1084.94,556.17Z"
              />
              <path
                class="cls5-546"
                d="M1086.24,509.88q-2,8.21-4,16.41c-1.16-.95-1.36-3.32-3.64-2.6-1.76.55-1.78,2.25-2.14,3.68a69.49,69.49,0,0,0-1.7,11.75c-1.18,4.48,1.12,8,3.13,11.62,1.28,2.28,3.07,4.27,4.15,6.66.64,1.42.83,2.42-1.61,2.46-4.06.08-8.14.95-9.58-4.52.07,1.17,1.06,1.61,1.46,2.45.66,1.38.21,2.14-1.3,2.17a16.7,16.7,0,0,0-3-.11c-4.09.73-4.31-.36-6.75-2.9-2.68-2.79-1.44-5.64-1.76-8.47-.13-1.23.16-1.26,2.18-1,.1-.07.09-.28-.15-.53-.78-.82-2.7-1.28-1.78-2.73s2.48-.48,3.68.14,1.93,1.93,2.82,3c2.1,2.48,3.13,1.71,3.35-1.2-3.44-7.62-.2-15,.87-22.38-1.76-2.85-4.16-.91-6.22-.72-4.16.37-4.84-.16-4.56-4.35,1.53-1.53,3.5-1.29,5.4-1.38a34.89,34.89,0,0,0,4.89-.58,2.83,2.83,0,0,0,2.41-3.2s0-.07,0-.11c-.12-1.7-1.58-1.61-2.79-1.73-3.11-.28-6.3.52-9.36-.66a.78.78,0,0,1-.35-1.05l0,0c4.65-.08,9.29-.13,13.94-.24,2,0,3.27.54,2.63,3.32C1078.75,507.72,1082.88,510.18,1086.24,509.88Z"
              />
              <path
                class="cls5-547"
                d="M1005.63,508c-.8,1.49-2.21.8-3.32.81H956a.72.72,0,0,1,0-1,.69.69,0,0,1,.13-.11c2-1.16,4.31-.73,6.48-.75,7.17-.05,14.34-.17,21.5.05,3.54.11,5.62-1.25,7.14-4.34,1.11-2.26.65-3.58-1.38-4.76-4.17-2.43-8.42-4.71-12.71-6.92-5.68-2.93-6.24-4.54-3.73-10.53,1.05-2.52,1.76-5.28,4.36-6.82a1.89,1.89,0,0,1,1.22.05c1.29,2.3-.65,3.89-1.36,5.7-1.64,4.16-1.46,4.93,2.39,6.86s7.87,4.07,11.7,6.27c3.16,1.81,4.66.95,6-2q2.44-5.28,4.92-10.53c.64-1.35,1-4,3.69-2.17a12.22,12.22,0,0,1,.25,6.46c-2.77,6.47-6.27,12.6-9.26,19-1.59,3.39-1.42,3.6,2.34,3.77C1001.69,507.06,1003.85,506.47,1005.63,508Z"
              />
              <path
                class="cls5-525"
                d="M1070.53,547c.56,2-1.14,2.59-2.3,3.13-1.61.75-2-1-2.7-1.94-1.36-1.89-2.4-4.09-5.69-3.74a14.72,14.72,0,0,1,4,5.31c-1.86.06-1.88-2.08-3.29-2.24-1.84,6-.68,8.72,3.7,8.19-.34,1.69-2,2.19-3.23,3.86,2.79-.76,5.59,1.94,7.4-1.71.3-.61.72-.09.94.19.59.73,1.21,2.06,2.19,1.19,1.25-1.12-.47-1.8-1-2.64-.67-1.16-1.71-2.17-1.41-4.25,1.79,2.46,3.08,4.83,4.93,6.64,2.25,2.19,5-1.64,7.83-.16-1.63-2.49-3.43-4.89-4.84-7.5-2-3.63-4.78-7.1-3.16-11.73,3.06,4.39,4,9.93,7.65,14,.51.57.52,1.64,1.63,1.59l.93,1.86c.59,1.74-.59,2.51-1.8,3.26-6.49,0-13,0-19.46.12-2,0-3-.22-3.33-2.81-1-8.15-.28-16.29-.48-24.43-.16-6.5-.08-13,0-19.49,0-1.28-.66-2.8.8-3.81l.09.63a7.74,7.74,0,0,1,0,8.21c-.65,3.36,1.33,3.92,3.82,3.21a18.66,18.66,0,0,1,7.76-.53c2.09.29,1.42,1.15-.11,1.61-1.91,1.55-4.24.93-6.39,1.18-2.78.32-4.28,1.53-4.1,4.54.14,2.2,0,4.41,0,6.62C1060.9,541.59,1064.48,545.91,1070.53,547Z"
              />
              <path
                class="cls5-548"
                d="M1081,561.9c-5.68,7.17-13.65,11.31-21.2,16-1-.56-.59-1.69-1-2.49,0-3.73.09-7.46.14-11.19,0-1.39-.12-3.05,1.93-3C1067.61,561.57,1074.36,560.39,1081,561.9Z"
              />
              <path
                class="cls5-549"
                d="M1007.51,508.78a1.51,1.51,0,0,1,0-.79c2.88-1.91,6.11-.86,9.18-1,2.5-.14,3-.91,2.11-3.31-1.07-2.72-3.33-5.11-2.64-8.39,2.15-1.47,2.57.56,3.09,1.73,1.15,2.63,2.66,5.07,3.38,6.81-1.79-3.47-3.8-7.92-6-12.27-.92-1.8-2-3.68-1.63-5.88a3,3,0,0,1,.48-1.16c.65-.6,1.31-1.14,2.23-.47,1.73,6.31,5.11,11.92,7.51,17.94,1.51,3.82,3.94,5.41,8,5,3.23-.32,6.75.46,9.13-2.7.86-1.2.41-3.08,2-3.89,2.62,1.88,1.46,4.56,1.49,7-.41,1.68-1.78,1.46-3,1.46Z"
              />
              <path
                class="cls5-550"
                d="M1060.55,500.46c-1.67,6.05-.58,7.58,5.41,7.59,9.64,0,9.63,0,12.09-9.39.69-2.66,1.42-5.31.82-8.1.64-.46,1.73-.44,1.74.14.06,3.43,3.16,6.15,2.15,9.85-.49,1.83-1.47,3.85-1,5.58s3.38.23,4.53,1.86a.87.87,0,0,1,0,.77c-2.79-.38-5.84,1.42-8.43-1.3-.76-.79-1,1.57-2.57,1.47-4.67-.27-9.38-.09-14.08-.08-1.58,0-2.54-.88-2.06-2.3C1059.84,504.55,1057.12,501.77,1060.55,500.46Z"
              />
              <path
                class="cls5-551"
                d="M1058,473.87V479c-.78,2.46-1.46,5-4.89,4.75-.23-.35-.48-.87-.27-1.14,3.13-4.18.55-6.2-2.88-8.07a9.61,9.61,0,0,1-3.81-3.05c-.75-1.8.14-3.17,1.27-4.4a7.42,7.42,0,0,0,2-4.78,52.62,52.62,0,0,1,2.4-5.37c1.73-.49,3,.46,4.32,1.33a1.71,1.71,0,0,1,.63,1.57,76.52,76.52,0,0,0-4.65,6.24c-1.26,2-1,3.19,1.11,4.25C1054.87,471.28,1057,471.75,1058,473.87Z"
              />
              <path
                class="cls5-552"
                d="M1058,473.87c-.49-.25-1-.46-1.47-.75-2.37-1.52-7.17-2.16-6.67-4.57.7-3.33,2.77-7.2,6.72-8.83,1.22-.1,1.79.45,1.68,1.68Q1058.1,467.64,1058,473.87Z"
              />
              <path
                class="cls5-549"
                d="M1058,484.82c-4.67,5.07-9.9,10-10.57,17.29-.49,5.44,3.49,7.82,8.56,5.83,1.69-.67,1.27-1.9.92-3.06-.57-1.93-1-3.78,1-5.18a8.14,8.14,0,0,1,.13,1.21c-.19,2.54,1.18,6.2-.82,7.35-2.8,1.61-6.61.75-10,.27-.31,0-.53-.83-.79-1.26-2.42-5.53-1.78-10.58,2.38-15.06,2.23-2.46,3.68-5.5,5.83-8,.92-1.07,1.53-2.67,3.3-2.81C1058,482.54,1058,483.68,1058,484.82Z"
              />
              <path
                class="cls5-553"
                d="M1058,481.4c-3.08,3.34-4.83,7.68-8.15,10.84a1.32,1.32,0,0,1-1.59.24c-.18-3.63,3.1-5.41,4.39-8.26l.49-.3c2.13-1.11,3.4-3.06,4.81-4.89C1057.93,479.82,1058,480.61,1058,481.4Z"
              />
              <path
                class="cls5-554"
                d="M1048.21,492.24h1.6c-3.46,4.48-5.2,9.36-3.36,15-.22,0-.45.07-.68.09-2.16-1.88.09-4.9-1.77-6.86-1.47-3.3,1-5.25,2.54-7.55A2.6,2.6,0,0,1,1048.21,492.24Z"
              />
              <path
                class="cls5-436"
                d="M1048.9,518.91a39.18,39.18,0,0,1-1.72-8.51c3.61-1.06,7.22-1.43,10.79.17h-.41C1049.07,510.39,1049.07,510.39,1048.9,518.91Z"
              />
              <path
                class="cls5-550"
                d="M1061.5,495.66c.4-2.63,2.38-4.18,4-6a2,2,0,0,1,1,1.88c.13,2.67-2,3.91-3.48,5.59a1.4,1.4,0,0,0-1.34-1.47A1.08,1.08,0,0,0,1061.5,495.66Z"
              />
              <path
                class="cls5-555"
                d="M1047.93,569.18c-1.39-.69-2.47-1.25-1.83-2.79a1.1,1.1,0,0,1,1-.4C1048.54,566.7,1048,567.88,1047.93,569.18Z"
              />
              <path
                class="cls5-556"
                d="M1162.75,598.55c-.47-.46-.94-1.34-1.38-1.32-5.94.23-11.57-2.12-17.48-2-4.2-.92-8.8,0-12.7-2.52.36-1.7,1.76-1.62,2.88-2,4.86-1.44,7.49-4.73,8.37-9.69.94-5.27,1.31-10.65,2.71-15.84.94-1.58.7-3.34.78-5,1-3.22-.06-7.19,3.59-9.36,3,.72,6.2-.06,9.16,1.13a17.33,17.33,0,0,0-4.15-.87c-13.34-1.57-26.32-5-39.5-7.31a7.62,7.62,0,0,1-3.83-1.47,1.86,1.86,0,0,1-.06-2c1.43-1.16,3.09-1,4.71-.69a17.8,17.8,0,0,0,7.72-.22c7.13-.61,14,1.44,21.08,1.79a53,53,0,0,0,8.83,1.62c1.59.19,3,.31,3.44-1.81.26-1.32.66-3.15,2.25-3s1.4,2.11,1.75,3.4a5.66,5.66,0,0,0,2.33,5.24c.58,4.64.87,9.35,3.72,13.36a1.63,1.63,0,0,1,.23,1.12,4.61,4.61,0,0,1-4.7,2,11.54,11.54,0,0,1-1.17-.1c-2.29-.54-3.76.1-4,2.68-.65,6.71-2.08,13.3-3.15,19.94-.3,1.89-1.88,4.3,1.16,5.77s4.2-.76,5.74-2.43a57.49,57.49,0,0,1,7.21-1.55,2.22,2.22,0,0,1,1.67,2.29c-.8,1.53,1.34,1.48,1.39,2.56a9.72,9.72,0,0,1,1,2.66c.55,2.79-.43,3.76-3.27,3.29-1.58-.26-3.08-1.17-4.76-.57C1163.73,597.85,1163,597.71,1162.75,598.55Z"
              />
              <path
                class="cls5-557"
                d="M1164.35,597.75c1.22-1.4,2.5-.35,3.79-.15s2.62.72,3.46-.43-.26-2.09-.61-3.1l-.66-1.94c2.67-3,4.93-3.49,9.26-1.91,1.73,1.79,2,4.24,2.89,6.43a5.24,5.24,0,0,1,.26,1.25,3.18,3.18,0,0,1-.72,2.37c-3.19-1.74-6.27-1.59-9.72-.32C1169.52,601,1167.26,597.71,1164.35,597.75Z"
              />
              <path
                class="cls5-67"
                d="M1181,603.29c-.27,1.58-1.17,2.65-2.72,2.68a2.19,2.19,0,0,1-2.52-1.8,2.16,2.16,0,0,1,0-.76c.12-1.6,1-2.7,2.54-2.73S1180.74,601.8,1181,603.29Z"
              />
              <path
                class="cls5-558"
                d="M1163.73,602.13l-.21-1.75c3.32.47,6.85.15,9.77,2.31C1170,603.55,1167,601.51,1163.73,602.13Z"
              />
              <path
                class="cls5-559"
                d="M1146.18,565.25c-.88,5-2,9.88-2.58,14.87-.91,7.74-3.57,10.78-11.55,12.39,3.69,2,8.11.89,11.84,2.77l-5.22.1c-5.84-1.33-11.91-1.28-17.71-3-3.34-1-6.85-.25-10.28-.38v-2.36L1127,592c-6.58-3.72-7.38-8.15-6.15-13.84s2-11.22,3-16.84a4.9,4.9,0,0,1,3.79-1.22c4.94-.05,9.87-.12,14.8,0C1146.48,560.24,1146.85,560.85,1146.18,565.25Z"
              />
              <path
                class="cls5-560"
                d="M1197.61,596.84c-.75.37-1,1.93-2.29,1-1.86-.24-2.65-2.21-4.36-2.7,1.14-2,.15-3.06-1.65-3.77-.31-.5-.92-.5-1.35-.8-.83-.74-2.75-.73-2.1-2.49.72-2,2.44-1.22,3.88-1.05,1,.07,1.28-.74,1.63-1.46.66-1,1.46-1.75,2.8-1.34.66.45.47,1.11.44,1.74.87-.62.19-1.45.29-2.17a2.27,2.27,0,0,1,1.15-1.32,2.57,2.57,0,0,1,1.77,0c1.24,1.7,4.31,2.52,2.7,5.6a30.69,30.69,0,0,0-4,3C1193.52,593.63,1197.77,594.84,1197.61,596.84Z"
              />
              <path
                class="cls5-561"
                d="M925.22,354.05l29,20.89c1.9,3.42,1.14,7.06.85,10.66-1.47,2.84-3.28,1.11-4.76.15C944.57,382,939,378,933.22,374.26c-9.09-5.94-17.8-12.44-27.29-17.77a3.55,3.55,0,0,1-1.74-1.7,1.73,1.73,0,0,1,.78-1.14C911.74,352.7,918.5,352.39,925.22,354.05Z"
              />
              <path
                class="cls5-562"
                d="M956.66,376.48l10.8,7.77a1.27,1.27,0,0,1,.5,1,4.62,4.62,0,0,1-2,2.79c-2.39,2-4.26,1.11-6.06-1.62.64,3.77,3.31,3,5.33,3.47a16.81,16.81,0,0,0,7.57,8.36,25.5,25.5,0,0,1,4.79,3.17c1.47,1.39,2.23,2.9-.09,4.29-7.15.11-14.31.69-21.44-.33A26.91,26.91,0,0,1,954.78,391a7.08,7.08,0,0,1,2.32,2c.12-1.49-1.26-2-1.64-3.13-.86-3.93-.25-7.9-.28-11.85a1.49,1.49,0,0,1,1.44-1.54Z"
              />
              <path
                class="cls5-563"
                d="M887.8,314.24c4,1.37,6.79,4.48,10,6.92,1.52,1.14.48,3.09.69,4.67-3.76,6-3.76,6,1.88,10.35.54.42,1,.88,1.57,1.32,1.78,4.83,1.39,9.71.34,14.6-3.74,1.59-5.35-1.92-7.86-3.28-1-2,.48-3.34,1.49-4.69,1.42-1.93,1.42-3.44-.88-4.58a18.75,18.75,0,0,0-5.85-4.21c-2.35-2.25-2-4.6-.26-7,.49-.67,1.12-1.24,1.54-1.95,3.25-5.59,4.37-4.69-1-8.77C888.5,316.83,887.22,316,887.8,314.24Z"
              />
              <path
                class="cls5-564"
                d="M915.15,346.74l7.39,5.18c-.15.37-.09.92-.6,1-5.76.87-11.54.39-17.32.25a1.7,1.7,0,0,1-1.66-1.6c0-4.33-1.21-8.75.74-13l.76.49A26.75,26.75,0,0,1,915.15,346.74Z"
              />
              <path
                class="cls5-565"
                d="M970.86,360c.14-1.26,0-2.34-1.56-2.63-1.19-.48-2.59-.39-3.56-1.47s-1.11-1.77.28-2.45a9.53,9.53,0,0,1,4.41-.2,6.47,6.47,0,0,1,2.23.94c2.27,1.31,4,3.47,6.5,4.41a11,11,0,0,1,2.23,1.79c1.71,1.61,3.25,4.19,5.75,1a3.08,3.08,0,0,1-1.93-1.35c-.58-1-.52-2.05.66-2.29,2.62-.54,4-2.73,5.92-4.14a4.31,4.31,0,0,1,3.68.1c1.42,1.63.15,2.89-.74,4-2,2.47-3.74,5.14-5.92,7.46a6.08,6.08,0,0,1-1.52.83c-2,.53-2.66,3-4.72,3.5a23.6,23.6,0,0,1-2.78-.29,2.8,2.8,0,0,1-1.52-.72c-.47-1.41.9-1.65,1.54-2.42-1.14-.42-2.37.37-3.45-.31a4.56,4.56,0,0,1-2.05-2C974.66,361.16,971.1,362.12,970.86,360Z"
              />
              <path
                class="cls5-566"
                d="M853.75,267.75c1.56-1.24,3.88-1.25,4.75-3.79.5-1.48,2.75-1.36,4.41-1.2,3.14,4.6,2.54,7.4-2.23,10.2a1.75,1.75,0,0,0-.89,1.28,28.93,28.93,0,0,1-.31,3.36c.38,1.18,2.72.63,2.29,2.43-.32,1.31-1.53.83-2.44.83-.43-.13-1-.61-1.26,0-.15.31.34.64.59.93-4,2.74-6.16-1.32-9.11-2.48,1.29-1.27.58-1.91-.74-2.36l-.92-2.62a1.85,1.85,0,0,1,1.46-.55q2.34.51,1.89-1.86a2.72,2.72,0,0,1,.85-2.58l1.66-1.61c.24.28.52.53.74.82C854.46,268.11,854,268.07,853.75,267.75Z"
              />
              <path
                class="cls5-567"
                d="M903.45,323.46c-2-2.57-3.34-5.25-1.64-8.53-.24-2.37-3.36-3.07-3.28-5.63,2.36-.1,3.45-3.23,6.13-2.58,2.38-.21,4.47-2.49,7.09-1-.73,2.54-1.06,5.2-2.36,7.57-.08,1.16-.21,2.33.81,3.21,1.21,1.76,3.69,1.28,5,2.85l-6,2.39a1.1,1.1,0,0,1-1.1-.31c-2.14-2.95-3.3-1.82-4.1,1A2.71,2.71,0,0,1,903.45,323.46Z"
              />
              <path
                class="cls5-78"
                d="M956.73,335.92l-.76-.08c-1.26-2.3-3.06-3.62-5.81-3.17.22-1.14,1.94-2,.72-3.41l.38-.43c2.52-.72,5.12-1.35,5.58-4.59,2.06.25,3.43-.38,3.43-2.72.94-.71,1.92-1.24,3.12-.6l.08.25c.49,1-.05,2.18.74,3.07-.48,1.24-2.31,2.1-.8,3.89,1,1.15-.26,1.85-1.11,2C959,330.7,958,333.45,956.73,335.92Z"
              />
              <path
                class="cls5-568"
                d="M893.59,247.73a34.43,34.43,0,0,1-11.58.7c-1.36-1-2.56-2.17-4.29-2.48-1.08-.73-2.38.41-3.44-.41a1.8,1.8,0,0,1-.75-2.13c1.82-1.84,4.41-1.77,6.61-2.69a106.39,106.39,0,0,1,11.66,4.77A3.18,3.18,0,0,1,893.59,247.73Z"
              />
              <path
                class="cls5-569"
                d="M885.48,250.83c4.09-2,7.36.3,10.72,2.09a2.06,2.06,0,0,1,2.4,1.5c1.55,2.23,5.25,3.7,2.59,7.41Z"
              />
              <path
                class="cls5-570"
                d="M905.61,266l-1.27-.94a.87.87,0,0,1-.59-.69l-.08-3.41c1.83-1.22,3.13.08,4.44,1,2.58,1.84,5.12,3.75,7.75,5.53,2.19,1.49,4.23,1.93,6.28-.15.92,0,1.73.09,1.49,1.35,0,1.77-1,3.14-1.82,4.55-2.87.9-4.89-.74-7-2.24-2.31-1.63-4.73-3.11-7.11-4.66-.58-.55-1.15-1.2-2-.36Z"
              />
              <path
                class="cls5-83"
                d="M908.5,281.87c-1.21-2.42-1.23-6.53-5.89-3.94-.94.53-1.25-.67-1.58-1.4-1-2.36-.8-4.83-.75-7.29,3.63.1,5.48,3,7.81,5.07L911,281c.65,1.69.83,3-1.74,2.39A1.32,1.32,0,0,1,908.5,281.87Z"
              />
              <path
                class="cls5-571"
                d="M890.26,292.69c-1,.9-2,1.81-.71,3.23.13,3.71-1.12,5.26-4.52,5.66-2.18.26-4.24-.56-6.37-.7-.21-1.34.53-2.27,1.17-3.35.86-1.46,4.15-3.24-.05-4.78-.15-.06-.16-1.06.06-1.46.56-1,1.39-.92,2.46-.6,1.53.45,2.7,2.69,4.7,1.1A2.76,2.76,0,0,1,890.26,292.69Z"
              />
              <path
                class="cls5-86"
                d="M909.38,282.79c2,.74,1.58-.73,1.66-1.76,1.37,1.06.74,2.55.78,3.86,0,1.53.25,2.77,2.21,2.74,1.24,0,2.6-.09,2.78,1.7.14,1.49-1.15,1.69-2,2.26-.45.3-.86.67-1.29,1-1.59,1.5-3.3,1.31-5,.34C906.5,289.34,907.52,286,909.38,282.79Z"
              />
              <path
                class="cls5-567"
                d="M928.52,296.8c.84.53,1.18,1.81,2.48,1.66,1,2.22-1,2.73-2.18,3.67a3.5,3.5,0,0,1-1.75.28c-1.67,0-3-1.74-4.84-.86a1.91,1.91,0,0,1-2.07-.71l-2.51-1.49a3.69,3.69,0,0,1,.38-.41,3.68,3.68,0,0,1-.4.39l-1.7-1.76a1.75,1.75,0,0,1,.06-2.41c2.12,1,4.15,1.45,5.74-.9a4.7,4.7,0,0,0,3.52.83,1.69,1.69,0,0,1,1.55.85c0,.49-.2,1.13.16,1.41C927.62,297.86,928,297.08,928.52,296.8Z"
              />
              <path
                class="cls5-88"
                d="M927,301.81h1.46a2.17,2.17,0,0,1,2.24-.36,1.3,1.3,0,0,1,.56,1,15,15,0,0,1-2.68,4.26V308c1,1.71,2.21,3.39.73,5.44-1.59,0-2.08,1.59-3.68,2.5-.45-3.74-.88-7.26-1.31-10.78A5.18,5.18,0,0,0,927,301.81Z"
              />
              <path
                class="cls5-572"
                d="M935,331.07c-1.41-1.1-4.56-.35-4.5-2.61s2.68-4,4.79-4.5c1.47-.35,3.57,1.38,3.66,3.28C939.05,329.43,937.09,330.37,935,331.07Z"
              />
              <path
                class="cls5-89"
                d="M867,267.87c-.7,1.6-2,3.34,1,4.05l1.49,1.41c1.21,2.52,5.13,1.92,5.82,5-1.43,1.53-2.81,1.62-4.53.27a19.88,19.88,0,0,0-7.16-3.59,27.33,27.33,0,0,1,1.92-9.82Z"
              />
              <path
                class="cls5-91"
                d="M908.63,292.72l4.86-.13h.13c.55,3.7-3.17,2.16-4.44,3.64-2.17-.53-.6,1.67-1.5,2.07-.51,1.44.3,3.39-1.64,4.29a1.78,1.78,0,0,1-1.92.5c-2.5-1.23.55-3.93-1.4-5.31.2-1.92.91-3.46,2.95-4C906.64,293.39,907.51,292.69,908.63,292.72Z"
              />
              <path
                class="cls5-573"
                d="M879.46,302.58c3.92-1.47,6.68,1.52,9.94,2.58-.2,1,1.36,2.12.11,3-1.06.74-2.06-.29-3-.78-1.23-.65-2.27-2.38-3.82-.52a13.66,13.66,0,0,1-5-4.08Z"
              />
              <path
                class="cls5-574"
                d="M930.85,302.87l.14-1c.66-1.73,1.13-3.56,2.45-5,1.14,1.54,2.21.8,3.28-.1a3.74,3.74,0,0,1,3.33.75c-3.36,1.19-4.3,3.05-1.61,5.89-.83,1.13-2.31,1.41-3.21,2.45-1.15-1.8-2.28-2.46-3.34.06A2.74,2.74,0,0,1,930.85,302.87Z"
              />
              <path
                class="cls5-95"
                d="M865.5,265.23c-.07,3.39-.1,6.78-1.92,9.82l-1.65.06c-1-.33-2.23.35-3.08-.69.36-.83-1.42-1.91.48-2.64,5-1.93,5.15-2.43,3.69-7.81a7,7,0,0,1-.11-1.21C864.61,262.71,865.22,263.79,865.5,265.23Z"
              />
              <path
                class="cls5-575"
                d="M903.05,328.39c1.56.59,3.74.63,3.81,2.65s-2.08,2.73-3.54,2.71c-1.67,0-4.1-.69-4.26-2.61C898.87,328.79,901.57,329.17,903.05,328.39Z"
              />
              <path
                class="cls5-576"
                d="M872.73,257c2-.94,3-4,6.14-2.94.83.29,1.35-1.1,1.46-2.1,1.29,1.52,1.27,3.29-.17,4.38-1.8,1.35-3.53,3.27-6.17,2.93C872.68,259.08,872.81,257.93,872.73,257Z"
              />
              <path
                class="cls5-577"
                d="M961,350l4.94-6.6c1-.91,1.8-.35,2.51.47.49,1.31-.65,2.11-1,3.16s-2,1.93-.69,3.38c.54.61,1.08,1.22.71,2.12a3.62,3.62,0,0,1-4.81-.14C962,351.67,960.81,351.33,961,350Z"
              />
              <path
                class="cls5-96"
                d="M906,294.4c-2.11.16-1.33,3.11-3.29,3.42a26.44,26.44,0,0,0-6.76-3.93c-1.7-.8-2.88-1.77-1.52-3.78,3-.57,4.86,2.6,7.74,2.55C903.48,293.17,905.06,293.09,906,294.4Z"
              />
              <path
                class="cls5-98"
                d="M944.29,313.57c1.73-.08,2.17-1.76,3.27-2.62,2.75,1.55,3.26,3.77,1.91,6.52l-5.9,1a8.43,8.43,0,0,1-2.56-2.59C941.73,314.57,944.2,315.77,944.29,313.57Z"
              />
              <path
                class="cls5-99"
                d="M937.5,354.05c-1.71-1.75-.64-5.3,2-6.4,1-.42,2-.72,3-1.07-1,2.72,1.27,1.76,2.37,2.08a10.35,10.35,0,0,1,2.28.82c1.6,1.8,1.46,3.08-1.07,3.65-1.9-.45-3.23-2-5.09-2.55C938.85,350.75,938.45,352.67,937.5,354.05Z"
              />
              <path
                class="cls5-578"
                d="M869,285.83c1.41,0,3-.08,2.85,2-.14,1.63-.52,3.74-2.58,3.63a3.66,3.66,0,0,1-3.63-3.4C865.54,285.91,867.44,286,869,285.83Z"
              />
              <path
                class="cls5-579"
                d="M916.35,283.35c-1.47,0-3.17-.41-3-2,.15-1.9,1.67-4,3.46-4s2.45,2.65,2.71,4.18S917.82,283.39,916.35,283.35Z"
              />
              <path
                class="cls5-100"
                d="M883.69,284.92c.09-1.37,0-3.18,1.92-3s4,1.4,4.12,3.23c.1,2.19-2.6,2.05-4.12,2.42C883.67,288.08,883.58,286.38,883.69,284.92Z"
              />
              <path
                class="cls5-580"
                d="M914.34,344.23c-3.65-1.58-3.39-3.9.81-7.48h0c.64,1.47,2.77.17,3.32,1.8Z"
              />
              <path
                class="cls5-581"
                d="M945.63,326.59c-2.83,2.26-3.55-1.35-5.32-2-.77-.3.11-2.12.37-2.06,1.86.45,3.8-3.27,5.51.1C947,324.07,947.17,325.45,945.63,326.59Z"
              />
              <path
                class="cls5-582"
                d="M945.63,326.59c.19-1.33.37-2.66.56-4h5.56a7.88,7.88,0,0,1-.72,6.48l-.15.13H949.3a1.16,1.16,0,0,1-1-1.32,1.36,1.36,0,0,1,0-.17C947.79,326.53,946.6,326.83,945.63,326.59Z"
              />
              <path
                class="cls5-103"
                d="M951,329.13c0-2.19-.49-4.42.72-6.48,2-.6,3.56.52,5.09,1.59C957.63,328,956.11,329.27,951,329.13Z"
              />
              <path
                class="cls5-104"
                d="M950.16,332.67a7.87,7.87,0,0,0,1.15-.41c2.8-1.56,5.31-2.69,4.19,2.47-.06.32.3.74.47,1.11l-2.7,1.85C952.75,335.7,949.62,335.32,950.16,332.67Z"
              />
              <path
                class="cls5-583"
                d="M913.72,312.8c1.95-.64,3.34.59,4.82,1.49,1.17,1.7.93,3.08-.9,4.12l-.73.18c-1.46.24-3.07.82-4-.93A3.92,3.92,0,0,1,913.72,312.8Z"
              />
              <path
                class="cls5-584"
                d="M903.45,323.46c-1.4-2.65.69-4.68,2.2-5.28,2.48-1,2,2.65,3.58,3.59C908,324.67,905.46,323.16,903.45,323.46Z"
              />
              <path
                class="cls5-585"
                d="M963.39,320.92a2.53,2.53,0,0,1-3.12.6c.06-.8.19-1.61.17-2.41-.1-3.63.63-5.11,3.82-1.74.65.69,2.11.57,2.35,1.92Z"
              />
              <path
                class="cls5-107"
                d="M849.4,274.33h-1.51c-1.55-.32-3.89,1-4.14-2-.17-1.95,1.13-2.24,2.67-2.19l2.48.06c1.58,0,1.69,1.21,1.82,2.37A2.2,2.2,0,0,1,849.4,274.33Z"
              />
              <path
                class="cls5-586"
                d="M926.76,343.57c-1.62.33-1.75,3.12-4,2.4-.63-1.43-1.25-2.86-1.88-4.3,1.42-3.71,3.63-2.63,5.94-1A3.74,3.74,0,0,1,926.76,343.57Z"
              />
              <path
                class="cls5-567"
                d="M920.16,304.28c-1.07.35-1,2.77-2.7,1.75-1.37-.81-3.16-1.41-3.67-3.14-.57-1.94.86-2,2.18-1.79,1.11.21,1.94,1.72,3.32.69C920.19,302.41,920.7,303.16,920.16,304.28Z"
              />
              <path
                class="cls5-587"
                d="M909.35,333.43c1.11.54,2.6,1.23,2.21,2.5a16,16,0,0,1-2.75,4.31c-.1.15-1-.18-1.45-.44-1.57-.92-.5-2.1-.24-3.2Z"
              />
              <path
                class="cls5-110"
                d="M913.72,312.8c-.09,2.56-1.58,5.9,3.19,5.79l-1.72.79c-2.27,0-4.57,0-5.8-2.48a8,8,0,0,1,1.51-3.31Z"
              />
              <path
                class="cls5-588"
                d="M926.83,340.68c-2,.44-4.36-1.72-5.94,1-.95-3.64,2.25-4.73,4.25-5C927.86,336.27,926.39,339.21,926.83,340.68Z"
              />
              <path
                class="cls5-111"
                d="M889.32,262.88a5.61,5.61,0,0,0,0,.58c-1,1.47-1.32,3.51-3.31,4.23h0c-2.36-2.45-1.75-4.5.85-6.28C888.33,260.78,888.5,260.88,889.32,262.88Z"
              />
              <path
                class="cls5-589"
                d="M911.75,305.75c-2.54-1-4.33,3.6-7.09,1,0-.45-.07-.91-.11-1.36,2-2.24,4.57-2.36,7.29-1.79Z"
              />
              <path
                class="cls5-590"
                d="M901.84,293.31c-3.16.55-4.87-2.29-7.4-3.2-.5-.77-2.63-1-.8-2.53l2.48.83C898.87,289.05,901.45,289.9,901.84,293.31Z"
              />
              <path
                class="cls5-113"
                d="M927,301.81c2.2,3.69-.68,3.11-2.72,3.25-.24-1,.16-2.37-1.58-2.3a1.24,1.24,0,0,1-.17-1.71c.22-1.27.8-2.4,2-.94A6.92,6.92,0,0,0,927,301.81Z"
              />
              <path
                class="cls5-591"
                d="M949.12,309.39,951.6,316h.06c.78,1.61,1.11,2.92-1.5,2.39l-.69-1a11.51,11.51,0,0,0-1.91-6.52,1.73,1.73,0,0,1,.9-1.79A5,5,0,0,1,949.12,309.39Z"
              />
              <path
                class="cls5-592"
                d="M875.27,278.37c-1.52-.88-3.07-1.71-4.54-2.65-.81-.53-2.27-.84-1.28-2.39a22.12,22.12,0,0,1,7.18,3.47c.44.29,1.28.93.51,1.55C876.75,278.65,875.9,278.38,875.27,278.37Z"
              />
              <path
                class="cls5-593"
                d="M931.06,311.88c.31,1.35.62,2.71.92,4.06-.06.66-.07,1.45-.85,1.61s-1.08-.5-1.18-1.21c-.13-1,.26-2.15-.65-3-.25-1.81-.49-3.63-.73-5.44C931.29,308,930.34,310.48,931.06,311.88Z"
              />
              <path
                class="cls5-594"
                d="M917.64,318.41a5.87,5.87,0,0,0,.9-4.12c1.75.77,4.67,1.12,4.1,3.44C922,320.41,919.35,318.09,917.64,318.41Z"
              />
              <path
                class="cls5-595"
                d="M884.46,260.83c-.63-.9-2.13-.3-2.58-1.51,1.71-1.95,3.23.81,4.89.2a19.44,19.44,0,0,1,3.36,1.89c1.47,1.26,0,1.29-.81,1.47L887,261.45Z"
              />
              <path
                class="cls5-596"
                d="M926.92,333.19c-1-3.17-.86-6.45-1-9.71C929,326.46,928.18,329.8,926.92,333.19Z"
              />
              <path
                class="cls5-120"
                d="M931.87,339c.36-1.66.26-3.48,1.62-4.8l1.73,1.6c-.22,1.33.42,3.1-1.75,3.41Z"
              />
              <path
                class="cls5-597"
                d="M938.43,359.2c2.15,0,3.7.82,4,3.13a.92.92,0,0,1-.83,1h-.17a3.52,3.52,0,0,1-3-4l0-.19Z"
              />
              <path
                class="cls5-598"
                d="M945.08,302.64h.41c1.88.09,3.62.49,4.18,2.6.07.28-.63,1.12-1,1.11-2.35-.08-3.31-1.63-3.6-3.76Z"
              />
              <path
                class="cls5-599"
                d="M934.89,353.49l.21,1.49c-1.91,1.5-3,.18-4-1.24a1.2,1.2,0,0,1,.12-1.69.61.61,0,0,1,.16-.12C933.09,351.13,933.73,353,934.89,353.49Z"
              />
              <path
                class="cls5-121"
                d="M933.44,296.88a5.38,5.38,0,0,1-2.45,5l-2.5-.07c.3-1.51,2.55-1.54,2.51-3.31C931.51,297.47,932.15,296.67,933.44,296.88Z"
              />
              <path
                class="cls5-600"
                d="M923.52,287.63c-1.95-.37-3.31-1.37-3.34-3.5a.93.93,0,0,1,.78-1.06,1,1,0,0,1,.6.11c2,.89,2.17,2.63,1.9,4.51Z"
              />
              <path
                class="cls5-123"
                d="M925.25,295.09c-.56.94-1.21,1.83-2.48,1.48s-.91-1.44-1-2.31C923.53,291.85,924.58,292.65,925.25,295.09Z"
              />
              <path
                class="cls5-601"
                d="M877,284c0,.88-.24,1.68-1.24,1.75a1.76,1.76,0,0,1-2-1.5s0-.06,0-.09a1.57,1.57,0,0,1,1.08-1.94,1.4,1.4,0,0,1,.41-.06C876.4,282.14,876.88,283,877,284Z"
              />
              <path
                class="cls5-602"
                d="M949.24,355c.1-1.57.75-2.63,2.5-2.63.81.79,2.23,1.5,1,2.84C951.61,356.34,950.33,356.19,949.24,355Z"
              />
              <path
                class="cls5-603"
                d="M944.93,352.41c-.77.39-1.54.78-2.3,1.18-1.62-.42-1.43-1.83-1.63-3C943.05,349.58,944.34,350.23,944.93,352.41Z"
              />
              <path
                class="cls5-604"
                d="M927.62,291a6.13,6.13,0,0,1,2,.18,2.4,2.4,0,0,1,1.43,2.7c-.07.63-.42,1.09-1,1a2.87,2.87,0,0,1-2-1.9,8,8,0,0,1-.32-2Z"
              />
              <path
                class="cls5-605"
                d="M908.09,274.31c-3.11-.91-4.5-4.47-7.81-5.07,3.7-1.52,4.85,2.38,7.32,3.46C907.76,273.24,907.92,273.77,908.09,274.31Z"
              />
              <path
                class="cls5-606"
                d="M897.76,275a2.94,2.94,0,0,1,1.53,3.43c-1,.66-2.07,1.15-2.86-.1C895.41,276.71,896.55,275.79,897.76,275Z"
              />
              <path
                class="cls5-600"
                d="M923.46,287.69c2.63-.45,4.47.08,4.16,3.32l.06-.05c-2.36.1-3.84-.89-4.16-3.33Z"
              />
              <path
                class="cls5-125"
                d="M903.75,264.34l.59.69c-.61,1.19-1.23,2.58-2.79,2.44-1.06-.1-1.27-1.25-1.35-2.23.63-1,1.66-.81,2.61-.89Z"
              />
              <path
                class="cls5-598"
                d="M945.11,302.61c-2.09.16-3-1.17-3.24-2.92-.12-.75.6-1.25,1.38-1,2,.62,2.18,2.2,1.83,4Z"
              />
              <path
                class="cls5-607"
                d="M886.06,267.69c-.31,1.3,1.05,3.86-2.15,3a1.46,1.46,0,0,1-1.07-1.78,1.42,1.42,0,0,1,.07-.22c.63-1.61,2.06-.86,3.2-.94Z"
              />
              <path
                class="cls5-608"
                d="M941,315.87c1.93-.21,2.63.81,2.56,2.59a2,2,0,0,1-2.8.4l-.1-.08C939.55,317.8,940.57,316.81,941,315.87Z"
              />
              <path
                class="cls5-127"
                d="M930.85,302.87a2.2,2.2,0,0,1-1.85,4,1.9,1.9,0,0,1-.39-.23C928.39,304.79,929,303.46,930.85,302.87Z"
              />
              <path
                class="cls5-609"
                d="M943.41,355a2.78,2.78,0,0,1,3.32.13c.22,1.42-.14,2.66-1.75,2.65C943.18,357.71,943.39,356.19,943.41,355Z"
              />
              <path
                class="cls5-567"
                d="M911.75,296.84a4.81,4.81,0,0,0-3-.9c.46-2.83,4.48-.4,4.89-3.31a2,2,0,0,1,.77,1.75c.25,1.35-.74,1.87-1.65,2.45Z"
              />
              <path
                class="cls5-567"
                d="M911.84,303.57c-2.46.48-5.1.21-7.29,1.79-.28-.72-1-1.35-.42-2.23l1.91-.5C907.77,304.18,910.27,301,911.84,303.57Z"
              />
              <path
                class="cls5-610"
                d="M928.52,296.8c0,1.14,0,2.28-1.54,2.52a1.37,1.37,0,0,1-1.68-.83c-.53-1.44.57-1.95,1.5-2.55Z"
              />
              <path
                class="cls5-131"
                d="M940.05,297.53c-1.19.08-2.45.5-3.33-.75.23-1.09.54-2.36,1.93-2.12S940.35,296.19,940.05,297.53Z"
              />
              <path
                class="cls5-132"
                d="M910.9,313.59c0,1.35.49,2.89-1.51,3.31-1.88-1.19-2-2.39,0-3.58Z"
              />
              <path
                class="cls5-611"
                d="M938.26,318.56c-.4.94-1,1.86-2,1.85s-1.31-.92-1.21-1.85a1.61,1.61,0,0,1,1.66-1.51C937.67,317,938.2,317.58,938.26,318.56Z"
              />
              <path
                class="cls5-612"
                d="M955.09,359.71a1.57,1.57,0,0,1-1.71-1.37,1.32,1.32,0,0,1,1.24-1.72c1-.13,2,.11,2,1.4A1.69,1.69,0,0,1,955.09,359.71Z"
              />
              <path
                class="cls5-613"
                d="M922.56,301.05c.06.57.11,1.14.17,1.71a2.92,2.92,0,0,1-2.57,1.52l-.87-2.49.87-1Z"
              />
              <path
                class="cls5-614"
                d="M890.26,292.69a4.86,4.86,0,0,1-3.26-.9c.56-1,.55-2.74,2.35-2.06a1.77,1.77,0,0,1,1.35,2.12A1.75,1.75,0,0,1,890.26,292.69Z"
              />
              <path
                class="cls5-615"
                d="M912.74,296.83c0-1.21,1-1.71,1.65-2.45l1.6.78-.06,2.41C914.81,297.54,913.58,298,912.74,296.83Z"
              />
              <path
                class="cls5-602"
                d="M951.69,350.85c-2.76,1.49-3.66.52-3.12-2.36C950.76,347.75,951.69,348.68,951.69,350.85Z"
              />
              <path
                class="cls5-616"
                d="M848.81,277c1.28-.93,2.72-1.41,3.18.57.4,1.72-1.09,1.9-2.44,1.79Z"
              />
              <path
                class="cls5-133"
                d="M880.2,263.62a1.24,1.24,0,0,1-.91,1.51,1.19,1.19,0,0,1-.46,0,1.48,1.48,0,0,1-1.63-1.33.22.22,0,0,1,0-.08,1.45,1.45,0,0,1,1.24-1.64h.15C879.55,262,880,262.77,880.2,263.62Z"
              />
              <path
                class="cls5-599"
                d="M938.48,359.15c-1.69.27-3-.2-3.36-2-.1-.5.12-1.21.83-1.08a2.86,2.86,0,0,1,2.48,3.16Z"
              />
              <path
                class="cls5-134"
                d="M953.42,315c-.37-.94-1.95-1.51-1.17-2.75.57-.91,1.73-.48,2.66-.39a2.29,2.29,0,0,1-1.16,3A2.19,2.19,0,0,1,953.42,315Z"
              />
              <path
                class="cls5-135"
                d="M858.66,281.81c-1.11.08-2.26.11-2.72-1.15-.1-.27.42-1,.8-1.15,1.25-.44,2.46-.5,2.59,1.35Z"
              />
              <path
                class="cls5-617"
                d="M858.85,274.42c1.06.09,2.28-.55,3.08.69-.89.76-1,2.23-2.45,2.49A2.56,2.56,0,0,1,858.85,274.42Z"
              />
              <path
                class="cls5-618"
                d="M852,265.11c.29-2,2-2.06,3.39-2.55C855.67,264.65,855.33,264.91,852,265.11Z"
              />
              <path
                class="cls5-137"
                d="M935.23,305.87c0-2.23,1.51-2.46,3.21-2.45C938.91,306.25,937.2,306.23,935.23,305.87Z"
              />
              <path
                class="cls5-123"
                d="M919.64,292.6a1.32,1.32,0,0,1-1.44-1.13c-.05-.76.56-1.16,1.33-1.2a1.16,1.16,0,0,1,1.36.94,1.1,1.1,0,0,1,0,.18C921,292.17,920.45,292.6,919.64,292.6Z"
              />
              <path
                class="cls5-619"
                d="M1007.46,334.32c1.29-1.05,2.57-2.11,2.29-4.06-4.54-8.78-4.62-17.91-2.2-27.26,3-3,6.86-1.85,10.43-2,1.83-.12,2.89,1.14,4,2.3.93,1,1.81,2,3.4,1.62,3,1.92,3.11,4.08.76,6.71-1.43,1.6-3,3.23-3.56,5.42-.58,3.34-2.87,5.88-4.11,8.91-.36,2-2.39,3.44-2,5.72a6,6,0,0,1,.35,2.76c-.19.53-.73,1.37-.9,1.27-4-2.53-4.86,1.55-6.88,3.17a1.86,1.86,0,0,1-1.89.47C1005.41,337.57,1007.29,336,1007.46,334.32Z"
              />
              <path
                class="cls5-620"
                d="M1021.63,295.88c-.59-1.53-.83-3.38-1.85-4.51-3.81-4.19-1.85-7.55,1.09-10.95.78-.9,1.43-1.91,2.14-2.87a11.53,11.53,0,0,1,1.2-.64,12.83,12.83,0,0,1,9.89,4.1c1.32,1.37,2.6,3.2-.17,4.63-5.1-1-5.85-.67-8,3.3-.38.72-1.06,1.45-.25,2.21s1.73.38,2.54-.31c1.85-1.57,2.6-4.36,5.42-4.85.77-.13,1.6.12,1.54.88-.33,4.11,1.28,8.15.39,12.27-.83,2-2.62,2.11-4.39,2.12a38.16,38.16,0,0,1-7.63-.26C1021,300,1021.52,297.88,1021.63,295.88Z"
              />
              <path
                class="cls5-621"
                d="M998.16,318.48a30.33,30.33,0,0,0-2.94-2.84c-2.4-1.77-1.55-3.41,0-5.13,2.29-2.53,4.87-4.83,6.61-7.82,3.09-1.57,4.55-1.24,4.62,1.45a186.85,186.85,0,0,1-.16,21.3c0,.23-.32.43-.5.63l-.84-.36a13.17,13.17,0,0,0-1.35-1.54c-2-1.58-2.93-3.23-.21-5.08C1001.58,317.46,999.69,319.83,998.16,318.48Z"
              />
              <path
                class="cls5-622"
                d="M1005.57,264.9l.36,1.16c-.34,2.84-1.95,1.11-2.91.68-6.57-2.9-12.6-6.79-18.77-10.42-2.84-1.67-5.69-3.35-8.57-5-1.16-.65-1.13-1,.13-1.33l4.46.42c4.68,1,8.09,4.38,12.21,6.41a6.36,6.36,0,0,1,4.65,2.3C999.82,261.25,1003.51,261.87,1005.57,264.9Z"
              />
              <path
                class="cls5-140"
                d="M955,270.19c-1.84,3.27,1.8,5.49,1.61,8.44-1.89,1-2.73,3.35-4.92,4-2.24-1.29-4.52.66-6.77-.09a3,3,0,0,1,.93-3.21c.92-.05,1.92.13,2.54-.84,1.05-1.27,1.3-3,2.49-4.2v0c.47-1,2.3-2.51-.76-2.44-.17-2-1.33-1.47-2.47-.95-1.35-2.43,1.21-3.24,2-4.8,2-2.61,4.33-3.54,7.09-1-.28.85-.55,1.69-.82,2.53C954.64,268.22,953.83,268.87,955,270.19Z"
              />
              <path
                class="cls5-623"
                d="M971.72,250.23c2.53,1.42,3.18,3.11,1,5.45-.51.54-2.15,1.85.38,2.09.72.39.7.89.22,1.46-5.27,1.24-7.62-3.38-11-5.74-1.38-1-.17-2.46,1.08-3.3A7.94,7.94,0,0,1,971.72,250.23Z"
              />
              <path
                class="cls5-141"
                d="M979.25,296c2.56-1.18,3.28-4.79,6.58-5,1.14,2.2,0,4.38,0,6.57-.69,1.44-.88,2.6,1.32,2.54a2.58,2.58,0,0,1,2.93,2.55h0l-7.51-.08c-.89-1,.54-2.46-.7-3.45-1.41.73-.62,2.68-1.9,3.44h-6c-1.82.06-2.32-.94-2.24-2.52C973,296.58,975.64,295.35,979.25,296Z"
              />
              <path
                class="cls5-624"
                d="M1024,277.64l-1-.09c.7-2-.86-2.23-2.07-2.79-4.57-2.11-9.12-4.24-13.69-6.37l.27-2.51c2.73-.83,4.87,1.48,7.46,1.4,1.45.49,2.49,1.69,3.93,2.2,4.07,1.87,8.22,3.56,12.27,5.48,1.56.74,3.35,1.27,3.86,3.27l.66,2c-3,1.12-4.32-2.12-6.79-2.63C1027.16,277.2,1025.66,276.29,1024,277.64Z"
              />
              <path
                class="cls5-174"
                d="M949.17,238.83l2.66,1.27c.23,1.78-1,3-1.67,4.44.7.71,1.58,1.29,1.64,2.43.91,1.49,3.22-.13,4,1.77a5.44,5.44,0,0,1-2.33,1,4.91,4.91,0,0,0,2.54-.35c1.09.85.65,2.07.77,3.16a3.64,3.64,0,0,1-2.54,1.84c-.93.65-.72,1.68-.85,2.59-2-.31-1.81-2.16-2.43-3.45a1.73,1.73,0,0,0-1-1.71c-1-.69-2-1.4-3-2.12l-1.07-1.17a4.5,4.5,0,0,1-.17-3.09c1.1-.45,3.14-.33,1.73-2.46C945.82,240.61,947.31,239.67,949.17,238.83Z"
              />
              <path
                class="cls5-143"
                d="M957.58,280.83l1.65-.7c2.18-1.67,4.86-3.08,3.32-6.62,2-.24,3.35.24,3.58,2.64a3.81,3.81,0,0,0,2.2,3.22,2,2,0,0,1,.93,2.31,10.84,10.84,0,0,0,.52,4.86,1.53,1.53,0,0,1-.56,2.09l-.09.05c-1.23.49-1.69-.68-2.08-1.46-2.59-5.22-2.94-5.4-8.6-3.76C957.5,282.8,957,282,957.58,280.83Z"
              />
              <path
                class="cls5-625"
                d="M923.63,268.68a1.85,1.85,0,0,0-1.72-1,2.6,2.6,0,0,1-2.86-2.23,1.61,1.61,0,0,1,1.71-1.48l.29,0c.92.27,1.51,1.27,2.6,1.16,1.17-.48.92-1.64,1.21-2.54a4.89,4.89,0,0,1,2.4-2.22,42.66,42.66,0,0,0,6.54-9.27c1-1.23,2.08-2.24,3.68-.84l-11.61,17.44Z"
              />
              <path
                class="cls5-144"
                d="M985.79,297.59c-1.91-2.2-.46-4.38,0-6.57,1.24-.87.66-2.18.8-3.32a4.66,4.66,0,0,1,2.53-1.75c1.25.43,2.41.55,3.25-.75a9.09,9.09,0,0,1,2.39,2.4c-.93,1.64-1.22,3.72-4.27,2.72-2.14-.7-2.9,1.52-3.08,3.41C987.3,295.22,987.56,296.82,985.79,297.59Z"
              />
              <path
                class="cls5-146"
                d="M956.7,265.18c-2.6-.67-5-.74-6.71,1.86-1.09-1-.59-2.42-.8-3.65a1.69,1.69,0,0,0-.74-1.6c-.2-1.41,1-1.68,1.82-2.27,2.17-.88,4.29-1.17,6.23.56a3.8,3.8,0,0,1,.21,5.1Z"
              />
              <path
                class="cls5-621"
                d="M1005.84,326.82c.92-.21,1.42-.65,1.25-1.73-1-6.6-.19-13.25-.45-19.87,0-.87-.71-2.8,1.59-1.76-1.73,6.45-1,13.08-.34,19.47.24,2.16,1.94,4.66,1.86,7.33A8.88,8.88,0,0,1,1005.84,326.82Z"
              />
              <path
                class="cls5-147"
                d="M989.16,286c-.07,1.69-1.29,1.74-2.53,1.75l-2.54-2.43c-.18-2.48-3.81-3.08-3.24-6,.74-1.18,1.41-2.14,2.69-.41C985.34,281.31,987.28,283.61,989.16,286Z"
              />
              <path
                class="cls5-149"
                d="M962.55,273.51c3.43,4.32,2.8,5.57-3.32,6.62,0-1-.37-2.07.43-2.78,1.62-1.44,1.31-2.49-.38-3.53-.81-.5-2-1.21-1.37-2.21.8-1.33,2-.32,2.87.22A11.73,11.73,0,0,1,962.55,273.51Z"
              />
              <path
                class="cls5-151"
                d="M955.92,260.4c-1.91-1.27-3.85-.32-5.79-.07a1.4,1.4,0,0,1-1-1.71h0l-.74-1.56a5.26,5.26,0,0,1,1.69-2.62l.87-.91c2.41,0,1,2.71,2.43,3.45a2.38,2.38,0,0,0,.19.68,8.59,8.59,0,0,0,6.53.15c.75.26.82.88.78,1.54C959.63,261.75,957.79,261.15,955.92,260.4Z"
              />
              <path
                class="cls5-149"
                d="M957.58,280.83l.87,2.63c-2.58,2.56-4.69,1.21-6.72-.81,1.57-1.44,1.6-4.74,4.92-4Z"
              />
              <path
                class="cls5-153"
                d="M978.47,262.64c2-.41,2.15,1.51,3,2.51s1.81,2.23-.27,3.15c-1.7.76-3.43,2.12-4.63-.63a2.78,2.78,0,0,1-.67-2.19,4,4,0,0,1,1-2.09A2.26,2.26,0,0,1,978.47,262.64Z"
              />
              <path
                class="cls5-626"
                d="M998.16,318.48a25.74,25.74,0,0,0,2.68-.93c1.44-.68,2.94-1.33,3.78.61,1,2.17-.52,2.87-2.45,2.91.42,2.09,2.75,2.66,2.77,4.64C1002,323.91,1000.16,321.14,998.16,318.48Z"
              />
              <path
                class="cls5-627"
                d="M997.31,333.33l-2.48.93a.45.45,0,0,1-.65,0,.27.27,0,0,1-.07-.08c-.17-2.49,3-7.09,5.1-7.27,1.69-.15,1.93.83,1.19,2C999.47,330.49,998.34,331.88,997.31,333.33Z"
              />
              <path
                class="cls5-628"
                d="M974.46,288.82c.71-1.55,1.76-3.61,3.45-3.47s2.48,2.49,2.56,4.2c.07,1.41-1.16,2-2.7,1.59C976.41,290.76,974.53,291.27,974.46,288.82Z"
              />
              <path
                class="cls5-629"
                d="M969.26,281.68a2.56,2.56,0,0,1-.93-2.31l2.31-.9c1.33-.52,3.07-1.94,3.86,0a5.5,5.5,0,0,1-.86,4.57c-1.55,1.9-2.4-.62-3.58-1.19A3.68,3.68,0,0,0,969.26,281.68Z"
              />
              <path
                class="cls5-154"
                d="M988.13,309.23c-.81,2.32-2.86,2.17-4.44,2.58-1.18.31-2.36-.51-1.84-1.86s-.28-4,2-3.85C985.58,306.19,987.16,307.63,988.13,309.23Z"
              />
              <path
                class="cls5-155"
                d="M936.86,265.25c.08-1.4-.78-2.48-1.66-3.76,3.45.33,6.68,3.62,6.6,6.25a2.1,2.1,0,0,1-1.86,2.32h0c-1.61.2-3.49.62-4.48-1.12-.86-1.53-.35-2.93,1.4-3.66.92.55.23,2.28,2,2.45C939.19,266,937.72,265.86,936.86,265.25Z"
              />
              <path
                class="cls5-630"
                d="M979.44,256.91a8.28,8.28,0,0,0-1.13,5c-2.1,1.25-3.26.28-4-1.69l-1-1c-.08-.49-.15-1-.23-1.46C975.12,256.92,976.9,254.11,979.44,256.91Z"
              />
              <path
                class="cls5-631"
                d="M935.9,274.41c-3.79,0-4.54-3.89-7.08-5.5a1.07,1.07,0,0,1-.06-1.51,1.09,1.09,0,0,1,.3-.23c.38-.22,1.31-.22,1.47,0,1.64,2.52,5.45,3.37,5.49,7.1Z"
              />
              <path
                class="cls5-156"
                d="M974.32,260.23c1.32.58,2.15,2.34,4,1.68a3.76,3.76,0,0,0,.16.74l-.92.75a16.34,16.34,0,0,0-2.75.63c.4.81,1.52.43,1.91,1.2l-.12,2.44c-1.43-.16-3,.42-4.25-.77C969.93,264.66,970.7,262,974.32,260.23Z"
              />
              <path
                class="cls5-632"
                d="M994.11,334.2a1.27,1.27,0,0,0,.72.06c1.9,2.37,5,3.4,6.67,6,0,1.15-.86,1.21-1.67,1.36-3.05-.45-5-2.44-6.58-4.85a2.22,2.22,0,0,1,.23-2.42A.94.94,0,0,0,994.11,334.2Z"
              />
              <path
                class="cls5-633"
                d="M976.67,314.23c-2.43-.88-3.27-3.35-5-5h.81c1.62-.1,3.19-1.52,4.87.28C979.3,311.57,976.33,312.59,976.67,314.23Z"
              />
              <path
                class="cls5-634"
                d="M949.19,263.39c1.73.89.85,2.36.8,3.65-.76,1.33-2.27,2.2-2.35,3.93-.8.35-1.08,2-2.24,1.18-.83-.6,0-1.52.34-2.22C946.87,267.74,948,265.57,949.19,263.39Z"
              />
              <path
                class="cls5-158"
                d="M980,302.59a12.7,12.7,0,0,1,.07-1.63c.12-1.28-.5-2.92,1.14-3.55.55-.22,1.62.29,2.15.8,1.36,1.3,0,2.45-.44,3.65-.09.25-.22.49-.32.74Z"
              />
              <path
                class="cls5-635"
                d="M980.85,279.31c.64,2.22,4.1,2.92,3.24,6-2-1-3.32-2.88-4.82-4.48-.71-.76-2.08-1.8-1.26-2.69C979.41,276.57,979.78,279.08,980.85,279.31Z"
              />
              <path
                class="cls5-633"
                d="M971.7,309.27l-2.52-1.68c.16-1.41-.48-3.2,1.51-3.82.91-.28,1.46.59,2,1.2C974.28,306.82,972.31,307.9,971.7,309.27Z"
              />
              <path
                class="cls5-140"
                d="M955.92,260.4c1.68-.16,3.44,0,4.92-1,.3.51.61,1,.92,1.52a4.71,4.71,0,0,1-1.7,2.69l-3.35,1.62C956.79,263.53,957,261.86,955.92,260.4Z"
              />
              <path
                class="cls5-636"
                d="M963.45,289.28c.23,1.57-.58,2.55-2,2.21-1.84-.45-2-2.51-2.27-3.93-.41-1.86,1.2-1.63,2.43-1.43C962.88,286.8,962.82,288.24,963.45,289.28Z"
              />
              <path
                class="cls5-160"
                d="M990.82,269.69c-1.21,0-1.64-.78-1.5-1.85a2,2,0,0,1,2.17-1.82l.15,0c1.21,0,1.7.73,1.63,1.86C993.17,269.39,991.9,269.38,990.82,269.69Z"
              />
              <path
                class="cls5-162"
                d="M1005.73,297.75c-1.82-.91-1.66-2.61-1.7-4.24l.9-.87C1008.9,293.77,1007.28,295.76,1005.73,297.75Z"
              />
              <path
                class="cls5-631"
                d="M936,274.29c1.93.12,3.55.7,3.78,2.93,0,.33-.73,1.08-1.07,1-2.27-.24-2.69-2-2.83-3.85Z"
              />
              <path
                class="cls5-637"
                d="M1003.81,273.54c1,.22,1.77.75,1.77,1.87s-.86,1.6-1.92,1.48-1.88-.6-1.83-1.75S1002.79,273.64,1003.81,273.54Z"
              />
              <path
                class="cls5-638"
                d="M987.27,274.38c-1.12-.17-2-.64-1.89-1.8s1-1.53,2.06-1.53,1.65.37,1.59,1.42A2.09,2.09,0,0,1,987.27,274.38Z"
              />
              <path
                class="cls5-639"
                d="M950.92,274.31c0,1.88.56,4.12-2.49,4.2C946.83,275.67,947.71,274.3,950.92,274.31Z"
              />
              <path
                class="cls5-640"
                d="M999.76,288.2c-.12,1.12-.69,1.88-1.8,1.86s-1.9-.6-1.81-1.77a1.68,1.68,0,0,1,1.77-1.59l.23,0a1.52,1.52,0,0,1,1.61,1.43Z"
              />
              <path
                class="cls5-164"
                d="M956,249.39c-.63,2.34-2.29,1.79-3.84,1.29a.81.81,0,0,1-.63-1,.86.86,0,0,1,.15-.32c1.16-1.36,2.67-.87,4.12-.66A1.59,1.59,0,0,0,956,249.39Z"
              />
              <path
                class="cls5-637"
                d="M1000.2,274.16a1.76,1.76,0,0,1-1.79-1.56c-.18-1.2.65-1.74,1.63-1.91s1.4.63,1.52,1.46A1.81,1.81,0,0,1,1000.2,274.16Z"
              />
              <path
                class="cls5-641"
                d="M971.73,271.67c-.11,1.24-.62,1.81-1.61,1.7a1.71,1.71,0,0,1-1.69-1.75,1.21,1.21,0,0,1,0-.19c.09-1,1-1.19,1.85-1.14A1.46,1.46,0,0,1,971.73,271.67Z"
              />
              <path
                class="cls5-642"
                d="M990,302.68c1.13-.73,2-2.68,3.68-.76a1.26,1.26,0,0,1,.07,1.78l-.07.07c-1.64,1.28-2.74.35-3.63-1.09Z"
              />
              <path
                class="cls5-643"
                d="M954.19,254.39c.17-1.55,1.21-1.89,2.54-1.84,1.14,1.11,1.12,2.23-.22,3.06S954.46,255.78,954.19,254.39Z"
              />
              <path
                class="cls5-644"
                d="M1020.86,295.94c-.07.51-.14,1-.22,1.52-2.12.86-2.56-.77-3.1-2.15a1.18,1.18,0,0,1,.48-1.6l.18-.08C1020.33,292.91,1019.49,295.72,1020.86,295.94Z"
              />
              <path
                class="cls5-167"
                d="M945.89,279.35a3.7,3.7,0,0,1-.93,3.21c-1.47-.08-2.54-.81-2.11-2.32S944.61,278.78,945.89,279.35Z"
              />
              <path
                class="cls5-168"
                d="M945,252.8a1.63,1.63,0,0,1-1.72,1.47c-1,0-1.43-.69-1.41-1.63A1.29,1.29,0,0,1,943,251.2a1.37,1.37,0,0,1,.45,0A1.56,1.56,0,0,1,945,252.8Z"
              />
              <path
                class="cls5-645"
                d="M946.92,249.7c2-.69,3,0,3,2.12C947.07,253.67,946.52,252.36,946.92,249.7Z"
              />
              <path
                class="cls5-646"
                d="M945.68,245.44c.87,1,1.28,2,.17,3.09-1-.09-2.25.44-2.45-1.21C943.18,245.51,944.41,245.45,945.68,245.44Z"
              />
              <path
                class="cls5-647"
                d="M969.36,295.93c-.08.53-.16,1.05-.25,1.58-.93.7-1.88,1.12-2.84.05a1.3,1.3,0,0,1-.07-1.83C967.25,294.69,968.37,294.86,969.36,295.93Z"
              />
              <path
                class="cls5-170"
                d="M960.06,263.56c-.17-1.36,0-2.49,1.7-2.69,1.29.4,1.88,1.23,1.16,2.48S961.06,264,960.06,263.56Z"
              />
              <path
                class="cls5-639"
                d="M950.11,271.92c.87-1.17,1.89-1.63,2.7-.08,1,2-.59,2.21-1.94,2.52Z"
              />
              <path
                class="cls5-648"
                d="M1004.79,287.78a1.42,1.42,0,0,1-1.22,1.6h-.22c-.94.09-1.6-.28-1.6-1.33,0-.88.27-1.72,1.31-1.64C1003.82,286.47,1004.72,286.68,1004.79,287.78Z"
              />
              <path
                class="cls5-649"
                d="M968.87,265.61a1.75,1.75,0,0,1-1.58,1.77c-1.13.2-1.34-.65-1.41-1.52s.22-1.63,1.32-1.6A1.7,1.7,0,0,1,968.87,265.61Z"
              />
              <path
                class="cls5-650"
                d="M997.36,292.75a4.18,4.18,0,0,1-.81,3.13c-1.35,0-2.57-.42-2.16-2S996.1,292.43,997.36,292.75Z"
              />
              <path
                class="cls5-651"
                d="M994.8,287.6c-1.87.26-2.57-.63-2.39-2.4.64-.77,1.31-.91,2-.11S995.64,286.63,994.8,287.6Z"
              />
              <path
                class="cls5-652"
                d="M991,295c-1.18-.11-1.3-1-1.33-1.77,0-1,.8-1.36,1.61-1.4,1.08-.06,1.32.74,1.18,1.62A1.6,1.6,0,0,1,991,295Z"
              />
              <path
                class="cls5-653"
                d="M950,254.44c.2,1.37,0,2.45-1.7,2.62-.73-.47-1.4-1.09-.91-2S949.14,254.53,950,254.44Z"
              />
              <path
                class="cls5-174"
                d="M960.06,257.81c-2.22,2.06-4.38,1.29-6.53-.15Z"
              />
              <path
                class="cls5-654"
                d="M850.29,244.36c.15,4.12-1.41,5.14-7.12,4.62-1.5-.14-3-.36-4.48-.54C842.29,246.32,846.38,245.59,850.29,244.36Z"
              />
              <path
                class="cls5-655"
                d="M849.57,372.46h-.85c-1.73-4.84-6.41-6.44-10.34-7.75-4.28-1.43-3.41,5.2-7.19,6.42,1-3.56,3.42-6,5.23-8.75.78-1.18,1.67,0,2.44.49l11.26,6.91c-.2.9-.39,1.79-.59,2.69Z"
              />
              <path
                class="cls5-472"
                d="M850.38,388.3v1.64l-18-11.42C839,380.64,844.43,385,850.38,388.3Z"
              />
              <path
                class="cls5-656"
                d="M827.37,355.17c8.48,3,9.31,5,4.31,9.3-1.79-2.07,3.26-3,.85-5.22C831,357.87,828.62,357.71,827.37,355.17Z"
              />
              <path
                class="cls5-657"
                d="M832,354.41a21.48,21.48,0,0,1,6.79,0C836.59,358.34,835.94,358.34,832,354.41Z"
              />
              <path
                class="cls5-658"
                d="M901.73,230.09l.12,1.88c-2.16,1.94-5.05,2.16-7.59,3.24-10.71,3.12-21.12,7.12-31.73,10.54-3.36,1.08-6.62,2.62-10.3,2.15v-1.19c3.3-2.78,7.65-2.89,11.42-4.46a47,47,0,0,0,5-1.87c.48-.29-.52-.84-.21-.39.1.15.12.25,0,.28a77.66,77.66,0,0,1-16.25,5.11v-2c9.51-2.26,18.52-6,27.85-8.85,1.18-.36,2.38-.63,3.57-.93,6,.17,10.87-3.08,16.19-5C901.39,227.86,901.29,229.32,901.73,230.09Z"
              />
              <path
                class="cls5-659"
                d="M897.39,213.73c-1,.31-2,.59-3,.82a3.31,3.31,0,0,0,.4,1.34c1.94,3.8,2.18,8.25,4.61,11.85a1,1,0,0,0,.84.88l1.51,1.47v-6.57c-2.16-2.6-2.73-5.93-4.08-8.9A9.18,9.18,0,0,1,897.39,213.73Z"
              />
              <path
                class="cls5-468"
                d="M1035.69,238.66c-2.42,2.54-3,7.44-6.44,7.94-3.11.45-5.65-3.4-8.58-5.14-4.56-2.72-8.44-6.47-13.29-8.76l.77-1.41c1.92-.95,3.08.62,4.33,1.47,4.57,3.07,9,6.36,13.56,9.46,2.28,1.56,3.7,1.29,5-1a79.68,79.68,0,0,1,4.88-7.68c1.21-1.67,1.25-2.91-.71-4a27.84,27.84,0,0,1-4.46-3c-6.25-5.39-12.84-8.38-20.87-3.7a2.42,2.42,0,0,1-2.39,0v-1.71c9.75-5.77,17.79-2.62,25.9,4,6.76,5.53,7.16,5,2.7,12.77A6.86,6.86,0,0,0,1035.69,238.66Z"
              />
              <path
                class="cls5-470"
                d="M1019.31,204.43c-1.25-.64-2.46-1.34-3.64-2.1-.13.16-.27.32-.4.49a235.75,235.75,0,0,0,20.34,14l.66-1L1020.32,205Z"
              />
              <path
                class="cls5-660"
                d="M839.48,250.38l9-.07c-.09,2.5-2.24,2.31-3.76,2.79a80.38,80.38,0,0,0-18.65,8.2,41,41,0,0,1-4,2.35c-5.76,5.35-5.76,5.34.71,10.3,1.19.91,2.33,1.9,3.49,2.85a1.08,1.08,0,0,1,.85.88l-.89.93c-3.52-2.85-7-5.8-10.62-8.49-1.8-1.34-1.71-2.06.07-3.2,1.27-.81,2.4-1.91.68-3.44,2.93-1.91,6.14-3.5,7.68-7a5.94,5.94,0,0,1,3-2.72,8.59,8.59,0,0,1,1.73-.43C832.46,252.68,835.75,250.73,839.48,250.38Z"
              />
              <path
                class="cls5-661"
                d="M824.54,279.37c2.12,2.59,5,4.31,7.57,6.34,3.65,2.84,2.82,6.72-1.82,8.59l.21-1.62c1.8-2.52,1-4.71-.86-6.76-5.27-5.27-11.64-9.16-17.29-13.95-.29-.24-.52-.55-.26-1.56Z"
              />
              <path
                class="cls5-662"
                d="M827.13,254.41c-.64,1-2.19,1.12-2.5,2.48a4.56,4.56,0,0,1-4.17,2.49l-3.3.87-.06-.07c-.22-.35-.42-.72-.66-1.05-1-1.31-3.5-2.15-2.92-3.64.82-2.09,3.43-.93,5.24-1.12a11.91,11.91,0,0,1,4.48.48c1.27.35.61-.69.45-1.23C825.1,252.72,826.14,253.46,827.13,254.41Z"
              />
              <path
                class="cls5-175"
                d="M827.13,254.41l-3.44-.79c-2.65-.68-5.73,1.09-8.1-1.19,5.65.47,11.24,1.3,16.36-2.1l4.42.11c-2.07,2.33-5.22,2.54-7.76,3.95Z"
              />
              <path
                class="cls5-176"
                d="M820.46,259.38c1.11-1.3,2.75-1.71,4.17-2.49.11.51.45,1.38.3,1.48-2.78,1.8-4.94,4.68-8.54,5.11C817.06,261.43,819.64,261.28,820.46,259.38Z"
              />
              <path
                class="cls5-662"
                d="M817.16,260.25c-2.26,2.7-4.53,5.4-7.95,6.79a19.26,19.26,0,0,1,7.89-6.86Z"
              />
              <path
                class="cls5-663"
                d="M928,219c-2.37.94-3.62.23-4.47-2-1.17-3-2.79-6-3.6-9.05l-3.08.71c1,2.83,2.18,5.59,3.23,8.4s.71,4.77-2.83,5.63c-4.39,1.06-8.62,2.72-12.92,4.13.72,1.23,1.92,1.37,3.17,1.41,2.33-.68,4.49-2,7-1.74a1.62,1.62,0,0,0,1.57-.41v-.79c5-2.37,10.06-4.43,15.61-5a1.78,1.78,0,0,0,1.8-.71c1.13-1.89,4.34-.61,5-3.26v-.92C934.94,216.52,931.39,217.59,928,219Z"
              />
              <path
                class="cls5-664"
                d="M904.28,226.78a5.63,5.63,0,0,1,3.4,1c2.11-.93,4.18-2,6.59-1.73h1.79l-2.53,1.75c-2.85,2.48-6,3.64-9.83,2.63.55-1.21,0-2.39-.06-3.59A.84.84,0,0,0,904.28,226.78Z"
              />
              <path
                class="cls5-665"
                d="M850.33,325.93c-7.66-3.67-14.47-8.75-21.65-13.22-3.08-1.92-4.43-1.47-6,1.42-.89,1.64-1.4,3.64-3.56,4.77-.2-1.61,1-2.58,1.34-3.78,1.38-1.84,2.41-4.52,4.24-5.3s3.78,1.78,5.79,2.61c.3.13.76-.12,1.18-.2.08-1.8-2.14-1.71-2.5-4.05l21.19,12.74C850.77,322.59,851.5,324.27,850.33,325.93Z"
              />
              <path
                class="cls5-472"
                d="M818.84,314.29c-1.71-1.12.29-2.22,0-3.34,2.39-1.34,2.64-2.5-.06-3.93-1-.52-2.34-.94-2.78-2.31C822.38,305.66,823,307.9,818.84,314.29Z"
              />
              <path
                class="cls5-666"
                d="M903.47,355.8l.92-.73h0c5.11,3.28,10.47,6.18,15.31,9.9.41,3.71-3,5.66-4.08,8.67a11.18,11.18,0,0,1-1.32,2.07c-3.33,5.07-3.33,5.07,1.94,7.91,4.55,3.13,9.4,5.78,14,8.79,2.26,1.47,4,1.28,5.43-1.24a28.13,28.13,0,0,1,3.68-5c.61-.7,1.38-1.71,2.38-.95s.43,1.81,0,2.66a43.37,43.37,0,0,1-3.41,5.19c-1.72,2.37-1,3.64,1.36,4.73,1.76.79,3.29,2,5,2.91a4.69,4.69,0,0,1,.94.72c.61.82,1.26,1.64.26,2.63-6,1.86-12,.56-18.08.69-.46-2.22,1.28-3.51,2.24-5.09s.8-2.59-.83-3.29c-6-2.59-11-7-16.69-10.17-2.64-1.42-3.93-1.23-4.9,1.6a12.81,12.81,0,0,1-2.34,3.88c-1.14,1.38-2,1.16-2.6-.55-.46-10.48-.21-21-.24-31.43C902.4,358.3,902.38,356.89,903.47,355.8Z"
              />
              <path
                class="cls5-667"
                d="M897.79,399.23c-2.56,4.76-6.48,6.24-11.84,5.81-6.4-.52-13,.55-19-2.65l-.55-.2c-2.3-1.78-4.85-3.18-7.31-4.72a3.06,3.06,0,0,1-.62-3.39c3.29-1.21,5,1.75,7.19,3,6.34,3.68,6.23,3.83,9-3.15.7-1.74,1.68-3.26,4-2.57a2.28,2.28,0,0,1,.65,1.58,3.42,3.42,0,0,1-.59,1.91,35,35,0,0,0,3.36-5c.36-.66.72-1.31,1.13-1.94a27.76,27.76,0,0,0,2.55-3.65c.51-1,.28-1.48-.76-1.71a1.59,1.59,0,0,1-.5-2.19,1.28,1.28,0,0,1,.23-.29c1.76-1.79,2.77-4.33,5.3-5.35a1.86,1.86,0,0,1,1.33,1.07,2.55,2.55,0,0,1-.21,1.56c-.16.36,0,.42.1.07,1.61-4.79,5.23-3.33,8.57-2.79a3,3,0,0,1,2.57,1.38,5.42,5.42,0,0,1,0,3.64c-2,1.72-4,.74-5.58-.54-1.7-1.43-2.29-.65-3.06.74a38.87,38.87,0,0,1-4.19,6.64c-1.36,1.59-.51,3.1.51,4.51a3.3,3.3,0,0,1,.45,2.15c-.41,2.37,1.88,2.18,3,3.07s3.13.82,4.4,1.94A.94.94,0,0,1,897.79,399.23Z"
              />
              <path
                class="cls5-668"
                d="M945.85,404l-.75-2.44c2.58-.46,4.68-2.35,7.38-2.49,1.44.9,1.73,2.22,1.71,3.86-.07,8.1-.05,16.21-.06,24.32-2.06,1.72-4,.22-5.8-.44-5.06-1.84-9.46-5.11-14.55-6.95-1.65-.59-1.66-1.91-.64-2.94,3.56-3.6,6.41-8,11.2-10.25a3.21,3.21,0,0,0,2.66-1.95A12,12,0,0,0,945.85,404Z"
              />
              <path
                class="cls5-669"
                d="M866.94,402.39l3.14,2.52H854.14c-1.66,0-2.11-.8-2.1-2.29V382.75c0-3.3,2-1.86,3.31-1.18,3.12,1.67,5.94,2.14,8.32-1.14a1.94,1.94,0,0,1,.52,1c0,2-1.58,3.05-2.63,4.44-1.72,2.27-3.64,4.46-4,7.46-2.16,2.29,1.09,2.56,1.47,3.9a58.15,58.15,0,0,1,8,5.18Z"
              />
              <path
                class="cls5-670"
                d="M878.68,393.3v-1.66c-2.3-3.31-6.13-4.54-9.24-6.75-1.89-1.36-4-2.37-5.84-3.88a1.38,1.38,0,0,1,.07-.57c.18-.68,1.3-1.35,0-2.05A211.38,211.38,0,0,1,881.94,360c.43.31,1,.46,1.26,1,.71,2,3.22,2.22,4,4.12a1.28,1.28,0,0,1-.37,1c-1.61.71-2.84-.4-4.28-.88.89,1.36,3.33,1.68,2.6,4-1.26.85-2.5.27-3.46-.41-2.67-1.9-4.43-.7-6.39,1.27-6.66,6.67-6.69,6.6,1.19,11.75a71.28,71.28,0,0,1,6.46,4.46,3.41,3.41,0,0,1,.74,2.19l-.71,1.58C880.81,390.14,881.25,393.72,878.68,393.3Z"
              />
              <path
                class="cls5-671"
                d="M916,404.77a62.57,62.57,0,0,0,6.52-9.07c1.21-1.89.52-2.84-.89-3.7-3.54-2.14-7.16-4.15-10.72-6.27-1.55-.91-1.91-.14-2.65,1.19-1.52,2.68-1.8,6.09-4.55,8.07a1.63,1.63,0,0,1-.36-2.28,2.06,2.06,0,0,1,.29-.3c.89-1.37,1.88-2.68,2.67-4.11,2.82-5.08,3-5.32,7.92-2.08,3.81,2.48,8.63,3.59,11.2,7.85.06.12.2.29.29.28,3-.34,6.18,1.11,6.25,3.53.07,2.24-2.68,4.56-4.19,6.84h-1c-1.06-2.05.65-3.3,1.4-4.81.36-.74,1-1.53.21-2.21-1-.82-1.8-.17-2.47.6-1.87,2.15-2.92,5-5.62,6.46Z"
              />
              <path
                class="cls5-672"
                d="M901.76,390.77v14.05a12.21,12.21,0,0,1-5.31-.27c-.39-2,2.89-3.08,1.36-5.32a7.07,7.07,0,0,0-.14-1c-2.57-1.5-6-1.71-7.42-5l-.82-1.79c2.41-1,3.91.93,5.53,1.94,2.24,1.42,3.66,1.67,4.61-1.23A1.84,1.84,0,0,1,901.76,390.77Z"
              />
              <path
                class="cls5-673"
                d="M891.81,407.37c-5.24,5-5.24,5-11.62.49-.55-.39-1.05-.85-1.57-1.28C883,406.8,887.52,405.33,891.81,407.37Z"
              />
              <path
                class="cls5-674"
                d="M852.83,354l4.62.39c-1.67,3.69-3,7.22-5.27,10.32C852.46,361.17,851.08,357.5,852.83,354Z"
              />
              <path
                class="cls5-675"
                d="M849.53,372.5a3.8,3.8,0,0,1,.49,5.1c-.78.86-2-.45-1.28-2a16.78,16.78,0,0,0,.8-2.29,3.66,3.66,0,0,0,0-.81Z"
              />
              <path
                class="cls5-462"
                d="M866.16,314.27c.08-1.94-1.88-2.64-2.49-4.16,2.22,1.31,3.85.77,5.19-1.44.88-1.46,1.58-3.15,4.15-4.63C871.62,308.83,868.86,311.53,866.16,314.27Z"
              />
              <path
                class="cls5-462"
                d="M854.39,333a5.65,5.65,0,0,1,2.64-5.09A5.89,5.89,0,0,1,854.39,333Z"
              />
              <path
                class="cls5-462"
                d="M863.82,310.35a6.18,6.18,0,0,1-4.16-3.92C862.33,306.79,863.2,308.22,863.82,310.35Z"
              />
              <path
                class="cls5-676"
                d="M957.62,210.57c1.54-2.92,8.49-2,4.15-8.49,1.38,1.8,3.69.89,4.43,3.23.54,1.69,2.33.61,3.56.11,3.38-1.35,6.68-3,10.64-2.33Z"
              />
              <path
                class="cls5-677"
                d="M936.61,247.61,934,247c-5.38-1.07-8.84-5.39-13.37-7.89-1.75-1-3.32-2.14-2.72-4.56,1.91-3,3.33-6.41,6.59-8.34l3.94-.16.88.76a1.75,1.75,0,0,1,.38,1.64,2.65,2.65,0,0,1-1.13,1.3,4.14,4.14,0,0,1-1.09.32c-3.12.49-1.57,2-.68,3.3a4,4,0,0,1,1.17,1.15c.13,2,.28,4,2.92,4.29.39.15.76.48,1.13.48,1.73,0,3.54,2.94,5,.5,1.32-2.18-1.59-3.07-2.53-4.58-1-.86-2.61-.8-3.24-2.19a3.5,3.5,0,0,1-.18-1.2,4.16,4.16,0,0,1,.31-1.2c1.54-3,3.49-.88,5.31-.42l10,4.35C942.46,238.25,940.17,243.43,936.61,247.61Z"
              />
              <path
                class="cls5-678"
                d="M980.17,230.12a1.89,1.89,0,0,1,0-.67c3.25-1.13,6.5-2.25,9.74-3.41.87-.32,2-.47,2.17-1.61s-1.09-1.44-1.84-2l-16.4-11.85c2.73-1,3.75.68,4.91,1.46,4.8,3.21,9.51,6.55,14.19,9.93a7.17,7.17,0,0,0,5.38,1.6,3.14,3.14,0,0,1,.85.73c1.61,2.58,5,3.38,6.39,6.14l.09,3c-3-.52-4.89-2.78-7.13-4.42-2.72-2-5.24-2.51-8.36-1a38,38,0,0,1-7.77,2.54C981.54,230.75,980.73,231.08,980.17,230.12Z"
              />
              <path
                class="cls5-679"
                d="M992.49,257.75l-12.23-7.3a135.65,135.65,0,0,1,16.87,0C997.35,254,995.53,256.28,992.49,257.75Z"
              />
              <path
                class="cls5-477"
                d="M979.6,235.44l16,9.52c.64,1.67,2.59,1.89,3.66,3.22-1.11,1-2.31.3-3.43.31-6-3.79-12-7.53-17.87-11.42-1.71-1.13-4.26-1.51-4.55-4.22C976.12,232.19,977.13,235.56,979.6,235.44Z"
              />
              <path
                class="cls5-680"
                d="M980.17,230.12c3.91-.24,7.41-2,11-3.27a6.3,6.3,0,0,1,6.82,1c2.44,2,5.07,3.72,7.62,5.57v1.92c-3.11-2.24-6.25-4.45-9.32-6.73-1.67-1.25-3.27-.87-5-.26-4.51,1.56-9.07,3-13.6,4.44C977.51,231,979.87,231.52,980.17,230.12Z"
              />
              <path
                class="cls5-681"
                d="M1022.19,256.76c.68-2.39,3.14-3.85,3.41-6.46l1.79.75c5.18-.1,8.16,3.73,11.68,6.58l-.4.41c-2,.52-3.27-.81-4.65-1.82s-3-2.25-5-2.2a5.52,5.52,0,0,1-1.07-.15c-2.43,0-2.77,3.37-5.27,3.24Z"
              />
              <path
                class="cls5-682"
                d="M1005.51,230.46c-2.63-1.74-5.87-2.75-7.24-6a12.41,12.41,0,0,1,7.38-2.57v1.83c-4.12,1.73-.95,3.66-.14,5.53Z"
              />
              <path
                class="cls5-683"
                d="M1005.53,229.23l-4.79-3.65c1.5-1.52,3.32-1.45,4.93-1.88C1005.62,225.54,1005.58,227.38,1005.53,229.23Z"
              />
              <path
                class="cls5-453"
                d="M976.7,248.61h16.58A36.55,36.55,0,0,1,976.7,248.61Z"
              />
              <path
                class="cls5-684"
                d="M1005.65,221.87l-7.38,2.57v-.85l7.28-3.1C1005.58,221,1005.62,221.41,1005.65,221.87Z"
              />
              <path
                class="cls5-685"
                d="M852.23,247.9q17.85-5.9,35.68-11.9c2.09-.7,4.08-1.75,6.37-1.62,2.49-.27,5-1.8,7.47,0v1.79a5.35,5.35,0,0,1-3.26,1.37c-2.28.27-3.14,1.59-3.2,3.71-1.58.86-2.52-.35-3.6-1.13-.6-.43-1.24-.67-1.82-.08-.72.74-.46,1.49.15,2.16,1,1.11,3.07,1.7,1.86,3.87a35.68,35.68,0,0,1-11.66-4.94c-2.27,1.08-4.93,1-7.1,2.31-5.14,2.43-10.4,4.47-16.11,5.07-1.65-.09-3.28,1.18-4.94.05A6.37,6.37,0,0,1,852.23,247.9Z"
              />
              <path
                class="cls5-686"
                d="M852.18,245.38c5.62-2.52,11.62-3.8,17.4-5.84l.39,1.15-17.78,6C852.19,246.27,852.18,245.83,852.18,245.38Z"
              />
              <path
                class="cls5-419"
                d="M828.61,254.39c2.26-1.95,5.16-2.65,7.76-3.95l3.11-.06C835.92,251.9,832.54,253.88,828.61,254.39Z"
              />
              <path
                class="cls5-687"
                d="M924.54,226.25l-5.87,8.22c-1.42,2.36-1.74,5.12-2.84,7.61a6.7,6.7,0,0,1-3.08,3.7c-1.11.68-1.57,2-2.68,2.7-2.54-.41-6.6,2.33-6.67-3.21l.3-14.85,9.83-2.63c4.15,1.41,7.24-1.88,10.94-2.47C924.5,225.63,924.52,225.94,924.54,226.25Z"
              />
              <path
                class="cls5-688"
                d="M891.88,246.06a2.53,2.53,0,0,0-1.77-2.52c-2.82-1-2.65-2.84-1.08-4.74,1.78-2.17,2.7-.27,3.72,1a3.31,3.31,0,0,0,2.44,1.36,1.42,1.42,0,0,1,1.12,1.67h0c-.64,1.45.32,2.16,1.35,2.78s1-.29,1.26-.84c.85-1.08,1.84-.81,2.85-.32.08.29.17.58.25.88.26,2.72-1.1,3.72-3.65,3.32-1.6-.25-3.19-.6-4.78-.91Z"
              />
              <path
                class="cls5-689"
                d="M896.09,242.7l-.9-1.55c-2-2.46-1.43-3.86,1.74-4.22,1.62-.19,3.11-1.15,4.82-.77v8.28a2.08,2.08,0,0,1-2.36,0A3.58,3.58,0,0,1,896.09,242.7Z"
              />
              <path
                class="cls5-689"
                d="M901.75,234.37h-7.47a17.65,17.65,0,0,1,7.57-2.42C901.82,232.77,901.79,233.57,901.75,234.37Z"
              />
              <path
                class="cls5-690"
                d="M933.49,219.51c.69-2.58,3.93-1.25,5-3.26,4-.23,7.49-3,11.66-2.61C945,216.61,939,217.48,933.49,219.51Z"
              />
              <path
                class="cls5-690"
                d="M916.08,225.25c1.29-2.92,4.71-2.79,6.87-3.7,2.35-1,5.61-2.54,8.74-1.33l-15,5H916Z"
              />
              <path
                class="cls5-691"
                d="M1016.09,215.36c-9.16,3.51-9.22,3.47-8.32-5.57Z"
              />
              <path
                class="cls5-692"
                d="M1284.15,469.74c.09,4.25-2.39,6.72-5.86,8.52-2.26,1-3-1.26-4.43-2.06-1.28-1.19-3.08-1.87-3.63-3.75-.28-1.82.83-3.1,1.71-4.47a3.86,3.86,0,0,1,1-.84C1277,466.51,1280.89,466.72,1284.15,469.74Z"
              />
              <path
                class="cls5-693"
                d="M1284.08,483.92c-.42,2.48.7,3.81,3.11,4.18.85,2-1.66,2.2-1.94,3.6a6.19,6.19,0,0,1-1,.77,18.23,18.23,0,0,1-11.84,2.37c-1.13-.29-2.07-.79-2.22-2.11a4.78,4.78,0,0,1,1.64-3.36,5.3,5.3,0,0,1,3.54-1.92c.58,0,2.81,1.63.64-.87-1.08-1.25.79-1.32,1.9-1.28.26,0-.36-.63-.43-1-.31-1.89,1-1.72,2-1.45a20.15,20.15,0,0,0,4,.82Z"
              />
              <path
                class="cls5-694"
                d="M1288.87,473.07c-.21.54-.42,1.09-.64,1.63a1.61,1.61,0,0,1-.08.61c-.65,2.15-2.16,3.83-3.21,5.76-1.89,3.46-3,3.49-6.21.58a1.62,1.62,0,0,1,1.34-1.85c1.58-2.06,3.11-4.17,4.77-6.16.59-.71.8-2.33,2.41-1.48C1288.24,471.64,1288.58,472.32,1288.87,473.07Z"
              />
              <path
                class="cls5-695"
                d="M1288.33,487.46c-2.52-.8-3.28-2.36-1.56-4.49,1.29-1.6,1.41-4.13,3.8-4.85C1291.77,481.7,1291.24,484.87,1288.33,487.46Z"
              />
              <path
                class="cls5-696"
                d="M1288.23,474.7c1.4,4.33-2.24,6.38-4.15,9.22h0c-.56-3.94,2.94-6.05,4.13-9.21Z"
              />
              <path
                class="cls5-697"
                d="M1288.87,473.07l-1.62-.91c.07-.26.15-.52.21-.79.27-1.28.35-3.42,2-2.79,2.3.85-.51,2.1-.38,3.28A4.16,4.16,0,0,1,1288.87,473.07Z"
              />
              <path
                class="cls5-476"
                d="M1288,540.33a166,166,0,0,1-11.18,19.12l-1.07-.62,11.26-19Z"
              />
              <path
                class="cls5-698"
                d="M1090.4,309.5c-2.06.15-.86,1-.33,1.64,6.72,8.05,13.41,16.13,20.19,24.13,5.06,6,10.48,11.66,15.28,17.84,6.83,8.79,2.58,19.4-5.77,23.6-.91.31-1.89.77-1.84-.9,10-4.87,11-14.77,6.85-21.22a13.14,13.14,0,0,0-6.83-5.42,25.4,25.4,0,0,1-7.5-5.84L1078,320.66c-1.41-.06-2-1.15-2.65-2.13-4.11-2.42-7.53-6.13-12.9-6.07-6.29.08-11.3,3.18-13.65,9-2,4.8-.43,11.3,3.62,15.21,1,1,2.12,1.77,3.19,2.65,3.25,1.62,3.32,1.76,1.66,3.29a57.25,57.25,0,0,1-6.36-4.58c-5.47-5.16-6.27-15.44-1.83-20.88,5.82-7.12,15-8.68,22.09-3.66,14.27,10.05,28.5,20.16,42.93,30-3.95-6.58-9.51-11.83-14.23-17.74-4.47-5.61-9.19-11-13.84-16.47-.69-.81-1.28-1.48-.38-2.46a4.21,4.21,0,0,1,.71,0C1087.39,308.16,1089.76,307.55,1090.4,309.5Z"
              />
              <path
                class="cls5-699"
                d="M1006.58,346.89c1.4-2.44,0-5.23,1-7.72,1.38-.62,1.57-2.24,2.61-3.13,1.58-1.34,2.69-6.1,5.27-.79l.71-1c1.92-1.49,2.69-4.05,4.93-5.24a1.14,1.14,0,0,1,1.16,1c-.72,1.31-1.55,2.56-2.13,3.92-.94,2.18-4.6,3.36-3.45,5.88.92,2,3.68,3.12,5.63,4.63l1,.77a2.19,2.19,0,0,1,.55,1.48c-.16,1.25.35,2.54-.17,3.78-1.28,1.63-2.68,1-4,.1s-3-1.91-4.44-3-2.67-1.65-4.14.15c-1.22,1.49-2.87,1.4-4.38.15a.85.85,0,0,1-.24-.69C1006.49,347,1006.53,346.89,1006.58,346.89Z"
              />
              <path
                class="cls5-700"
                d="M1023.92,301.08l-.79-.82c2.84-.06,5.69-.07,8.53-.2,1.25-.05,2.87.42,3.21-1.58,2-4.37,5.82-8.13,3.93-13.77-.58-1.7.75-1.95,3.76-.17-.76-1.61-3.42-1.19-3.61-3.4l1.67-1.75c.19,2,2,2.23,3.26,2.72a16.48,16.48,0,0,1,6,3.78c-1.57,1.63.16,2.83.55,4.2-2.32,3.9-4.65,7.8-8,11-2.11,0-1-1.92-1.7-2.77-.29-.56-.29-1.64-1.13-1.38a1.89,1.89,0,0,0-1.34,2.26c.27.83,1.43,1.46.11,2.34C1033.54,302.32,1028.69,302.89,1023.92,301.08Z"
              />
              <path
                class="cls5-701"
                d="M1025.73,346.15c0-2.78,2-4.44,3.57-6.28,2.23-2.69,4.58-2.55,7.38-.25,3,2.48,1.6,4.32-.09,6.46-1.27,1.61-2.48,3.27-3.71,4.9C1029,351.58,1027,349.37,1025.73,346.15Z"
              />
              <path
                class="cls5-702"
                d="M1073.11,353.36c-3.48,1.58-7.6,1-10.86,3.32-1.51.6-2.24-.87-3.38-1.27a17.51,17.51,0,0,0-2-.57,5.17,5.17,0,0,1-.94-.39c-.62-.5-1.61-.78-1.19-1.93,2.29-.93,4-2,2.73-5-.38-.9.39-2.28.63-3.45a2.16,2.16,0,0,1,1.71-.46A97.64,97.64,0,0,1,1073.11,353.36Z"
              />
              <path
                class="cls5-703"
                d="M1040,356.57c1.81,1.34,3.26,3.27,5.78,3.36a7.87,7.87,0,0,1,5.29,4.74c-.09,1.84-1.91,2.72-2.44,4.33a2.37,2.37,0,0,1-.91.72,3.51,3.51,0,0,1-2.35,0c-1.81-1.48-4-2.47-5.29-4.61.18-5.37-3.18-7.72-10.2-7.09-1.8-1.17-1.75-2.64-.68-4.28a4,4,0,0,1,1.24-.51c2.12-.36,4.06.47,6.06.92v.06A5.6,5.6,0,0,1,1040,356.57Z"
              />
              <path
                class="cls5-704"
                d="M1017.38,326c.8-3.33,4-5.58,4.16-9.2,2.09-1.37,3-3.92,5.1-5.26a2,2,0,0,1,1.15.12,5,5,0,0,1,2.35,2.62c0,1.68-1.05,2.46-2.45,3-2.26.8-3.85,2.1-3.52,4.78,2.76-1.74,4-5.09,7-6.51a1.44,1.44,0,0,1,1,.4c-2,4.37-5.29,7.87-8.11,11.69-.26.16-.65.26-.72.1C1022.07,324.71,1019.78,325.17,1017.38,326Z"
              />
              <path
                class="cls5-705"
                d="M1042.34,301.76c-1.22,3-3.5,5.14-5.47,7.55-2.93.82-2.93.82-4.56-1.65-1.89,1.09-1.84,4.47-4.91,4.14h0a14.83,14.83,0,0,1,5.72-10.39C1036.16,302,1039.31,300.28,1042.34,301.76Z"
              />
              <path
                class="cls5-706"
                d="M1027.4,311.8c2.11-1.06,2.6-3.35,3.84-5.07.45-.63,1-1.45,1.94-1,.53.27,1.31,1.18,1.19,1.43-1.92,4,1.53,1.61,2.5,2.14l-4.64,6.6h-.68c-.76-.38-.77-1.55-1.78-1.67A5.26,5.26,0,0,1,1027.4,311.8Z"
              />
              <path
                class="cls5-707"
                d="M1017.38,326a5.84,5.84,0,0,0,1.27-1c2.16-2.85,3.53-2.21,4.49.9a8.45,8.45,0,0,0,1,1.69l-1.9,2.44-.68-.8c-2.36-.09-3,3.47-5.68,2.69C1013.72,329.28,1017.57,328.15,1017.38,326Z"
              />
              <path
                class="cls5-708"
                d="M1025.73,346.15c2.07,2.08,4.14,4.15,7.15,4.83.22.28.45.55.68.83-1.54,2.56-4.28.27-6.15,1.53a3.71,3.71,0,0,1-2.44-.44,2.12,2.12,0,0,1-.69-1.62c.66-1.8-.53-3.18-1.09-4.7v-1.34Z"
              />
              <path
                class="cls5-709"
                d="M1065.67,234.3c1.19,1.8,2.72,3.32,4.2,3.68a29.81,29.81,0,0,1,4,1.34C1071.08,237.69,1068.39,236,1065.67,234.3Z"
              />
              <path
                class="cls5-710"
                d="M1098.81,295.29c-5.18-3.15.23-5.19.81-7.73l1.07.95c-3.25,4.94-3.25,4.94,2,7.22C1100.93,296.52,1100.93,296.52,1098.81,295.29Z"
              />
              <path
                class="cls5-711"
                d="M1150.36,334.22a14.65,14.65,0,0,1,5.14,2.39c-1.66.36-1.37,3.78-4.07,2.53-1.34-.61-3.06-.76-3.42-2.54S1149.88,335.32,1150.36,334.22Z"
              />
              <path
                class="cls5-712"
                d="M1098.81,300.12h-6.16C1094.43,296.91,1094.43,296.91,1098.81,300.12Z"
              />
              <path
                class="cls5-713"
                d="M1189.39,395.73a9.85,9.85,0,0,1,3.15-4.2c1-.25,2-1.08,3,0,2.58,2.94,5.2,5.85,7.69,8.86.59.7.17,1.54-.67,2-3-.93-4.56,1.1-6.3,2.85a3.64,3.64,0,0,1-1.11.33c-1.47,0-3.38.66-4.17-.93-1-2.12,1.19-3.42,2-5.65a51.58,51.58,0,0,1-4.41,5.37c-1,1.07-2.4,1.79-3.67.77-1.51-1.2.15-2.2.75-3.06A66.75,66.75,0,0,0,1189.39,395.73Z"
              />
              <path
                class="cls5-714"
                d="M1196.15,404.78a10.92,10.92,0,0,0,.9-1.35c1.38-2.87,3-4.16,5.49-1-.08,1.24,1.11,1.58,1.67,2.37A8.08,8.08,0,0,1,1196.15,404.78Z"
              />
              <path
                class="cls5-497"
                d="M1274.35,466.27c-.92.15-1.93.19-1.73,1.58l-.15.28a3.07,3.07,0,0,1-2.3.76c-1.46-.31-3.62,1.61-4.27-1.33-.14-5.52-.05-11,0-16.53,0-1.33-.34-2.81,1-3.84.72.38,1.72.57,2.11,1.16,1.94,3,3.52,1.91,5.1-.27,3.47-4.73,3.67-4.77,8.81-1.65,7.12,4.33,7.31,5.24,2.48,11.75-1.76,2.36-3.44,4.74-7,3.86-1.31-.32-1.8,1-2.4,1.92Z"
              />
              <path
                class="cls5-715"
                d="M1275.86,464c.12-1.72.73-2.82,2.76-2.77s9-5.86,9.46-7.94a2.82,2.82,0,0,0-.73-2.27c-2-2.82-5.14-4.16-7.92-5.77-2.49-1.44-3.26,2.46-5.41,2.87l.18-1.54c3.64-4.69,3.63-4.69,8.55-1.19,1.45,1,3,2,4.39,3,3.77,2.75,3.93,3.83,1.16,7.47-1.07,1.41-2.23,2.78-3.23,4.25-1.65,2.42-3,5.23-6.72,2.76C1277.4,462.24,1276.82,463.86,1275.86,464Z"
              />
              <path
                class="cls5-470"
                d="M1281.66,391.57c5.82,1.52,10.16,5.66,15.12,8.7a53.85,53.85,0,0,1-15.18-8.62Z"
              />
              <path
                class="cls5-499"
                d="M1261.68,378.29a8.84,8.84,0,0,1-5-3.32C1259.45,374.43,1260.53,376.4,1261.68,378.29Z"
              />
              <path
                class="cls5-716"
                d="M1244.33,395.79l-.95-.93c-1.67-4.53-.88-8.91.83-13.23,1.69,1.65,2.15-2.63,3.88-.81a3,3,0,0,1,2.26,2.68c0,4.06.29,8.17-1.22,12.08Z"
              />
              <path
                class="cls5-717"
                d="M1249.13,395.58c-.54-4.91,1.45-10-1-14.76,2.23-.93.8-4.52,3.64-5-1.08,2.77.24,5.57-.12,8.37-.41,3.24-.57,6.52-.88,9.77A1.84,1.84,0,0,1,1249.13,395.58Z"
              />
              <path
                class="cls5-718"
                d="M1248.36,460.64c4.05,3.84,9,6.52,13.31,9.95a2.38,2.38,0,0,1,1.25,2.64c-2.79,4.06-3.51,4-9-.08-2.56-1.8-4.77-4-7.26-5.94-2.16-1.65-4.13-3.22-6.72-.74-.38.36-1,0-1.47-.38-.54-.8-.21-2-1.22-2.62-1.86-1.41-3.57-3.57-5.68-3.92-2.77-.47-2.17,3.72-4.43,4.59-2.28-1.36-.64-3.32-.78-5,.06-1.39,0-2.75-1.45-3.49a2.82,2.82,0,0,0-3.39.4c-.49.45-1.21,1-.82,1.7.7,1.21,2,.39,3,.5a6,6,0,0,1,1.2.2c1.29.77,1.9,2.23.59,2.89-3.1,1.57-2.11,3.4-.92,5.46a1.09,1.09,0,0,1-.62.88c-2,.38-3.29-.84-4.62-1.94a7.59,7.59,0,0,0-4-1.75c-2.27-.17-.34,2.09-1.46,2.59-1.77,2.34-4.42,3.9-5.82,6.56-1.18.79-1.23,1.94-1,3.18a6.88,6.88,0,0,1-1.69,2.17c-1.53,1.7-4.08,2.93-2.72,5.95,1.51,1.6,2.37,4.05,5.21,3.84,4.53,2.83,3.5,7.28,3.34,11.48a2.05,2.05,0,0,1-1.68.47,10,10,0,0,1-4-2.47,57,57,0,0,0-5-3.6c-6.5-4.75-10.46-3-11.72,5.29a7.14,7.14,0,0,0-3.69,3.87,10.29,10.29,0,0,1-1.93,2.13c-1.63,1.71-2.79,4-5.35,4.59-1.44.48-2.86.81-4.28-.06a2.43,2.43,0,0,1-.51-2.31,17.45,17.45,0,0,0,3.14-6.5c5.2-3.31,7.74-8.8,11.12-13.59a2.55,2.55,0,0,0-.23-3.43c-3.06-2.92-5.87-6.24-10.3-7.21a2.56,2.56,0,0,1-1-.54c-2-3.51-5.85-4.92-8.82-7.33-1.81-1.48-4-2.53-4.83-4.94-.24-1.64-.71-3.48,1-4.48,1.4-.81,2.57.48,3.76,1.11a12,12,0,0,0,8.93,1.43,2.24,2.24,0,0,1,1.1-.27,12.5,12.5,0,0,1,5.42,3.13c1.17,1.54,3,2,4.64,2.76a1.82,1.82,0,0,1,.75,2.14c-1.44,4.29-.9,5.71,2.93,7.91,1.11.21,2.18,1.07,3.2-.43,1.72-2.56,4.34-4.37,6-7,.16-.31.33-.62.48-.94.4-1,.1-2.13.85-3,3.21-3.37,4.88-8,8.72-10.88,1.2-.89,1.87-2.95,3.94-1.54a4.93,4.93,0,0,1,.45,2.65c.27-1.91-.55-3.94.21-5.92,1.3-2.39,3.17-3.69,6-3.27,1.1.16,2.25.2,2.75-1.13a1.22,1.22,0,0,0-.44-1.46,2.83,2.83,0,0,0-3.11,0c-2.06,1.06-4.07,2.1-5.41-.95a24.83,24.83,0,0,1-.3-5.71c0-2.69,1-4.5,3.89-4.71,3.14.36,2,3.08,3,5.24,2.39-3.51.8-7.91,2.79-11.25a3.53,3.53,0,0,1,1.85-1.46c1.78-.48,3.19.54,4.69,1.18,2.24-.1,2.41-1.57,2.39-3.35,0-1.37-.58-3.16,1.85-3.39.47,0-.47-.37-.47-.75,3.88-4.65,3.86-4.62-1.57-8.58a47.86,47.86,0,0,1-5-3.63.82.82,0,0,1,.15-1h5c3.71,2.19,8.21,3.31,10.09,7.9.49,1.2,1.58.86,2.36.06,1-1,1.74-2.22.57-3.6s-3-2.15-2.23-4.39c3.12-.45,6-.68,5.4,4-.09.65-.22,1.74,1,1.88-1,5.65-5.5,9.17-8.27,13.74-1.46,2.43-3.27,4.64-4.92,6.95-1.94,1.6-3.75,3.34-3.79,6.05,0,1.4-1,1.72-1.78,2.48-2.46,2.47-2.27,4.34.42,6.59,1,.79,2.11,1.27,3.1,2C1239.08,453.83,1244.09,456.74,1248.36,460.64Z"
              />
              <path
                class="cls5-719"
                d="M1241.25,398.16c.19-2.21,1.78-1.5,3-1.48,6.91.48,6.91.48,5.61,8.25l-6.47-.15c.64-1.84-1.38-3.71.33-5.78C1244.31,398.35,1242.16,398.44,1241.25,398.16Z"
              />
              <path
                class="cls5-720"
                d="M1249.23,443.18c-3.82-1.16-7.24-2.87-9.17-6.65A35.17,35.17,0,0,1,1249.23,443.18Z"
              />
              <path
                class="cls5-721"
                d="M1243.39,406.56c.6,1.06.83,2.5,2,3,3.47,1.43,2.41,3.43.74,5.42-2.5,3-3.18,2.87-4.79-.78a7.67,7.67,0,0,0-4-4c-1.84-.87-3.88-1.55-4.83-3.63l3.31.13c1.27.73,2.53,1.46,3.84,2.2.56-.7.32-1.81,1.15-2.38Z"
              />
              <path
                class="cls5-722"
                d="M1217.7,414.27c-1.53-2.75-1.47-5.31.94-7.57a19.75,19.75,0,0,1,7.27-.1c-.29,4.26-3.17,6.58-6.47,8.59C1218.62,415.35,1217.8,415.48,1217.7,414.27Z"
              />
              <path
                class="cls5-718"
                d="M1240.9,406.54v3.75c-2.18-.88-3.89-1.75-5-3.57Z"
              />
              <path
                class="cls5-723"
                d="M1224.42,427.35a24.64,24.64,0,0,0-1.1,8.53c.13,2-.36,4.06-2.5,4-1.64-.05-1.64-2.13-1.49-3.68.07-.78.3-1.7-.83-2-1.41.44-2.93.15-4.34.59a2.35,2.35,0,0,1-2.34-2.36,2.25,2.25,0,0,1,.18-.89c1.32-3.92-.63-5.17-4-5.6a2.42,2.42,0,0,1-1.07-.57c-.87-.82-.52-2.09-1.13-3-.36-.93-1.52-2-.06-2.77s2.89,0,4.18.78,1.72,3.19,3.8,1.35l.56-.11,1-.27c2.12-1.15,4.54-.62,6.79-1.19a3.11,3.11,0,0,1,3.64,2.08A4,4,0,0,1,1224.42,427.35Z"
              />
              <path
                class="cls5-724"
                d="M1219.35,414.86l2.36-.09c1.59-.08,3,1.07,4.75.5,1.3-.41,2.23.76,2.4,2.21-.3,1.82-.28,3.85-2.7,4.34-2.3-1.32-4.61-2.16-7.31-1a3,3,0,0,1-3.43-.22c0-1.6-.07-3.2-.11-4.8-.06-1.84,1-1.86,2.39-1.54Z"
              />
              <path
                class="cls5-431"
                d="M1215.42,420.61c3.64-.74,7.35-2.28,10.66.9a3.73,3.73,0,0,1,0,4.93,1.66,1.66,0,0,1-1.61.91c1-1.92,1.46-4,0-5.72-1.34-1.53-2.81-.35-4.4.22-1.33.47-3.11-.32-4.7-.54A4.07,4.07,0,0,1,1215.42,420.61Z"
              />
              <path
                class="cls5-723"
                d="M1213.5,416.58c1.55,1.46.81,3.29.78,5h0c-2.27,1.23-3.08,0-3.39-2-.18-1.83,1.24-2.34,2.48-3Z"
              />
              <path
                class="cls5-186"
                d="M1238.61,398.37l2-.08c.48,3.6-.66,4.6-5.45,4.81-1.33-1.84-1.62-3.24,1.38-3.13C1237.76,400,1238.17,399.21,1238.61,398.37Z"
              />
              <path
                class="cls5-530"
                d="M1284.93,491.41h1.67c3.72.23,5.56,2.94,7.42,5.63-.32.68-.47,1.43-.83,2.09l-.42.81-1.36.56a3.67,3.67,0,0,1-1.45-3.14c0-1.18-.3-2.13-1.73-2.2a3.73,3.73,0,0,1-2.89-.51,2.32,2.32,0,0,1-.84-.92,2.12,2.12,0,0,1,.46-2.35Z"
              />
              <path
                class="cls5-725"
                d="M1255.83,537.29c2.19,0,3,1.85,4.33,3.05-1.54,0-3.37-1.23-3.71,1.9a5.4,5.4,0,0,1-5.15,4.62c-2.8.1-3.42-3.25-4.92-5.08-1-1.2.85-2,1.58-2.94a3.76,3.76,0,0,1,4.37-1.44C1253.38,537.7,1254.8,540.16,1255.83,537.29Z"
              />
              <path
                class="cls5-726"
                d="M1240.2,543l-1-3.35c1.75-1.34,3.54-2.63,5.23-4,1-.87,1.72-.42,2.43.4a1.49,1.49,0,0,1,.19,2.1,1.37,1.37,0,0,1-.48.38C1244.27,539.82,1242.87,542.31,1240.2,543Z"
              />
              <path
                class="cls5-727"
                d="M1256.64,509.79c-2.79,5-6.72,9.28-10,14a5.12,5.12,0,0,1-3.93-.84,1.65,1.65,0,0,1-.65-1c1.7-2.7,2.36-4.94-.74-7.54-2.35-2-.88-4.1,3.34-5.1C1248.65,509.58,1252.68,508.72,1256.64,509.79Z"
              />
              <path
                class="cls5-728"
                d="M1221.76,549.56a122.89,122.89,0,0,1,10.85-13.25c1.58.81,3.56,1.37,3.28,3.71-.17,1.34,1.07,4.35-2.58,2.37-1.27-.68-2.83,1-2.14,2,1.69,2.61.12,1.92-1.48,2.22-2.3.43-5,.32-6.25,3.18C1223.14,550.51,1222.24,550.23,1221.76,549.56Z"
              />
              <path
                class="cls5-729"
                d="M1236.69,524.62c-.84-1.64-1.25-3.7-4-3.91.8,3.32.75,6.35-2.46,8.36-1.39.86-1.67.22-1.68-1,2.26-2.68,1.67-5.18-.49-7.56a1.7,1.7,0,0,1,.7-2c1-.33,2.06-.36,2.73-1.3,1.25-1,2.5-.47,3.76,0a9.3,9.3,0,0,1,2.85,2c3,2.25,3,5,1.19,8a1.71,1.71,0,0,1-1.67.87C1236.5,527.09,1236.53,525.87,1236.69,524.62Z"
              />
              <path
                class="cls5-730"
                d="M1228.52,560.28c-1.25-1.17-2.17-2.78-4.09-3-1.62,1.06,2.36,1.34.33,2.49-1,.54-1.78.68-2.5-.3s-2.25-1.45-1.64-3c.34-.84,1-1.94,2.11-1.48s2.43,1.84,2.88,0c.56-2.3-1.85-1.1-2.84-1.66-.36-.2-.74-.35-1.12-.53,1.74-2.15,3.33-2.27,4.76.31C1227.65,555.33,1229.54,557.37,1228.52,560.28Z"
              />
              <path
                class="cls5-731"
                d="M1236.69,524.62c1.28.86.78,2.21.91,3.38-.3.54-.6,1.08-.89,1.62-.94.24-2.4,1.25-2.54-.39C1234,527.42,1234.44,525.37,1236.69,524.62Z"
              />
              <path
                class="cls5-732"
                d="M1225.29,583c-1.06,1.23-2.71,2-2.82,4-1.09,1.06-1.76.29-2.4-.56-.15-1.72-.2-3.56-2.57-1.48-1.51,1.33-2.78,2.94-4.63,3.86a3.82,3.82,0,0,1-2.46.39c-3.28-1.52-4.93-4.71-7.16-7.26a3.1,3.1,0,0,1,.33-4.36,3.54,3.54,0,0,1,.51-.35c1.47-1,3.07-1.43,4,.79.07.81-.47,1.55-.24,2.38.14.55.4,1.1,1,1.2,1,.16.82-.83,1.16-1.32,1.22-1.45,3.49-2.1,3.38-4.54.35-1.18.82-2.85,2.3-1.68,2.34,1.87,5.34,1.67,7.77,3a12.93,12.93,0,0,1,2.42,2.59C1227.23,581,1227.11,582.14,1225.29,583Z"
              />
              <path
                class="cls5-733"
                d="M1227.6,583.76c1.64.58,3.14,2,5.07.91.08.4.18.8.25,1.21.24,1.47,3.39.64,2.44,2.54-1,2.07-2.94-.07-4.47.1-.37,0-.79-.37-1.17-.35C1225.53,588.36,1224.92,586.86,1227.6,583.76Z"
              />
              <path
                class="cls5-734"
                d="M1228.47,568.66c-.6-1-1.83-.43-2.61-1.22,1.54.8,2.15-4.73,4.2-.43q1.2,3,2.38,6L1231,574.5a2.89,2.89,0,0,1-2.28-1.76A7.18,7.18,0,0,1,1228.47,568.66Z"
              />
              <path
                class="cls5-735"
                d="M1238.46,567.92c1.11-1.93,2.23-3.86,3.34-5.8.57,0,1.34.19,1.06.74a35.28,35.28,0,0,1-3.45,5.87C1238.68,569.68,1238.54,568.52,1238.46,567.92Z"
              />
              <path
                class="cls5-736"
                d="M1224.18,561.48l1.75,1.22c0,2.62-3.55,2.91-3.68,5.48a2.37,2.37,0,0,1-1.94,1.83,2.8,2.8,0,0,1-1.53-.51c-1.14-1-2.76.36-3.89-.73-1-1.69.69-3.51-.26-5.2a1.8,1.8,0,0,1,.49-1.54c1.21-1.29,2.89-.47,4.28-.93C1220.87,562.79,1222.63,560.77,1224.18,561.48Z"
              />
              <path
                class="cls5-737"
                d="M1265.08,557.23c-4-1.91-4-2.25-.22-5.44.1,1.92.18,3.65.26,5.38Z"
              />
              <path
                class="cls5-681"
                d="M1044.85,261.74v.83c-3.24,0-5.19-1.59-5.92-4.72l.18-.22A12.09,12.09,0,0,1,1044.85,261.74Z"
              />
              <path
                class="cls5-738"
                d="M1039,281.14c1.54.87,3.1,1.72,4.63,2.62.76.44,1.38,1.13.78,2-.83,1.2-1.26-.17-1.88-.43-1-.4-1.53-1.63-3.17-1.48,2.7,6.16-.14,10.64-4.44,14.63.4-3.77-1.74-7.44-.38-11.3.34-1-.94-.44-1.48-.57a.94.94,0,0,1,.12-1.32l0,0c1.81-1.79,1.48-3.78-1.53-5.18-2.37-1.11-4.76-2.62-7.6-2.45.71-2.36,2.3-2.42,4.14-1.49,2.54,1.3,5,2.69,7.54,4Z"
              />
              <path
                class="cls5-739"
                d="M1037.52,279.06l8.62-13,1,.68c-2.31,4.7-5.64,8.73-8.55,13Z"
              />
              <path
                class="cls5-63"
                d="M1287.29,502.81a2.61,2.61,0,0,1-1.56,2c-2.1-.74-3.68-2.75-6.17-2.55a.62.62,0,0,1-.79-.41.58.58,0,0,1,0-.23,5.83,5.83,0,0,1,1-3.51c2.22-.11,2.74-3.35,5.29-2.88,2,.63,1.21,2.46,1.54,3.78S1285.94,501.76,1287.29,502.81Z"
              />
              <path
                class="cls5-740"
                d="M1244.17,507.11c.42-.74.71-1.48-.09-2.16a1.25,1.25,0,0,1,.41-1.58,4,4,0,0,1,2.14-.89c1.34-.14,2.73.8,4-.21.79-.95,0-1.85-.07-2.78.63-1.83,0-4.21,2.28-5.32,3.81.18,4.27.72,3,3.48-.42.52-1,.92-1.16,1.63-.57,2.67.2,3.38,2.78,2.54a5.72,5.72,0,0,1,2-.42c1.82,0,3.42.07,1.48,2.46a43,43,0,0,0-2.61,4.05C1253.57,507.64,1248.77,509.08,1244.17,507.11Z"
              />
              <path
                class="cls5-741"
                d="M1265,497.22c-1.42,1.93-2.3,5.71-5.53,1.67-.68-.22-.83-.77-.86-1.4a3.55,3.55,0,0,1,1.62-2.38c.43-.41.87-.81,1.29-1.23,1.4-.56,1.62-3.9,4.16-1.77.75,1.83-.11,3.47-.59,5.16Z"
              />
              <path
                class="cls5-63"
                d="M1273.28,497.18c.14-1-.2-2.49,1.51-2.27,1.11.14,2.68.32,1.8,2.24l-2.41,1.77Z"
              />
              <path
                class="cls5-742"
                d="M1195,405.85a1.88,1.88,0,0,1,.36.63l-7.57,10.09c-1.92,2.77-3.63.11-5.4-.26-1.11-.23-2.28-1.85-3.27-.35-1.19,1.83,1,2.14,1.84,3,1.48,1.52,4.69,2,3.18,5.35-3.25,3.86-6.13,8-9.25,12-2.26,2.77-4.66,3-7.32.51-1.32-1.23-3.17-1.56-4.69-2.46a2.15,2.15,0,0,1-.52-1.07c2.23-5.58,6.38-9.94,9.55-14.93.88-1.4,1.88-2.72,2.68-4.17a3.26,3.26,0,0,0,.76-3.41c-.25-1.41-1.42-1.91-2.47-2.56-.87-.53-1.69-1.27-1-2.31s1.62-.82,2.47-.08c2.34,2.08,4.58,5.09,7.56.75,1.22-.87,2.76-1.38,3.76-.21,1.47,1.72-.7,3.23-.7,4.83C1186.73,406.73,1190.12,404.94,1195,405.85Z"
              />
              <path
                class="cls5-743"
                d="M1183.59,424c.69-3.49-2.7-3.55-4.37-4.79-1.47-1.09-3-1.63-1.62-3.62,1.1-1.58,2.08-2.92,4.43-.74,1.13,1.06,3.28,3,5.72,1.68,1.47,1.93,2.67,4.24,5.64,4.11a2.35,2.35,0,0,1,.91.41,7.33,7.33,0,0,0,2.7,1.29,6.09,6.09,0,0,1,1,.39,3.88,3.88,0,0,1,1.69,1.39c.58,1.79,1.4,1.68,2.57.43s2.23-3.36,4.68-2.32v2.57c3.61,1.68,6.27,3.72,4.51,8.45-.7,1.88,2.37,1.52,2.73,3.08a20.81,20.81,0,0,1-.09,6.4c-1.94,2.21-3.74.67-5.48-.28-3.66-2-6.07-5.54-9.43-7.94a5,5,0,0,1-1.53-3.16c-.15-.38-.37-1-.7-.91-4.76.8-8-1.56-10.92-4.92C1185.36,424.82,1184.23,424.8,1183.59,424Z"
              />
              <path
                class="cls5-744"
                d="M1193.56,421.57c-.06-.3-.11-.59-.17-.89,2-3,3.9-6,5.9-9,2.36-3.47,3.62-3.56,6.14-.17,2,2.75,4.15,5.2,8,5-.37.95-1.83,1.2-1.63,2.52-2.07,1.16-4.27.12-6.39.37-1.35-1-.33-2.28-.34-3.44a3.35,3.35,0,0,0-1.75-3.1c-1.48-.74-2.23.62-3,1.58-1.18,1.54-2.12,3.25-3.28,4.8C1196.19,420.41,1195.5,422,1193.56,421.57Z"
              />
              <path
                class="cls5-745"
                d="M1099.41,398c2.28,2.14,4.21,4.8,7.73,5a1.45,1.45,0,0,1,1.68,1.16s0,0,0,.08c.15.79-.52,1.08-1.14,1.32a4.21,4.21,0,0,0-3.35,1.49c-1.3.6-2.61.52-4.65-.22,1.92.86,3.28,1.27,3.55,2.87a4.32,4.32,0,0,1-2.81,3c-1.65.06-2.87-.95-4.06-1.86-11.22-8.54-23.4-15.7-34.64-24.21-.33-.25-.82-.41-1-.75-1.56-3.5-5.39-3.68-8.07-5.55-1.93-1.59-4.11-2.83-6-4.38-1.19-.95-2.55-2-2.12-3.76s2-2.07,3.62-2.21,3.33-.66,5-.18a2.15,2.15,0,0,1,.43,2.27c.11.57-1.59.83-.45,1.39a21.35,21.35,0,0,1,6.07,4.51c2.36-1.47-.76-5.3,3.07-5.63,1.34.83,2.45,2.2,4.3,1.81,1.5.68,2.77,1.5,2.35,3.48a3.14,3.14,0,0,1-2.66.1c-1.8.4.08,1.31-.25,1.91.25,1.91,1.34,2.35,3,1.72a2.3,2.3,0,0,1,1.14.31c-.34-.53-1.09-.4-1.44-.91.09-1.61,1.42-1.72,2.51-2.14a2,2,0,0,1,2.48,1.29l1.21,1.59c.35.64,1.14,1.06,1,1.95-.16,2-3.83,1.69-2.81,4.41,2,1.74,4.46,2.51,6.69,4.16,1.23-1.82.2-3.28-.11-4.79-.26-1.27-.08-2.25,1.6-1.39l4.27,3.17a5.43,5.43,0,0,1-.32,1.49c-.42,1.23.17,2.34.43,3.48.65,2.76,4.21,2.44,5.17,4.87.35,1.81,2.06,1.25,3.15,1.79,1.38,1.46,3.4.66,5.17,1.67-.5-2.29-2.5-2.64-3.69-3.8-.47-.93,0-1.46.81-1.8l2.77,1C1099.44,397.55,1099.55,397.64,1099.41,398Z"
              />
              <path
                class="cls5-746"
                d="M1156.11,403.27c-4.8-4.48-10.42-7.84-15.74-11.62a12.67,12.67,0,0,0-2.73-1.86c-4.87-1.72-3-5.73-3-9,0-1.16,1.24-2.16,2.71-.83,1.06,1,2.12,2.41,3.78.8,2,.57,3.34.42,2.54-2.19-.32-1-1.3-1.75-1.45-2.89l-.83-1.45c2.45-1.31,3.7,1.24,5.59,1.75a8.65,8.65,0,0,1,1.36,1c1,1.32,3,1.8,3,3.86-1.34,2.29-5.65,1.87-5.23,5.75.29,1.67-1,4,1.93,4.56a2.37,2.37,0,0,1,1,.33c2.6,2.25,5.63,3.87,8.47,5.84-.46-1.18-2.48-1.91-1.19-3.65,3.17-.74,4.75,1.24,6.13,3.58a5.71,5.71,0,0,1,.38,1.28c0,2.62,1,5.44-1.72,7.43a2.6,2.6,0,0,1-1.26.23A5.68,5.68,0,0,1,1156.11,403.27Z"
              />
              <path
                class="cls5-747"
                d="M1156.11,403.27a6.47,6.47,0,0,1,3.45,2.32c.15,2.45-1.72,2.55-3.32,2.67-12,.91-23.94.47-35.92.25A4.17,4.17,0,0,1,1117,407a3,3,0,0,1-.55-1.34,2.2,2.2,0,0,1,1.84-2.51l.16,0a4.57,4.57,0,0,0,1.51.63C1132,404,1144.09,404.89,1156.11,403.27Z"
              />
              <path
                class="cls5-196"
                d="M1156.34,394.12c.63,2.21,3.48,3,3.89,6.76-3.93-4.1-8.93-5.05-11.6-9.27-1.4-1.82-.89-3.54.23-5.3-.78.37-1.45,1.08-2.43.87a1.86,1.86,0,0,1-.94-.61c-.72-4.57,2.58-4.91,5.71-5.41,2.35.1,1.76,4.18,4.71,3.47,1.76.26,3.3,0,4.35-1.65a1.57,1.57,0,0,1,2.52-.54,7.16,7.16,0,0,1,.71,4.22,2.94,2.94,0,0,1-.5,1,4.18,4.18,0,0,1-1,.59c-1.6.65-2.13,2.71-4.25,2.91a2.27,2.27,0,0,0-1.43,2.87Z"
              />
              <path
                class="cls5-748"
                d="M1087.2,388.73c.43-3.33,3.2-5.25,4.83-7.86,1.19-1.91,2.34.06,3.33.7,4.9,3.17,4.88,3.19,1.7,7.73-1.09,1.56-2.12,3.14-3.18,4.72C1089.71,393.88,1087.19,391.9,1087.2,388.73Z"
              />
              <path
                class="cls5-749"
                d="M1117.93,375.81c.4.74,1.11.82,1.84.9-5.3,2.92-10.6,2.18-15.29-.95-9.64-6.43-19-13.28-28.47-20a6.44,6.44,0,0,1-1.07-1.26c2-1,3,.52,4.16,1.32,7.92,5.55,15.87,11,23.64,16.81A17,17,0,0,0,1117.93,375.81Z"
              />
              <path
                class="cls5-750"
                d="M1195,405.85c-5.9-.14-8.7,4.53-12.29,8.18a50.09,50.09,0,0,0,2.75-7c-1.08-.93-2.37-.25-3.52-.47a53.22,53.22,0,0,1,7.49-10.85c-.34,3.4-2.31,6-4.77,8.86,3.62.8,4.13-2.42,5.72-3.72s2.63-4.78,4.13-3.6c2,1.6-1.7,3-2.13,4.9-.16.73-1.2,1.15-.91,2.21,1.1,1.12,2.66-.47,3.8.53Z"
              />
              <path
                class="cls5-751"
                d="M1118.47,403.13l-1.52,1.69c-2,1.73-4.46,1.92-6.31.27-2.45-2.2-1.07-5-.12-7.53,2.54-3.79,5.06-1.83,7.84-.17C1121.76,399.42,1119.08,401.22,1118.47,403.13Z"
              />
              <path
                class="cls5-752"
                d="M1069,377.39l-2.38-3.24c.1-.85.76-1.24,1.36-1.68,1.09-1,1.77-2.42,2.84-3.49,1.78-1.78,3.61-1.76,5.45-.2s2.35,3.34.58,5.3-2.78,5.79-6.89,4.21A2.25,2.25,0,0,1,1069,377.39Z"
              />
              <path
                class="cls5-753"
                d="M1087.2,388.73c1.45,2.75,4.09,4,6.68,5.29.32,1.34,1.64,1.77,2.44,2.69-.28.44-.55.88-.82,1.32a2,2,0,0,1-1.81,1.34c-1.69-.36-.89-2.12-1.73-3.21-.37,1,.5,1.58.3,2.33-.3,1.12-.92,1.21-1.8.64-1.57-2.13-5.76-1.47-5.67-5.36,2-1.4-1.14-2.69-.09-4.07l.9-.69Z"
              />
              <path
                class="cls5-754"
                d="M1069.7,377.5c3,.57,7-2.21,7.35-5.18a3.41,3.41,0,0,0-2-3.37,2.57,2.57,0,0,0-3.39.33c-1.23,1.09-2.09,2.61-3.75,3.19.18-2.59,2.06-4.3,3.69-5.79,2.81-2.58,4.08,1.38,6.13,2.14,1.75.64,2.25,2.23.92,4-1.71,2.31-3.3,4.71-4.94,7.07l-2.33-.77C1070,379.46,1069.54,378.8,1069.7,377.5Z"
              />
              <path
                class="cls5-755"
                d="M1059.75,344.27c0-.54-1.19-1.89.55-1.27s3,1.81,4.52,2.75c2.48,1.73,5,3.44,7.43,5.2.8.57,2.31,1,.86,2.41C1068.1,351.15,1064.25,347.22,1059.75,344.27Z"
              />
              <path
                class="cls5-703"
                d="M1048.11,369.18c1.71-1.39,4.88.5,5.82-2.61l2.33,1.86c.06.23.11.45.17.68a2.72,2.72,0,0,1-3.19.93,9.31,9.31,0,0,1-5.23.73,1.17,1.17,0,0,1,.12-1.62Z"
              />
              <path
                class="cls5-756"
                d="M1171.9,404.24c-.1.1-.18.25-.3.28-2.85.55-8.34-3.34-8.78-6.21a31.91,31.91,0,0,0,6.63,4.05Z"
              />
              <path
                class="cls5-749"
                d="M1101.71,368.44c-.09.69-.5,1.23-1,1.11a3.67,3.67,0,0,1-3-2.39c-.08-.25.67-1.08,1-1.05C1100.12,366.24,1100.87,367.46,1101.71,368.44Z"
              />
              <path
                class="cls5-757"
                d="M1156.11,384.84V384l4.11-1C1159.54,385.06,1158.35,385.6,1156.11,384.84Z"
              />
              <path
                class="cls5-709"
                d="M938.53,435.2c-.21,2.05.3,3.64-.85,4.91-.77.86-1.56,1.62-2.68.39-.72-.81-1.78-1.43-.29-2.56,1.25-.95,2.11-2.17,1.26-3.88-.56-1.13-1.25-2.6.52-3s2.11,1.36,2.3,2.71A3.19,3.19,0,0,1,938.53,435.2Z"
              />
              <path
                class="cls5-758"
                d="M949.24,433.18a2.56,2.56,0,0,0-1.66-2.51c1.84-2.37-1.2-2.66-1.71-4,2.76.5,5.79.36,7.58,3.17C951.18,429.85,950.67,432.09,949.24,433.18Z"
              />
              <path
                class="cls5-759"
                d="M1109.43,579.39l-4,.14c-.26-.07-.66,0-.77-.22-1.2-1.89-6.07,2.08-5-3,.45-2.18-.41-4.76,1.84-6.62,1-.87.34-2.28-.56-3.27-.61-.68-1.31-1.16-2-.31-1.39,1.6-3,2.12-4.61.61-1.88-1.81,0-3.51.55-5.23,3.22-2.56,6.18-1.52,9,.67,2.56,2.54.57,5.12,0,7.69-.44,2.15-2.33,4.36.2,6.39.75.61,1.82,1.31,2.59.56,1.67-1.64.61-3.9.94-5.87a10.19,10.19,0,0,0-3.61-10c4.93-1.56,6.54-.56,6.69,4.27.11,3.32.06,6.63,0,10C1110.75,576.74,1110.8,578.3,1109.43,579.39Z"
              />
              <path
                class="cls5-760"
                d="M1084.94,556.17c1.24-3.13,3.06-6.15,1.87-9.75a8.58,8.58,0,0,1,8.25.24c3.65,1.84,2.45,5.29,1.54,8.36-2.38,4.8-2.38,4.8-7.32,3.13a7.67,7.67,0,0,1-4.19-1.94Z"
              />
              <path
                class="cls5-761"
                d="M1081,573.48a1.71,1.71,0,0,1-2-1.4,2.64,2.64,0,0,1,0-.29c-.07-1.4.68-2,2.09-1.58,1,.28,2.5-.08,2.56,1.44C1083.78,573.45,1081.87,572.83,1081,573.48Z"
              />
              <path
                class="cls5-762"
                d="M1089.63,557.21c-.25.81,2.48,1.37.19,2.34-1.59-1.1-3.91-1.15-4.73-3.34Z"
              />
              <path
                class="cls5-762"
                d="M1109.5,553.1c.19,6.94.19,6.93-6.48,6.85a17,17,0,0,0-2,.34c-5.47.51-5.54.45-5.57-4.81,1.59-7.7,1.59-7.7-6.22-8.7-.81-.1-1.61-.24-2.41-.36.73-1.16.06-3,1.75-3.71,1.65-1.2,3.27-.47,4.89,0s3,1,3.15-1.45,1.66-4.18,3.52-5.64a4.15,4.15,0,0,1,2.91-.77c1.9.36,3.74.84,4.64,2.84a9.91,9.91,0,0,1,.91,3.63c-1.52,2.82.33,6.52-2.33,9-.57.58-2.52,1.08-.13,1.83A25.23,25.23,0,0,0,1109.5,553.1Z"
              />
              <path
                class="cls5-763"
                d="M1150.05,551.47c-2.67,0-1.63,2.4-2.18,3.64-.7,1.58-.71,3.47-1,5.23-3.72,1.07-7.53.2-11.27.5-1.72-.23-1.46-1-.34-1.68,1.61-.94,3.49-.52,5.25-.68.93-.08,2,0,2.34-1.22s-.53-1.78-1.3-2.36c-2.72-2-5.69-2.81-8.88-1.35-2.59,1.19-3.37,3.43-2.91,6.16.11.67-.27,1-.88,1.12-2.3-.18-5.71,1-4.46-3.56.25-3.69,3.25-5.14,5.71-7,.53-.41,1.3-.8.82-1.58a1.27,1.27,0,0,0-1.74-.43l-.09.06c-4.81,4.91-10,1-15,.66l-2.88-.19c-2.58-2.94-2.58-4.41,0-6.79l44,8.61C1153.83,552.76,1151.81,551.37,1150.05,551.47Z"
              />
              <path
                class="cls5-764"
                d="M1110.42,579.62c0-4.93.24-9.86.09-14.78-.09-2.65.63-3.77,3.42-3.53a59.65,59.65,0,0,0,6.55-.1c.38,6.14-1.47,12-2.1,18a1.46,1.46,0,0,1-1.48,1.44,1.37,1.37,0,0,1-.59-.13C1114.39,580,1112.18,581.25,1110.42,579.62Z"
              />
              <path
                class="cls5-765"
                d="M1120.5,560.49c-1.1,0-2.2-.1-3.3-.1-7,0-7,0-6.53-7.22,2.49.5,5,1.09,7.49,1.47C1122.49,555.29,1123,556.47,1120.5,560.49Z"
              />
              <path
                class="cls5-766"
                d="M1108,541.13c3.2,2,1.26,5,1.32,7.57-1,.64-1.65,1.88-3.09,1.71C1107.1,547.37,1105.79,543.91,1108,541.13Z"
              />
              <path
                class="cls5-767"
                d="M1128.45,504l-.21.14H1128c-2.33-1.34-4-3.63-6.7-4.45-1.69-.63-3.32-1.55-5.24-1.19a4,4,0,0,1-2.07-1,11.26,11.26,0,0,1-4-9.31c0,1.55.35,4.2-1.53,6.5-1.16,1.41-.12,3.18-.11,4.79a5.48,5.48,0,0,1-1.36,2.65c-1.25,1.31-1.9,3-3,4.45-1.44,1.8-3,3.42-6.14,2.38,1.22.69,3.06-.15,2.59,1.55-.52,1.92-1.37,4-4.15,3.6-3.45-1.83-3.65-2.36-1.71-4.53.14-.16.29-.3.44-.45-6.29-1.52,1.92-4.3-.54-6.16-1.17-2.93.83-5.09,1.8-7.5,4.22-6.25,4.22-6.25-1.36-12a12.75,12.75,0,0,0-5.19-5.52c-3.48-2.11-6.83-4.42-10.29-6.56-4.1-3.2-8.42-6.12-12.43-9.44-2.64-2.66-6-4.59-8-8-.13-1.09-.06-2.09,1.06-2.68a2.43,2.43,0,0,1,1.68.54c1.15.92,2.21,2.18,3.88,1.87,2.33-.43,3.41,1.15,4.64,2.59.29.24.57.49.85.74a54,54,0,0,0,8.89,6.08,11.23,11.23,0,0,1,1.89,1.32c3.68,2,6.19,6.23,11.07,6.06,4.8-3.5,4.79-3.48,9.66.41,2.2,1.76,5.13,2.64,6.52,5.39.9,1.93-.61,3.41-1.09,5.43,1.31.35,2.74-.71,3.9.21,2.88,4.44,8.24,5.07,12.16,7.87,1.45.37,1.79-1.49,3-1.54,3.24-.18,2.89,1.77,2,3.72-.65,1.51-1.64,2.88-.4,4.52,1.51,2.29,3.84,3.54,6.12,4.86a7.93,7.93,0,0,1,1,.62,33.29,33.29,0,0,0,4.33,3.52c2.58,2.81,2.58,2.81-2.41,4.09a4.92,4.92,0,0,1-2.41,0C1133.17,507.61,1130.72,505.91,1128.45,504Z"
              />
              <path
                class="cls5-768"
                d="M1128.45,504a12.93,12.93,0,0,1,7.12,4.95c2.55.76,5-.38,7.55-.31,3.91-.67,5.54,3.17,8.54,4.31a7.42,7.42,0,0,1,1,.69c3.64,2.76,6.29,6.39,8.85,10.11a4,4,0,0,1,.9,3.42c-.61,4.3.63,8.72-.83,13-.91.85-1.28.4-1.67-.58a50,50,0,0,1-2.11-7.4c-5-11.08-15.33-16.61-24.51-23.21C1131.27,507.47,1129.24,506.48,1128.45,504Z"
              />
              <path
                class="cls5-769"
                d="M1145.26,542.18l-21.47-1.94a3.11,3.11,0,0,1-1-2.38,3.16,3.16,0,0,1,.89-2.44c.12-5,.94-5.75,5.89-4.92,2.43.41,5.53.23,7.09,1.67,2.78,2.57,6.12,1.36,8.94,2.57,3.23,1.39,1.09,4.29,1.59,6.46C1146.71,541.86,1146.31,542.64,1145.26,542.18Z"
              />
              <path
                class="cls5-770"
                d="M1110.65,536.94c.27-2.68.53-5.37.79-8.05.68-.36.72-1,.83-1.68,2.35-3,5.34-.8,8-1a3.37,3.37,0,0,1,1.74,1c2.24,1.63.32,3.79.71,5.66-.89,1.72.75,3.62-.38,5.33C1118.21,540.19,1114.36,539.25,1110.65,536.94Z"
              />
              <path
                class="cls5-771"
                d="M1089.73,534.55a16.1,16.1,0,0,0-1.7-1c-3.34-1.43-4.37-5-2.49-8.17.78-1.32,1.81-1,2.83-.85,3.48.63,7,1.34,10.43,2,1.89,5.51.7,8.24-4,9.27C1093,535.9,1091.16,536,1089.73,534.55Z"
              />
              <path
                class="cls5-772"
                d="M1145.26,542.18l1.92-1c.13,0,.34,0,.39-.1,1.36-2.48,4.72-4.43,8.59-5,2.6-.41,1.38-2.49,1.66-3.92,2,2.43,1.64,5.77,3.31,8.31.46.79.6,1.45-.61,1.6-.85-1.11-.79-2.53-1-3.73-1.08-.28-1.11.41-1.23.84-.46,1.67-.52,4.59-1.33,4.81-2,.53-4.28-.09-6.42-.45C1148.78,543.22,1147,542.64,1145.26,542.18Z"
              />
              <path
                class="cls5-773"
                d="M1089.73,534.55l4.88.16c1.35.6,4.33.67,3.07,2.59-1.4,2.14,1.31,6.85-3.86,6.58l-5.26-1.17C1087.26,539.75,1089.23,537.26,1089.73,534.55Z"
              />
              <path
                class="cls5-774"
                d="M1116.19,497.94c2.11-1.89,3.5.16,5.13.94.53.49,1.32.88.74,1.82-2.36-.24-1.84,3.31-4.14,3.15h0C1116.33,502.2,1114.78,500.51,1116.19,497.94Z"
              />
              <path
                class="cls5-768"
                d="M1122.06,500.7l-.74-1.82c3.46.16,4.75,3.09,6.66,5.22C1125.39,504.06,1123.72,502.39,1122.06,500.7Z"
              />
              <path
                class="cls5-775"
                d="M1132,510.48a2.5,2.5,0,0,0-1.42,1.74,1.81,1.81,0,0,1-1.81,1.56v.05c-.34-1.21-1.88-2.44-.39-3.67a2.32,2.32,0,0,1,3.29-.07A2,2,0,0,1,1132,510.48Z"
              />
              <path
                class="cls5-776"
                d="M1146,529.06a1.45,1.45,0,0,1,1.51,1.12,1.4,1.4,0,0,1-1,1.71l-.25,0a1.31,1.31,0,0,1-1.5-1.1C1144.54,529.88,1145.13,529.32,1146,529.06Z"
              />
              <path
                class="cls5-777"
                d="M1070.22,551.57c3.65-3.44,4.84-2.59,6.6,3.41C1074.52,553.92,1075.21,548.93,1070.22,551.57Z"
              />
              <path
                class="cls5-550"
                d="M1079.69,473.28c-1.73,2.64-3.32,5.38-5.25,7.86-1.25,1.6-.85,2.11.7,3,6,3.53,6,3.59,10.25-2.07a20,20,0,0,1,1.78-1.66c-.81,3.46-2.69,5.37-4.33,7.42-2.48,3.1-4.37-2.18-6.82-.56.15,1.91,2.58,1.66,2.87,3.28a9.45,9.45,0,0,1-5.09-2.21,2.82,2.82,0,0,0-4-.28l0,0c-1.08.23-2.14,1.12-3.26.1.38-1.47,2-2.5,1.49-4.27,1.62-.33,1-1.8,1.44-2.77,2.51-3.38,4.59-7.09,7.71-10a2.93,2.93,0,0,1,2.75,1A.92.92,0,0,1,1079.69,473.28Z"
              />
              <path
                class="cls5-778"
                d="M995,467.29c-1.14-.81-2.41.21-3.57-.22-2.48-.91-4.64-4.58-7.3-2.48-2,1.62-2.75,5-4.06,7.51-.31.62-.62,1.22-.94,1.83h-.88c2.11-4.38-1.52-5.17-4.13-6.6-.09-.17-.18-.34-.26-.51a1.41,1.41,0,0,1,.72-.83c1.67-.37,3.52.79,5.08-.58,1.66,0,1.75-1.53,2.23-2.56,1.91-4.1,4.09-8.07,5.81-12.26,1.55-2.48,3.46-4.85,2.52-8.11a6.26,6.26,0,0,1,2.77-5c3.42-.52,6.85-1.14,10.15.53.65,2.19-1.28,1.9-2.2,1.9-3.14,0-4.65,1.8-5.84,4.38-1.86,4-3.87,7.92-5.89,11.84-1.21,2.34-1.28,4.18,1.52,5.34,2.3.95,4.59,2.47,6.11-1.11a22,22,0,0,1,2.36-3.88c2.18-3.1,3.53-3.11,6.42-.1v3.44c-.83.49-1.86.49-2.65,1.11-2.6,2.06-2.58,4,0,6.09.69.56,1.84,1,1,2.23A9.64,9.64,0,0,1,995,467.29Z"
              />
              <path
                class="cls5-779"
                d="M1067.17,479.91l2.53,1.59c.82,1.12,1,2.33-.11,3.25-.69.56-.9-.76-1.56-.81-2.52-.12-3.27-3.39-5.89-3.33C1063.16,475.65,1065.49,480.14,1067.17,479.91Z"
              />
              <path
                class="cls5-780"
                d="M1004.92,439c-.18-1.83-1.58-1.5-2.79-1.65-15.54-2-31.25-3-46.15-8.39V405.79c8.86-.21,17.72,0,26.58-.1,8.68,2.79,14.13,10.47,22,14.56,1.53.79,1.46,2.52,1.51,4.05.07,2.32-.15,4.68.65,6.94.12,2.37.9,4.85-1,6.93l-.13,1-.36.13Z"
              />
              <path
                class="cls5-781"
                d="M1007.42,459.81l-.34-19.26c1.38-3,3.32-3.46,7.8-1.68,1.16,1.83-.24,3.39-.54,5.07-1,3-3.08,5.46-3.77,8.59a33.17,33.17,0,0,1,5-9.3c1.67-1.68,3.56-2.27,5.53-.68s1,3.56.14,5.27c-1.71,3.32-2.86,6.91-4.79,10.11C1014.28,461.53,1011.09,462.16,1007.42,459.81Z"
              />
              <path
                class="cls5-782"
                d="M1015,439.73c4-.25,7.75.47,10.71,3.5.63,1.81-.51,3.19-1.2,4.64-3.21,6.85-7,13.4-10.19,20.28-1,2.05-1.31,3.86,0,5.78-.65,2.22-2,1.14-3.28.76a22,22,0,0,0-3.48-2.4l-.06-1.68c3.33-5.39,3.33-5.53-.08-10a2.21,2.21,0,0,1,0-.81c4.16,1.13,7.35.22,9.09-4.12,1.13-2.78,2.55-5.45,3.69-8.23.55-1.35,2.37-2.69.36-4.31s-3.27-.26-4.69.84a2.41,2.41,0,0,1-2.63,0C1013.81,442.58,1014.39,441.16,1015,439.73Z"
              />
              <path
                class="cls5-781"
                d="M1010.72,473.94c1.12-.31,2.23,1.52,3.35,0,.63-.24,1,.1,1.34.57a8.17,8.17,0,0,1,.7,1.47c1,1.36,2.63,2.12,3.26,3.77a6.68,6.68,0,0,1-.52,3.39c-.3.53-.66.95-1.36.79l-1.75.8a1.32,1.32,0,0,1,0-1.81c.69-2.63-2.78-7.21-5.23-6.78-1.92.33-1,3.12-2.92,3.64v-5.84A2.69,2.69,0,0,1,1010.72,473.94Z"
              />
              <path
                class="cls5-781"
                d="M1007.4,460.62c1.7,1,4.51,1.6,3.89,4-.58,2.16-.49,5.37-3.82,6Q1007.44,465.61,1007.4,460.62Z"
              />
              <path
                class="cls5-554"
                d="M1010.72,473.94c-1.07,0-2.14.86-3.2,0V472.3C1009.63,470.84,1010,472.66,1010.72,473.94Z"
              />
              <path
                class="cls5-554"
                d="M1015.7,485.64c1.17,5.72,4.36,10.58,6.69,15.8.88,2,2.1,3.79,2.06,6.78-3.88-4.27-4.18-9.93-7.9-13.5h0a35.36,35.36,0,0,1-2.35-5.17C1013.51,488,1013.07,486.13,1015.7,485.64Z"
              />
              <path
                class="cls5-783"
                d="M1015.7,485.64c-1.47,1.21-1.72,2.41-.56,4.15a7.93,7.93,0,0,1,1.42,4.95c-4.22-4.35-4.47-7.71-.87-11.83v1.81A4.7,4.7,0,0,1,1015.7,485.64Z"
              />
              <path
                class="cls5-784"
                d="M1043.2,504.68c-.26-4.71-.42-9.38,4.07-12.54.25.19.34.4.27.61s-.16.32-.24.32c-1.38,2.35-3,4.58-3.3,7.43C1043.75,501.9,1044.52,503.49,1043.2,504.68Z"
              />
              <path
                class="cls5-785"
                d="M1037.37,448.75c-1-.23-2-.31-2.57-1.31,5.25-5.9,5.24-5.89,11.72-1.32,1.55,1.09,3.08,2.32,5.13,2.37a13.21,13.21,0,0,1,4.68,2.45c1.05.79,1.75,1.53,2-.47,2,.66.41,2.59,1.3,3.64,2.44,2.6,5.91,4.21,7.48,7.66l-.83.61c-2.54,0-4.11-1.76-6-3.15-1.22-.91-2.85-3.83-4.68-.41-1.5-.2-2.54-1.78-4.23-1.4l-4.8-3.45C1044,451.31,1041.17,449.21,1037.37,448.75Z"
              />
              <path
                class="cls5-786"
                d="M1047.3,493.07v-.93a17.25,17.25,0,0,1,5.86-8.25c-.52,3.44-3.29,5.56-4.92,8.35Z"
              />
              <path
                class="cls5-787"
                d="M1173.73,509.72a5.63,5.63,0,0,0,3.85-.88c.92.32,1.37,2.4,2.87.58.67-.81,2-.72,3-.81,2,0,4.11-.28,6.1.46,1.66,2.05,3.69,4.1-.62,5.55-.47.16.39,1.11.19,1.75-.37,1.9-1.85,2.92-3.16,4.08-2.69,3.78-7.56,3.39-11.85-1-.5,1.39-2,1.68-2.84,2.7-6.61,6.47-7.54,13.82-4.11,22.29,1.47,3.64,1.55,7.8,3.14,11.51.85,4.91.39,5.5-3.44,4.45-4.46-1-2.61-5.34-4.08-7.94-.87-1.55-.21-4-.25-6a5.24,5.24,0,0,1-.88-2.87c.57-5.33.11-10.69.3-16,.23-2.55.79-5.1.24-7.69-.4-1.9,0-3.42,2.36-3.3,2.07.11,2.68-1.27,3.68-2.66C1169.63,512.09,1170.14,508.81,1173.73,509.72Z"
              />
              <path
                class="cls5-788"
                d="M1169.62,590.27a2.46,2.46,0,0,0-1.19-2.23c-.81-3.49-4.44-4-6.5-6.2-.61-5.54-.22-11.08-.24-16.61a4,4,0,0,1,1.18-3c1.64.92,2.51-1.17,4-1,3.25-1.1,5.07-.28,5.73,3.43.6,3.36,1.55,6.69,2.45,10,.58,3,1.64,5.94,1.57,9.07-.66,2.89-3.35,4.23-4.9,6.45C1171,590.64,1170.35,591.13,1169.62,590.27Z"
              />
              <path
                class="cls5-789"
                d="M1161.24,589.67c-1.41.89,0,4.19-3.78,3.42s-5.83-1.08-4.74-5.87c1.73-7.55,2.7-15.27,3.83-23,.61-4.12,3-2.71,5.31-2,.34,7.24,1.05,14.48-.19,21.7C1160.48,585.76,1162.09,587.81,1161.24,589.67Z"
              />
              <path
                class="cls5-790"
                d="M1161.24,589.67c-.73-1.61-1.56-3.21-.91-5.08,1.08-.36,1.09-2.13,2.58-2,5.2-1.63,5,2.21,5.52,5.41A12.47,12.47,0,0,1,1161.24,589.67Z"
              />
              <path
                class="cls5-791"
                d="M1150.19,583c-2.51,1.63-3.1.17-3.11-2,0-4.34,1.6-8.44,1.84-12.79.11-2.07,2.55-1.07,4.06-.75.06,0,.13.22.12.33a1.7,1.7,0,0,1-.19.35C1151.52,573,1151,578,1150.19,583Z"
              />
              <path
                class="cls5-792"
                d="M1150.05,551.47c1.68-.58,3.63.42,5.18-.89,2.33-.29,4.75-.29,6.48,1.4,1,.92-.86,1.54-4.51.77a5.62,5.62,0,0,1-1.56-.41C1153.87,551.33,1151.67,553.27,1150.05,551.47Z"
              />
              <path
                class="cls5-793"
                d="M1181.81,597.12c.24-1-.26-2.4,1.36-2.5,1.09-.06,1.22.89,1.19,1.72-.08,1.57-.75,2.29-2.35,1.45A3,3,0,0,0,1181.81,597.12Z"
              />
              <path
                class="cls5-794"
                d="M1126.07,584.05c-3.14-5.55,1.36-11.44,1-17.61-.16-3.05,1.1-4.69,4.42-4.39,1.92.17,3.88,0,5.81,0,8.24-.07,6.56-.15,5,7.14-.53,2.56-.76,5.13-1.3,7.63-1.08,4.94-1.64,10.46-7.16,12.93C1130.63,591.25,1125.87,588.12,1126.07,584.05Z"
              />
              <path
                class="cls5-795"
                d="M1207.86,600.57c-1.15-.78-2.75.89-2.67.65,1.09-3-4.77-3.4-2.49-6.68-.25-.81.25-1.17.87-1.46,1.45-.33,2.61,0,3.22,1.48.67.81,1.18,2,2,2.37,2.67,1.19.27,1.8-.17,2.64Z"
              />
              <path
                class="cls5-450"
                d="M964.21,324.24c-3.48-.24-1-1.92-.74-3.07,3.58-.71,4.38,2.54,6.14,4.38.41.42.09,1.11-.41,1.39-.79.45-1.24-.25-1.72-.69C966.51,325.37,966.8,322.48,964.21,324.24Z"
              />
              <path
                class="cls5-796"
                d="M993.2,404.85l-2.36.11c-4.2,2-8.35,1.19-12.51-.15-.34-3.6-3.62-4.26-6-5.53-2.91-1.59-4.82-4-7-6.3a2.58,2.58,0,0,1-.37-3.09c-.53-1,.16-1.61.72-2.27l1.83-2.72h4c0,1.67-1.38,3.83,1.52,4.56,7,3.39,12.84,8.54,19.24,12.84C993.13,402.85,994.34,403.48,993.2,404.85Z"
              />
              <path
                class="cls5-797"
                d="M955.87,390.67c1.33.4,2.82.84,2.79,2.51,0,1.18-1,1.81-2.27,2-.9-1.48-.22-3-.59-4.46Z"
              />
              <path
                class="cls5-798"
                d="M993.2,404.85c-5.42-5.12-11.76-9-17.92-13.11-.9-.6-1.85-1.13-2.77-1.69-1.89-1.39-1.47-2.7-.34-4.54,4.41-7.15,9.93-13.48,14.56-20.46l1.58-.1a3.56,3.56,0,0,1,2.25,1.76c.81,1.9,1.76,3.27-1.21,4.86-1.89,1-3,4-4.67,6.07-1.28,1.57,1.33,2.38,1.57,3.81a5.13,5.13,0,0,1-1.58,3.8,2.8,2.8,0,0,1-1.57.83c-1.56-.24-1.75-1.53-1.83-3.41-1.59,2-5.08,3-.94,5.16.8.42.88,1.36,1.3,2.06.7,1.13,1.42,2.27,2.73.54,1.19-1.55,2.73-.89,4.2-.63,2.75.86,4.57,3,6.67,4.77a5.82,5.82,0,0,1,.76,1.54c1,2.12,1.27,4.56,2.85,6.42a2.72,2.72,0,0,1,.71,1.52,1.59,1.59,0,0,1-.49,1C997.15,403.73,995.15,405.11,993.2,404.85Z"
              />
              <path
                class="cls5-799"
                d="M979.09,359.2l3.42-3.49c1.11-.47,2.52-.31,3.26-1.56l.8-1.62c.77-3.18-3.09-3.91-3.44-6.5.78-1.37,1.56-2.75,3.47-2.61,2.15,0,3.5,1.36,4.82,2.79,1.16,1.68.72,3.21-.41,4.67-.23.44-1.08.75-.29,1.44.53.54,1.46.89,1,1.93-1.32,2.23-2.45,4.52-5.79,4.26-1.11-.08-.08.94.07,1.45.63,1.74-.26,2.22-1.78,2.05-1.2-.14-2.12-1.16-3.38-1.19Z"
              />
              <path
                class="cls5-800"
                d="M986.73,365.05c-1,4.93-5.09,7.95-7.57,12a95.49,95.49,0,0,1-6.72,9.27c-1.15,1.44-.4,2.53.07,3.77-3.74-1.07-3.71-2.87-1-5.17,3.08-5.63,7.4-10.38,11-15.65C983.89,367.8,984.68,365.79,986.73,365.05Z"
              />
              <path
                class="cls5-801"
                d="M980,368.43a3.61,3.61,0,0,1-3.23,3.27c-.77-.3-2.52.31-2.12-1.05.45-1.54,1.41-3.48,3.85-2.54Z"
              />
              <path
                class="cls5-802"
                d="M853.75,267.75c1.19.17,3-.79,3,1.53a1.39,1.39,0,0,1-1.2,1.46c-2,0-1.75-1.66-1.83-3Z"
              />
              <path
                class="cls5-803"
                d="M857,275.22c-.06,1-.76,1.39-1.6,1.53a1.32,1.32,0,0,1-1.61-.95,1.26,1.26,0,0,1,0-.39,1.43,1.43,0,0,1,1.26-1.58h.23A1.64,1.64,0,0,1,857,275.22Z"
              />
              <path
                class="cls5-228"
                d="M850.31,272.63l1.61.06a1.08,1.08,0,0,1,.57,1.42,1.07,1.07,0,0,1-.44.5c-1,.91-1.86.69-2.65-.28C849.51,273.66,849.6,273,850.31,272.63Z"
              />
              <path
                class="cls5-804"
                d="M861.39,268.64c-.11.86-.82.83-1.48.81a1.11,1.11,0,0,1-1.21-1,1,1,0,0,1,0-.24,1.18,1.18,0,0,1,1.16-1.2H860C861,267,861.28,267.7,861.39,268.64Z"
              />
              <path
                class="cls5-805"
                d="M906.84,310.05c.9,0,1.59.43,1.59,1.39,0,.77-.61,1.12-1.36,1.11a1.45,1.45,0,0,1-1.59-1.29.41.41,0,0,1,0-.11C905.44,310.35,906.13,310.12,906.84,310.05Z"
              />
              <path
                class="cls5-806"
                d="M946.75,345.86l.09,4a24.39,24.39,0,0,0-2.69-.33c-2.33-.06-2.24-1.37-1.64-3l-.06-1.47c-.22-2-.51-4.05-.64-6.08-.06-1-.21-2.52,1.32-2.5a2,2,0,0,1,1.9,2.1l0,.23C944.6,341.49,945.88,343.6,946.75,345.86Z"
              />
              <path
                class="cls5-807"
                d="M920.91,264.4a1.68,1.68,0,0,1-.62-.08c-.68,0-1.51.28-2-.14-4.22-3.44-9.61-5.29-13.14-9.67-2.31.65-1.54-1.12-1.61-2.13-.09-1.18.17-2.2,1.7-2.17l6.51.16a4,4,0,0,1,.6.56,17.11,17.11,0,0,0,6.7,5.24c3.82,1.42,3.53-3.78,6.16-4.67a2.75,2.75,0,0,1,1.21-.06c2.56,1.29,2.42,3.27.83,5C924.92,259,923.16,261.86,920.91,264.4Z"
              />
              <path
                class="cls5-808"
                d="M919.25,265.36l2.66,2.35c-.58,4.31-3.35,2.52-5.13,1.49a98.19,98.19,0,0,1-9.49-6.56c-1.12-.84-2.12-1.76-3.62-1.71-.18-1.87-.69-3.84,1.51-5A43.36,43.36,0,0,1,919.25,265.36Z"
              />
              <path
                class="cls5-809"
                d="M925.13,251.85c-1.36,2.33-2.62,6.48-4.75,6.09-3.5-.64-6.56-3.55-9-6.49-.12-.14.25-.71.4-1.08l1.68-1c3-1.92,6.28-1.34,9.46-.84C924.49,248.74,926.09,249.59,925.13,251.85Z"
              />
              <path
                class="cls5-810"
                d="M925.13,251.85c-.18-2.24-1.73-2.47-3.52-2.46-2.73,0-5.46,0-8.2-.06a2.68,2.68,0,0,0,0-.8,3.18,3.18,0,0,1,.25-2.38c.35-.75.8-1.43,1.19-2.15,2.2-3.94,3.66-4.33,7.49-1.85,2,1.32,4.32,2.4,5.72,4.56a4,4,0,0,1-.3,3.65,3,3,0,0,1-2,1.45C925.58,251.81,925.35,251.83,925.13,251.85Z"
              />
              <path
                class="cls5-811"
                d="M898.6,254.42l-2.4-1.5-1.32-2.28c1.93,2.09,9.23-3.25,6.69,4.85Z"
              />
              <path
                class="cls5-812"
                d="M914.12,246.87l-.72,1.66-3.33-.05c.07-1.37.35-2.64,1.79-3.25C913.67,244.31,914,245.51,914.12,246.87Z"
              />
              <path
                class="cls5-231"
                d="M901.84,293.31c-1.17-2.5-4-3-5.72-4.9.09-.1.2-.3.26-.28,3.94,1,5-1.39,5.47-4.57,1.93-1.7,4.9.72,6.65-1.69l.88.92c.15,3.34-1.44,6.55-.75,9.93A3.07,3.07,0,0,1,906,294.4C904.55,294.29,903.06,294.31,901.84,293.31Z"
              />
              <path
                class="cls5-232"
                d="M905.61,266h.08c.74.91,1.91,1.77.71,3.06a1.41,1.41,0,0,1-1.43,0C903.68,267.77,905,266.91,905.61,266Z"
              />
              <path
                class="cls5-234"
                d="M935.24,342.65c1.54.49,2.77,1.21,2.35,3.16C934,346.82,935.34,344.21,935.24,342.65Z"
              />
              <path
                class="cls5-813"
                d="M895.11,301.68c0,.87,0,1.74.07,2.6a26.86,26.86,0,0,1-2.84.09c-1.46-.1-3.28,0-3.58-1.9s1.39-2.9,2.76-3.6c2-1.07,1.83,1.27,2.62,2.1A5.62,5.62,0,0,0,895.11,301.68Z"
              />
              <path
                class="cls5-814"
                d="M917.63,299.33c-.11-1.18-.56-2.54,1.38-2.62.77,0,1.44.41,1.37,1.12-.14,1.7-1.54,1.5-2.73,1.52Z"
              />
              <path
                class="cls5-815"
                d="M954.15,324.37c.88.21,1.6.65,1.49,1.65a1.6,1.6,0,0,1-1.72,1.45c-1.12,0-1.35-.74-1.33-1.65a1.31,1.31,0,0,1,1.11-1.47A1.36,1.36,0,0,1,954.15,324.37Z"
              />
              <path
                class="cls5-816"
                d="M1024.17,302h8.16c-.31,4-4.32,6.07-5,9.87-2.49,1-2.29,5.2-5.83,5,.23-2.37,2.06-3.94,3.48-5.34,2.5-2.45,2.31-4.22-.16-6.23C1023.27,304.41,1024.46,303,1024.17,302Z"
              />
              <path
                class="cls5-236"
                d="M1015.86,331.93c1.41-1.19,3.08-1.91,4.18-3.69,1-1.56,1.7-.49,1.5,1-2.14,1.31-2.14,4.92-5.41,5Z"
              />
              <path
                class="cls5-817"
                d="M1006.63,348.81c-.85,3.14-1.62,4.47-5.91,3.33-2.89-.77-7.14,0-10.74.58-1.25-.75.06-1.25.17-1.86a1.66,1.66,0,0,1,.68-.42c1.16-.31,2.62-.54,2.75-1.92.16-1.72-2.05-.78-2.62-1.86l-4.36-3.24c.62-1,1.29-2,.79-3.32,3.87.18,5.57,4.39,9.23,5,2.24-.42,3.83-1.36,3.25-4.05l1.63-.73c1.63.09,2.48-1.47,4-1.93,1,2.81-.76,5.93,1.1,8.54,0,.22.06.44.08.66a.83.83,0,0,1,0,1.16Z"
              />
              <path
                class="cls5-681"
                d="M1028.43,253.77c-1.85,4.45-5.13,8-7.6,12.08-.85,1.4-1.64,2.83-2.45,4.25-1.77.06-2.42-1.55-3.57-2.42l7.39-10.92.39.23c2.87.48,2.82-3.7,5.54-3.48Z"
              />
              <path
                class="cls5-818"
                d="M925.8,251.81l1.07-1.49c1.62-1.16,3.22-1.57,4.81.05.08.64,0,1.33.74,1.7,1.07,2.4-1.06,3.81-2.24,4.69-1.62,1.21-2,2.72-2.63,4.27l-2.37,1.76c-.93,1.25-.68,3.09-2.09,4.09l-2.17-2.48c.3-3.62,3-5.74,5.22-8.07C927.79,254.64,928.37,253.13,925.8,251.81Z"
              />
              <path
                class="cls5-819"
                d="M976.71,265.23a10.85,10.85,0,0,0-1.59.39c-1.37.57-2.24,0-2.44-1.28-.27-1.63,1-1.64,2.17-1.68a3.35,3.35,0,0,1,2.7.74Z"
              />
              <path
                class="cls5-820"
                d="M936.86,265.25c1.41-.83,2.58-.85,3.29.92.36.9.94,1.8-.12,2.58a2.52,2.52,0,0,1-2.75.22c-1.84-1,0-2.48-.43-3.69Z"
              />
              <path
                class="cls5-821"
                d="M914.12,246.87c-.66-.67-1-1.75-2.26-1.64,3.5-1.35,2.95-5.16,4.6-7.65.71-1.06.49-2.75,2.21-3.11-.5,1.88.76,2.66,2.08,3.53,4.46,3,8.86,6,13.29,9l-.61,1.47c-2.4,1.14-4.61,1.55-5.92-1.54l-3-2.1C918.18,240.47,918.18,240.47,914.12,246.87Z"
              />
              <path
                class="cls5-822"
                d="M815.88,256.15c1.91,0,3.38-1.08,4.92.3C819.22,258.69,817.72,258.47,815.88,256.15Z"
              />
              <path
                class="cls5-690"
                d="M914.27,226.06l-6.59,1.73C909.52,225.84,911.64,225,914.27,226.06Z"
              />
              <path
                class="cls5-823"
                d="M825.48,261h1.63c1,2.18,2.79.42,4.15.84,1.7,2.05.41,4.52.93,6.73-3-.61-4.78-3-7.16-4.54C823.19,262.87,825.38,262.05,825.48,261Z"
              />
              <path
                class="cls5-824"
                d="M866.07,358.4c1.61-1.23,2.73-1.18,4.24-.14C868.94,359.37,867.81,359.39,866.07,358.4Z"
              />
              <path
                class="cls5-825"
                d="M945.89,383.32c-3.4,3.1-5.38,7.24-8,10.87-1,1.34-.3,1.76.72,2.54,2.16,1.65,4.93,2.49,6.54,4.87-3.22-.56-5.49-3-8.34-4.32-1.45-.67-1.44-1.92-.32-3.38a27.6,27.6,0,0,0,4.56-8.52q-2.64,3.74-5.26,7.48c-1.27,1.81-2.48,2.57-4.74,1.05-5-3.32-10.53-5.69-15-9.77l.45-.37c4.81.38,8.21,3.73,12.12,5.93,4.57,2.59,4.79,2.67,7.75-1.85,1.66-2.53,3.09-5.26,5.57-7.14Z"
              />
              <path
                class="cls5-661"
                d="M919.21,365.19a2.42,2.42,0,0,1,1.81,1.36c-.81,3.68-3.53,6.29-5.39,9.36-1.5,2.46-2.63,4.49.2,6.67a1.26,1.26,0,0,1,.21,1.52h0c-1.26-.5-2.53-1-3.76-1.52-2.1-.94-2.38-2.17-1-4.2C914,374.12,917.15,370,919.21,365.19Z"
              />
              <path
                class="cls5-826"
                d="M907.42,379l4.61-7A8.43,8.43,0,0,1,907.42,379Z"
              />
              <path
                class="cls5-827"
                d="M885.29,369.17c-.74-1.64-2.28-2.32-3.71-3.14-.75-.42-2.18-.6-1.37-1.93.69-1.12,1.69-.34,2.56,0,1.38.6,2.77,1.17,4.15,1.75,3.57,2.48,7.39,4.56,10.93,7.06.69.49,1.95.63,1.56,2-.07.54-.38,1.43-.8,1.08-4.49-3.66-5.71.44-7.52,3.1a2.21,2.21,0,0,1-2.17,1.33c.05-1.95,1.74-3.06,2.16-4.68.41-2,0-3.46-2.06-4.43a20.34,20.34,0,0,1-3.77-2.21Z"
              />
              <path
                class="cls5-828"
                d="M899.41,375c-3.7-3.66-9.19-4.85-12.49-9.06v-.8c5,3,9.62,6.52,14.9,9v1.8Z"
              />
              <path
                class="cls5-827"
                d="M890.23,393.28c2.35,1.85,5.34,2.72,7.42,5-3.5.37-5.93-1.89-8.58-3.55C888.12,394.09,888.22,393.93,890.23,393.28Z"
              />
              <path
                class="cls5-670"
                d="M885.25,369.14c6,1.93,6.93,3,5.83,6.64l-.92-.82c.85-1.18.45-1.84-.74-2.6C888,371.41,886.16,370.82,885.25,369.14Z"
              />
              <path
                class="cls5-829"
                d="M898,352.26a14.12,14.12,0,0,1-5.57.08C894.55,349.23,894.7,349.23,898,352.26Z"
              />
              <path
                class="cls5-830"
                d="M933.37,235.39c0,1.76-1.6,2.64-2.27,4-3.9.44-5-1.2-3.43-4.72C929.79,233.05,931.59,234.15,933.37,235.39Z"
              />
              <path
                class="cls5-831"
                d="M933.37,235.39l-5.7-.69-1.68-.45a1.26,1.26,0,0,1,.06-1.78,1,1,0,0,1,.2-.15c1.94-.85,3.82-1.07,5.47.64.9,1.28,2.77.06,3.65,1.41C935.23,235.76,934.34,235.66,933.37,235.39Z"
              />
              <path
                class="cls5-832"
                d="M926,232.88v1.37c-.85-1.47-2.3-2.88-1.25-4.71.72-1.26,1.92-.55,2.91-.1C929,231.48,926.86,231.88,926,232.88Z"
              />
              <path
                class="cls5-832"
                d="M929.24,228.6c1.84-.09,2.76.76,2.71,2.62-.07.21-.13.43-.2.64-2.42.89-3.86.47-3.38-2.53Z"
              />
              <path
                class="cls5-833"
                d="M1270.7,492.39l-3.4-.85c-2.6-1.47-1.28-3.3-.19-4.76,1.66-2.21,1.63-4-.61-5.66a4.35,4.35,0,0,1-.57-1.09,9,9,0,0,1,.28-5.6l.47-.44c2.69,1.8,5,4.3,8.31,5l2.47,1.84c.8,2.22-.93,3.28-2,4.74a31.41,31.41,0,0,0-3,4.32Z"
              />
              <path
                class="cls5-834"
                d="M1006.63,348.81v-1.26c1.08-.18,1.94,1,3.14.41,4.92-2.33,5-2.32,10.2,1.76,1.16.92,2.2,1.77,3.41.14a1.26,1.26,0,0,1,1.47,1,.36.36,0,0,1,0,.11l-.1,1.63c-3.61,1.22-7.22,2.25-10.83,0C1011.14,352.08,1006.84,354.4,1006.63,348.81Z"
              />
              <path
                class="cls5-835"
                d="M1041.57,298.54c-1,.45-1.26,1.81-2.54,1.79l-3.21-.51c1.8-1.71,2.25-4,4.31-5.1C1041.43,295.79,1041.48,297.17,1041.57,298.54Z"
              />
              <path
                class="cls5-834"
                d="M1029,354.27l1,3.29c2.78,1.93,6.86,2.25,7.88,6.36-1.31,2.15-1.32,2.23-.27,4.52a2.18,2.18,0,0,1-1.3,1.17c-5.82-1.78-10-6.17-14.82-9.5-2-1.36-5.23-1.84-5-5.36C1020.5,352.1,1024.73,353.23,1029,354.27Z"
              />
              <path
                class="cls5-836"
                d="M1037.61,364c1,.14,1.71,1.29,2.89.86,1.54,1.62,4,2.11,5.09,4.31a2.62,2.62,0,0,1-2.17,3,2.89,2.89,0,0,1-.83,0,5.6,5.6,0,0,1-5.28-3.94C1035.25,366.69,1035.33,365.26,1037.61,364Z"
              />
              <path
                class="cls5-837"
                d="M1027.4,316.8l-3.42,5.77c-.46-.23-1.26-.41-1.33-.72C1022.25,319.84,1025.27,316.71,1027.4,316.8Z"
              />
              <path
                class="cls5-838"
                d="M1238.28,463.25a2.18,2.18,0,0,1,.23,2.44c.12,2.66-3,5.21-.24,7.94a20.47,20.47,0,0,1,2.49,5.21,6.38,6.38,0,0,1,.67,7.58c-1.77,3.39-2.65,7-.19,10.59a1.73,1.73,0,0,1-.85.75c-2.44-.47-3.94,1.75-6.09,2.15a2.91,2.91,0,0,1-.8-.84c-1.26-2.13-2.22-4.25.08-6.33.64-1,2.42-1.89.26-3.12a13.92,13.92,0,0,1-3.56-2.63c-2.35-2.95-3.32-.35-4.55,1.14a6.13,6.13,0,0,1-1.18,1.26c-1.86,1.35-3.23-.13-4.75-.82-1-.63-1.94-1.31-1.76-2.71.25-1.12.48-2.26-1.33-1.9-1.51.3-2.19-.46-2.54-1.79a111.66,111.66,0,0,1,.14-16.46,3.42,3.42,0,0,1,1-2.6c2.13-.27,3.66.71,5,2.23a7,7,0,0,0,4,2,2.77,2.77,0,0,1,1.57.32c3.67,2.15,6.52,1.91,8.4-2.45A3.22,3.22,0,0,1,1238.28,463.25Z"
              />
              <path
                class="cls5-691"
                d="M1199.35,434c2.74.39,3.83,2.91,5.68,4.45,2.5,2.09,4.8,4.49,8.35,4.71,2.09,3.6,1.41,7.2,0,10.8-3.17,1.81-6.7,5-7.46,7.32-1,3.24-3,4.47-5,6.18-2.67.06-4.4-1.31-5.52-3.63,0-2.77.26-5.46,2.86-7.2,1-.9,2.18-2.34,3.43-2.08,2.85.59,3-1.6,3.79-3.11a2.69,2.69,0,0,0-.72-3.38c-1.08-1-2.09,0-2.93.59a50.87,50.87,0,0,1-5.35,3.87c-2.7,3.2-4.74,1.2-6.76-.87s-3.17-4-.73-6.76,4-5.93,6.14-8.8C1196.14,434.74,1197,432.85,1199.35,434Z"
              />
              <path
                class="cls5-839"
                d="M1211,499.61c.17-2.77-1.62-5.23-1.18-8.09.21-1.33-1.14-2-2.2-2.62-1.42-1.75-3.74-2.83-4-5.44.08-2,1.84-3.48,1.48-5.56.09-1.07.77-1.49,1.75-1.57,4.29-.11-.68-2.3.69-3.06.22-3.75,3.6-4.81,5.83-6.86,1.77,2.63.69,5.58.86,8.38s.07,5.75,0,8.61c-1.22,3.05-1.81,5.9-.21,9.27a8.86,8.86,0,0,1-.38,7.87C1212.5,501.12,1211.69,500.61,1211,499.61Z"
              />
              <path
                class="cls5-840"
                d="M1237.58,473.94c-3.66-3.19-.71-5.65.93-8.25,5.85-2,6.64-1.73,12.21,3.51,1.09,1,2.31,1.94,3.47,2.9a19.92,19.92,0,0,1-12.19,7.06,2.12,2.12,0,0,1-1.1-1.25A8.37,8.37,0,0,0,1237.58,473.94Z"
              />
              <path
                class="cls5-841"
                d="M1241.78,478.61c.61-.49,1.24-1.41,1.82-1.39a7.78,7.78,0,0,0,7.31-3.86,3.6,3.6,0,0,1,3.28-1.26,22.64,22.64,0,0,1,2.57,1.89c2.46,2.42,4.22,1.53,5.68-1.09,0,2.23-2.52,5.19,1.74,6.23a3.13,3.13,0,0,1,2.51,1.44h0c-.12,3.14-.41,3.25-3.92,1.41-.89-.1-1.59.51-2.42.65a10.87,10.87,0,0,1-3.84-.6c-2-.85-.83-3.36-2.36-4.73-1.52,1.31-1.46,3-1.62,4.55a8,8,0,0,1-2.3,4.72c-1.31,1.38-2.72,1.51-3.8-.08a53.51,53.51,0,0,0-4.5-5.35C1241.21,480.33,1240.93,479.51,1241.78,478.61Z"
              />
              <path
                class="cls5-842"
                d="M1166.11,473.13c-1.1-2-4.35-2.7-3.3-5.86h0c4.92,2.32,8.62,6.43,13.29,9.12h.7c2.34.35,3.74,2.26,5.59,3.41,1.07.66,2.38,1.43,2,2.82s-2.06.94-3.2,1.17c-1.71-.05-3.39-1.27-5.15-.13a3.42,3.42,0,0,1-2.78-1.14c-1-1-1.56-.5-2,.56-1.38.84-2.12.14-2.62-1.1v-.58c.73-1.4-1.65-2.82,0-4.22C1169.11,475,1166.44,474.82,1166.11,473.13Z"
              />
              <path
                class="cls5-843"
                d="M1223.34,413.16c1.33-2,2.32-4.23,4.19-5.84,3.89.95,6.62,3.85,9.65,6.13,2.65,2,1.3,4.66-2.92,6.27-.92,1.07-1.9.79-2.91.14-2.11-2.3-3.45-5.63-7.43-5.41C1223.4,414.48,1223.19,413.76,1223.34,413.16Z"
              />
              <path
                class="cls5-844"
                d="M1238.28,463.25a6,6,0,0,0-4.28,4.15c-1.28,3.91-3.43,3.69-6.3,2-1.15-.67-2.79-.51-3.4-2.06v-.23a14.19,14.19,0,0,0,3.3-3.17c-.48-2.15,1.13-3.54,2-5.16a1.64,1.64,0,0,1,2.12-.93,1.61,1.61,0,0,1,.63.43C1234.3,460,1236.29,461.6,1238.28,463.25Z"
              />
              <path
                class="cls5-845"
                d="M1215.3,450.6v-5.71c1.75,1.28,2.68-.2,3.89-1.06,1.67-1.19,3.44-.83,5,.25s.4,2.19.14,3.33a2,2,0,0,1-2.3,1.65,2,2,0,0,1-.58-.19C1218.77,447.57,1217.07,449,1215.3,450.6Z"
              />
              <path
                class="cls5-846"
                d="M1184.41,503.05c3,1.8,6.38,3.1,9,5.64-.6,1.15-1.71,1.07-2.75,1.14h-.53l-7.35-.11c-1.72-1.67-.29-3.39-.08-5.09Z"
              />
              <path
                class="cls5-847"
                d="M1226,426.44v-4.93c2-.66,1-3.1,2.35-4.12,2-.11,2.13,1.79,3.1,2.79,1.27,2.75,2.32,5.46-1.48,7.16C1228.37,428.58,1227.46,426.34,1226,426.44Z"
              />
              <path
                class="cls5-848"
                d="M1202.76,506.31c3.9-.53,4.17-4.76,6.75-6.63l1.53-.07,2.4.85c1-.38,1.56.18,2.06.91a2,2,0,0,1-.12,1.74c-2.13,1-4.94.56-6.28,3.12-1.24,1-1.94,2.56-3.48,3.23a3.93,3.93,0,0,1-3.7-.33C1201.15,507.87,1201.94,507.08,1202.76,506.31Z"
              />
              <path
                class="cls5-849"
                d="M1225.36,459.42l2.15-.72c-.38,1.76-1.55,3.54.08,5.27.33,2.55-.62,3.77-3.3,3.17a11.6,11.6,0,0,0-1.31-1.57c-2.11-1.8-2.56-3.23.73-4C1224.79,461.26,1226,461.05,1225.36,459.42Z"
              />
              <path
                class="cls5-850"
                d="M1240.89,444c0,1.79,1.33,2.89,2.77,4.92-2.68-1.09-5.41-1.1-5.83-3.55-.37-2.08,1.93-1.11,3.11-1.33Z"
              />
              <path
                class="cls5-851"
                d="M1240.94,444c-.4-1-1.49-2-.41-3s2,.27,2.82.88,1.64,1.29,3.16,2.5l-5.62-.44Z"
              />
              <path
                class="cls5-852"
                d="M1240.61,453l-4.22-2.4-1.68-2.19C1237.38,449.12,1240,449.8,1240.61,453Z"
              />
              <path
                class="cls5-431"
                d="M1231.69,419.2l-.82.7-2.44-2.51c-.54-1-1.6-2.16-2.5-1.41-2.26,1.89-3-.22-4.22-1.21.55-.53,1.09-1.07,1.63-1.61C1226.74,414.32,1230.18,415.43,1231.69,419.2Z"
              />
              <path
                class="cls5-853"
                d="M1213.52,434c0,.59-.06,1.17-.1,1.76-2.61.13-5.05.35-2.92-3.62,1-1.95,1.3-4.21-1.73-5.25-.77-.26-1.25-1.35-1.87-2.06a6.78,6.78,0,0,0,1.6.38c4.29.11,6.24,1.79,4.41,6.27C1212.59,432.28,1212.31,433.42,1213.52,434Z"
              />
              <path
                class="cls5-526"
                d="M1286,494c.46,1.1-2,.38-1.1,1.74-1.9.25-2.62,3-4.93,2.39-.23-.9-2.13-1.66-.77-2.59,1.61-1.1,3.32-2.68,5.65-1.68Z"
              />
              <path
                class="cls5-854"
                d="M1210.93,543.62c1.72,3-1,4.25-2.42,6a2.28,2.28,0,0,1-.9,1.52,1.71,1.71,0,0,1-2.21.07,12,12,0,0,1,.14-11.39,8.31,8.31,0,0,0,1-5.93,2.3,2.3,0,0,0-2.31-2c-1.39,0-1.85,1-2,2.18A23.32,23.32,0,0,0,1202,537c-.09,3-1.06,5.36-3.8,6.81-3.15.77-3.52-2.84-5.76-3.78,3,6,3,6.06-.45,9a2.13,2.13,0,0,1-1.12,0,7.45,7.45,0,0,1-2.54-2.09c-1.52-1.83-3-1.57-4.52-.07-1.17.7-2.24,1.63-3.72,1.61-4.16-1.49-6.3-4.77-7.71-8.71.63-2.17,2.26-3.67,3.59-5.37a14.84,14.84,0,0,0,7.24-4.24,11.58,11.58,0,0,1,3.54-1.83,12.36,12.36,0,0,1,6.9.13c1.81,1.36,3.29,2.34,5.43,0s1.27-3.71-.44-5.4a7.62,7.62,0,0,1-1.16-1.66c-.67-2.17-3.4-4.91,1.49-5.6a15.57,15.57,0,0,1,4.89,3.58c.84,1.69,1.55,3.53,4,3.28a7.5,7.5,0,0,1,4,3.29c1,1.35,2.15,1.31,3.49,1.15a29.67,29.67,0,0,0,4.08,4c1.35,2,1.11,4.34,1.68,6.52a6,6,0,0,1-.12,1.89c-.28.86-.73,1.54-1.76,1.55l-2.33,1C1214.29,540.47,1212.63,542.12,1210.93,543.62Z"
              />
              <path
                class="cls5-855"
                d="M1219.27,523.87c2.3.88,2.7,4.43,5.83,4.14,2,2.74-.15,5.5,0,8.24l-.54.19c-2.66-1.08-3.37-4.44-6.19-5.32-1.56-.84-3.78-1.08-3.39-3.7C1215,524.53,1217,524.06,1219.27,523.87Z"
              />
              <path
                class="cls5-856"
                d="M1226.17,537.31l7.21-5.93.51.45-12.12,15.08c-1.14-1.12-.77-2.26-1-3.24C1221.71,540.81,1223.18,538.41,1226.17,537.31Z"
              />
              <path
                class="cls5-857"
                d="M1208.47,559.45c0-1.15-.29-2.37.78-3.25l4.2-2.39c.63,2.49.53,4.79-1.73,6.52a2.3,2.3,0,0,1-3.18.36.87.87,0,0,1-.08-1.23Z"
              />
              <path
                class="cls5-273"
                d="M1226.17,537.31l-5.37,6.36-1.65-2.71c.36-.48.72-1,1.09-1.42a29.68,29.68,0,0,1,2.57-1.88,8.16,8.16,0,0,1,2.25-1.35l.06-.06Z"
              />
              <path
                class="cls5-858"
                d="M1211.91,549.65l-3.36,2.6c-1.43,0-1.41-.85-1-1.87l.93-.79C1209.64,549.94,1210.81,547.85,1211.91,549.65Z"
              />
              <path
                class="cls5-509"
                d="M1226,509.69l17.4.13c-2.27,1.54-3.66,3-.3,5,4.55,2.7,1.75,5.06-.52,7.39-1.59-1-3-2.4-5-2.58l-2.45-1.65a57.94,57.94,0,0,1-9.36-6.65A1.43,1.43,0,0,1,1226,509.69Z"
              />
              <path
                class="cls5-859"
                d="M1213.67,562.08a10.24,10.24,0,0,1-5,3.23c.3-2.66,2.83-2.82,3.91-4.25Z"
              />
              <path
                class="cls5-860"
                d="M1229.41,572.78l1.59,1.73c.09,3.81-3.11,4.45-5.59,5.79l-2.09-2.31a7.8,7.8,0,0,1-.51-1.5,4.38,4.38,0,0,0-.72-2.92,4.79,4.79,0,0,1-.5-2.68C1224.65,569.62,1226.94,571.55,1229.41,572.78Z"
              />
              <path
                class="cls5-861"
                d="M1207.59,593.69c-1-1.67-2.53-3.24-1-5.54,1.43.57,2.62,4.15,4.47.57l1.5-.72a3.21,3.21,0,0,1,1.4,3.93c-.72,1.21-1,2.69-2.31,3.55C1208.94,598,1209,594.15,1207.59,593.69Z"
              />
              <path
                class="cls5-511"
                d="M1228.78,582.11c1.46-.75,1.64-3,3.57-2.85.2,0,.53.88.52.89C1231.56,581,1231.06,583.29,1228.78,582.11Z"
              />
              <path
                class="cls5-862"
                d="M1215.13,592c-1.56-4.69,2.13-4.74,4.93-5.58,0,2.6.07,5.21,0,7.81,0,1.17-.09,2.54-1.76,1C1217.51,593.88,1216.17,593.06,1215.13,592Z"
              />
              <path
                class="cls5-278"
                d="M1215.13,592c2.4-.23,3.95.39,3.2,3.26-1.25.22-2.73-.28-3.59,1.21-.42.72,0,2.18-1.49,2-1.66-.26-1.15-1.88-1.57-2.91.25-1.37-.68-3.35,1.83-3.54Z"
              />
              <path
                class="cls5-863"
                d="M1215.11,503.12v-1.78c-1.42-2.79-.75-5.74-.62-8.65,1.93-2.62,4.18-3.9,7.25-1.71a1.61,1.61,0,0,1-.08,2.26l-.06.05c-1.15.79-3.14,0-3.77,2.2,1.67.84,4-2.09,5.22.69a3.57,3.57,0,0,1,.06,1.13,9.14,9.14,0,0,1-1.57,3.7c-.54.16.13.49.21.35.47-.77,1.33-.74,2.15-.68,1.07.11,1.82,1.66,3.14.7a3.16,3.16,0,0,1,1.55-.47,4.56,4.56,0,0,1,2.84,1.86c2,3.9,3.49-.63,5.25-.34h.38a1.73,1.73,0,0,1,.37.16c-1.43-2.92-.69-4.78,2.64-5.35a6.49,6.49,0,0,1,.77-.11,2.13,2.13,0,0,1,1.48,1.24,6.23,6.23,0,0,1,.09,4c-1.08,1.41-2,3.16-4.25,2.43-.41,0-1.12-.08-1.17.05-2,5.94-7.12,3.43-11.08,4-3,2.18-4.67-.92-6.91-1.75C1217.79,505.72,1214.38,506.45,1215.11,503.12Z"
              />
              <path
                class="cls5-527"
                d="M1238.19,504.82a4.28,4.28,0,0,0,3.6-2.72c1.55-.27,3-.26,3.37,1.7l-1.08,1.14c-1.08-.42-2.1-1.09-3.22.06a1.58,1.58,0,0,1-2.21.35A1.56,1.56,0,0,1,1238.19,504.82Z"
              />
              <path
                class="cls5-527"
                d="M1246.53,503c-2.64-1.61-.57-3.24,0-4.87.61.52,1.22,1,1.82,1.57,2.2.05,2.72,1.77,3.36,3.37C1249.93,504.83,1248.23,503.65,1246.53,503Z"
              />
              <path
                class="cls5-864"
                d="M1260.8,487.25c.85-.18,1.17-2,2.48-.79a2,2,0,0,1,1.89,2.1,1.09,1.09,0,0,1,0,.26c-1.58,1.75-4.17,2.92-3.41,6l-.92.73c-2.29-.36-5.12-.3-3.23-4C1257.23,489,1258.53,487.77,1260.8,487.25Z"
              />
              <path
                class="cls5-286"
                d="M1256,498a2.66,2.66,0,0,0,.79-.12,1.37,1.37,0,0,1,.63,1.72c-.21.79.46,2.24-1,2.19s-1.6-1.27-1.28-2.44A6,6,0,0,1,1256,498Z"
              />
              <path
                class="cls5-865"
                d="M1114.49,409a5.57,5.57,0,0,1,2.58-3.3c.86,1.94,2.6,1.72,4.25,1.71,11.9-.08,23.8.45,35.7-.3a2.58,2.58,0,0,0,2.54-1.52l.91.24c2.75,2.12,4.87,5.37,9,4.88,2.77-.29,4.12,1.68,5.54,3.52-2.17,6.23-7,10.77-10.31,16.27-.57.94-1.27,1.8-1.91,2.69,0,4-3.22,5-6,6.05-2.16.81-3.43-.93-4.19-2.84-1.1-3.31-4.5-4.19-6.77-6.24s-3.56-3.85-3-6.73-2.46-4.82-2.21-7.7c0-.62-.94-.94-1.66-.91-3.93.15-8.2-.91-11.13,3-2.61,1-4-1.44-6.09-2.08-1.78-1-3.33-2.27-5-3.33C1115.52,411.65,1114.05,410.91,1114.49,409Z"
              />
              <path
                class="cls5-690"
                d="M1183.59,424c1.5-.32,2.69-.4,3.91,1.15,2.17,2.78,4.52,5.69,8.92,4,.6-.23,3.23-1.34,2.11,1.58a94.5,94.5,0,0,1-14,20h0c-5.12-1.28-8.94-4.67-12.28-8.37-2.53-2.8,1.12-4.53,2.25-6.65C1177.17,431.57,1179.81,427.35,1183.59,424Z"
              />
              <path
                class="cls5-866"
                d="M1174.45,435.72c-2.63,6-2.6,6,3.52,10.09,2.26,1.51,4.34,3.28,6.51,4.93.59,1.15,2.5,2.45,1.35,3.47-1.45,1.28-3-1.26-4.74-1.11-.89.51-1.61,0-2.22-.5-3.44-2.9-7.24-5.34-10.6-8.33-.39-2.55-.71-5.15-4-5.58-.81-.08-1.62-.16-2-1.05a4.06,4.06,0,0,1,.7-3.56,4.84,4.84,0,0,1,4.81,1.64C1170.08,438.23,1172.21,438.14,1174.45,435.72Z"
              />
              <path
                class="cls5-867"
                d="M1175,414.23c-2.4-.29-3.5-2.65-5.54-3.52-.5-2.45-3.41-1.89-4.69-3.65,5.15-2.21,7.64,2.54,11.3,3.95C1176.46,412.32,1176.8,413.62,1175,414.23Z"
              />
              <path
                class="cls5-868"
                d="M1184.48,450.73c2.68-4.92,6.35-9.16,9.78-13.53,1.62-2.06,1.53-5.2,4.27-6.44a5.58,5.58,0,0,0,.82,3.26c-2.13.13-2.84,1.86-3.81,3.34-1.65,2.5-3.41,4.94-5,7.49-.73,1.17-2.81,1.63-2.08,3.57.86,2.28,3,3.55,4.74,4.93,1.22,1,1.39-1.68,2.65-1.87,1.53,1.63.15,5,3.38,5.62-2.89,1.48-2.42,4.54-3.26,7-1.7-.83-3-2.36-5-2.73-1.56-2.12-3.23-4.07-3.47-7C1187.43,452.84,1186.8,450.84,1184.48,450.73Z"
              />
              <path
                class="cls5-869"
                d="M1205.1,418.94c-2.32,1.24-2,5.39-5.67,5.15l-1.68-.62c.81-3,3.46-4.75,4.57-7.15-1.68,2.14-3.12,4.87-5.48,6.87a4.41,4.41,0,0,1-3.28-1.62c2.81-1.95,3.88-5.25,6-7.74,1-1.21,1.85-4,3.9-2.37,1.67,1.33,4.67,3.16,2.06,6.32A3.44,3.44,0,0,0,1205.1,418.94Z"
              />
              <path
                class="cls5-870"
                d="M1109.82,407.38c-.15,2.28-.31,4.56-.47,6.95-2.54-1-4.35-2.89-6.41-4.44l-4-3.26h5.56c1.59-.85,1.72,1.12,2.71,1.41C1108.1,407.84,1108.05,404,1109.82,407.38Z"
              />
              <path
                class="cls5-871"
                d="M1069.7,377.5l1.71,1.64-2.41,1.47a.78.78,0,0,1,.09,1.09l-.15.13c-.27,1.4-1.17,1.85-2.26,1-.92-.67-2.6-1.35-1.17-3.05.5-1-.21-2.28.76-3.16l2.69.73A3.14,3.14,0,0,0,1069.7,377.5Z"
              />
              <path
                class="cls5-872"
                d="M1146.91,376.79c-.43-1.82-3.36-2.88-2.17-5a27.86,27.86,0,0,1,6.4-7.92c.8-.66,1.58-.27,2.18.38a4.39,4.39,0,0,0,3.62,1.6c4.34,5.17,4.24,5.1.39,11.08-1.8,2.79-3.55,4.1-6.55,1.65a4,4,0,0,0-3-1.05Z"
              />
              <path
                class="cls5-873"
                d="M1146.33,386.72c2.5.57,2.08-4.09,3.79-2.82,2.14,1.58-2,2.79-1.46,4.88a11.17,11.17,0,0,1,0,2.83h-.89C1145.42,390.52,1145.63,388.69,1146.33,386.72Z"
              />
              <path
                class="cls5-296"
                d="M1142.69,389.65a13,13,0,0,1-5.27-3.56C1141.4,383.87,1141.48,383.91,1142.69,389.65Z"
              />
              <path
                class="cls5-874"
                d="M1162.9,386.56c1.23-1.45,2.34-3.3,4.68-2.08,2.86,1.49,6.17,2.5,7.57,5.83.47,1.1-.28,2.09-1.08,2.92a14.93,14.93,0,0,0-1.89,2.16c-3.87,5.8-3.86,5.81-9.28,1.18-1.44-3.05-1.15-6.11-.14-9.19Z"
              />
              <path
                class="cls5-875"
                d="M1115.57,420.6a15.24,15.24,0,0,0-3.73-4.15c-1.65-1.5-3.1-3.64.76-4.63,1.72-.44,1.42-1.22.21-2.12-.9-.67-2.53-.6-2.46-2.31,1.74-.39,2.74,1.13,4.15,1.61,2,2.75,5.42,3.68,7.77,6,2.38,2.8.22,3.49-1.94,4.18a15.22,15.22,0,0,0-1.65.39C1117.62,419.83,1117.19,422.06,1115.57,420.6Z"
              />
              <path
                class="cls5-876"
                d="M1103.77,562.06c3.81-.63,5.6.61,5,4.8-.33,2.57.07,5.22,0,7.83,0,1.28.63,3-1,3.7-2,.93-3.64-.52-5.25-1.53a3,3,0,0,1-1-4c.74-1.64.94-3.54,1.75-4.92,1.23-2.08.6-3.9.45-5.86Z"
              />
              <path
                class="cls5-877"
                d="M1134.7,560.21h-5.25c-1.58-2.1-.68-6,1.74-7.53,3.07-2,10.63-.39,12.7,2.62a3.45,3.45,0,0,1,.46,3.14c-.44,1.42-1.75,1-2.79,1.14C1139.28,559.9,1136.89,559,1134.7,560.21Z"
              />
              <path
                class="cls5-878"
                d="M1081,464.78l-1.21-.8c-1-1.5-2.64-2.31-4-3.42-1.57-1.29-2.24-2.68-1.25-4.61a6.09,6.09,0,0,1,.72-.95,4.61,4.61,0,0,1,3.69-1.68c2.33,1,4.12.51,5.5-1.74,1.14-1.84,2.67-3.42,3.75-5.31,1.83-3.31,4.71-5.86,6.48-9.21a9.43,9.43,0,0,1,1.13-1.74c4.35-5.53,4.35-5.53-.44-10.12-.42-1.1.42-1.67,1-2.37a14.28,14.28,0,0,0,1.13-1.83,1.43,1.43,0,0,1,.91-.6c2.93.54,4.59,3.35,7.39,4.13,3.48,2.13,5.62,4.88,4.25,8.49.13-2.57.48-3.26,2-3.34,1.83-.1,5.36,2.87,5.64,4.79a3.59,3.59,0,0,1-.6,2.36,2.77,2.77,0,0,1-.8.8,5.77,5.77,0,0,0-5.73,2.07c-1.37.89-2.62.9-3.71-.45-.42-1.67-1.72-3-1.59-5a6.61,6.61,0,0,0-4,5.72c-.14,2,2.38,1.27,3.4,2.25a2.78,2.78,0,0,1,0,2.36,2.17,2.17,0,0,1-2.28,1.62,4.64,4.64,0,0,1-2.16-1.07c-1.69-1.35-3.2-1.35-4.44.58-1.14,1.77-1,3.32.83,4.56a5.7,5.7,0,0,1,1.57,1.27c.14,1.87-.52,3.18-2.5,3.56-4.12-3.57-4.15-3.58-7.08,1.14-1.23,2-2.33,4.05-4.71,4.92C1082.2,461.74,1082.52,464,1081,464.78Z"
              />
              <path
                class="cls5-879"
                d="M1145.44,497.2c2.42,1.06,1.83,4.32,4.31,5.68,1,.57-.47,2.62-1.9,3.36-1.66.85-3.35,1.66-5,2.48a4.74,4.74,0,0,1-5-.07c.92-1,2.27-.32,3.38-.86-.45-.86-1.92-.89-1.73-2.18-1.51-1-1.87-3.39-4.17-3.39h0c-2.29-2-5.42-2.9-7.06-5.69-.23-3.63,2.35-3.6,4.82-3.73,3.64,1.88,8.65,1.26,10.86,5.83C1144.37,498.05,1144.6,497.33,1145.44,497.2Z"
              />
              <path
                class="cls5-880"
                d="M1057.48,434.11c4.22,2,7.53,5.32,11.41,7.8,2.35,1.51,2.48,3.36.94,5.51-.47,2.39-1.21,4.76.28,7.1a2.29,2.29,0,0,1-.24,2.7c-1.39-1.42-2.41-3.24-5.06-2.5-1.56.44-2.59-1.08-3.41-2.35,1.45-.87,3.27-1.34,3.52-3.58-1,1.78-2.36,3-4.52,2.75-.81.69-.57,1.69-.76,2.57-1.15-.81.06-2.67-1.47-3.3a1.51,1.51,0,0,1-.42-1c.69-1.73-.48-2.46-1.68-3.21-1.84-1.18-4-2.1-5.29-3.84-1.17-1.56-3.33-3.65.33-5.09C1054.35,438.48,1054.8,434.27,1057.48,434.11Z"
              />
              <path
                class="cls5-881"
                d="M1093.12,471.44c.34-3.74,2-7.5-.13-11.19-.27-.46-1-1-.37-1.35s1.28.07,1.93.13a7.16,7.16,0,0,0,4.52-1.33c2.27.21,2.25,1.22,1.39,2.26.88-3.24,3.44-6.12,5.69-9.19.77-1,1.65-2.83,3.17-1.83,1.71,1.13.42,2.77-.34,4a75.67,75.67,0,0,1-8.62,11c.49,2,4.86.26,3.6,3.14s-3.33-1.32-5.71-.13c2.64,1.92,5.09,3.64,7.48,5.44,1.38,1,3.15,1.84,3,4-2.57-2.7-6.32-3.79-8.82-6.64-1.33-1.52-3.1-1.89-4.5.16A2.84,2.84,0,0,1,1093.12,471.44Z"
              />
              <path
                class="cls5-882"
                d="M1097.18,495.59c-2.74.17-4-2.16-6-3.42.64-2.76,1.29-5.53,1.93-8.3.5-1.13,1.27-1.54,2.43-.91l.93.82C1102.39,489.13,1102.39,489.13,1097.18,495.59Z"
              />
              <path
                class="cls5-883"
                d="M1116.21,504c-1.12,4.14-3.26,4.31-6,1.47-1.29-1.33-3.42-1.83-3.94-3.93l1.59-1.91c.37-.44.69-1,1.33-1.05C1112.39,499.22,1115,500.66,1116.21,504Z"
              />
              <path
                class="cls5-305"
                d="M1124.5,490.63c-.31-1.68-3.89-2.69-1.72-4.48,1.26-1,3.09,1.22,4.19,2.7C1125.87,489.07,1126.58,491.78,1124.5,490.63Z"
              />
              <path
                class="cls5-307"
                d="M1120.43,521.52c.76,1.2,3.66,0,3.1,2.41s-2.67.25-3.89,1c-3.32-.27-5.28-1.49-3.84-5.28.45-1.17.54-2.46,2.31-2.31s1.47,1.32,1.5,2.41A2,2,0,0,0,1120.43,521.52Z"
              />
              <path
                class="cls5-308"
                d="M1100.57,529c2.12.45,4.25.86,6.36,1.36.69.16,1.87,0,1.49,1.33-.3,1.06-1.16.82-2,.69-2-.31-4-.52-6-.76C1099.08,530.62,1100,529.8,1100.57,529Z"
              />
              <path
                class="cls5-884"
                d="M960.05,432.38a16.14,16.14,0,0,1,8.32,2.45c-3.85.6-3.79,5.09-6.64,6.68-.6-1-1.51-.93-2.46-.78a1.79,1.79,0,0,1,.36-2.26C961.67,436.52,961.09,434.49,960.05,432.38Z"
              />
              <path
                class="cls5-885"
                d="M974.1,466.57a18.69,18.69,0,0,1-7.82-5.21c2.8,1.48,5.84,2.56,8,5Z"
              />
              <path
                class="cls5-886"
                d="M983.27,406.61l7.64-.2c2.72.41,5.4-.42,8.2,1.37,5.1,3.27,7.69,7.14,6.66,13.37-.51,3.07-.13,6.29-.16,9.44-.22-.49-.72-1-.62-1.46,1.78-7.3-3.52-9.81-8.39-12.73a12.07,12.07,0,0,1-4.34-3.75C990.18,409.06,985.42,409.84,983.27,406.61Z"
              />
              <path
                class="cls5-887"
                d="M1030.4,439.74c-.38-.16-1-.55-1.11-.44-3.19,3.11-6.28,1.08-9-.48-3.09-1.76-6.12-.45-9.14-.49s-3.85-1-3.76-3.83c.16-5.66.06-11.34,0-17,0-1.47.15-2.77,1.64-3.48,1.57-.41,2.36.85,3.42,1.57A81.5,81.5,0,0,0,1028,426.66c3.6,1.09,6.17,2.88,4.86,7.27-1.43,1.18-.57,2.78-.76,4.19C1031.72,438.88,1031.32,439.58,1030.4,439.74Z"
              />
              <path
                class="cls5-887"
                d="M1058.13,449.76v1.05c-.54.44.68,2.91-1.6,1.35-1.66-1.13-3.39-2.17-5.08-3.24a27.15,27.15,0,0,1-11.66-8.36l-2.48-2.4c-1.34-.37-2.71-.69-3-2.37.08-1.5-1.82-3.28,0-4.41,1.64-1,3.34.05,4.68,1.32.54,1.52.67,3.29,2.5,4,4.57,3.08,8.92,6.46,13.47,9.58C1056.23,447.14,1058.08,447.71,1058.13,449.76Z"
              />
              <path
                class="cls5-888"
                d="M1039.83,440.56l11.66,8.36c-1.46,1.52-2.5,0-3.51-.63-1.86-1.11-3.53-2.54-5.35-3.71s-3.66-2-4.87.92a3.37,3.37,0,0,1-3,1.94,1.26,1.26,0,0,1-.68-.2C1035.8,444.82,1037,442,1039.83,440.56Z"
              />
              <path
                class="cls5-889"
                d="M1004.18,401.47l1.57,1.69a2.29,2.29,0,0,1-1.74,2.54c-.91.38-1.43-.15-1.9-.8-.62-2.18-2-2.45-3.91-1.64-2.44-1.37-1.19-4.67-3.26-6.24,3.12-2.11,4.36,1.57,6.62,2.13A6,6,0,0,1,1004.18,401.47Z"
              />
              <path
                class="cls5-890"
                d="M1002.34,404.84l1.67.86c-1.47,2.16-2,2.08-5-.66v-.94C1000.48,403.06,1001.55,403.33,1002.34,404.84Z"
              />
              <path
                class="cls5-891"
                d="M1014.9,474.74c5,2.12,5.16-2.37,6.71-4.95a.7.7,0,0,1,1,0h0a2.78,2.78,0,0,1,.33,2.3,5.64,5.64,0,0,1-.48,1.1c-2.88,5.12-2.88,5.12-7.58,3.24C1014.89,475.85,1014.89,475.3,1014.9,474.74Z"
              />
              <path
                class="cls5-554"
                d="M1014.89,476.41c4.42,2.09,5.52-1.82,7.49-4.15a1.83,1.83,0,0,1,0,2.52h0c-1,1.75-1.33,3.93-3.33,5Z"
              />
              <path
                class="cls5-892"
                d="M1019.05,479.77a15.31,15.31,0,0,1,3.33-5,13.28,13.28,0,0,1-4.15,8.4A5.72,5.72,0,0,1,1019.05,479.77Z"
              />
              <path
                class="cls5-893"
                d="M1022.37,474.78v-2.52h0a4.11,4.11,0,0,0,.78-1.38,4.45,4.45,0,0,1,.8-1.38c-.51,0-.88.67-1.46.28h-.87l3-5.42c.54-1,1.25-1.51,2.35-.94s1.56,1.56.94,2.41C1025.85,468.69,1025.73,472.75,1022.37,474.78Z"
              />
              <path
                class="cls5-894"
                d="M1043,472.24c.57,1.12,1.57.84,2.51.76-1,1.47-1.89,3-3,4.39-.52.68-1.25,1.83-2.31,1a1.84,1.84,0,0,1,0-2.6l0,0C1041.21,474.59,1041.59,473,1043,472.24Z"
              />
              <path
                class="cls5-895"
                d="M1187.93,526c0-2.46-3.91-3.29-2.6-6.28a10,10,0,0,0,3.19-3.51c2.61-2.7,3.92.21,5.65,1.31,2,1.73,1.36,3.63-.15,5C1192.3,524.05,1191.46,527.5,1187.93,526Z"
              />
              <path
                class="cls5-846"
                d="M1193.64,518.08c-1.55-1.06-2.63-3.4-5.12-1.9.25-1.68-1.59-.42-2-1.63,2.78-.36,4.74-1.48,3.59-4.74l.16-.14c2.3-.69,4.31-.87,3.67,2.55-.29,1.56.74,2.57,1.14,3.84S1196.1,518.82,1193.64,518.08Z"
              />
              <path
                class="cls5-896"
                d="M1176,583.83c3.86.19,5.89-2.84,8.24-5,1.19-1.1,2.15-2.7,3.64-3.17,3.68-1.17,3.36-3.49,2.28-6.23,3.14,1.37,5.61.31,8.06-1.83a70.55,70.55,0,0,0,6-5.73c1-1.07,1.67-2.65,3.54-2.47a1.1,1.1,0,0,0,.69.08v.83c.23,1.72-3.88,7.25-6,8.1a6.12,6.12,0,0,0-3.88,3.24c-1.64,1.14-3.3,2.27-4.92,3.44-1.36,1-1.29,2.26,0,3,1.66,1,1.59,2.41,1.56,3.93-1.48-.73-2.29-2.11-3.25-3.35-3.33-2.06-4.47,1.52-6,2.84s1.27,2.45,1.94,3.78c-.38.56-.79.57-1.35.17-1.12-.8-1.93-3.38-3.43-2s-5,1.85-4.45,5.26a15.32,15.32,0,0,1-7.51.6Z"
              />
              <path
                class="cls5-897"
                d="M1183.2,563.9c.35.8.7,1.61,1.06,2.41,0,2.61-3.53,2.3-3.82,4.65.67,1.42,1.87,2.63,1.62,4.37a4.15,4.15,0,0,1-3.14,3.82c-2.41.44-1.41-2.43-2.5-3.4a4,4,0,0,1-1.22-2.87c-.69-3.43-.76-7-2.31-10.26-.25-.52-.14-1.71.22-1.94,2.75-1.73.2-2.94-.32-4.34l.81-1c1.45-2.21,1.9-5.56,5.75-5,2.58,2.32,3.38,5.08,1.1,7.87-1.28,1.58-.15,2.09.53,3A3,3,0,0,0,1183.2,563.9Z"
              />
              <path
                class="cls5-559"
                d="M1137.88,570.58a3.68,3.68,0,0,1-3.91,3.15,3,3,0,0,1-3.21-2.77,1.77,1.77,0,0,1,0-.23c-.11-2.68,2.57-1.85,4-2.35C1136.67,567.68,1137.16,569.5,1137.88,570.58Z"
              />
              <path
                class="cls5-898"
                d="M1212.19,577.31c-.13,1-.55,1.81-1.47,1.69a2.76,2.76,0,0,1-2.23-2.53,1.38,1.38,0,0,1,1.14-1.6,1.23,1.23,0,0,1,.27,0C1211.33,574.94,1211.58,576.38,1212.19,577.31Z"
              />
              <path
                class="cls5-899"
                d="M1027.22,403.22c-2.24-1.52-4.43-3.15-6.76-4.53a3.51,3.51,0,0,0-4.24.36c-2.46,2.09-2.45-.24-3-1.62-.33-2-2.84-1-3.47-2.55h-.63c-.48-.78-.08-1.49.15-2.23,1.1-3.21,0-5.49-2.65-7.53-3.62-2.8-7.06-5.83-11.41-7.45-1.25-.47-2.08-.94-2.53,1.52-.55,3-3.69,5-5.91,7.2-1,1-2.64.57-2.67-1.5l1.79-3.16c1.81-4.33,3.81-8.52,8.37-10.71.06,0,.82.4.27-.24-2.34-2.77.71-4.11,1.57-6a3.22,3.22,0,0,1,1.46-1c.73-.08,1.71,0,1.72.74.06,4.44,3.36,4.26,6.12,4.54-.46-2-.91-4.17-3.27-5.15-.64-.26-1-1.52-.36-1.7,3.68-1,2.4-4.85,4.08-7l.89-.21a5.87,5.87,0,0,1,4.68,3.33,10.34,10.34,0,0,1,.07,3.19c0,1.87,1,2.77,2.83,2.19a9.82,9.82,0,0,1,4.75-.37c5.34,2.09,9.32,6.26,14.09,9.23,1.58,1,1.74,3.06,2.67,4.57.6,1.81,0,2.89-1.95,3-.93.06-1.88-.13-2.56.74a25.27,25.27,0,0,0-2,2.6c-2.35,3.59-2.11,4.57,1.34,7,1.91,1.32,3.42,1.34,4.91-.63,1.14-1.51,1.92-3.33,3.53-4.49,1.5-.62,2.65.13,3.74,1,3.05,2.43,7,3.8,9.06,7.39.13,1.9-1.25,3-2.39,4.11-2.15,2.1-2,4,.22,5.89,2.43,2,4.22,1.84,6.45-.37,1.3-1.3.94-3.12,1.9-4.46a22.41,22.41,0,0,1,13.75,9.15,3.18,3.18,0,0,1-1.43,2.57c-1.77,1.53-4.08,3.18-3.28,5.67.85,2.66,3.66,4.1,6.05,5.31,1.52.76,3.11-.68,4-2.16.71-1.18,1.45-2,2.95-1.43a3.06,3.06,0,0,1,1.88,3c.43,4.46-3.75,8.63-8.41,8.32-4.85-3.23-10.12-5.78-14.89-9.15-1.33-.95-2.49-2.22-4.19-2.57-2.2-.57-3.58-2.28-5.17-3.71-4.1-3.75-9.12-6.24-13.34-9.83a3,3,0,0,1-.66-.91,4,4,0,0,0-2.48-3.27C1030.11,399.54,1029.78,403.24,1027.22,403.22Z"
              />
              <path
                class="cls5-900"
                d="M984.11,384.91c.54.38,1,1,1.64,1.09s6.76-7,6.52-7.59c-1.43-3.69,1.87-2.33,2.64-2.05,5.92,2.13,10.58,6.31,15.13,10.42,1.56,1.41,1.28,4.33-.06,6.52a22,22,0,0,0-6-3.42,12.67,12.67,0,0,1-1.44-.81c-2-1.09-3,.16-4,1.66s-1.65,3.53-3.63,4.32l-6.48-4.41c-1.7-1.73-5.88-.82-5.3-5Z"
              />
              <path
                class="cls5-901"
                d="M994.92,395.05l3.24-5.72c1.29-2.28,3-2.55,5-1a31.29,31.29,0,0,0-3.11,3.09c-2.54,3.54.55,5.53,1.72,8.08l-.25.51c-2.59-.12-3.65-3.68-6.62-3C994.93,396.36,994.93,395.71,994.92,395.05Z"
              />
              <path
                class="cls5-902"
                d="M983.13,346c.64,1.15,1.87,1.49,2.91,2.08,2.2,1.25,2.87,2.64.53,4.42-2.66-.78-5.89,1.54-8.14-1.48,1.36-1.25,1.4-3.46,3.18-4.4A1.45,1.45,0,0,1,983.13,346Z"
              />
              <path
                class="cls5-321"
                d="M973.54,350.13c-.47,1.53-1.18,2.63-2.94,1.44-.68-.46-1.33-1-.81-2,1-2.11,2.35-.31,3.53-.32C973.39,349.51,973.46,349.82,973.54,350.13Z"
              />
              <path
                class="cls5-322"
                d="M976.82,339.28c1.25-1,2.48.25,3.73,0a2.62,2.62,0,0,1-.74,2.41l-2.4-.62a1.33,1.33,0,0,1-.59-1.79Z"
              />
              <path
                class="cls5-719"
                d="M1010.76,358.3l-4-3.29c1.91-1.89,4.33-.23,6.41-.94a5.9,5.9,0,0,1,3.38,1c4,4.22,9.16,6.8,13.77,10.16,2,1.43,3.63,3.37,6.12,4,5.56,3.59,10.43,8.25,16.67,10.8,1.46,2.65,5.08,3.41,5.84,6.68a1.89,1.89,0,0,1,.49,1.65c-.5,2-1.36,3.42-3.76,2.23a7.56,7.56,0,0,1-1.44-1c-2-1.46-3.74-3.19-6.12-4a7.78,7.78,0,0,1-2.33-1.65c-3-2.53-5.76-5.26-9.61-6.43h-.55c-3,0-1.23-3.29-3.27-4.44-4.63-2.6-8.88-5.88-13.28-8.89C1016.09,362.5,1012.84,361.23,1010.76,358.3Z"
              />
              <path
                class="cls5-903"
                d="M997.47,356.64c5.11,2.48.75,5,.06,7.56l-.82.9c-1.4.25-2.26-.91-3.41-1.3-.12.3-.3.54-.44.49-.46-.18-.44-.59-.39-1A25.42,25.42,0,0,0,997.47,356.64Z"
              />
              <path
                class="cls5-904"
                d="M992.47,363.3l.83.5c0,2.11-.74,3.37-3.14,2.6a2.54,2.54,0,0,1,1.93-3A2.5,2.5,0,0,1,992.47,363.3Z"
              />
              <path
                class="cls5-905"
                d="M904.87,289.42c1,.11,1.84.56,1.93,1.68s-.57,1.43-1.49,1.48a1.38,1.38,0,0,1-1.58-1.14,1.23,1.23,0,0,1,0-.27C903.63,290.28,903.8,289.56,904.87,289.42Z"
              />
              <path
                class="cls5-906"
                d="M1110.6,447.16l.83-2.22a15.34,15.34,0,0,1,4.85-7.59h0c1.84-2.13,2.35-3.94-.73-5.57-1.3-.69-2.46-1.75-3.79-2.48-1.17-.64-2.18-1.31-1.47-2.88,2.5-.53,5.63-3.26,6.52,1.86,1.82-.45,3.16.49,4.46,1.53l1.46-.91c2.2-1.09,3.84-1.13,3.63,2a1.94,1.94,0,0,0,.92,2.1c7.57,4.61,14.28,10.44,21.63,15.36a14.55,14.55,0,0,0,1.5.7c2,1.1,3.79,2.62,5.85,3.65,1.23,1.7,3.38,2.26,4.72,3.82a4,4,0,0,1,.91,3.19l-1.35,3.18-11-7.33c-2.27.41-3.25-1.81-5-2.48-1.09-.6-.64-2.63-2.42-2.58-6.18-5.27-13.19-9.4-19.62-14.31-1.75-1.34-3-.87-3.51.71a12.94,12.94,0,0,1-3.64,5.32C1114.52,444.64,1114.36,447.65,1110.6,447.16Z"
              />
              <path
                class="cls5-907"
                d="M1126.24,459.74c1,0,1,2.39,2.54,1.08,2.44-.36,2.77,1.61,3.5,3.15.43,1.71,2.08,2.65,2.71,4.24.44.28-.83,1.63.89,1.22,1.36-.32,2.16.63,2.39,2a4.69,4.69,0,0,1-1.2,3.29c.27,1.22,1.88,1.82,1.56,3.32a1.64,1.64,0,0,1-1,1.38,2.5,2.5,0,0,1-2.39-.08c-2.47-2-5.37-1.51-8.17-1.62a1.13,1.13,0,0,1-1-1.16c0-1.84.88-3.4,1.61-5-3-.72-6.22-.76-7.39-4.33.32-.53.64-1.06,1-1.59C1122.59,463.39,1123.12,460.48,1126.24,459.74Z"
              />
              <path
                class="cls5-908"
                d="M1146.89,489h-2.53c-2.35-1.19-4.87-2.19-5.75-5.06l-.11-1.79c2-5,4.7-9.35,9.22-12.42,1.56,1.39,6.48.39,3.52,5,1.55,4.22.08,8.1-1.45,11.93C1149.32,487.83,1148.72,489.31,1146.89,489Z"
              />
              <path
                class="cls5-909"
                d="M1159.51,499.78l-4.23-19.71a22,22,0,0,1-.61-3.22c-.09-1.42-1.85-3.05-.29-4.15s3.46-.7,5.15.09a3.66,3.66,0,0,1,2.35,4c-1,7.37-.5,14.78-.78,22.17C1160.79,499.65,1160.36,500.13,1159.51,499.78Z"
              />
              <path
                class="cls5-910"
                d="M1155.42,490.47c1.73,3.38,1.62,7.16,2.25,10.77.51,2.87-1.26,3.1-3.15,1.75-3.84-2.74-7.31-5.87-8.35-10.81a7,7,0,0,1,5.2-5.43C1154,486,1154.2,489.05,1155.42,490.47Z"
              />
              <path
                class="cls5-911"
                d="M1169.61,489.69c-.13,1.88-2,2.6-2.68,4.16a25.84,25.84,0,0,0-1.58,3.71c-.5,1.32-1.28,2.62-2.91,1,0-2.07-.32-4.15.22-6.19.09-2.28.28-4.57.22-6.85,0-1.5.27-2.64,1.75-3.24,1-1.72-1-2.72-1-4.2-.17-.62-.68-1.51-.44-1.81.75-.95,1.37-.07,1.84.51,1.24,1.53,2.43,3.11,3.64,4.67h0C1169.56,484.09,1171,486.72,1169.61,489.69Z"
              />
              <path
                class="cls5-912"
                d="M1169.42,501.45c-.11,3,4.26,2.77,4.21,5.76-1.58,1.12-3,2-5.25,1.23s-4.09-.07-3.8,2.93l-.08.11c-.71.09-1.86.69-1.56-.79.35-1.71.53-2.52-1.82-2-1.88.39-1.87-2.2-1.24-2.32C1163.58,505.6,1165.43,501.41,1169.42,501.45Z"
              />
              <path
                class="cls5-913"
                d="M1155.42,490.47c-1.22-.25-1.54-1.38-2.18-2.22-.76-1-2.2-1.44-2.71-.45-1,2-3.61,2.26-4.36,4.38-1.77-1.52.12-2.18.73-3.15a14.83,14.83,0,0,0,3.69-11.67,4,4,0,0,1,.65-2.62c1.55.11,1.47,1.34,1.69,2.41C1153.87,481.57,1155.17,485.92,1155.42,490.47Z"
              />
              <path
                class="cls5-914"
                d="M1133.68,493.89c-1.21-2-1.45-3.8,1-5.05,3.63-1.55,4.77,2.31,7.22,3.33l3.5,5-1.3,2.69C1141.92,495.57,1137.25,495.71,1133.68,493.89Z"
              />
              <path
                class="cls5-915"
                d="M1140.45,457.26c1,2.47,3.44,3.38,5.38,4.78s2.84,2.19.1,3.68c-1.33.73-1.31,3.07-3.27,3.4a1.19,1.19,0,0,1-1.08-1.05c0-1.37,1-2.64.38-4.06a3.4,3.4,0,0,0-3.06-2.39,4.16,4.16,0,0,1-3.34-2.21,5.77,5.77,0,0,1-.64-3c1.9-2.7,3.5-.5,5.19.32Z"
              />
              <path
                class="cls5-916"
                d="M1155.33,464.82c3.88-3.41,5.11,1.23,7.46,2.47h0c-.54,2-2.57,2.1-3.9,3a3.88,3.88,0,0,1-4.31,0c-1-.8.22-2.25.47-3.41.14-.67.19-1.36.28-2Z"
              />
              <path
                class="cls5-917"
                d="M1152,513.88c-.63-1.66-2.39-2.14-3.53-3.29,4.37-2.36,8.45-.57,9.18,4a1.79,1.79,0,0,1-.39,1.44,1.45,1.45,0,0,1-1.87-.12c-1.08-.79-1.87-2.06-3.42-2.06Z"
              />
              <path
                class="cls5-918"
                d="M1163,498.76c2.61-.6,1.56-4.15,4-4.91l.06,6.66c-1.38,0-2.12,1.08-3.09,1.8-1.19.86-2.49,2.06-4,1.19s0-2.49-.34-3.72l1.59-.83.28.08A3.19,3.19,0,0,0,1163,498.76Z"
              />
              <path
                class="cls5-915"
                d="M1155.35,464.79c-.86,1.2-1.72,2.4-2.59,3.63-2-2.92-2.08-3,.36-4.64,1.18-.81,1-1.43.14-2.28s-2.36-.94-2.72-2.42c4.15.74,4.69,1.4,4.79,5.74Z"
              />
              <path
                class="cls5-919"
                d="M1138.61,484c1.56,2.1,4.7,2.39,5.76,5.06v3.31C1141.57,489.56,1138.85,487.7,1138.61,484Z"
              />
              <path
                class="cls5-920"
                d="M1141.93,492.17c-2.82-.2-4.23-3.48-7.22-3.33-.07-1.69.92-2.6,2.33-3.2Z"
              />
              <path
                class="cls5-912"
                d="M1164.76,515.78c-5-.56-5.12-.78-3.67-6.35C1162,512,1161.57,515.05,1164.76,515.78Z"
              />
              <path
                class="cls5-909"
                d="M1163.59,478.07c1.18,1.19,4.16,1.95,1,4.2C1164,480.93,1161.76,480,1163.59,478.07Z"
              />
              <path
                class="cls5-921"
                d="M1158.59,507.11c-.1,1-.4,1.63-1.27,1.53-1.31-.16-1.19-1.36-1.44-2.22s.52-.84,1-.85C1158.09,505.54,1158.62,506.22,1158.59,507.11Z"
              />
              <path
                class="cls5-922"
                d="M1260.8,487.25l-3.22,4.28c-1.77,1.29-2.86-.56-3.94-1.18a8.37,8.37,0,0,0-6.46-1.2c1.15,2.33,5.7.07,5.34,4-1.81-2.81-3.65.76-5.9-.09-3.3-1.24-1.39,3.18-3.14,4.1l-1.74.91-.87-.93a2.33,2.33,0,0,0-1.33-1.91c-1.88-1.27-2.53-2.72-.82-4.74a6.26,6.26,0,0,0,1.29-3c.49-2.85,2.89-5.73,0-8.58.19-.82.25-1.76,1.49-1.6l.27,1.25c-.73,1.58.51,2.19,1.44,3s1.92,1.56,2.79,2.42.3,3.84,2.35,3a5.37,5.37,0,0,0,3.13-4.91c0-1.36-.34-3,.84-4.24.74-.75-.31-3.23,1.64-2.38.92.4,2.92,1.59,2.37,3.6-.24.89-1,1.75.24,2.45.44.86,2.63,1.24.67,2.75-.78.6-1.4,1.48-.4,2.44s1.71.18,2.48-.43C1260.83,485.05,1260.81,486.17,1260.8,487.25Z"
              />
              <path
                class="cls5-923"
                d="M1234.29,499.77c-.1.49-.21,1-.31,1.46-.4,1.6-1.44,1.76-2.79,1.26-1.51-1.48-1.63-3,0-4.46,1.07.08,1.8,1.52,3.08.8Z"
              />
              <path
                class="cls5-844"
                d="M1241.51,477.36,1240,479c-.81-1.67-1.62-3.35-2.44-5C1239.39,474.51,1241.25,475,1241.51,477.36Z"
              />
              <path
                class="cls5-924"
                d="M1199.24,457.1c-6.39,1.3-2.76-3.45-3.38-5.62,2.25-1.5,4.45-3.1,6.8-4.46.91-.53,2.8-1.89,3-.5.31,1.79,1.68,3.25,1,5.55C1205.52,456.21,1201.13,454.62,1199.24,457.1Z"
              />
              <path
                class="cls5-743"
                d="M1209.09,445c1.42-.17,3-.77,3.3.87s-.42,2.85-1.66.39C1210.47,445.78,1209.75,445.52,1209.09,445Z"
              />
              <path
                class="cls5-925"
                d="M1262.49,480.61c.73,1,1.64,2.14.08,3-1.16.64-1.52-.58-1.89-1.42C1260.78,481.07,1261.29,480.44,1262.49,480.61Z"
              />
              <path
                class="cls5-926"
                d="M1168.57,444c4.64,2.41,8.49,5.9,12.52,9.14,2,1.65,1.57,3.07.12,5-1.31,1.76-1.8.63-2.64-.09,0-.22-.07-.43-.09-.65-.42-1.1-1.5-1.27-2.39-1.72a17.66,17.66,0,0,1-5.81-4.52c-1.55-2.06-4.29-2.14-6.22-3.59a2.75,2.75,0,0,1,0-1.21C1165.23,444.86,1166.1,442.91,1168.57,444Z"
              />
              <path
                class="cls5-927"
                d="M1180.23,489.8c-.8.1-.82,1.69-1.78,1.16-.75-.42-.16-1.15.23-1.68l3.33-4.46c2.73-1.29,2.9,1.72,4.53,2.38-.92,1.23-1.63,0-2.35.2C1182.89,488.23,1182.08,489.88,1180.23,489.8Z"
              />
              <path
                class="cls5-928"
                d="M1191.82,496.42c.44-2.15,1.59-4.5,3.76-4,2.71.6,5.64,2,6.17,5.49-1.09,1-.87,2.91-2.43,3.61-2.18-1-5.19-.9-5.35-4.49C1193.93,496.16,1192.61,496.44,1191.82,496.42Z"
              />
              <path
                class="cls5-929"
                d="M1202.76,506.31l-.83,2.51c-2.48,1.68-4.93,1.8-7.35-.1-.09-.54-.18-1.07-.26-1.6,0-1.75,1.15-2.63,2.64-3.18l2.25-.85Z"
              />
              <path
                class="cls5-345"
                d="M1197,503.94l-2.64,3.18c-1.18-.68-3.32-.61-2.57-2.85.47-1.44,1.46-3,2.93-3.17S1197,502.36,1197,503.94Z"
              />
              <path
                class="cls5-930"
                d="M1214.47,516.33l.61-.07c1,.63.86,1.59.8,2.53-.23,2.61,2.62,3.14,3.39,5.08-1,1.71-3.56,1.5-4.27,3.55-.92.88-1.5,3.17-2.92.11-.85-1.82-2.87-3.09-4.36-4.6-2-.3-3.28-1.63-4.36-3.2-1.43-1.05-3.07-1.83-4.11-3.36-.48-.62-1.42-1.29-1.36-1.86.19-1.75-4.38-1.25-1.79-3.78,1.71-1.67,6.61-1.21,8.27.52l-.06.57c-.71,1.35-1,2.54.76,3.4s2.85,2.16,4.45,3C1212.05,519.9,1212.78,516.85,1214.47,516.33Z"
              />
              <path
                class="cls5-931"
                d="M1193.49,528.83c-1.55-3.22,0-5.45,5-7.39.25.32.52.62.74.95.92,1.42,3.58,2.33,2.91,3.91a11.67,11.67,0,0,1-4.64,5C1195.4,532.52,1194.89,529.6,1193.49,528.83Z"
              />
              <path
                class="cls5-351"
                d="M1191,548.85c.09.52.19,1,.28,1.57-3.33.79-5,4.05-8.31,5.43.33-2.71-.42-5-2.88-6.3l.3-1.48,3.07-1.91c1.18-.39,2.43-1.77,3.53,0,1,1.59-.54,2.43-1.59,3.83,1.81-2,3.39-2.85,5.38-1.12Z"
              />
              <path
                class="cls5-353"
                d="M1176.29,534.74l-.08-2.61a3.44,3.44,0,0,1,2.37-1.74c1.7.86,3.44-4.2,5.12,0C1181.88,533,1179.87,535.21,1176.29,534.74Z"
              />
              <path
                class="cls5-932"
                d="M1186,530.23c2,1.61,3.49,2.69,4.86,3.84.52.44.91,1,.24,1.71a1,1,0,0,1-1.39.24.18.18,0,0,1-.07,0A9.47,9.47,0,0,1,1186,530.23Z"
              />
              <path
                class="cls5-933"
                d="M1220.17,538c1.09-1.11,2.18-2.57,3.28,0-.78,1.12-1.69,2-3.21,1.59C1220.21,539,1220.19,538.49,1220.17,538Z"
              />
              <path
                class="cls5-934"
                d="M1215.88,518.79c-.91-.64-.66-1.64-.8-2.53l2.4-4.14a4.83,4.83,0,0,1,2-2.37c2.45-.59,4.35,1,6.49,1.61,2.79,3.71,2.64,4.15-1.86,5.18C1220,512.19,1218.16,516.39,1215.88,518.79Z"
              />
              <path
                class="cls5-935"
                d="M1223.41,576.2c-3.8.59-6.38-.85-7.59-4.57,2.71-.8,2.84,7.17,6.83,2C1225.06,573.84,1224.15,575,1223.41,576.2Z"
              />
              <path
                class="cls5-354"
                d="M1221.7,491.59l2.43,1.64c1.39,2,4.64,2,5.37,4.74a3.27,3.27,0,0,1-.79,3.29l-1.14,1c-3.31-.61-2.8-3.81-4-5.86-.29-1.6-3-1.15-2.76-3.18A1.49,1.49,0,0,0,1221.7,491.59Z"
              />
              <path
                class="cls5-936"
                d="M1164.49,437.34c.93,2.14,1.59,4.25-.28,6.29-1,1.13-.09,2,.5,2.91a2.39,2.39,0,0,0-.31.69,7,7,0,0,0-.78.13c-2.83-2.2-2.23-4.83-.93-7.55.08-.58.17-1.16.26-1.74Z"
              />
              <path
                class="cls5-937"
                d="M1161.67,440c-.3,2.52-.46,5.18-4.27,4.42-.47-1.5,1-2.33,1.28-3.56Z"
              />
              <path
                class="cls5-865"
                d="M1148.78,434.09a4.37,4.37,0,0,1,4.07,1.6c-2-.56-3,1.35-4.55,1.92C1147.5,436.23,1148.81,435.26,1148.78,434.09Z"
              />
              <path
                class="cls5-938"
                d="M1081.38,407.26c4.09-1.29,8-2.09,11.41,1.77,1.88,2.12,5,2.8,6.9,5,.25.34.49.69.73,1a3.46,3.46,0,0,0,2.46,3.57,10,10,0,0,1,4.37,3.54c.71.89,1.71,2,.07,3.05-.87.2-1.39-.53-2.1-.78-3.76-1.34-6.22-4.87-10.1-6-1.67-.54-2.73-1.91-4-3a38.15,38.15,0,0,0-4.55-3.12,6.73,6.73,0,0,1-.93-.65C1084.28,410.15,1081.83,409.66,1081.38,407.26Z"
              />
              <path
                class="cls5-939"
                d="M1107.12,424.93c-.09-3.4-2.79-4.38-5.21-5.58-1.94-1-3.74-1.89-1.49-4.28,3,2.73,7.75,3.3,9.32,7.87.47,1.35,1.58-1.54,2.38-.19,1.14,1.9,4.15.84,4.74,2.54.83,2.4,4,2.1,4.4,4.54-.91,1.16-2.63-3-3.37.51-.06.28-2.43-.53-2.26-1.57.63-4-1.39-2.68-3.35-1.91-.43.17-1.06-.15-1.59-.25C1110,425.08,1107.28,427.69,1107.12,424.93Z"
              />
              <path
                class="cls5-940"
                d="M1071.35,408.59c-3.39-4.37-8.47-6.45-12.82-9.51a6.47,6.47,0,0,1-5.21-4.07,4.62,4.62,0,0,1,2-4.36c3.38.15,5.47,3.44,8.83,3.64a2,2,0,0,1,1.84,1.17,8.34,8.34,0,0,0,5.19,5.21,13,13,0,0,1,4,2.76c1.26,1.09,2.49,2.2,3.78,3.25l.72.83c2.71.61,4.44,2.88,6.81,4.05h0c1.11,1.25,2.8,1.81,3.83,3.16,0,2,2.31,4.53-1.32,5.68-3.67-1-6.32-3.75-9.46-5.65C1076.85,412.5,1073.73,411,1071.35,408.59Z"
              />
              <path
                class="cls5-941"
                d="M1065.53,395.9a1.54,1.54,0,0,0-1.55-1c-5-1.94-5.67-2.76-5-6.68v-1.56c1.41-1.74,2.23.12,3,.66,8,5.52,16,11.13,24.64,17.2l-8.53.42c-1.63.57-2.33-1-3.5-1.51C1071.88,400.53,1067.46,399.72,1065.53,395.9Z"
              />
              <path
                class="cls5-942"
                d="M1095.15,437.32c-1.26,3.7-4.07,6.35-6.29,9.4-2.44,2.63-3.8-.63-5.64-1.09a5,5,0,0,1-3.08-3.11c-.51-2.45,2.26-3.77,2.12-6.1a4.56,4.56,0,0,1,.46-1.12c2.71-4.52,3.29-4.68,7.84-2.19A11.16,11.16,0,0,1,1095.15,437.32Z"
              />
              <path
                class="cls5-943"
                d="M1095.15,437.32l-4.71-3.21c-4.14-3.69-3.27-6.82,2.93-10.52a2,2,0,0,1,2.08,1c6.86,4.83,6.87,4.83,1.18,11.34A19.46,19.46,0,0,1,1095.15,437.32Z"
              />
              <path
                class="cls5-368"
                d="M1102.23,451.58c.1,1.52-.78,2.4-1.87,3.34-.91.78-2.21,1.66-1.43,3.29-1.15,1.93-2.35,3.54-4.38.82a3.72,3.72,0,0,1,.94-3.85c1.59-.72,1.76-2.46,2.6-3.7a8.28,8.28,0,0,1,4.09-5.56c1.06-.21,1.85-.66,1.73-1.93a2.81,2.81,0,0,1,3.53.29C1106.43,447.23,1103.81,449,1102.23,451.58Z"
              />
              <path
                class="cls5-944"
                d="M1106.42,440.79c.82.52,1.74.24,3.29-.24L1107,444c-1,.84-2.08,0-3.12,0-.28-.86.77-1,.89-1.63Z"
              />
              <path
                class="cls5-945"
                d="M1126.11,476.55l1,.68c1,1.44.3,2.41-.92,3.22-4.3,5-4.32,5-9.13.86-1-.82-1.61-.83-2.36.12s-1.67.32-2.48-.12c.55-2,1.3-3.77,4-2.72a1.39,1.39,0,0,0,1.88-.59,1.61,1.61,0,0,0,.12-.33C1120.15,472.68,1123.11,474.51,1126.11,476.55Z"
              />
              <path
                class="cls5-946"
                d="M1102.84,462.26a38.78,38.78,0,0,1,6.14-8c1.49,1.58-.46,2.57-.31,3.81.25,1.66-.86,2.64-1.82,3.71a4.12,4.12,0,0,1-2.21,1.39A1.77,1.77,0,0,1,1102.84,462.26Z"
              />
              <path
                class="cls5-947"
                d="M1119,470.68c1.21,0,2.13.16,1.84,1a6.41,6.41,0,0,1-3.39,3.4c-.37.19-1.86-.18-1.45-1.37A4.11,4.11,0,0,1,1119,470.68Z"
              />
              <path
                class="cls5-948"
                d="M1110.5,470.69l2.36.85c-.69,1.25-1.11,3.28-3.14,1.88S1110,471.55,1110.5,470.69Z"
              />
              <path
                class="cls5-949"
                d="M1107.09,467.33l1,1.53c-.33,1.58-1.38,2.44-2.52,1.1S1106.17,468,1107.09,467.33Z"
              />
              <path
                class="cls5-377"
                d="M1088.8,419.93l1.69,1.63c.44,4.27-2.86,6.83-4.8,9.93a58.22,58.22,0,0,1-3.77,4.81l-.56.2-.93-.87a6.75,6.75,0,0,1-3.28-2.05c-1.18-1.74-4.35-2.22-3.37-5.31,3.74,1.59,4.52-2.2,6.52-3.68,1.71-1.27.08-3.34.63-5a3.09,3.09,0,0,0-1.63-1c-1-.23-.71.77-1,1.28-2,3.39-4.78,3.76-7.88,1.17-.32-.26-.63-.54-1-.79-5.19-3.9-5.11-6.1.41-10.26.85,1.34-.07,2.39-.64,3.43-1.26,2.35-.38,3.91,1.68,5.16s3.79,1.4,5.31-.86a9.39,9.39,0,0,1,3.44-3.5C1083.12,415.45,1085.63,418.21,1088.8,419.93Z"
              />
              <path
                class="cls5-378"
                d="M1072.92,435c-.69,3.28-2.05,4.34-5,1.83-1.81-1.54-4.41-2.1-5.61-4.45-.06-2.92,1.68-3.34,4-2.66a15,15,0,0,1,4.15,2.49c.61.44,1.23.87,1.84,1.34A1.68,1.68,0,0,1,1072.92,435Z"
              />
              <path
                class="cls5-379"
                d="M1059.64,433.16c-1.48-1-2.75-2.05-2.42-4.08,0-2.93,1.61-4.82,4-6.16a8.68,8.68,0,0,1,3.76,1.91C1065.21,428.89,1062.26,430.92,1059.64,433.16Z"
              />
              <path
                class="cls5-381"
                d="M1054.06,431.64a1.08,1.08,0,0,0,.66-.13c1.15.62,2.59.93,2.76,2.6-1,1.27-1.93,2.55-2.91,3.82s-2,1.8-3.28.35C1050.57,435.38,1052.51,433.59,1054.06,431.64Z"
              />
              <path
                class="cls5-950"
                d="M1072.92,435l-.7-1c1.8-1.31,3.82-.79,5.79-.75.63,1,2.35.82,2.42,2.37-1.78,1.71-3.53,2.9-5.34,0A1.9,1.9,0,0,0,1072.92,435Z"
              />
              <path
                class="cls5-951"
                d="M1069.84,451.36c-.41-1.22.33-2.18.71-3.23l4.12-4.78C1073.88,446.57,1072.55,449.4,1069.84,451.36Z"
              />
              <path
                class="cls5-952"
                d="M1080.59,442.39c-1.31.33-1.47,1.82-2.48,2.46-1.66-1.66.11-2.7.85-3.74,1-1.44,2.24-2.73,2.4-4.61v-.07a1.26,1.26,0,0,1,1.68.07C1083.26,438.9,1080.57,440.08,1080.59,442.39Z"
              />
              <path
                class="cls5-384"
                d="M1089.93,467.92c-.68-1.9-1-4.06-3.72-3.66-1.11.16-2.31-1-1.9-2.05s2.55-2.36,3.2-1.12c1.08,2.06,6.2-1.65,4.38,3.2C1091.5,465.33,1091.39,466.9,1089.93,467.92Z"
              />
              <path
                class="cls5-953"
                d="M1016.08,436.55c-5.67-.11-5.86-.47-5.48-5.65.17-2.25.76-3,2.95-2.29a11.43,11.43,0,0,0,2.85.37c5.3.24,5.11.2,4.24,5.24C1020.06,437.6,1017.62,436.12,1016.08,436.55Z"
              />
              <path
                class="cls5-954"
                d="M1027.49,427.38c-.16-2.92,2.06-4.36,3.86-6,.91-.82,1.38.23,1.78.94h0c-1,2.56.54,3.84,2.44,5.1s4.6,2.06,5.11,4.93c-.3.71-.73,1.17-1.59.82l-4.27-1.53c-1.36,1.67,2,2.75-.07,4.12l-2.4-1.74c-.1-.09-.3-.2-.29-.26C1033,429.9,1030.26,428.62,1027.49,427.38Z"
              />
              <path
                class="cls5-955"
                d="M1015,427.88c-2.74-.19-4.46-.95-4.66-3.81-.14-1.88.94-1.76,2-1.66,2.49.25,4.81,1.51,5.4,3.81C1018.21,428.12,1015.51,427,1015,427.88Z"
              />
              <path
                class="cls5-956"
                d="M1023,410.7l-1.32,1.61c-2.32,3-3.78,1.34-5.13-.94l-4.14-3.81c5-8.8,4.93-9.9,13.93-2.61C1027.19,408,1025.87,409.81,1023,410.7Z"
              />
              <path
                class="cls5-957"
                d="M1023,410.7a12.75,12.75,0,0,0,3.35-5.75c.29-.58.59-1.15.89-1.73,1.22-1.49,2.5-3,3.66-4.5s1.73-.81,2.25.45c0,1.88,1.89,2.58,2.63,4h0c-.42,2.42-2.74,2.39-4.3,3.35-1.7,1.12.6,3.27-1.14,4.38-1.41-.54-1.58-1.86-1.87-3.4C1026.5,408.54,1026.66,413.29,1023,410.7Z"
              />
              <path
                class="cls5-901"
                d="M1004.11,389.14c2.38.78,5.1,1.09,5.87,4.16-.28.53-.56,1.07-.85,1.6-3,1.17-3.17,4.48-5,6.57-.93-.39-2-.5-2.61-1.5l.07-.1C1004.66,396.8,1005.73,393.29,1004.11,389.14Z"
              />
              <path
                class="cls5-958"
                d="M1009.76,394.88c1.22-.17,2.16,1,3.51.61.84-.27,2.19-.19,2.18,1,0,1.45-1.7,0-2.22.9C1012.5,396,1008.27,399.34,1009.76,394.88Z"
              />
              <path
                class="cls5-959"
                d="M1016.53,411.37c1.73.22,3,3.12,5.13.94,1.12.09,2.38-.33,3.18.89a2.26,2.26,0,0,1-1.73,2.54c-1.4.94-2.14-.39-3.12-.9-1.57,0-3.28.4-4.18-1.49-.52-.28-1.54-.15-1.3-1.1S1015.84,411.64,1016.53,411.37Z"
              />
              <path
                class="cls5-887"
                d="M1016.63,415.72c-1.4,2.26-2.83,0-4.24,0,.19-2.44,2-1.53,3.34-1.63C1016.4,414.44,1017,414.8,1016.63,415.72Z"
              />
              <path
                class="cls5-554"
                d="M1022.48,469.81c.88-1,1.77-1.91,3.49-3.76-1.21,3-1.63,5-3.61,6.24Z"
              />
              <path
                class="cls5-960"
                d="M1171.07,527.14l4.1,5.1c-.25,1.06.81,2.57-.91,3.12-1.5.48-2.6-.25-3.42-1.5s-1.51-2.23-2.27-3.34C1167.94,528.31,1169.5,527.72,1171.07,527.14Z"
              />
              <path
                class="cls5-961"
                d="M1179.33,571.26c-1.41-.84-1.35-1.7.19-2.07,1.93-.47,3.25-1.78,4.74-2.88a5.33,5.33,0,0,1,3.34,4.9c-2.81,3.52-3.52,3.58-6.64.59C1180.49,571.35,1180.14,570.64,1179.33,571.26Z"
              />
              <path
                class="cls5-962"
                d="M1179.33,571.26c.54-.58,1.28-.85,1.75-.17,2.16,3.17,4.33,1.56,6.52.12l1.56.46c-1.26,2.22-3.3,3.76-5.23,5.25-1.7,1.32-.78-1.56-1.87-1.59Z"
              />
              <path
                class="cls5-963"
                d="M1188.5,558.69l-1.59,1.79a4.83,4.83,0,0,1-.83-.86c-.67-1.16-1.41-2.36-.56-3.74.26-.43.68-1,1.26-.61A3.92,3.92,0,0,1,1188.5,558.69Z"
              />
              <path
                class="cls5-964"
                d="M1186,561.27c.23.78.45,1.57.68,2.36-2.68-1.07-2.64-4.14-4.52-5.83C1184.54,557.89,1184.62,560.26,1186,561.27Z"
              />
              <path
                class="cls5-961"
                d="M1183.2,563.9c-3,1-3.41-.14-2.22-2.65C1182.22,561.71,1183.19,562.4,1183.2,563.9Z"
              />
              <path
                class="cls5-965"
                d="M1055.62,390.75l-1.65,4.19c-1.13.89-1.92.29-2.63-.62a34.26,34.26,0,0,0-12.23-8.46A35.23,35.23,0,0,1,1031,380c.29-1.46,1-1.66,2.25-.91,1.88,1.16,2.29,0,2.4-1.59h0c1.71-1.22,2.75.4,3.89,1.06,2.43,1.42,4.49,3.41,7,4.78l1.65,1.37c2.44,1.31,4.39,3.4,7,4.45a1.28,1.28,0,0,1,.45.35.74.74,0,0,1,0,1.24Z"
              />
              <path
                class="cls5-966"
                d="M1031,380a16.09,16.09,0,0,1,8.14,5.88,17.33,17.33,0,0,1-.89,1.84c-4,6.31-4.6,6.8-10.38,1.82-1.78-1.53-2.11-2.31-.75-4.25A35.94,35.94,0,0,1,1031,380Z"
              />
              <path
                class="cls5-967"
                d="M1079.66,414.19c-.33,2.49-2.42,4-3.73,5.79-1.47,2-3.93.66-5.85-.71s-3.75-2.57-2.33-5.31c.7-1.34,1.41-2.67,2.11-4l1.49-1.37C1074.77,409.48,1077.3,411.71,1079.66,414.19Z"
              />
              <path
                class="cls5-968"
                d="M1051.34,394.32l2.63.62c1,2,3.4,2.36,4.56,4.14.78,3.84-1.64,6.2-4.52,7.26s-5-1.58-6.82-3.64c-1.24-1.39-.79-2.78.34-4.05C1048.81,397.21,1050.07,395.76,1051.34,394.32Z"
              />
              <path
                class="cls5-969"
                d="M1010.76,358.3c3,1.61,6.08,3.13,8.31,5.85-1.58.26-3.14,0-4.79.54-3,1.05-4.48-.55-3.8-3.55A22.57,22.57,0,0,0,1010.76,358.3Z"
              />
              <path
                class="cls5-970"
                d="M1007.31,377.9c1.59.46,3.28.67,4,2.33a1.87,1.87,0,0,1-.87.7C1008.05,381.53,1008.26,379,1007.31,377.9Z"
              />
              <path
                class="cls5-971"
                d="M1028.37,399a6.55,6.55,0,0,1-5.93-3.09C1024.74,396.42,1026.7,396.53,1028.37,399Z"
              />
              <path
                class="cls5-972"
                d="M1004.36,376.32c-1.59-1.2-4.07-.9-5.61-3.7C1001.41,373.53,1003.41,374.05,1004.36,376.32Z"
              />
              <path
                class="cls5-973"
                d="M1004.11,389.14c3.25,4.27,2.35,8.18-2.48,10.73a20.71,20.71,0,0,1-1.86-2.21c-.68-1.09-3.55-1.59-2.37-2.64,2.28-2,.53-7.53,5.8-6.73Z"
              />
              <path
                class="cls5-395"
                d="M1125.91,449.93a9.19,9.19,0,0,1-4.65,6.41c-.42-.82-1.68-1.08-1.53-2.29-.12-1.23-.35-2.33-2-1.88-3.09.25-4-.82-1.77-3.28,1.09-1.2,1.33-3.46,3.67-3.3C1121.72,447,1124.32,447.73,1125.91,449.93Z"
              />
              <path
                class="cls5-396"
                d="M1108.81,464.83c-1.87.83-1.72-.42-1.63-1.6.22-3.53,3.1-5.24,5.15-7.52,1.32-.87,2.11-1.27,2.17,1.06.09,3-2.25,4.78-3.22,7.22C1110.36,464,1109.37,463.78,1108.81,464.83Z"
              />
              <path
                class="cls5-398"
                d="M1125.91,449.93c-1.25-.16-1.83-1.66-3.69-1-2.92,1-.32-3.26-2.61-3.34-.84-2,.34-1.92,1.45-1.19,2.61,1.71,5.1,3.61,7.64,5.43C1127.82,451.25,1126.83,449.79,1125.91,449.93Z"
              />
              <path
                class="cls5-974"
                d="M1129.43,444.69a21.69,21.69,0,0,1-2.18-1.17c-.75-.51-.7-1.27.08-1.57,1.67-.63,2.26,1.18,3.42,1.76,1,.48,1.59,1.3.63,2.26s-1.6,2.11-3,1.75c-.86-.23-2-.93-1.77-2C1126.94,443.92,1128.55,446.42,1129.43,444.69Z"
              />
              <path
                class="cls5-975"
                d="M1126,440.75c-.82,1.76-3.68-1.41-3.68,1.93,0,.43-1.11-.27-1.61-.66a1.62,1.62,0,0,1-.61-2.21,1.71,1.71,0,0,1,.52-.55c.7-.67,1.24-2.14,2.59-1C1124.18,439,1125.55,439.53,1126,440.75Z"
              />
              <path
                class="cls5-401"
                d="M1117.71,452.17c.54-1.34,1.51-2.33,2.8-1.23s-.34,2.1-.78,3.11c-1.15.71-2.5,1.1-3.34-.09S1118,453.34,1117.71,452.17Z"
              />
              <path
                class="cls5-976"
                d="M1117.22,460.46c-1.29-1.16-2.37-2.26-1.29-3.92a1.13,1.13,0,0,1,1.55-.34,1.21,1.21,0,0,1,.24.21C1119.91,458.15,1116.56,458.94,1117.22,460.46Z"
              />
              <path
                class="cls5-977"
                d="M1206.22,509.08c1.21-.6,2.16,0,3.1.67,1.44,3-.57,4.54-2.5,6.14-4.22-1-4.22-1-2.56-4.5l.11-.14A3,3,0,0,0,1206.22,509.08Z"
              />
              <path
                class="cls5-978"
                d="M1212.63,512.09c1.17.84,2.84,1.42,1.7,3.41-1.3,1.78-1.58,5.7-5.25,2.5C1208.68,515.08,1209.74,513,1212.63,512.09Z"
              />
              <path
                class="cls5-979"
                d="M1192.66,567.09c2.79-1.6,4.36-4.74,7.46-6,3.43,2.55-1.85,3.4-1.06,5.44-2.27-.64-3.38,1.4-5,2.17C1191.58,569.89,1192.1,568.48,1192.66,567.09Z"
              />
              <path
                class="cls5-980"
                d="M1131.94,431.63a14.87,14.87,0,0,0,1.84-4.13c.81-4.77,1.65-5,5.75-1.81,1.79.17.9,1.29.56,1.94a37.92,37.92,0,0,1-3.39,5.37C1134.68,434.06,1133.41,432.48,1131.94,431.63Z"
              />
              <path
                class="cls5-981"
                d="M1131.94,431.63c1.3.9,2.6,1.83,4.23.69,1.3-.09,1.35.52.83,1.46-.68.69-1,1.29.19,1.85s2.44.82,2.28,2.49c-4.2-.47-7.5-2.75-10.67-5.31-1.26-1-2.33-2-.79-3.61Z"
              />
              <path
                class="cls5-982"
                d="M1122.84,423.1a3.37,3.37,0,0,0,1-2.28c2.49.16,3.5-1.66,4.57-3.41,2.7-2.75,3.21-.66,3.62,1.65h0c-2.3-.14-4.45-.2-3.84,3.23.33,1.84-3.84,1.53-2.18,4.19C1121.05,429.07,1123.59,424.52,1122.84,423.1Z"
              />
              <path
                class="cls5-983"
                d="M1137,433.78a1.48,1.48,0,0,0-.83-1.46c.7-2.42,3.68-3.69,3.36-6.63.08-1.77,1.37-2.25,2.51-1.51,1.68,1.09.52,2.65,0,4l-.89.75a5.48,5.48,0,0,1-3.38,5.08A2.86,2.86,0,0,1,1137,433.78Z"
              />
              <path
                class="cls5-410"
                d="M1083,436.5l-1.68-.07c2.64-4.11,5.27-8.23,7.93-12.33.52-.8,1.32-1.44,1.2-2.54,1.65-.09,1.19,2.89,3.23,2.22-1,1-1.91,1.94-2.84,2.93-2.2,2.34-3.62,4.73-.44,7.4C1086.52,430.41,1084.75,433.37,1083,436.5Z"
              />
              <path
                class="cls5-984"
                d="M1055.46,418.31l2.59,2.45c-1,3.55-2.44,6.73-6.62,7.48l-1.48-1c-.09-1.89,1-3.47.39-5.76C1049.83,419.64,1052.15,416.91,1055.46,418.31Z"
              />
              <path
                class="cls5-985"
                d="M1040.64,435.79v-3.45c.92-.48,2-.74,2.51-1.81,1.81.36,3.07,1.67,4.51,2.64,1.23.83,3.84,1.06,1.67,3.72-1.46,1.79-2.44,3.41-4.81,1.07A17.21,17.21,0,0,0,1040.64,435.79Z"
              />
              <path
                class="cls5-986"
                d="M1050.45,418.35c-.51.83-1.07,2.38-2.18,1.87-2.58-1.19-5.24-2.57-6.65-5.23-.42-.8.45-1.9,1.35-2.3C1044.43,412,1050.61,416.7,1050.45,418.35Z"
              />
              <path
                class="cls5-987"
                d="M1020.78,418.36c-1.55.74-2.73,1.77-3.77-.07-.29-.5-.45-1.16.2-1.42C1018.78,416.25,1019.67,417.22,1020.78,418.36Z"
              />
              <path
                class="cls5-988"
                d="M917.61,218.93c-1.45,0-101.82,34.81-101.82,34.81s-5.52,4.06-5.81,4.06,59.77,44.39,59.77,44.39L859,328l-22,48.16s8.42,3.77,10.74,3.77,5.8-.87,5.8-1.74,29.59-31,29.59-31,1.45-2,3.19-.58,67.31,44.67,67.31,44.67l-29.3,25.24s-1.16,2-.29,2.32,26.11,12.19,31,13.64,37.13,4.93,39.45,5.8S1020,440,1020,440l69.92,42.36-6.09,25.82s-5.52,24.08-6.39,27.27.58,15.08,1.16,18.27,2.32,7,1.45,7-2.9,6.09-6.67,9.57-11.6,8.12-11.6,8.12l-8.13,4.65v1.74l74.85,11.89,91.68,13.93V596.36l20.59.58s-4.35-29.3-4.35-30.17-6.67-12.77-6.67-12.77l9.28-5.51,8.71,11.32,8.12,5.51,13.63-17.12-23.2-19.72,34.81-47.29,29.9-42.36s-27.27-29.59-28.72-31.91-19.15-29-19.15-29L1252.4,373l-8.7-6.09L1233,360.5s-24.66,47.87-25.24,47-47.87-58.6-47.87-58.6l5.23-10.45L1079.78,301l-36.55-18-48.74-24-22.63-12.8Z"
              />
              <path
                class="cls5-989"
                d="M936.18,221.25l104,54-11.74,14.36-6.1,7.4s-8.7,8.7-9.57,8.7-10.44,5.66-10.44,5.66l-1.6,10.15L988,335.12l-23.79-18.86s12.76-9.86,10.15-12.47-66.58-45.26-66-46.42S936.18,221.25,936.18,221.25Z"
              />
              <path
                class="cls5-990"
                d="M875.69,299.58c.87-1.74,29.89-39.74,29.89-39.74l5.22,5.8,21,10.44,35.25,29.59-9.14,17,24.8,16.1-28.43,37.14L880.05,322.5s-1.16-2.9-.29-4.93,4.64-7.26,3.77-8.71-4.93-4.93-4.93-4.93l-4.07-3.48"
              />
              <path
                class="cls5-991"
                d="M1015,319.6c2.61-3.77,30.17-37.72,30.17-37.72l100.66,45.84-4.35,9.86-18.27,13.35s-20.6,32.49-21.47,32.49S1015,319.6,1015,319.6Z"
              />
              <path
                class="cls5-992"
                d="M1232.92,366.45s15.89,7.06,20.15,8c9.48,2.07,20.07,21.74,20.65,23.77s28.43,31.62,28.43,31.62l-28.43,40L1245,448.7s8.7-12.19,7-13.35S1233.11,422,1233.11,422s-23.3-12.92-23.3-13.79,22.82-41.77,22.82-41.77"
              />
              <path
                class="cls5-993"
                d="M1238.85,428.07c-10.25-.93-89-88.89-89-88.89l-42.94,59.91,76.24,52.69s-7.69,8-7.11,9.18,25.77,16,25.77,16l16.3-23.7S1239.36,428.12,1238.85,428.07Z"
              />
              <path
                class="cls5-994"
                d="M1106.33,424.91l74.41,52.22-32.55,38s-13.14-9.19-16.62-11.51-64.23-37.4-62.49-38.56S1106.33,424.91,1106.33,424.91Z"
              />
              <polygon
                class="cls5-995"
                points="1084.57 480.17 1124.17 504.11 1145.93 518.47 1145.49 549.37 1137.81 586.79 1055.75 582.14 1080.93 561.4 1077.38 536.22 1084.57 480.17"
              />
              <polygon
                class="cls5-996"
                points="991.45 339.04 1006.68 318.73 1098.06 384 1103.07 395.47 1180.19 450 1174.26 459.78 1240.36 507.3 1235.14 514.84 991.45 339.04"
              />
              <path
                class="cls5-997"
                d="M1236.78,430.44l-31.11,45-1.78,3,2.53,1.73,10,8.27,8.7,6.09,14.36,11.75,4.35-3.91,10.71-1.41s20.73-20.77,20.15-22.22-32.6-26.42-32.6-26.42l4.79-13.92Z"
              />
              <polygon
                class="cls5-998"
                points="962.73 379.22 991.01 343.53 1101.98 423.17 1066.41 465.41 1013.09 437.56 958.27 432.22 924.5 416.82 962.73 379.22"
              />
              <path
                class="cls5-998"
                d="M1147,595.47c-.43-1.3,3.28-76.57,3.28-76.57l33.07-39.16,61.3,46.11-14.79,26.55s11.48,40.7,10.17,40.7-19.55.3-19.55.3l-.89,15.7Z"
              />
              <polygon
                class="cls5-999"
                points="869.75 302.19 930.19 225.25 917.61 218.93 815.79 253.74 809.98 257.81 869.75 302.19"
              />
            </g>
            <g id="logos_texto" data-name="logos texto">
              <circle class="cls5-1000" cx="1239.5" cy="475.74" r="10.53" />
              <path
                class="cls5-1001"
                d="M1239.5,488a12.28,12.28,0,1,1,12.27-12.29h0A12.31,12.31,0,0,1,1239.5,488Zm0-21.07a8.8,8.8,0,1,0,8.79,8.81v0a8.81,8.81,0,0,0-8.79-8.78Z"
              />
              <path
                class="cls5-1002"
                d="M1235.17,472.35h0l-1.58.85-.23-.93,2-1.06h1v9.05h-1.18Z"
              />
              <path
                class="cls5-1002"
                d="M1245.67,475.64c0,3.08-1.15,4.77-3.15,4.77-1.77,0-3-1.65-3-4.65s1.31-4.71,3.15-4.71S1245.67,472.75,1245.67,475.64Zm-4.92.14c0,2.35.72,3.69,1.84,3.69s1.85-1.47,1.85-3.78-.57-3.69-1.84-3.69c-1.07,0-1.85,1.31-1.85,3.78Z"
              />
              <circle class="cls5-1000" cx="1258.68" cy="416.89" r="10.53" />
              <path
                class="cls5-1001"
                d="M1258.68,429.16A12.27,12.27,0,1,1,1271,416.89a12.27,12.27,0,0,1-12.32,12.27Zm0-21.06a8.79,8.79,0,1,0,8.8,8.79A8.8,8.8,0,0,0,1258.68,408.1Z"
              />
              <path
                class="cls5-1002"
                d="M1259,413.51h0l-1.57.85-.24-.94,2-1.06h1v9.06H1259Z"
              />
              <circle class="cls5-1000" cx="1177.48" cy="413.01" r="10.53" />
              <path
                class="cls5-1001"
                d="M1177.48,425.28A12.28,12.28,0,1,1,1189.76,413,12.28,12.28,0,0,1,1177.48,425.28Zm0-21.07a8.8,8.8,0,1,0,8.8,8.8A8.8,8.8,0,0,0,1177.48,404.21Z"
              />
              <path
                class="cls5-1002"
                d="M1174.45,417.75V417l1-.94c2.31-2.2,3.36-3.37,3.37-4.73a1.61,1.61,0,0,0-1.43-1.77H1177a3.19,3.19,0,0,0-1.93.76l-.39-.86a4,4,0,0,1,2.57-.92,2.55,2.55,0,0,1,2.76,2.32c0,.1,0,.21,0,.31,0,1.67-1.21,3-3.12,4.87l-.73.66h4.07v1Z"
              />
              <circle class="cls5-1000" cx="1188.2" cy="555.02" r="10.53" />
              <path
                class="cls5-1001"
                d="M1188.2,567.29A12.27,12.27,0,1,1,1200.47,555,12.27,12.27,0,0,1,1188.2,567.29Zm0-21.06A8.79,8.79,0,1,0,1197,555h0A8.8,8.8,0,0,0,1188.2,546.23Z"
              />
              <path
                class="cls5-1002"
                d="M1184,551.71h0l-1.57.85-.24-.93,2-1.06h1v9H1184Z"
              />
              <path
                class="cls5-1002"
                d="M1188.47,559.62v-.75l1-.93c2.31-2.2,3.35-3.37,3.37-4.74a1.62,1.62,0,0,0-1.45-1.77H1191a3.09,3.09,0,0,0-1.92.77l-.39-.86a4,4,0,0,1,2.56-.92,2.54,2.54,0,0,1,2.76,2.3c0,.11,0,.22,0,.33,0,1.67-1.21,3-3.12,4.86l-.72.67h4.07v1Z"
              />
              <circle class="cls5-1000" cx="1115.6" cy="544.53" r="10.53" />
              <path
                class="cls5-1001"
                d="M1115.6,556.8a12.28,12.28,0,1,1,12.27-12.29v0A12.29,12.29,0,0,1,1115.6,556.8Zm0-21.07a8.8,8.8,0,1,0,8.79,8.81h0A8.8,8.8,0,0,0,1115.6,535.73Z"
              />
              <path
                class="cls5-1002"
                d="M1112.35,541.14h0l-1.57.85-.24-.93,2-1.06h1v9h-1.19Z"
              />
              <path
                class="cls5-1002"
                d="M1119.5,541.14h0l-1.58.85-.23-.93,2-1.06h1v9h-1.18Z"
              />
              <circle class="cls5-1000" cx="1124.41" cy="468.47" r="10.53" />
              <path
                class="cls5-1001"
                d="M1124.41,480.74a12.27,12.27,0,1,1,12.28-12.27A12.27,12.27,0,0,1,1124.41,480.74Zm0-21.06a8.79,8.79,0,1,0,8.8,8.79A8.8,8.8,0,0,0,1124.41,459.68Z"
              />
              <path
                class="cls5-1002"
                d="M1121.36,470.7a2.59,2.59,0,0,1,1.79-2.42h0a2.26,2.26,0,0,1-1.44-2,2.53,2.53,0,0,1,2.65-2.42h.15a2.33,2.33,0,0,1,2.62,2,1.49,1.49,0,0,1,0,.21,2.33,2.33,0,0,1-1.49,2.12h0a2.51,2.51,0,0,1,1.82,2.34c0,1.57-1.35,2.63-3.08,2.63C1122.5,473.15,1121.36,472,1121.36,470.7Zm4.87-.06c0-1.1-.76-1.63-2-2a2,2,0,0,0-1.63,1.86,1.66,1.66,0,0,0,1.6,1.73h.21a1.64,1.64,0,0,0,1.81-1.45A.66.66,0,0,0,1126.23,470.64Zm-3.37-4.52c0,.9.68,1.39,1.73,1.67a1.78,1.78,0,0,0,1.38-1.65,1.4,1.4,0,0,0-1.34-1.47h-.2a1.44,1.44,0,0,0-1.56,1.3.76.76,0,0,0,0,.15Z"
              />
              <circle class="cls5-1000" cx="1023.76" cy="408.18" r="10.53" />
              <path
                class="cls5-1001"
                d="M1023.76,420.45A12.28,12.28,0,1,1,1036,408.13v.05A12.29,12.29,0,0,1,1023.76,420.45Zm0-21.06a8.79,8.79,0,1,0,8.8,8.79A8.8,8.8,0,0,0,1023.76,399.39Z"
              />
              <path
                class="cls5-1002"
                d="M1026.62,403.65v.81l-3.94,8.24h-1.27l3.93-8h-4.43v-1Z"
              />
              <circle class="cls5-1000" cx="1069.04" cy="379.92" r="10.53" />
              <path
                class="cls5-1001"
                d="M1069,392.2a12.28,12.28,0,1,1,12.28-12.28A12.28,12.28,0,0,1,1069,392.2Zm0-21.07a8.79,8.79,0,1,0,8.8,8.79A8.8,8.8,0,0,0,1069,371.13Z"
              />
              <path
                class="cls5-1002"
                d="M1066.72,383.59a5.57,5.57,0,0,0,1,0,3.42,3.42,0,0,0,1.89-.88,4,4,0,0,0,1.2-2.41h0a2.67,2.67,0,0,1-2.13,1,2.63,2.63,0,0,1-2.68-2.58,1.33,1.33,0,0,1,0-.2,3.1,3.1,0,0,1,3-3.21h.11c1.85,0,3,1.5,3,3.81a5.71,5.71,0,0,1-1.56,4.25,4.58,4.58,0,0,1-2.63,1.21,5.32,5.32,0,0,1-1.13.07Zm.45-5.21a1.73,1.73,0,0,0,1.55,1.91h.19a2,2,0,0,0,1.78-.94.79.79,0,0,0,.11-.45c0-1.55-.57-2.73-1.85-2.73-1,0-1.78.92-1.78,2.2Z"
              />
              <circle class="cls5-1000" cx="1077.71" cy="329.37" r="10.53" />
              <path
                class="cls5-1001"
                d="M1077.71,341.64A12.28,12.28,0,1,1,1090,329.37a12.28,12.28,0,0,1-12.29,12.27Zm0-21.06a8.79,8.79,0,1,0,8.79,8.79,8.8,8.8,0,0,0-8.79-8.79Z"
              />
              <path
                class="cls5-1002"
                d="M1075.22,332.49a4.17,4.17,0,0,0,2,.57c1.58,0,2.07-1,2-1.76,0-1.26-1.15-1.81-2.34-1.81h-.68v-.92h.68c.89,0,2-.46,2-1.53,0-.72-.46-1.36-1.59-1.36a3.45,3.45,0,0,0-1.81.59l-.32-.89a4.42,4.42,0,0,1,2.37-.69c1.78,0,2.59,1.06,2.59,2.16a2.25,2.25,0,0,1-1.67,2.13h0a2.35,2.35,0,0,1,2,2.32c0,1.45-1.13,2.72-3.3,2.72a4.64,4.64,0,0,1-2.36-.61Z"
              />
              <circle class="cls5-1000" cx="978.63" cy="273.39" r="10.53" />
              <path
                class="cls5-1001"
                d="M978.63,285.66a12.27,12.27,0,1,1,12.27-12.27A12.27,12.27,0,0,1,978.63,285.66Zm0-21.06a8.79,8.79,0,1,0,8.79,8.79h0A8.81,8.81,0,0,0,978.63,264.6Z"
              />
              <path
                class="cls5-1002"
                d="M979.52,277.92v-2.47h-4.21v-.81l4-5.78h1.32v5.63h1.27v1h-1.27V278Zm0-3.43v-4.42h0c-.28.53-.5.92-.75,1.33l-2.22,3.08h3Z"
              />
              <circle class="cls5-1000" cx="928.07" cy="317.29" r="10.53" />
              <path
                class="cls5-1001"
                d="M928.07,329.56a12.27,12.27,0,1,1,12.27-12.27A12.27,12.27,0,0,1,928.07,329.56Zm0-21.06a8.79,8.79,0,1,0,8.79,8.79h0A8.81,8.81,0,0,0,928.07,308.5Z"
              />
              <path
                class="cls5-1002"
                d="M930.7,313.72h-3.45L926.9,316a6.13,6.13,0,0,1,.74-.05,3.69,3.69,0,0,1,2,.49,2.58,2.58,0,0,1,1.3,2.32,3.15,3.15,0,0,1-3.18,3.1h-.2a4.41,4.41,0,0,1-2.25-.55l.3-.94a4,4,0,0,0,1.94.51,2,2,0,0,0,2.14-1.84.92.92,0,0,0,0-.16c0-1.17-.8-2-2.61-2a10.36,10.36,0,0,0-1.25.1l.58-4.34h4.33Z"
              />
              <circle class="cls5-1000" cx="874.06" cy="260.67" r="10.53" />
              <path
                class="cls5-1001"
                d="M874.06,273a12.28,12.28,0,1,1,12.27-12.29h0A12.31,12.31,0,0,1,874.06,273Zm0-21.07a8.79,8.79,0,1,0,8.79,8.79h0a8.8,8.8,0,0,0-8.76-8.84h0Z"
              />
              <path
                class="cls5-1002"
                d="M876.27,257a4.69,4.69,0,0,0-.92.06,3.67,3.67,0,0,0-3.15,3.22h0a2.75,2.75,0,0,1,4.91,1.88,3,3,0,0,1-2.8,3.18h-.2c-1.94,0-3.21-1.51-3.21-3.86a5.7,5.7,0,0,1,1.53-4.08,5,5,0,0,1,2.9-1.34,5.26,5.26,0,0,1,.89-.07Zm-.35,5.23a1.84,1.84,0,0,0-1.58-2.06,1.37,1.37,0,0,0-.28,0,2,2,0,0,0-1.76,1.11,1.18,1.18,0,0,0-.14.55c0,1.49.71,2.59,2,2.59,1.05,0,1.76-.88,1.76-2.17Z"
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default Sectores;
